var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) =>
  key in obj
    ? __defProp(obj, key, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value,
      })
    : (obj[key] = value);
var __publicField = (obj, key, value) =>
    __defNormalProp(obj, typeof key != "symbol" ? key + "" : key, value),
  __accessCheck = (obj, member, msg) =>
    member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (
    __accessCheck(obj, member, "read from private field"),
    getter ? getter.call(obj) : member.get(obj)
  ),
  __privateAdd = (obj, member, value) =>
    member.has(obj)
      ? __typeError("Cannot add the same private member more than once")
      : member instanceof WeakSet
      ? member.add(obj)
      : member.set(obj, value),
  __privateSet = (obj, member, value, setter) => (
    __accessCheck(obj, member, "write to private field"),
    setter ? setter.call(obj, value) : member.set(obj, value),
    value
  );
(function () {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) return;
  for (const link of document.querySelectorAll('link[rel="modulepreload"]'))
    processPreload(link);
  new MutationObserver((mutations) => {
    for (const mutation of mutations)
      if (mutation.type === "childList")
        for (const node of mutation.addedNodes)
          node.tagName === "LINK" &&
            node.rel === "modulepreload" &&
            processPreload(node);
  }).observe(document, { childList: !0, subtree: !0 });
  function getFetchOpts(link) {
    const fetchOpts = {};
    return (
      link.integrity && (fetchOpts.integrity = link.integrity),
      link.referrerPolicy && (fetchOpts.referrerPolicy = link.referrerPolicy),
      link.crossOrigin === "use-credentials"
        ? (fetchOpts.credentials = "include")
        : link.crossOrigin === "anonymous"
        ? (fetchOpts.credentials = "omit")
        : (fetchOpts.credentials = "same-origin"),
      fetchOpts
    );
  }
  function processPreload(link) {
    if (link.ep) return;
    link.ep = !0;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
var lazysizes = { exports: {} },
  hasRequiredLazysizes;
function requireLazysizes() {
  return (
    hasRequiredLazysizes ||
      ((hasRequiredLazysizes = 1),
      (function (module) {
        (function (window2, factory) {
          var lazySizes = factory(window2, window2.document, Date);
          (window2.lazySizes = lazySizes),
            module.exports && (module.exports = lazySizes);
        })(
          typeof window < "u" ? window : {},
          function (window2, document2, Date2) {
            var lazysizes2, lazySizesCfg;
            if (
              ((function () {
                var prop,
                  lazySizesDefaults = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    fastLoadedClass: "ls-is-cached",
                    iframeLoadMode: 0,
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: 0.8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 0,
                    throttleDelay: 125,
                  };
                lazySizesCfg =
                  window2.lazySizesConfig || window2.lazysizesConfig || {};
                for (prop in lazySizesDefaults)
                  prop in lazySizesCfg ||
                    (lazySizesCfg[prop] = lazySizesDefaults[prop]);
              })(),
              !document2 || !document2.getElementsByClassName)
            )
              return { init: function () {}, cfg: lazySizesCfg, noSupport: !0 };
            var docElem = document2.documentElement,
              supportPicture = window2.HTMLPictureElement,
              _addEventListener = "addEventListener",
              _getAttribute = "getAttribute",
              addEventListener = window2[_addEventListener].bind(window2),
              setTimeout2 = window2.setTimeout,
              requestAnimationFrame2 =
                window2.requestAnimationFrame || setTimeout2,
              requestIdleCallback = window2.requestIdleCallback,
              regPicture = /^picture$/i,
              loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"],
              regClassCache = {},
              forEach = Array.prototype.forEach,
              hasClass = function (ele, cls) {
                return (
                  regClassCache[cls] ||
                    (regClassCache[cls] = new RegExp(
                      "(\\s|^)" + cls + "(\\s|$)"
                    )),
                  regClassCache[cls].test(ele[_getAttribute]("class") || "") &&
                    regClassCache[cls]
                );
              },
              addClass2 = function (ele, cls) {
                hasClass(ele, cls) ||
                  ele.setAttribute(
                    "class",
                    (ele[_getAttribute]("class") || "").trim() + " " + cls
                  );
              },
              removeClass2 = function (ele, cls) {
                var reg;
                (reg = hasClass(ele, cls)) &&
                  ele.setAttribute(
                    "class",
                    (ele[_getAttribute]("class") || "").replace(reg, " ")
                  );
              },
              addRemoveLoadEvents = function (dom, fn, add) {
                var action = add ? _addEventListener : "removeEventListener";
                add && addRemoveLoadEvents(dom, fn),
                  loadEvents.forEach(function (evt) {
                    dom[action](evt, fn);
                  });
              },
              triggerEvent = function (
                elem,
                name,
                detail,
                noBubbles,
                noCancelable
              ) {
                var event = document2.createEvent("Event");
                return (
                  detail || (detail = {}),
                  (detail.instance = lazysizes2),
                  event.initEvent(name, !noBubbles, !noCancelable),
                  (event.detail = detail),
                  elem.dispatchEvent(event),
                  event
                );
              },
              updatePolyfill = function (el, full) {
                var polyfill2;
                !supportPicture &&
                (polyfill2 = window2.picturefill || lazySizesCfg.pf)
                  ? (full &&
                      full.src &&
                      !el[_getAttribute]("srcset") &&
                      el.setAttribute("srcset", full.src),
                    polyfill2({ reevaluate: !0, elements: [el] }))
                  : full && full.src && (el.src = full.src);
              },
              getCSS = function (elem, style) {
                return (getComputedStyle(elem, null) || {})[style];
              },
              getWidth = function (elem, parent, width) {
                for (
                  width = width || elem.offsetWidth;
                  width < lazySizesCfg.minSize &&
                  parent &&
                  !elem._lazysizesWidth;

                )
                  (width = parent.offsetWidth), (parent = parent.parentNode);
                return width;
              },
              rAF = (function () {
                var running,
                  waiting,
                  firstFns = [],
                  secondFns = [],
                  fns = firstFns,
                  run = function () {
                    var runFns = fns;
                    for (
                      fns = firstFns.length ? secondFns : firstFns,
                        running = !0,
                        waiting = !1;
                      runFns.length;

                    )
                      runFns.shift()();
                    running = !1;
                  },
                  rafBatch = function (fn, queue) {
                    running && !queue
                      ? fn.apply(this, arguments)
                      : (fns.push(fn),
                        waiting ||
                          ((waiting = !0),
                          (document2.hidden
                            ? setTimeout2
                            : requestAnimationFrame2)(run)));
                  };
                return (rafBatch._lsFlush = run), rafBatch;
              })(),
              rAFIt = function (fn, simple) {
                return simple
                  ? function () {
                      rAF(fn);
                    }
                  : function () {
                      var that = this,
                        args = arguments;
                      rAF(function () {
                        fn.apply(that, args);
                      });
                    };
              },
              throttle2 = function (fn) {
                var running,
                  lastTime = 0,
                  gDelay = lazySizesCfg.throttleDelay,
                  rICTimeout = lazySizesCfg.ricTimeout,
                  run = function () {
                    (running = !1), (lastTime = Date2.now()), fn();
                  },
                  idleCallback =
                    requestIdleCallback && rICTimeout > 49
                      ? function () {
                          requestIdleCallback(run, { timeout: rICTimeout }),
                            rICTimeout !== lazySizesCfg.ricTimeout &&
                              (rICTimeout = lazySizesCfg.ricTimeout);
                        }
                      : rAFIt(function () {
                          setTimeout2(run);
                        }, !0);
                return function (isPriority) {
                  var delay2;
                  (isPriority = isPriority === !0) && (rICTimeout = 33),
                    !running &&
                      ((running = !0),
                      (delay2 = gDelay - (Date2.now() - lastTime)),
                      delay2 < 0 && (delay2 = 0),
                      isPriority || delay2 < 9
                        ? idleCallback()
                        : setTimeout2(idleCallback, delay2));
                };
              },
              debounce2 = function (func) {
                var timeout,
                  timestamp,
                  wait = 99,
                  run = function () {
                    (timeout = null), func();
                  },
                  later = function () {
                    var last = Date2.now() - timestamp;
                    last < wait
                      ? setTimeout2(later, wait - last)
                      : (requestIdleCallback || run)(run);
                  };
                return function () {
                  (timestamp = Date2.now()),
                    timeout || (timeout = setTimeout2(later, wait));
                };
              },
              loader = (function () {
                var preloadElems,
                  isCompleted,
                  resetPreloadingTimer,
                  loadMode,
                  started,
                  eLvW,
                  elvH,
                  eLtop,
                  eLleft,
                  eLright,
                  eLbottom,
                  isBodyHidden,
                  regImg = /^img$/i,
                  regIframe = /^iframe$/i,
                  supportScroll =
                    "onscroll" in window2 &&
                    !/(gle|ing)bot/.test(navigator.userAgent),
                  shrinkExpand = 0,
                  currentExpand = 0,
                  isLoading = 0,
                  lowRuns = -1,
                  resetPreloading = function (e) {
                    isLoading--,
                      (!e || isLoading < 0 || !e.target) && (isLoading = 0);
                  },
                  isVisible = function (elem) {
                    return (
                      isBodyHidden == null &&
                        (isBodyHidden =
                          getCSS(document2.body, "visibility") == "hidden"),
                      isBodyHidden ||
                        !(
                          getCSS(elem.parentNode, "visibility") == "hidden" &&
                          getCSS(elem, "visibility") == "hidden"
                        )
                    );
                  },
                  isNestedVisible = function (elem, elemExpand) {
                    var outerRect,
                      parent = elem,
                      visible = isVisible(elem);
                    for (
                      eLtop -= elemExpand,
                        eLbottom += elemExpand,
                        eLleft -= elemExpand,
                        eLright += elemExpand;
                      visible &&
                      (parent = parent.offsetParent) &&
                      parent != document2.body &&
                      parent != docElem;

                    )
                      (visible = (getCSS(parent, "opacity") || 1) > 0),
                        visible &&
                          getCSS(parent, "overflow") != "visible" &&
                          ((outerRect = parent.getBoundingClientRect()),
                          (visible =
                            eLright > outerRect.left &&
                            eLleft < outerRect.right &&
                            eLbottom > outerRect.top - 1 &&
                            eLtop < outerRect.bottom + 1));
                    return visible;
                  },
                  checkElements = function () {
                    var eLlen,
                      i,
                      rect,
                      autoLoadElem,
                      loadedSomething,
                      elemExpand,
                      elemNegativeExpand,
                      elemExpandVal,
                      beforeExpandVal,
                      defaultExpand,
                      preloadExpand,
                      hFac,
                      lazyloadElems = lazysizes2.elements;
                    if (
                      (loadMode = lazySizesCfg.loadMode) &&
                      isLoading < 8 &&
                      (eLlen = lazyloadElems.length)
                    ) {
                      for (i = 0, lowRuns++; i < eLlen; i++)
                        if (
                          !(!lazyloadElems[i] || lazyloadElems[i]._lazyRace)
                        ) {
                          if (
                            !supportScroll ||
                            (lazysizes2.prematureUnveil &&
                              lazysizes2.prematureUnveil(lazyloadElems[i]))
                          ) {
                            unveilElement(lazyloadElems[i]);
                            continue;
                          }
                          if (
                            ((!(elemExpandVal =
                              lazyloadElems[i][_getAttribute]("data-expand")) ||
                              !(elemExpand = elemExpandVal * 1)) &&
                              (elemExpand = currentExpand),
                            defaultExpand ||
                              ((defaultExpand =
                                !lazySizesCfg.expand || lazySizesCfg.expand < 1
                                  ? docElem.clientHeight > 500 &&
                                    docElem.clientWidth > 500
                                    ? 500
                                    : 370
                                  : lazySizesCfg.expand),
                              (lazysizes2._defEx = defaultExpand),
                              (preloadExpand =
                                defaultExpand * lazySizesCfg.expFactor),
                              (hFac = lazySizesCfg.hFac),
                              (isBodyHidden = null),
                              currentExpand < preloadExpand &&
                              isLoading < 1 &&
                              lowRuns > 2 &&
                              loadMode > 2 &&
                              !document2.hidden
                                ? ((currentExpand = preloadExpand),
                                  (lowRuns = 0))
                                : loadMode > 1 && lowRuns > 1 && isLoading < 6
                                ? (currentExpand = defaultExpand)
                                : (currentExpand = shrinkExpand)),
                            beforeExpandVal !== elemExpand &&
                              ((eLvW = innerWidth + elemExpand * hFac),
                              (elvH = innerHeight + elemExpand),
                              (elemNegativeExpand = elemExpand * -1),
                              (beforeExpandVal = elemExpand)),
                            (rect = lazyloadElems[i].getBoundingClientRect()),
                            (eLbottom = rect.bottom) >= elemNegativeExpand &&
                              (eLtop = rect.top) <= elvH &&
                              (eLright = rect.right) >=
                                elemNegativeExpand * hFac &&
                              (eLleft = rect.left) <= eLvW &&
                              (eLbottom || eLright || eLleft || eLtop) &&
                              (lazySizesCfg.loadHidden ||
                                isVisible(lazyloadElems[i])) &&
                              ((isCompleted &&
                                isLoading < 3 &&
                                !elemExpandVal &&
                                (loadMode < 3 || lowRuns < 4)) ||
                                isNestedVisible(lazyloadElems[i], elemExpand)))
                          ) {
                            if (
                              (unveilElement(lazyloadElems[i]),
                              (loadedSomething = !0),
                              isLoading > 9)
                            )
                              break;
                          } else
                            !loadedSomething &&
                              isCompleted &&
                              !autoLoadElem &&
                              isLoading < 4 &&
                              lowRuns < 4 &&
                              loadMode > 2 &&
                              (preloadElems[0] ||
                                lazySizesCfg.preloadAfterLoad) &&
                              (preloadElems[0] ||
                                (!elemExpandVal &&
                                  (eLbottom ||
                                    eLright ||
                                    eLleft ||
                                    eLtop ||
                                    lazyloadElems[i][_getAttribute](
                                      lazySizesCfg.sizesAttr
                                    ) != "auto"))) &&
                              (autoLoadElem =
                                preloadElems[0] || lazyloadElems[i]);
                        }
                      autoLoadElem &&
                        !loadedSomething &&
                        unveilElement(autoLoadElem);
                    }
                  },
                  throttledCheckElements = throttle2(checkElements),
                  switchLoadingClass = function (e) {
                    var elem = e.target;
                    if (elem._lazyCache) {
                      delete elem._lazyCache;
                      return;
                    }
                    resetPreloading(e),
                      addClass2(elem, lazySizesCfg.loadedClass),
                      removeClass2(elem, lazySizesCfg.loadingClass),
                      addRemoveLoadEvents(elem, rafSwitchLoadingClass),
                      triggerEvent(elem, "lazyloaded");
                  },
                  rafedSwitchLoadingClass = rAFIt(switchLoadingClass),
                  rafSwitchLoadingClass = function (e) {
                    rafedSwitchLoadingClass({ target: e.target });
                  },
                  changeIframeSrc = function (elem, src) {
                    var loadMode2 =
                      elem.getAttribute("data-load-mode") ||
                      lazySizesCfg.iframeLoadMode;
                    loadMode2 == 0
                      ? elem.contentWindow.location.replace(src)
                      : loadMode2 == 1 && (elem.src = src);
                  },
                  handleSources = function (source) {
                    var customMedia,
                      sourceSrcset = source[_getAttribute](
                        lazySizesCfg.srcsetAttr
                      );
                    (customMedia =
                      lazySizesCfg.customMedia[
                        source[_getAttribute]("data-media") ||
                          source[_getAttribute]("media")
                      ]) && source.setAttribute("media", customMedia),
                      sourceSrcset &&
                        source.setAttribute("srcset", sourceSrcset);
                  },
                  lazyUnveil = rAFIt(function (
                    elem,
                    detail,
                    isAuto,
                    sizes,
                    isImg
                  ) {
                    var src, srcset, parent, isPicture, event, firesLoad;
                    (event = triggerEvent(elem, "lazybeforeunveil", detail))
                      .defaultPrevented ||
                      (sizes &&
                        (isAuto
                          ? addClass2(elem, lazySizesCfg.autosizesClass)
                          : elem.setAttribute("sizes", sizes)),
                      (srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr)),
                      (src = elem[_getAttribute](lazySizesCfg.srcAttr)),
                      isImg &&
                        ((parent = elem.parentNode),
                        (isPicture =
                          parent && regPicture.test(parent.nodeName || ""))),
                      (firesLoad =
                        detail.firesLoad ||
                        ("src" in elem && (srcset || src || isPicture))),
                      (event = { target: elem }),
                      addClass2(elem, lazySizesCfg.loadingClass),
                      firesLoad &&
                        (clearTimeout(resetPreloadingTimer),
                        (resetPreloadingTimer = setTimeout2(
                          resetPreloading,
                          2500
                        )),
                        addRemoveLoadEvents(elem, rafSwitchLoadingClass, !0)),
                      isPicture &&
                        forEach.call(
                          parent.getElementsByTagName("source"),
                          handleSources
                        ),
                      srcset
                        ? elem.setAttribute("srcset", srcset)
                        : src &&
                          !isPicture &&
                          (regIframe.test(elem.nodeName)
                            ? changeIframeSrc(elem, src)
                            : (elem.src = src)),
                      isImg &&
                        (srcset || isPicture) &&
                        updatePolyfill(elem, { src })),
                      elem._lazyRace && delete elem._lazyRace,
                      removeClass2(elem, lazySizesCfg.lazyClass),
                      rAF(function () {
                        var isLoaded = elem.complete && elem.naturalWidth > 1;
                        (!firesLoad || isLoaded) &&
                          (isLoaded &&
                            addClass2(elem, lazySizesCfg.fastLoadedClass),
                          switchLoadingClass(event),
                          (elem._lazyCache = !0),
                          setTimeout2(function () {
                            "_lazyCache" in elem && delete elem._lazyCache;
                          }, 9)),
                          elem.loading == "lazy" && isLoading--;
                      }, !0);
                  }),
                  unveilElement = function (elem) {
                    if (!elem._lazyRace) {
                      var detail,
                        isImg = regImg.test(elem.nodeName),
                        sizes =
                          isImg &&
                          (elem[_getAttribute](lazySizesCfg.sizesAttr) ||
                            elem[_getAttribute]("sizes")),
                        isAuto = sizes == "auto";
                      ((isAuto || !isCompleted) &&
                        isImg &&
                        (elem[_getAttribute]("src") || elem.srcset) &&
                        !elem.complete &&
                        !hasClass(elem, lazySizesCfg.errorClass) &&
                        hasClass(elem, lazySizesCfg.lazyClass)) ||
                        ((detail = triggerEvent(elem, "lazyunveilread").detail),
                        isAuto &&
                          autoSizer.updateElem(elem, !0, elem.offsetWidth),
                        (elem._lazyRace = !0),
                        isLoading++,
                        lazyUnveil(elem, detail, isAuto, sizes, isImg));
                    }
                  },
                  afterScroll = debounce2(function () {
                    (lazySizesCfg.loadMode = 3), throttledCheckElements();
                  }),
                  altLoadmodeScrollListner = function () {
                    lazySizesCfg.loadMode == 3 && (lazySizesCfg.loadMode = 2),
                      afterScroll();
                  },
                  onload = function () {
                    if (!isCompleted) {
                      if (Date2.now() - started < 999) {
                        setTimeout2(onload, 999);
                        return;
                      }
                      (isCompleted = !0),
                        (lazySizesCfg.loadMode = 3),
                        throttledCheckElements(),
                        addEventListener(
                          "scroll",
                          altLoadmodeScrollListner,
                          !0
                        );
                    }
                  };
                return {
                  _: function () {
                    (started = Date2.now()),
                      (lazysizes2.elements = document2.getElementsByClassName(
                        lazySizesCfg.lazyClass
                      )),
                      (preloadElems = document2.getElementsByClassName(
                        lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass
                      )),
                      addEventListener("scroll", throttledCheckElements, !0),
                      addEventListener("resize", throttledCheckElements, !0),
                      addEventListener("pageshow", function (e) {
                        if (e.persisted) {
                          var loadingElements = document2.querySelectorAll(
                            "." + lazySizesCfg.loadingClass
                          );
                          loadingElements.length &&
                            loadingElements.forEach &&
                            requestAnimationFrame2(function () {
                              loadingElements.forEach(function (img) {
                                img.complete && unveilElement(img);
                              });
                            });
                        }
                      }),
                      window2.MutationObserver
                        ? new MutationObserver(throttledCheckElements).observe(
                            docElem,
                            { childList: !0, subtree: !0, attributes: !0 }
                          )
                        : (docElem[_addEventListener](
                            "DOMNodeInserted",
                            throttledCheckElements,
                            !0
                          ),
                          docElem[_addEventListener](
                            "DOMAttrModified",
                            throttledCheckElements,
                            !0
                          ),
                          setInterval(throttledCheckElements, 999)),
                      addEventListener(
                        "hashchange",
                        throttledCheckElements,
                        !0
                      ),
                      [
                        "focus",
                        "mouseover",
                        "click",
                        "load",
                        "transitionend",
                        "animationend",
                      ].forEach(function (name) {
                        document2[_addEventListener](
                          name,
                          throttledCheckElements,
                          !0
                        );
                      }),
                      /d$|^c/.test(document2.readyState)
                        ? onload()
                        : (addEventListener("load", onload),
                          document2[_addEventListener](
                            "DOMContentLoaded",
                            throttledCheckElements
                          ),
                          setTimeout2(onload, 2e4)),
                      lazysizes2.elements.length
                        ? (checkElements(), rAF._lsFlush())
                        : throttledCheckElements();
                  },
                  checkElems: throttledCheckElements,
                  unveil: unveilElement,
                  _aLSL: altLoadmodeScrollListner,
                };
              })(),
              autoSizer = (function () {
                var autosizesElems,
                  sizeElement = rAFIt(function (elem, parent, event, width) {
                    var sources, i, len;
                    if (
                      ((elem._lazysizesWidth = width),
                      (width += "px"),
                      elem.setAttribute("sizes", width),
                      regPicture.test(parent.nodeName || ""))
                    )
                      for (
                        sources = parent.getElementsByTagName("source"),
                          i = 0,
                          len = sources.length;
                        i < len;
                        i++
                      )
                        sources[i].setAttribute("sizes", width);
                    event.detail.dataAttr || updatePolyfill(elem, event.detail);
                  }),
                  getSizeElement = function (elem, dataAttr, width) {
                    var event,
                      parent = elem.parentNode;
                    parent &&
                      ((width = getWidth(elem, parent, width)),
                      (event = triggerEvent(elem, "lazybeforesizes", {
                        width,
                        dataAttr: !!dataAttr,
                      })),
                      event.defaultPrevented ||
                        ((width = event.detail.width),
                        width &&
                          width !== elem._lazysizesWidth &&
                          sizeElement(elem, parent, event, width)));
                  },
                  updateElementsSizes = function () {
                    var i,
                      len = autosizesElems.length;
                    if (len)
                      for (i = 0; i < len; i++)
                        getSizeElement(autosizesElems[i]);
                  },
                  debouncedUpdateElementsSizes = debounce2(updateElementsSizes);
                return {
                  _: function () {
                    (autosizesElems = document2.getElementsByClassName(
                      lazySizesCfg.autosizesClass
                    )),
                      addEventListener("resize", debouncedUpdateElementsSizes);
                  },
                  checkElems: debouncedUpdateElementsSizes,
                  updateElem: getSizeElement,
                };
              })(),
              init = function () {
                !init.i &&
                  document2.getElementsByClassName &&
                  ((init.i = !0), autoSizer._(), loader._());
              };
            return (
              setTimeout2(function () {
                lazySizesCfg.init && init();
              }),
              (lazysizes2 = {
                cfg: lazySizesCfg,
                autoSizer,
                loader,
                init,
                uP: updatePolyfill,
                aC: addClass2,
                rC: removeClass2,
                hC: hasClass,
                fire: triggerEvent,
                gW: getWidth,
                rAF,
              }),
              lazysizes2
            );
          }
        );
      })(lazysizes)),
    lazysizes.exports
  );
}
requireLazysizes();
var ls_parentFit = { exports: {} },
  hasRequiredLs_parentFit;
function requireLs_parentFit() {
  return (
    hasRequiredLs_parentFit ||
      ((hasRequiredLs_parentFit = 1),
      (function (module) {
        (function (window2, factory) {
          if (window2) {
            var globalInstall = function () {
              factory(window2.lazySizes),
                window2.removeEventListener(
                  "lazyunveilread",
                  globalInstall,
                  !0
                );
            };
            (factory = factory.bind(null, window2, window2.document)),
              module.exports
                ? factory(requireLazysizes())
                : window2.lazySizes
                ? globalInstall()
                : window2.addEventListener("lazyunveilread", globalInstall, !0);
          }
        })(
          typeof window < "u" ? window : 0,
          function (window2, document2, lazySizes) {
            if (window2.addEventListener) {
              var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                regCssObject =
                  /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                regPicture = /^picture$/i,
                cfg = lazySizes.cfg,
                getCSS = function (elem) {
                  return getComputedStyle(elem, null) || {};
                },
                parentFit = {
                  getParent: function (element, parentSel) {
                    var parent = element,
                      parentNode = element.parentNode;
                    return (
                      (!parentSel || parentSel == "prev") &&
                        parentNode &&
                        regPicture.test(parentNode.nodeName || "") &&
                        (parentNode = parentNode.parentNode),
                      parentSel != "self" &&
                        (parentSel == "prev"
                          ? (parent = element.previousElementSibling)
                          : parentSel && (parentNode.closest || window2.jQuery)
                          ? (parent =
                              (parentNode.closest
                                ? parentNode.closest(parentSel)
                                : jQuery(parentNode).closest(parentSel)[0]) ||
                              parentNode)
                          : (parent = parentNode)),
                      parent
                    );
                  },
                  getFit: function (element) {
                    var tmpMatch,
                      parentObj,
                      css = getCSS(element),
                      content = css.content || css.fontFamily,
                      obj = {
                        fit:
                          element._lazysizesParentFit ||
                          element.getAttribute("data-parent-fit"),
                      };
                    return (
                      !obj.fit &&
                        content &&
                        (tmpMatch = content.match(regCssFit)) &&
                        (obj.fit = tmpMatch[1]),
                      obj.fit
                        ? ((parentObj =
                            element._lazysizesParentContainer ||
                            element.getAttribute("data-parent-container")),
                          !parentObj &&
                            content &&
                            (tmpMatch = content.match(regCssObject)) &&
                            (parentObj = tmpMatch[1]),
                          (obj.parent = parentFit.getParent(
                            element,
                            parentObj
                          )))
                        : (obj.fit = css.objectFit),
                      obj
                    );
                  },
                  getImageRatio: function (element) {
                    var i,
                      srcset,
                      media,
                      ratio,
                      match,
                      width,
                      height,
                      parent = element.parentNode,
                      elements =
                        parent && regPicture.test(parent.nodeName || "")
                          ? parent.querySelectorAll("source, img")
                          : [element];
                    for (i = 0; i < elements.length; i++)
                      if (
                        ((element = elements[i]),
                        (srcset =
                          element.getAttribute(cfg.srcsetAttr) ||
                          element.getAttribute("srcset") ||
                          element.getAttribute("data-pfsrcset") ||
                          element.getAttribute("data-risrcset") ||
                          ""),
                        (media =
                          element._lsMedia || element.getAttribute("media")),
                        (media =
                          cfg.customMedia[
                            element.getAttribute("data-media") || media
                          ] || media),
                        srcset &&
                          (!media ||
                            ((window2.matchMedia && matchMedia(media)) || {})
                              .matches))
                      ) {
                        (ratio = parseFloat(
                          element.getAttribute("data-aspectratio")
                        )),
                          ratio ||
                            ((match = srcset.match(regDescriptors)),
                            match
                              ? match[2] == "w"
                                ? ((width = match[1]), (height = match[3]))
                                : ((width = match[3]), (height = match[1]))
                              : ((width = element.getAttribute("width")),
                                (height = element.getAttribute("height"))),
                            (ratio = width / height));
                        break;
                      }
                    return ratio;
                  },
                  calculateSize: function (element, width) {
                    var displayRatio,
                      height,
                      imageRatio,
                      retWidth,
                      fitObj = this.getFit(element),
                      fit = fitObj.fit,
                      fitElem = fitObj.parent;
                    return fit != "width" &&
                      ((fit != "contain" && fit != "cover") ||
                        !(imageRatio = this.getImageRatio(element)))
                      ? width
                      : (fitElem
                          ? (width = fitElem.clientWidth)
                          : (fitElem = element),
                        (retWidth = width),
                        fit == "width"
                          ? (retWidth = width)
                          : ((height = fitElem.clientHeight),
                            (displayRatio = width / height) &&
                              ((fit == "cover" && displayRatio < imageRatio) ||
                                (fit == "contain" &&
                                  displayRatio > imageRatio)) &&
                              (retWidth = width * (imageRatio / displayRatio))),
                        retWidth);
                  },
                };
              (lazySizes.parentFit = parentFit),
                document2.addEventListener("lazybeforesizes", function (e) {
                  if (!(e.defaultPrevented || e.detail.instance != lazySizes)) {
                    var element = e.target;
                    e.detail.width = parentFit.calculateSize(
                      element,
                      e.detail.width
                    );
                  }
                });
            }
          }
        );
      })(ls_parentFit)),
    ls_parentFit.exports
  );
}
requireLs_parentFit();
const TRANSITION = "transition",
  ANIMATION = "animation",
  transitionEndEvent = "transitionend",
  animationEndEvent = "animationend",
  animationFrameLength = Math.ceil(1e3 / 60),
  noop = () => {};
function whenTransitionEnds(el, cb) {
  const { type, timeout, propCount } = getTransitionInfo(el);
  if (!type) return cb(), noop;
  const eventType =
    type === TRANSITION ? transitionEndEvent : animationEndEvent;
  let ended = 0,
    timeoutId = null;
  const cleanup = () => {
      timeoutId && (window.clearTimeout(timeoutId), (timeoutId = null)),
        el.removeEventListener(eventType, onEnd);
    },
    end = () => {
      cleanup(), cb();
    },
    onEnd = (e) => {
      e.target === el && ++ended >= propCount && end();
    };
  return (
    (timeoutId = window.setTimeout(() => {
      ended < propCount && end();
    }, timeout + animationFrameLength)),
    el.addEventListener(eventType, onEnd),
    () => cleanup()
  );
}
function getTransitionInfo(el) {
  const styles = window.getComputedStyle(el),
    transitionDelays = (styles.transitionDelay || "").split(", "),
    transitionDurations = (styles.transitionDuration || "").split(", "),
    transitionTimeout = getTimeout(transitionDelays, transitionDurations),
    animationDelays = (styles.animationDelay || "").split(", "),
    animationDurations = (styles.animationDuration || "").split(", "),
    animationTimeout = getTimeout(animationDelays, animationDurations),
    timeout = Math.max(transitionTimeout, animationTimeout),
    type =
      timeout > 0
        ? transitionTimeout > animationTimeout
          ? TRANSITION
          : ANIMATION
        : null,
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  return { type, timeout, propCount };
}
function getTimeout(delays, durations) {
  for (; delays.length < durations.length; ) delays = delays.concat(delays);
  return Math.max.apply(
    null,
    durations.map((d, i) => toMs(d) + toMs(delays[i]))
  );
}
function toMs(s) {
  return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
const capitalize = (word) => {
    const firstSymbol = word.slice(0, 1),
      restWordPart = word.slice(1);
    return firstSymbol.toUpperCase() + restWordPart;
  },
  delay = (delay2 = 0) =>
    new Promise((resolve, reject) => {
      setTimeout(resolve, delay2);
    }),
  viewportObserver = new IntersectionObserver((entries, _) => {
    entries.forEach((entry) => {
      const isInViewport = entry.isIntersecting,
        isParentHidden = entry.target.closest('[aria-hidden="true"], .hidden');
      entry.target.classList.toggle(
        "is-in-viewport",
        isInViewport && !isParentHidden
      );
    });
  }),
  getFocusTargets = () =>
    [
      "button:enabled",
      "input:not([type=hidden]):enabled",
      "textarea:enabled",
      "a[href]",
      "[data-focus-trap-target]",
      '[tabindex]:not([tabindex^="-"])',
    ]
      .map(
        (target) =>
          `${target}:not([data-color-swatches-hidden-count]:empty):not(.hidden)`
      )
      .join(","),
  getTargets = (element, withCarouselButtons = !0) => {
    const targets = $list(getFocusTargets(), element).filter((target) =>
        withCarouselButtons
          ? target.clientWidth > 0
          : target.clientWidth > 0 && !target.hasAttribute("data-direction")
      ),
      firstTarget = targets[0],
      lastTarget = targets[targets.length - 1];
    return { targets, firstTarget, lastTarget };
  },
  createPortal = (children, parent) => {
    let element = $el("#Portal");
    element.appendChild(children),
      (parent && parent.appendChild ? parent : document.body).appendChild(
        element
      );
  },
  isExternalLink = (href) =>
    !href.match(/^\//) && !href.includes(window.location.host),
  isCurrentPageLink = (href) => href === window.location.href,
  createPrefetchLink = (href) => {
    const link = document.createElement("link");
    link.setAttribute("rel", "prefetch"),
      link.setAttribute("href", href),
      document.head.appendChild(link);
  },
  upperCamelCaseToSnakeCase = (value) =>
    value
      .replace(/^([A-Z])/, ($1) => $1.toLowerCase())
      .replace(/([A-Z])/g, ($1) => "-" + $1.toLowerCase()),
  registerComponent = (componentClass) => {
    try {
      const name = upperCamelCaseToSnakeCase(componentClass.name);
      customElements.define(name, componentClass);
    } catch {
      console.log(`${componentClass} has not been defined`);
    }
  },
  whenDefined = (componentTag) => customElements.whenDefined(componentTag),
  transitionToPromise = (el) =>
    new Promise((resolve) => {
      whenTransitionEnds(el, () => {
        resolve(null);
      });
    }),
  $el = (selector, scope = document) => scope.querySelector(selector),
  $list = (selector, scope = document) => [...scope.querySelectorAll(selector)],
  $elParent = (selector, scope = document) => scope.closest(selector),
  isNotIframe = () => window.self === window.top,
  isNotThemeStore = () => window.self === window.top || Shopify.designMode,
  requestAnimationFrameAfterStyleAndLayout = async () =>
    new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve))),
  strToBool = (str) => /true/i.test(str),
  SHOPIFY_EVENTS = {
    SECTION_LOAD: "shopify:section:load",
    SECTION_UNLOAD: "shopify:section:unload",
    SECTION_SELECT: "shopify:section:select",
    SECTION_DESELECT: "shopify:section:deselect",
    SECTION_REORDER: "shopify:section:reorder",
    BLOCK_SELECT: "shopify:block:select",
    BLOCK_DESELECT: "shopify:block:deselect",
  },
  KEY_CONSTS = {
    ARROW_LEFT_STRING_KEY: "ArrowLeft",
    ARROW_RIGHT_STRING_KEY: "ArrowRight",
    ARROW_LEFT_NUMBER_KEY: 37,
    ARROW_RIGHT_NUMBER_KEY: 39,
    ENTER_STRING_KEY: "Enter",
    ENTER_NUMBER_KEY: 13,
    ESCAPE_STRING_KEY: "Escape",
    ESCAPE_NUMBER_KEY: 27,
    TAB_STRING_KEY: "Tab",
    TAB_NUMBER_KEY: 9,
  };
class ShopifyEditor {
  constructor() {
    __publicField(this, "listeners", {});
  }
  on(eventName, listener) {
    this.listeners[eventName] || (this.listeners[eventName] = []),
      document.addEventListener(SHOPIFY_EVENTS[eventName], listener),
      this.listeners[eventName].push(listener);
  }
  off(eventName, removedListener) {
    this.listeners[eventName] &&
      (document.removeEventListener(SHOPIFY_EVENTS[eventName], removedListener),
      (this.listeners[eventName] = this.listeners[eventName].filter(
        (listener) => listener !== removedListener
      )));
  }
  destroy() {
    Object.keys(this.listeners).forEach((event) => {
      this.listeners[event].forEach((listener) => {
        this.off(event, listener);
      });
    }),
      (this.listeners = {});
  }
}
const { Shopify: Shopify$3 } = window;
class BaseComponent extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "listeners", []);
    __publicField(this, "events", {});
    __publicField(this, "editor", new ShopifyEditor());
    __publicField(this, "isEditor", Shopify$3.designMode);
  }
  connectedCallback() {
    try {
      this.mountComponent();
    } catch (error) {
      console.log(this.tagName, "mount", error.name);
    }
  }
  disconnectedCallback() {
    try {
      this.unmountComponent();
    } catch (error) {
      console.log(this.tagName, "unmount", error.name);
    }
    this.isEditor && this.editor.destroy(), this.destroyListeners();
  }
  mountComponent() {}
  unmountComponent() {}
  on(event, listener) {
    this.events[event] || (this.events[event] = []),
      this.events[event].push(listener);
  }
  off(event, removedListener) {
    this.events[event] &&
      (this.events[event] = this.events[event].filter(
        (listener) => listener !== removedListener
      ));
  }
  emit(event, data) {
    this.events[event] &&
      this.events[event].forEach((listener) => listener(data));
  }
  addListener(element, event, listener, options) {
    !element ||
      !event ||
      !listener ||
      (element.addEventListener(event, listener, options),
      (this.listeners = [...this.listeners, { element, event, listener }]));
  }
  removeListener(targetElement, targetEvent, targetListener) {
    !targetElement ||
      !targetEvent ||
      !targetListener ||
      (targetElement.removeEventListener(targetEvent, targetListener),
      (this.listeners = this.listeners.filter(
        ({ element, event, listener }) =>
          element !== targetElement &&
          event !== targetEvent &&
          listener !== targetListener
      )));
  }
  destroyListeners() {
    this.listeners.forEach(({ element, event, listener }) => {
      element.removeEventListener(event, listener);
    }),
      (this.listeners = []);
  }
}
const QUERY_IS_MOBILE = "(max-width: 768px)",
  isMobile = () => matchMedia(QUERY_IS_MOBILE).matches,
  isTouch = () => matchMedia("(hover: none) and (pointer:coarse)").matches,
  debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t), (t = setTimeout(() => fn.apply(void 0, args), wait));
    };
  },
  throttle = (callback, timeout) => {
    let timer = null;
    return (...args) => {
      timer ||
        (timer = setTimeout(() => {
          callback(...args), clearTimeout(timer), (timer = null);
        }, timeout));
    };
  };
class FeaturedNavigation extends BaseComponent {
  constructor() {
    var _a, _b;
    super();
    __publicField(this, "elementsTemplateAttribute");
    __publicField(this, "lineAttribute");
    __publicField(this, "imageAttribute");
    __publicField(this, "buttonAttribute");
    __publicField(this, "imageActiveClass");
    __publicField(this, "buttonActiveClass");
    __publicField(this, "buttonIconAttribute");
    __publicField(this, "template");
    __publicField(this, "floatingImg");
    __publicField(this, "floatingBtn");
    __publicField(this, "container");
    __publicField(this, "lines");
    __publicField(this, "images");
    __publicField(this, "buttons");
    __publicField(this, "iconPlaceholder");
    __publicField(this, "scrollingType");
    __publicField(this, "scrollingTypeAttribute");
    __publicField(this, "imageWidth");
    __publicField(this, "imageHeight");
    __publicField(this, "buttonWidth");
    __publicField(this, "buttonHeight");
    __publicField(this, "isAnimating");
    __publicField(this, "forceStopped");
    __publicField(this, "mouseIsOn");
    __publicField(this, "isMobile");
    __publicField(this, "resizeObserver");
    __publicField(this, "activeImage");
    __publicField(this, "activeButton");
    __publicField(this, "animation");
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "mouseY");
    __publicField(this, "initDesktop", () => {
      this.initFloatingElements(),
        this.setRects(this.floatingImg, this.buttons[0]),
        this.addEventListener("mouseenter", this.handleMouseEnter),
        this.lines.forEach((line) => {
          this.scrollingType === "none"
            ? (line
                .querySelector(".featured-navigation__link-text")
                .addEventListener("mouseenter", this.handleMouseEnterLine),
              line
                .querySelector(".featured-navigation__link-text")
                .addEventListener("mouseleave", this.handleMouseLeaveLine))
            : line.addEventListener("mouseenter", this.handleMouseEnterLine);
        });
    });
    __publicField(this, "deInitDesktop", () => {
      this.deinitFloatingElements(),
        this.removeEventListener("mouseenter", this.handleMouseEnter),
        this.lines.forEach((line) => {
          this.scrollingType === "none"
            ? (line
                .querySelector(".featured-navigation__link-text")
                .removeEventListener("mouseenter", this.handleMouseEnterLine),
              line
                .querySelector(".featured-navigation__link-text")
                .removeEventListener("mouseleave", this.handleMouseLeaveLine))
            : line.removeEventListener("mouseenter", this.handleMouseEnterLine);
        }),
        document.removeEventListener("mousemove", this.handleMouseMove);
    });
    __publicField(this, "initFloatingElements", () => {
      (this.activeImage = this.floatingImg.cloneNode(!0)),
        (this.activeButton = this.floatingBtn.cloneNode(!0)),
        this.container.appendChild(this.activeImage),
        this.container.appendChild(this.activeButton),
        this.scaleDown();
    });
    __publicField(this, "deinitFloatingElements", () => {
      this.activeImage.remove(), this.activeButton.remove();
    });
    __publicField(this, "handleMouseEnterLine", (event) => {
      const { targetImage, targetButton } = this.getTargetImageAndButton(event);
      this.replaceFloatingElementsData(targetImage, targetButton),
        (this.forceStopped = !1),
        this.isAnimating || this.handleMouseEnter(event);
    });
    __publicField(this, "handleMouseLeaveLine", () => {
      this.scaleDown();
    });
    __publicField(
      this,
      "replaceFloatingElementsData",
      (imageData, buttonData) => {
        imageData
          ? ((this.activeImage.src =
              imageData == null ? void 0 : imageData.src),
            (this.activeImage.srcset =
              imageData == null ? void 0 : imageData.srcset),
            (this.activeImage.style.maxHeight = `${
              imageData.getBoundingClientRect().height
            }px`),
            (this.activeImage.style.height = "100%"),
            this.toggleImageActiveClass(this.activeImage, "add"),
            (this.activeImage.style.opacity = "1"))
          : (this.toggleImageActiveClass(this.activeImage, "add"),
            (this.activeImage.style.opacity = "0")),
          buttonData
            ? (buttonData.hasAttribute("data-button-without-text")
                ? this.activeButton.replaceChildren(this.iconPlaceholder)
                : (this.activeButton.textContent = buttonData.textContent),
              (this.activeButton.className = `${buttonData.className} ${this.buttonActiveClass}`),
              (this.activeButton.href = buttonData.href),
              this.toggleButtonActiveClass(this.activeButton, "add"),
              (this.activeButton.style.opacity = "1"))
            : (this.activeButton.style.opacity = "0"),
          this.scaleUp(),
          this.setRects(imageData, buttonData);
      }
    );
    __publicField(this, "handleMouseEnter", (event) => {
      (this.activeImage.style.translate = `${
        event.clientX - this.imageWidth
      }px ${event.clientY - this.imageHeight}px`),
        (this.activeButton.style.translate = `${
          event.clientX - this.buttonWidth
        }px ${event.clientY - this.buttonHeight}px`),
        this.mouseIsOn ||
          (document.addEventListener("mousemove", this.handleMouseMove),
          this.toggleScrollListener(!0)),
        (this.mouseIsOn = !0);
    });
    __publicField(this, "handleMouseLeave", () => {
      this.scaleDown(), this.toggleScrollListener(!1);
    });
    __publicField(this, "toggleScrollListener", (add) => {
      add
        ? this.addListener(window, "scroll", this.handleScroll)
        : this.removeListener(window, "scroll", this.handleScroll);
    });
    __publicField(
      this,
      "handleScroll",
      debounce(() => {
        const { top, bottom } = this.getBoundingClientRect();
        (this.mouseY < top || this.mouseY > bottom) && this.handleMouseLeave();
      }, 100)
    );
    __publicField(this, "handleMouseMove", (event) => {
      if (!this.forceStopped) {
        const target = event.target;
        (target === this.container || !target.closest("featured-navigation")) &&
          this.handleMouseLeave();
        const { x, y, mouseY } = this.getMouseCoordinates(
          event.clientX,
          event.clientY
        );
        (this.x = x),
          (this.y = y),
          (this.mouseY = mouseY),
          this.isAnimating || this.startAnimation();
      }
    });
    __publicField(this, "startAnimation", () => {
      (this.isAnimating = !0),
        (this.animation = requestAnimationFrame(this.tick));
    });
    __publicField(this, "stopAnimation", () => {
      (this.isAnimating = !1),
        cancelAnimationFrame(this.animation),
        this.activeImage.style.scale === "0" &&
          this.activeButton.style.scale === "0" &&
          ((this.forceStopped = !0),
          this.toggleImageActiveClass(this.activeImage, "remove"),
          this.toggleButtonActiveClass(this.activeButton, "remove"),
          document.removeEventListener("mousemove", this.handleMouseMove),
          (this.mouseIsOn = !1));
    });
    __publicField(this, "tick", (time) => {
      const { x, y, width } = this.activeImage
          ? this.activeImage.getBoundingClientRect()
          : this.activeButton.getBoundingClientRect(),
        targetXimage = +(this.x - x).toFixed(3),
        targetYimage = +(this.y - y).toFixed(3),
        targetXbutton = targetXimage + this.imageWidth - this.buttonWidth,
        targetYbutton = targetYimage + this.imageHeight - this.buttonHeight;
      this.draw(
        targetXimage + x,
        targetYimage + y,
        targetXbutton + x,
        targetYbutton + y
      ),
        targetXimage !== 0 && targetYimage !== 0 && width > 0
          ? (this.animation = requestAnimationFrame(this.tick))
          : this.stopAnimation();
    });
    __publicField(this, "draw", (imageX, imageY, buttonX, buttonY) => {
      (this.activeImage.style.translate = `${imageX}px ${imageY}px`),
        (this.activeButton.style.translate = `${buttonX}px ${buttonY}px`);
    });
    __publicField(this, "getTargetImageAndButton", (event) => {
      const targetLine = event.currentTarget,
        id = targetLine.dataset.navigationLine || targetLine.dataset.lineId,
        targetImage = this.images.find(
          (img) => img.dataset.navigationLineImage === id
        ),
        targetButton = this.buttons.find(
          (btn) => btn.dataset.navigationLineButton === id
        );
      return { targetImage, targetButton };
    });
    __publicField(this, "setRects", (targetImage, targetButton) => {
      (this.imageWidth = this.activeImage.offsetWidth / 2),
        (this.imageHeight = targetImage
          ? targetImage.scrollHeight / 2
          : this.activeImage.offsetHeight / 2),
        (this.buttonWidth =
          (targetButton == null ? void 0 : targetButton.offsetWidth) / 2),
        (this.buttonHeight =
          (targetButton == null ? void 0 : targetButton.offsetHeight) / 2);
    });
    __publicField(this, "getMouseCoordinates", (x, y) => ({
      x: x - this.imageWidth,
      y: y - this.imageHeight,
      mouseY: y,
    }));
    __publicField(this, "toggleButtonActiveClass", (element, action) => {
      element == null ||
        element.classList.toggle(this.buttonActiveClass, action === "add");
    });
    __publicField(this, "toggleImageActiveClass", (element, action) => {
      element == null ||
        element.classList.toggle(this.imageActiveClass, action === "add");
    });
    __publicField(this, "scaleUp", () => {
      (this.activeImage.style.scale = "1"),
        (this.activeButton.style.scale = "1");
    });
    __publicField(this, "scaleDown", () => {
      (this.activeImage.style.scale = "0"),
        (this.activeButton.style.scale = "0");
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        isMobile() !== this.isMobile &&
          (isMobile() ? this.deInitDesktop() : this.initDesktop(),
          (this.isMobile = isMobile()));
      }, 200)
    );
    (this.elementsTemplateAttribute = "[data-elements-template]"),
      (this.lineAttribute = "[data-navigation-line]"),
      (this.imageAttribute = "[data-navigation-line-image]"),
      (this.buttonAttribute = "[data-navigation-line-button]"),
      (this.imageActiveClass = "featured-navigation__link-image--active"),
      (this.buttonActiveClass = "featured-navigation__btn--active"),
      (this.buttonIconAttribute = "[data-button-without-text]"),
      (this.scrollingTypeAttribute = "data-scrolling-type"),
      (this.template = this.querySelector(this.elementsTemplateAttribute)),
      (this.floatingImg = this.template.content.querySelector(
        this.imageAttribute
      )),
      (this.floatingBtn = this.template.content.querySelector(
        this.buttonAttribute
      )),
      (this.container = this.querySelector(".container")),
      (this.lines = this.querySelectorAll(this.lineAttribute)),
      (this.images = $list(this.imageAttribute, this)),
      (this.buttons = $list(this.buttonAttribute, this)),
      (this.iconPlaceholder =
        (_b =
          (_a = $el(this.buttonIconAttribute, this)) == null
            ? void 0
            : _a.firstElementChild) == null
          ? void 0
          : _b.cloneNode(!0)),
      (this.scrollingType = this.getAttribute(this.scrollingTypeAttribute)),
      (this.isAnimating = !1),
      (this.forceStopped = !0),
      (this.isMobile = isMobile()),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this);
  }
  connectedCallback() {
    this.isMobile || this.initDesktop();
  }
  disconnectedCallback() {
    this.deInitDesktop();
  }
}
const CONTENT_WRAP_SELECTOR = "[data-accordeon-content-wrap]",
  CONTENT_SELECTOR$2 = "[data-accordeon-content]",
  BODY_ELEMENT_SELECTOR$c = "body-element";
class AccordeonComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "isExpanded");
    __publicField(this, "handleAccordeonFocusout", () => {
      const bodyElement = $el(BODY_ELEMENT_SELECTOR$c);
      !this.isExpanded && bodyElement.isUsingKeyboard && this.show();
    });
    __publicField(this, "handleResize", () => {
      this.updateHeight();
    });
  }
  mountComponent() {
    const content = $el(CONTENT_SELECTOR$2, this);
    (this.isExpanded = this.getAttribute("data-aria-expanded") === "true"),
      this.updateHeight(),
      this.addListener(this, "focusout", this.handleAccordeonFocusout),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(content);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  hide() {
    this.setExpand(!1), this.emit("hide", { blockId: this.dataset.blockId });
  }
  show() {
    this.setExpand(!0), this.emit("show", { blockId: this.dataset.blockId });
  }
  toggle() {
    this.setExpand(!this.isExpanded),
      this.emit("toggle", { blockId: this.dataset.blockId });
  }
  updateHeight() {
    const contentWrap = $el(CONTENT_WRAP_SELECTOR, this),
      content = $el(CONTENT_SELECTOR$2, this);
    content &&
      (contentWrap.style.maxHeight = `${Math.ceil(
        this.isExpanded ? content.scrollHeight : 0
      )}px`);
  }
  setExpand(isExpanded) {
    (this.isExpanded = isExpanded),
      this.setAttribute("data-aria-expanded", isExpanded ? "true" : "false"),
      this.updateHeight();
  }
}
const isEnterKey = (event) => {
    const key = event.key || event.keyCode;
    return (
      key === KEY_CONSTS.ENTER_NUMBER_KEY || key === KEY_CONSTS.ENTER_STRING_KEY
    );
  },
  isEscKey = (event) => {
    const key = event.key || event.keyCode;
    return (
      key === KEY_CONSTS.ESCAPE_STRING_KEY ||
      key === KEY_CONSTS.ESCAPE_NUMBER_KEY
    );
  },
  isRightKey = (event) => {
    const key = event.key || event.keyCode;
    return (
      key === KEY_CONSTS.ARROW_RIGHT_NUMBER_KEY ||
      key === KEY_CONSTS.ARROW_RIGHT_STRING_KEY
    );
  },
  isLeftKey = (event) => {
    const key = event.key || event.keyCode;
    return (
      key === KEY_CONSTS.ARROW_LEFT_NUMBER_KEY ||
      key === KEY_CONSTS.ARROW_LEFT_STRING_KEY
    );
  },
  isTabKey = (event) => {
    const key = event.key || event.keyCode;
    return (
      key === KEY_CONSTS.TAB_NUMBER_KEY || key === KEY_CONSTS.TAB_STRING_KEY
    );
  },
  ACCORDEON_SELECTOR$1 = "accordeon-component";
class AccordeonButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.toggle();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.toggle());
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleButtonClick),
      this.addListener(this, "keydown", this.handleKeyDown);
  }
  toggle() {
    const accordeon = $elParent(ACCORDEON_SELECTOR$1, this);
    accordeon == null || accordeon.toggle();
  }
}
const BUTTON_SELECTOR$7 = "[data-back-to-top-button]";
class BackToTopButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "lastPosition", 0);
    __publicField(
      this,
      "handleWindowScroll",
      throttle(() => {
        const button = $el(BUTTON_SELECTOR$7, this),
          { scrollY, innerHeight: innerHeight2 } = window;
        button == null ||
          button.classList.toggle(
            "is-visible",
            scrollY > innerHeight2 && scrollY < this.lastPosition
          ),
          (this.lastPosition = scrollY === 0 ? this.lastPosition + 1 : scrollY);
      }, 200)
    );
    __publicField(this, "handleButtonClick", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    __publicField(this, "handleKeydown", (event) => {
      if (isEnterKey(event)) {
        const skipContent = $el("#SkipContent");
        window.scrollTo({ top: 0, behavior: "instant" }), skipContent.focus();
      }
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeydown),
      this.addListener(this, "click", this.handleButtonClick),
      this.addListener(window, "scroll", this.handleWindowScroll);
  }
}
const COLLECTION_LINK_SELECTOR = "[data-collection-link]";
class ProductBreadcrumbs extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "setCollectionPage", (collectionPage) => {
      if (collectionPage) {
        const link = $el(COLLECTION_LINK_SELECTOR, this);
        if (link) {
          const data = JSON.parse(collectionPage);
          (link.href = data.url),
            (link.ariaLabel = data.title),
            (link.textContent = data.title);
        }
      }
    });
  }
}
const showElement = (element) => {
    element && element.classList.remove("hidden");
  },
  hideElement = (element) => {
    element && element.classList.add("hidden");
  },
  getTemplateContent = (template) => template.content.cloneNode(!0),
  getTemplateFirstChild = (template) =>
    template == null
      ? void 0
      : template.content.firstElementChild.cloneNode(!0),
  setStyleVariable = (variable, value) => {
    document.documentElement.style.setProperty(`--gsc-${variable}`, value);
  },
  removeStyleVariable = (variable) => {
    document.documentElement.style.removeProperty(`--gsc-${variable}`);
  },
  parseHTML = (html) => new DOMParser().parseFromString(html, "text/html"),
  replaceNodeChildren = (node, newNode) => {
    newNode &&
      node &&
      node.replaceChildren(...newNode.cloneNode(!0).childNodes);
  },
  POPUP_ANIMATION_DELAY = 750,
  wildcardToRegExp = (wildcardPattern, flags) => {
    const regexMatch = /^\/(.+)\/([im]+)?$/.exec(wildcardPattern);
    if (regexMatch) return new RegExp(regexMatch[1], regexMatch[2] || flags);
    const pattern = wildcardPattern
      .replace(/[\-\[\]\/{}()?.\\^$|]/g, "\\$&")
      .replace(/\*/g, ".*?")
      .replace(/\+/g, ".+?");
    return new RegExp(`^${pattern}$`, flags);
  },
  gradientOpacity = (gradient, opacity) => {
    try {
      const colors = gradient.match(/rgba\([^()]*\)|#\w+/g);
      return (
        colors == null ||
          colors.forEach((color) => {
            const [r, g, b, a] = color
                .split("(")[1]
                .split(")")[0]
                .split(",")
                .map((c) => c.trim()),
              alpha = +a * +opacity;
            gradient = gradient.replace(
              color,
              `rgba(${r}, ${g}, ${b}, ${Math.round(alpha * 100) / 100})`
            );
          }),
        gradient
      );
    } catch {
      return gradient;
    }
  },
  isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
class BodyElement extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "notification");
    __publicField(this, "overlayCalls", []);
    __publicField(this, "isScrolling", !1);
    __publicField(this, "timeoutScrollId");
    __publicField(this, "removeOverlayTimeoutId");
    __publicField(this, "prefetchedLinks", []);
    __publicField(this, "isVisible");
    __publicField(this, "isFixed");
    __publicField(this, "fixedTopPosition");
    __publicField(this, "openedDialogWindows", []);
    __publicField(this, "lastFocusedTarget");
    __publicField(this, "currentFocusEl");
    __publicField(this, "isUsingKeyboard", !1);
    __publicField(this, "zIndex");
    __publicField(this, "scrollbarWidth");
    __publicField(this, "isOpenedOnFirefox");
    __publicField(this, "withGradient");
    __publicField(this, "handleMousedown", () => {
      this.setUsingKeyboard(!1);
    });
    __publicField(this, "handleKeydown", () => {
      this.setUsingKeyboard(!0);
    });
    __publicField(this, "handleFocusout", (event) => {
      const focusTarget = event.relatedTarget;
      focusTarget && (this.currentFocusEl = focusTarget);
    });
    __publicField(this, "handleWindowWheel", () => {
      this.timeoutScrollId &&
        (clearTimeout(this.timeoutScrollId), (this.isScrolling = !0)),
        (this.timeoutScrollId = setTimeout(() => {
          this.isScrolling = !1;
        }, 200));
    });
    __publicField(this, "handleLinkOver", (event) => {
      const link = $elParent("a[href]", event.target),
        href = link == null ? void 0 : link.href;
      if (
        !href ||
        (link != null && link.hasAttribute("without-prefetch-on-hover"))
      )
        return;
      const wasPrefetched = this.prefetchedLinks.includes(href),
        isNotPrefetchetable = isExternalLink(href) || isCurrentPageLink(href);
      wasPrefetched ||
        isNotPrefetchetable ||
        (createPrefetchLink(href), this.prefetchedLinks.push(href));
    });
    __publicField(this, "handlePageChange", () => {
      this.showLoadingOverlay("#GlobalLoadingOverlayDots");
    });
    __publicField(this, "handlePageHide", () => {
      this.removeLoadingOverlay("#GlobalLoadingOverlayDots");
    });
    __publicField(this, "handlePageShow", () => {
      this.removeLoadingOverlay("#GlobalLoadingOverlayDots");
    });
    __publicField(this, "showLoadingOverlay", (selector) => {
      this.setScrollLock();
      const loadingOverlay = $el(selector);
      loadingOverlay.classList.remove("hidden"),
        requestAnimationFrame(() => {
          loadingOverlay.style.opacity = "1";
        });
    });
    __publicField(this, "removeLoadingOverlay", async (selector) => {
      const loadingOverlay = $el(selector);
      loadingOverlay.classList.contains("hidden") ||
        ((loadingOverlay.style.opacity = "0"),
        await transitionToPromise(loadingOverlay),
        loadingOverlay.classList.add("hidden"),
        this.unsetScrollLock());
    });
    __publicField(this, "showNotification", (text, variant, duration) => {
      $el("#GlobalNotification").show(text, variant, duration);
    });
    __publicField(this, "setZindexVariable", () => {
      setStyleVariable("body-overlay-zIndex", this.zIndex);
    });
    __publicField(this, "removeZindexVariable", () => {
      removeStyleVariable("body-overlay-zIndex");
    });
    __publicField(this, "setRegistrationMessage", () => {
      const isCaptchaPage = window.location.pathname.includes("challenge"),
        isAccountPage = window.location.pathname.includes("account");
      !isCaptchaPage &&
        !isAccountPage &&
        localStorage.getItem("isRegistered") &&
        whenDefined("notification-component").then(() => {
          const message = window.auroraThemeLocales.registrationMessage;
          $el("#GlobalNotification").show(message, "success", 1e4),
            localStorage.removeItem("isRegistered");
        });
    });
    __publicField(this, "setGradientOverlay", () => {
      this.hasAttribute("data-gradient") &&
        !this.withGradient &&
        (this.parentElement.setAttribute(
          "style",
          `--gsc-gradient-overlay: ${gradientOpacity(
            this.dataset.gradient,
            this.dataset.opacity
          )}`
        ),
        (this.withGradient = !0));
    });
    __publicField(this, "logThemeData", () => {

    });
  }
  mountComponent() {
    this.setBreadcrumbs(),
      this.setViewportObserver(),
      this.setRegistrationMessage(),
      this.setNotification(),
      this.setThemeInfo(),
      (this.isFixed = !1),
      this.addListener(window, "wheel", this.handleWindowWheel),
      this.addListener(window, "beforeunload", this.handlePageChange),
      this.addListener(window, "pagehide", this.handlePageHide),
      this.addListener(window, "pageshow", this.handlePageShow),
      this.addListener(document, "mouseover", this.handleLinkOver),
      this.addListener(document, "mousedown", this.handleMousedown),
      this.addListener(document, "keydown", this.handleKeydown),
      this.addListener(document, "focusout", this.handleFocusout),
      this.removeLoadingOverlay("#GlobalLoadingOverlayDots"),
      (this.removeOverlayTimeoutId = setTimeout(() => {
        this.removeLoadingOverlay("#GlobalLoadingOverlayDots");
      }, 5e3)),
      this.setGradientOverlay(),
      this.logThemeData();
  }
  unmountComponent() {
    clearTimeout(this.timeoutScrollId),
      clearTimeout(this.removeOverlayTimeoutId);
  }
  addDialogWindow(newWindowId) {
    this.openedDialogWindows.length === 0 &&
      this.openedDialogWindows.every(
        (windowId) => !this.currentFocusEl.closest(`[id="${windowId}"]`)
      ) &&
      (this.lastFocusedTarget = this.currentFocusEl || $el("#MainContent")),
      this.openedDialogWindows.includes(newWindowId) ||
        (this.openedDialogWindows = [...this.openedDialogWindows, newWindowId]);
  }
  removeDialogWindow(removedWindowId) {
    this.openedDialogWindows = this.openedDialogWindows.filter(
      (windowId) => windowId !== removedWindowId
    );
    const lastOpenedWindowId =
      this.openedDialogWindows[this.openedDialogWindows.length - 1];
    if (lastOpenedWindowId) {
      const lastOpenedWindow = $el(`#${lastOpenedWindowId}`),
        { firstTarget } = getTargets(lastOpenedWindow);
      firstTarget == null || firstTarget.focus();
    } else
      this.lastFocusedTarget &&
        (this.lastFocusedTarget.focus(), (this.lastFocusedTarget = null));
  }
  isLastOpenedWindow(windowId) {
    return (
      this.openedDialogWindows[this.openedDialogWindows.length - 1] === windowId
    );
  }
  setUsingKeyboard(usingKeyboard) {
    document.body.classList.toggle("using-keyboard", usingKeyboard),
      (this.isUsingKeyboard = usingKeyboard);
  }
  setBreadcrumbs() {
    if (window.location.pathname.includes("products")) {
      customElements.define("product-breadcrumbs", ProductBreadcrumbs);
      const breadcrumbs = $list("product-breadcrumbs");
      if (breadcrumbs.length) {
        const page = localStorage.getItem("prevCollectionPage");
        breadcrumbs.forEach((el) => el.setCollectionPage(page)),
          localStorage.removeItem("prevCollectionPage");
      }
    } else
      window.location.pathname.includes("collections") ||
        localStorage.removeItem("prevCollectionPage");
  }
  setViewportObserver() {
    $list(".shopify-section").forEach((section) => {
      viewportObserver.observe(section);
    });
  }
  setThemeInfo() {
    window.auroraTheme = {
      ...window.auroraTheme,
      theme_version: "5.0.1",
      id: window.Shopify.theme.id,
      storeId: window.Shopify.theme.theme_store_id,
      isLicenseTheme: !!window.Shopify.theme.theme_store_id,
    };
  }
  setNotification() {
    const notification = $el("#GlobalNotification");
    if (!notification || !window.notification) return;
    const { text, variant, duration } = window.notification;
    notification.show(text, variant, duration);
  }
  showOverlay(key, styles) {
    (this.zIndex = styles.zIndex ?? 3),
      this.setScrollLock(),
      this.setZindexVariable(),
      this.setOverlayStyles(styles),
      styles.backdropFilter && this.classList.add("with-custom-background"),
      this.classList.add("visible"),
      (this.isVisible = !0),
      (this.overlayCalls = [...this.overlayCalls, { key, styles }]);
  }
  async hideOverlay(key) {
    if (!this.isVisible) return;
    this.overlayCalls = this.overlayCalls.filter(
      (overlayCall) => overlayCall.key !== key
    );
    const lastCall = this.overlayCalls[this.overlayCalls.length - 1];
    lastCall
      ? this.setOverlayStyles(lastCall.styles)
      : ((this.isVisible = !1),
        this.setOverlayZindex(),
        await transitionToPromise(this),
        this.isVisible === !1 &&
          (this.unsetScrollLock(),
          this.classList.remove("visible"),
          this.classList.remove("with-custom-background"),
          await transitionToPromise(this),
          this.removeZindexVariable()));
  }
  setScrollLock() {
    (this.isFixed = !0),
      isFirefox
        ? ((this.scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth),
          this.isOpenedOnFirefox ||
            (document.body.style.paddingRight = `${this.scrollbarWidth}px`),
          document.body.classList.add("scroll-y-off-firefox"),
          (this.isOpenedOnFirefox = !0))
        : ((this.fixedTopPosition = window.scrollY || this.fixedTopPosition),
          (document.body.style.top = `-${this.fixedTopPosition}px`),
          document.body.classList.add("scroll-y-off"));
  }
  unsetScrollLock() {
    this.isFixed &&
      ((this.isFixed = !1),
      isFirefox
        ? ((document.body.style.paddingRight = ""),
          document.body.classList.remove("scroll-y-off-firefox"),
          (this.isOpenedOnFirefox = !1))
        : ((document.body.style.top = ""),
          document.body.classList.remove("scroll-y-off"),
          this.fixedTopPosition &&
            (window.scrollTo(0, this.fixedTopPosition),
            (this.fixedTopPosition = void 0))));
  }
  setOverlayStyles(styles = {}) {
    Object.keys(styles).forEach((key) => {
      this.style[key] = styles[key];
    });
  }
  setOverlayZindex() {
    this.setAttribute("style", `z-index: ${this.zIndex};`);
  }
}
class Card extends BaseComponent {}
const QUICK_VIEW_BUTTON_SELECTOR$2 = "[data-product-card-quick-view-button]",
  QUICK_VIEW_SELECTOR$2 = "#Quick-view";
class HorizontalProductCard extends Card {
  constructor() {
    super(...arguments);
    __publicField(this, "handleQuickViewBtnKeyDown", async (event) => {
      isEnterKey(event) && (event.preventDefault(), this.callQuickView(!0));
    });
    __publicField(this, "handleQuickViewBtnClick", async () => {
      this.callQuickView(!0);
    });
    __publicField(this, "handleProductCardEnter", () => {
      this.callQuickView(!1);
    });
  }
  mountComponent() {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR$2, this);
    this.addListener(quickViewBtn, "keydown", this.handleQuickViewBtnKeyDown),
      this.addListener(quickViewBtn, "click", this.handleQuickViewBtnClick),
      this.addListener(this, "mouseenter", this.handleProductCardEnter);
  }
  async callQuickView(withOpen) {
    const quickView = $el(QUICK_VIEW_SELECTOR$2),
      url = this.dataset.url,
      id = this.dataset.id;
    !quickView ||
      !url ||
      !id ||
      (await quickView.requestProductFromUrl(url, id),
      withOpen &&
        (this.setQuickViewLoading(!0),
        await quickView.openAndRenderProductByUrl(url),
        this.setQuickViewLoading(!1)));
  }
  setQuickViewLoading(isLoading) {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR$2, this);
    quickViewBtn &&
      (quickViewBtn.classList.toggle("loading", isLoading),
      quickViewBtn.toggleAttribute("disabled", isLoading));
  }
}
const QUICK_VIEW_BUTTON_SELECTOR$1 = "[data-product-card-quick-view-button]",
  PRELOADER_SELECTOR$3 = "[data-product-card-preloader]",
  BUTTONS_SELECTOR = "[data-product-card-buttons]",
  FEATURED_MEDIA_SELECTOR = "[data-product-card-featured-image]",
  COLOR_SWATCHES_SELECTOR = "[data-product-card-color-swatches]",
  INNER_SELECTOR = "[data-product-card-inner]",
  QUICK_VIEW_SELECTOR$1 = "#Quick-view",
  MAIN_MEDIA_SELECTOR$1 = "[data-main-media]",
  DYNAMIC_DOTS_SELECTOR = ".product-card__dynamic-dots",
  SWITCH_VISIBLE_DOTS_OFFSET_WIDTH_THRESHOLD = 160;
class ProductCard extends Card {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "buttonsWidth", 0);
    __publicField(this, "buttonsHeight", 0);
    __publicField(this, "carouselInited");
    __publicField(this, "playingVideo");
    __publicField(this, "handleQuickViewBtnKeyDown", async (event) => {
      isEnterKey(event) && (event.preventDefault(), this.callQuickView(!0));
    });
    __publicField(this, "handleQuickViewBtnClick", async () => {
      this.callQuickView(!0);
    });
    __publicField(this, "handleProductCardEnter", () => {
      this.callQuickView(!1);
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        const buttons = $el(BUTTONS_SELECTOR, this),
          swatches = $el(COLOR_SWATCHES_SELECTOR, this);
        buttons && this.setButtonsOverflow(),
          swatches && swatches.update(),
          isMobile() && this.initMobileCarousel(),
          $list(DYNAMIC_DOTS_SELECTOR, this).forEach((dots) =>
            dots.changeVisibleDots(
              this.offsetWidth < SWITCH_VISIBLE_DOTS_OFFSET_WIDTH_THRESHOLD
                ? 3
                : 5
            )
          );
      }, 250)
    );
    __publicField(this, "handleMediaLoad", () => {
      const loader = $el(PRELOADER_SELECTOR$3, this);
      hideElement(loader);
    });
    __publicField(this, "initMobileCarousel", () => {
      var _a;
      if (this.carouselInited) return;
      const carousel = $el("carousel-component", this);
      if (!carousel) return;
      $el("video", carousel) &&
        ((_a = carousel.embla) == null ||
          _a.on("select", this.handleCarouselSelect),
        (this.carouselInited = !0));
    });
    __publicField(
      this,
      "handleCarouselSelect",
      debounce((embla) => {
        this.playingVideo &&
          (this.playingVideo.pause(), (this.playingVideo = null));
        const currentSlide =
          embla.slideNodes()[embla.selectedScrollSnap()].firstElementChild;
        currentSlide.tagName === "VIDEO" &&
          (currentSlide.play(), (this.playingVideo = currentSlide));
      }, 100)
    );
  }
  mountComponent() {
    const quickViewBtnList = $list(QUICK_VIEW_BUTTON_SELECTOR$1, this),
      featuredImages = $list(FEATURED_MEDIA_SELECTOR, this);
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this),
      featuredImages.forEach((featuredImage) => {
        featuredImage.complete ||
        featuredImage.readyState === 4 ||
        featuredImage.tagName === "IFRAME"
          ? this.handleMediaLoad()
          : (this.addListener(featuredImage, "load", this.handleMediaLoad),
            this.addListener(
              featuredImage,
              "loadeddata",
              this.handleMediaLoad
            ));
      }),
      quickViewBtnList.forEach((quickViewBtn) => {
        this.addListener(quickViewBtn, "click", this.handleQuickViewBtnClick),
          this.addListener(
            quickViewBtn,
            "keydown",
            this.handleQuickViewBtnKeyDown
          );
      }),
      this.addListener(this, "mouseenter", this.handleProductCardEnter);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  async callQuickView(withOpen) {
    const quickView = $el(QUICK_VIEW_SELECTOR$1),
      url = this.dataset.url,
      id = this.dataset.id;
    !quickView ||
      !url ||
      !id ||
      (await quickView.requestProductFromUrl(url, id),
      withOpen &&
        (this.setQuickViewLoading(!0),
        await quickView.openAndRenderProductByUrl(url),
        this.setQuickViewLoading(!1)));
  }
  setButtonsOverflow() {
    const buttons = $el(BUTTONS_SELECTOR, this),
      inner = $el(INNER_SELECTOR, this);
    if (!buttons || this.offsetWidth < this.buttonsWidth) return;
    const isWidthOverflow = buttons.offsetWidth > inner.offsetWidth,
      isHeightOverflow = buttons.offsetHeight > inner.offsetHeight;
    isWidthOverflow &&
      buttons.offsetWidth > this.buttonsWidth &&
      (this.buttonsWidth = buttons.offsetWidth),
      isHeightOverflow &&
        buttons.offsetHeight > this.buttonsHeight &&
        (this.buttonsHeight = buttons.offsetHeight),
      buttons.classList.toggle("is-width-overflowed", isWidthOverflow),
      buttons.classList.toggle("is-height-overflowed", isHeightOverflow);
  }
  setQuickViewLoading(isLoading) {
    $list(QUICK_VIEW_BUTTON_SELECTOR$1, this).forEach((quickViewBtn) => {
      quickViewBtn.classList.toggle("loading", isLoading),
        quickViewBtn.toggleAttribute("disabled", isLoading);
    });
  }
  getMainMedia() {
    return $list(MAIN_MEDIA_SELECTOR$1, this).filter(
      (item) => item.offsetWidth > 0
    )[0];
  }
}
const HIDDEN_COUNT_SELECTOR = "[data-color-swatches-hidden-count]",
  LABEL_SELECTOR$2 = "[data-color-swatches-label]",
  ITEM_SELECTOR$4 = "[data-color-swatches-item]",
  PRODUCT_CARD_SELECTOR$1 = "product-card",
  STACK_CLASS = "color-swatches--stack";
class ColorSwatches extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "productCard");
    __publicField(this, "currentVisibleImage");
    __publicField(this, "images");
    __publicField(this, "mediaQueryList");
    __publicField(this, "setStackClass", () => {
      this.classList.toggle(
        STACK_CLASS,
        (this.dataset.stack === "mobile_only" && isMobile()) ||
          (this.dataset.stack === "desktop_only" && !isMobile()) ||
          this.dataset.stack == "desktop_and_mobile"
      );
    });
    __publicField(this, "hasStackClass", () =>
      this.classList.contains(STACK_CLASS)
    );
    __publicField(this, "handleBreakpointChange", () => this.setStackClass());
    __publicField(
      this,
      "handleSwatchesLeave",
      debounce(() => {
        this.images.forEach((img) => {
          this.setImageVisible(img, img.hasAttribute("data-main-media"));
        }),
          this.reset();
      }, 100)
    );
    __publicField(
      this,
      "handleSwatchEnter",
      debounce((event) => {
        if (!this.productCard) return;
        const item = $elParent(ITEM_SELECTOR$4, event.target);
        if (!item) return;
        const variantId = item.dataset.variantId,
          image = $el(`img[data-variant-id="${variantId}"]`, this.productCard),
          color = item.dataset.color;
        color && this.updateLabel(color),
          !(!image || !this.productCard.getMainMedia() || !color) &&
            (this.images.forEach((img) => {
              this.setImageVisible(img, img === image);
            }),
            this.setHoverStatus(!0),
            (this.currentVisibleImage = image));
      }, 10)
    );
    __publicField(this, "leave", () => {
      this.currentVisibleImage &&
        this.setImageVisible(this.currentVisibleImage, !1),
        this.productCard.getMainMedia() &&
          this.setImageVisible(this.productCard.getMainMedia(), !0),
        this.reset();
    });
    __publicField(this, "reset", () => {
      this.setHoverStatus(!1), this.updateLabel("");
    });
    __publicField(this, "toggleSwatchVisibility", (swatch, isHidden) => {
      swatch.classList.toggle("hidden-swatch", isHidden),
        swatch.setAttribute("tabindex", isHidden ? "-1" : "0");
    });
    (this.productCard = $elParent(PRODUCT_CARD_SELECTOR$1, this)),
      (this.images = $list(
        "img[data-variant-id], [data-main-media]",
        this.productCard
      )),
      (this.mediaQueryList = matchMedia(QUERY_IS_MOBILE)),
      this.setStackClass();
  }
  mountComponent() {
    this.setOffsets(),
      this.update(),
      this.addListener(this, "mousemove", this.handleSwatchEnter),
      this.addListener(this, "mouseleave", this.handleSwatchesLeave),
      this.mediaQueryList.addEventListener(
        "change",
        this.handleBreakpointChange
      );
  }
  unmountComponent() {
    this.mediaQueryList.removeEventListener(
      "change",
      this.handleBreakpointChange
    );
  }
  update() {
    this.updateSwatchesVisible(), this.updateCount(), this.updateDetailsInner();
  }
  updateDetailsInner() {
    const detailsInner = $elParent("[data-product-details-inner]", this);
    detailsInner &&
      detailsInner.offsetHeight < this.offsetHeight &&
      (detailsInner.style.minHeight = `${this.offsetHeight}px`);
  }
  setImageVisible(img, isVisible) {
    img.classList.toggle("product-card__img--visible", isVisible);
  }
  updateSwatchesVisible() {
    const items = $list(ITEM_SELECTOR$4, this),
      parentWidth = this.parentNode.offsetWidth;
    this.hasStackClass()
      ? items.forEach((swatch, i) => {
          const rightPosition = i * swatch.offsetWidth + swatch.offsetWidth;
          this.toggleSwatchVisibility(
            swatch,
            rightPosition > parentWidth / 1.35
          );
        })
      : items.forEach((swatch) => {
          const rightPosition = swatch.offsetLeft + swatch.offsetWidth,
            maxWidth = parentWidth - swatch.offsetWidth;
          this.toggleSwatchVisibility(swatch, rightPosition > maxWidth);
        });
  }
  setOffsets() {
    $list(ITEM_SELECTOR$4, this).forEach((swatch) => {
      swatch.style.left = `${swatch.offsetLeft}px`;
    });
  }
  updateCount() {
    const items = $list(ITEM_SELECTOR$4, this),
      hiddenCount = $el(HIDDEN_COUNT_SELECTOR, this);
    if (!hiddenCount) return;
    const hiddenCountLabel = $el(
      "[data-color-swatches-hidden-count-label]",
      this
    );
    if (!hiddenCountLabel) return;
    const notHiddenSwatches = items.filter(
        (item) => !item.classList.contains("hidden-swatch")
      ),
      count = +(this.dataset.count || 0) - notHiddenSwatches.length;
    count > 0
      ? (showElement(hiddenCount), (hiddenCountLabel.innerText = `+${count}`))
      : (hideElement(hiddenCount), (hiddenCountLabel.innerText = ""));
  }
  updateLabel(color) {
    const label = $el(LABEL_SELECTOR$2, this);
    label && (label.innerText = color ? capitalize(color) : "");
  }
  setHoverStatus(isHover) {
    var _a;
    (_a = this.productCard) == null ||
      _a.classList.toggle("is-color-swatch-hover", isHover);
  }
}
const PRODUCT_CARD_SELECTOR = "product-card",
  CUSTOM_DYNAMIC_DOTS_SELECTOR = "custom-dynamic-dots",
  ITEM_SELECTOR$3 = "[data-product-media-tabs-item]",
  MAIN_MEDIA_SELECTOR = "[data-main-media]";
class ProductMediaTabs extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "selected", null);
    __publicField(this, "handleTabEnter", ({ currentTarget }) =>
      this.activateTab(currentTarget)
    );
    __publicField(this, "handleProductCardEnter", () => {
      const tabs = $list(ITEM_SELECTOR$3, this);
      this.activateTab(tabs[1]);
    });
    __publicField(this, "handleTabLeave", () => this.disactivateTab());
    __publicField(this, "handleProductCardLeave", () => this.disactivateTab());
    __publicField(this, "activateTab", (tab) => {
      const productCard = $elParent(PRODUCT_CARD_SELECTOR, this),
        img = $el(`[data-id="${tab.dataset.id}"]`, productCard);
      this.selected && this.reset(),
        this.setTabSelect(tab, !0),
        this.setImageVisible(productCard.getMainMedia(), !1),
        this.setImageVisible(img, !0),
        (this.selected = { tab, img }),
        $list(CUSTOM_DYNAMIC_DOTS_SELECTOR, productCard).forEach((dots) =>
          dots.updateDots(parseInt(img.dataset.id) - 1)
        );
    });
    __publicField(this, "disactivateTab", () => {
      const productCard = $elParent(PRODUCT_CARD_SELECTOR, this);
      this.selected && this.reset(),
        $list(MAIN_MEDIA_SELECTOR, productCard).forEach((media) => {
          this.setImageVisible(media, !0);
        }),
        $list(CUSTOM_DYNAMIC_DOTS_SELECTOR, productCard).forEach((dots) =>
          dots.updateDots(0)
        );
    });
  }
  mountComponent() {
    const tabs = $list(ITEM_SELECTOR$3, this),
      productCard = $elParent(PRODUCT_CARD_SELECTOR, this);
    tabs.forEach((tab) => {
      this.addListener(tab, "mouseenter", this.handleTabEnter),
        this.addListener(tab, "mouseleave", this.handleTabLeave);
    }),
      this.selectTabOnCardHover &&
        (this.addListener(
          productCard,
          "mouseenter",
          this.handleProductCardEnter
        ),
        this.addListener(
          productCard,
          "mouseleave",
          this.handleProductCardLeave
        ));
  }
  setTabSelect(tab, isSelected) {
    tab.classList.toggle("selected", isSelected);
  }
  setImageVisible(img, isVisible) {
    img.classList.toggle("product-card__img--visible", isVisible),
      img.tagName === "VIDEO" && (isVisible ? img.play() : img.pause());
  }
  reset() {
    this.selected &&
      (this.selected.img.tagName === "VIDEO" && this.selected.img.pause(),
      this.selected.img.classList.remove("product-card__img--visible"),
      this.selected.tab.classList.remove("selected"),
      (this.selected = null));
  }
  get selectTabOnCardHover() {
    return this.hasAttribute("data-select-tab-on-card-hover");
  }
}
const QUICK_VIEW_BUTTON_SELECTOR = "[data-product-card-quick-view-button]",
  QUICK_VIEW_SELECTOR = "#Quick-view";
class VerticalProductCard extends Card {
  constructor() {
    super(...arguments);
    __publicField(this, "handleQuickViewBtnKeyDown", async (event) => {
      isEnterKey(event) && (event.preventDefault(), this.callQuickView(!0));
    });
    __publicField(this, "handleQuickViewBtnClick", async () => {
      this.callQuickView(!0);
    });
    __publicField(this, "handleProductCardEnter", () => {
      this.callQuickView(!1);
    });
  }
  mountComponent() {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR, this);
    this.addListener(quickViewBtn, "click", this.handleQuickViewBtnClick),
      this.addListener(quickViewBtn, "keydown", this.handleQuickViewBtnKeyDown),
      this.addListener(this, "mouseenter", this.handleProductCardEnter);
  }
  async callQuickView(withOpen) {
    const quickView = $el(QUICK_VIEW_SELECTOR),
      url = this.dataset.url,
      id = this.dataset.id;
    !quickView ||
      !url ||
      !id ||
      (await quickView.requestProductFromUrl(url, id),
      withOpen &&
        (this.setQuickViewLoading(!0),
        await quickView.openAndRenderProductByUrl(url),
        this.setQuickViewLoading(!1)));
  }
  setQuickViewLoading(isLoading) {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR, this);
    quickViewBtn &&
      (quickViewBtn.classList.toggle("loading", isLoading),
      quickViewBtn.toggleAttribute("disabled", isLoading));
  }
}
function _extends() {
  return (
    (_extends =
      Object.assign ||
      function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source)
            Object.prototype.hasOwnProperty.call(source, key) &&
              (target[key] = source[key]);
        }
        return target;
      }),
    _extends.apply(this, arguments)
  );
}
var DECAY = 0.996,
  projection = function (velocityPxMs, decay) {
    return (
      decay === void 0 && (decay = DECAY), (velocityPxMs * decay) / (1 - decay)
    );
  };
function lastOf(array) {
  return array[array.length - 1];
}
function average(numbers) {
  return (
    numbers.reduce(function (a, b) {
      return a + b;
    }) / numbers.length
  );
}
var clamp$1 = function (value, min2, max2) {
  return Math.min(Math.max(min2, value), max2);
};
function addVectors(v1, v2) {
  if (v1.length !== v2.length) throw new Error("vectors must be same length");
  return v1.map(function (val, i) {
    return val + v2[i];
  });
}
function absMax(numbers) {
  return Math.max.apply(Math, numbers.map(Math.abs));
}
function deepFreeze(o) {
  return (
    Object.freeze(o),
    Object.values(o).forEach(function (value) {
      value !== null &&
        typeof value == "object" &&
        !Object.isFrozen(value) &&
        deepFreeze(value);
    }),
    o
  );
}
function EventBus() {
  var listeners = {};
  function on(type, listener) {
    return (
      (listeners[type] = (listeners[type] || []).concat(listener)),
      function () {
        return off(type, listener);
      }
    );
  }
  function off(type, listener) {
    listeners[type] = (listeners[type] || []).filter(function (l) {
      return l !== listener;
    });
  }
  function dispatch(type, data) {
    type in listeners &&
      listeners[type].forEach(function (l) {
        return l(data);
      });
  }
  return deepFreeze({ on, off, dispatch });
}
function WheelTargetObserver(eventListener) {
  var targets = [],
    observe = function (target) {
      return (
        target.addEventListener("wheel", eventListener, { passive: !1 }),
        targets.push(target),
        function () {
          return unobserve(target);
        }
      );
    },
    unobserve = function (target) {
      target.removeEventListener("wheel", eventListener),
        (targets = targets.filter(function (t) {
          return t !== target;
        }));
    },
    disconnect = function () {
      targets.forEach(unobserve);
    };
  return deepFreeze({ observe, unobserve, disconnect });
}
var LINE_HEIGHT = 16 * 1.125,
  PAGE_HEIGHT = (typeof window < "u" && window.innerHeight) || 800,
  DELTA_MODE_UNIT = [1, LINE_HEIGHT, PAGE_HEIGHT];
function normalizeWheel(e) {
  var deltaX = e.deltaX * DELTA_MODE_UNIT[e.deltaMode],
    deltaY = e.deltaY * DELTA_MODE_UNIT[e.deltaMode],
    deltaZ = (e.deltaZ || 0) * DELTA_MODE_UNIT[e.deltaMode];
  return { timeStamp: e.timeStamp, axisDelta: [deltaX, deltaY, deltaZ] };
}
var reverseAll = [-1, -1, -1];
function reverseAxisDeltaSign(wheel, reverseSign) {
  if (!reverseSign) return wheel;
  var multipliers =
    reverseSign === !0
      ? reverseAll
      : reverseSign.map(function (shouldReverse) {
          return shouldReverse ? -1 : 1;
        });
  return _extends({}, wheel, {
    axisDelta: wheel.axisDelta.map(function (delta, i) {
      return delta * multipliers[i];
    }),
  });
}
var DELTA_MAX_ABS = 700,
  clampAxisDelta = function (wheel) {
    return _extends({}, wheel, {
      axisDelta: wheel.axisDelta.map(function (delta) {
        return clamp$1(delta, -700, DELTA_MAX_ABS);
      }),
    });
  },
  ACC_FACTOR_MIN = 0.6,
  ACC_FACTOR_MAX = 0.96,
  WHEELEVENTS_TO_MERGE = 2,
  WHEELEVENTS_TO_ANALAZE = 5,
  configDefaults = deepFreeze({
    preventWheelAction: !0,
    reverseSign: [!0, !0, !1],
  }),
  WILL_END_TIMEOUT_DEFAULT = 400;
function createWheelGesturesState() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: WILL_END_TIMEOUT_DEFAULT,
  };
}
function WheelGestures(optionsParam) {
  optionsParam === void 0 && (optionsParam = {});
  var _EventBus = EventBus(),
    on = _EventBus.on,
    off = _EventBus.off,
    dispatch = _EventBus.dispatch,
    config = configDefaults,
    state = createWheelGesturesState(),
    currentEvent,
    negativeZeroFingerUpSpecialEvent = !1,
    prevWheelEventState,
    feedWheel = function (wheelEvents) {
      Array.isArray(wheelEvents)
        ? wheelEvents.forEach(function (wheelEvent) {
            return processWheelEventData(wheelEvent);
          })
        : processWheelEventData(wheelEvents);
    },
    updateOptions = function (newOptions) {
      return (
        newOptions === void 0 && (newOptions = {}),
        Object.values(newOptions).some(function (option) {
          return option == null;
        })
          ? config
          : (config = deepFreeze(
              _extends({}, configDefaults, config, newOptions)
            ))
      );
    },
    publishWheel = function (additionalData) {
      var wheelEventState = _extends(
        {
          event: currentEvent,
          isStart: !1,
          isEnding: !1,
          isMomentumCancel: !1,
          isMomentum: state.isMomentum,
          axisDelta: [0, 0, 0],
          axisVelocity: state.axisVelocity,
          axisMovement: state.axisMovement,
          get axisMovementProjection() {
            return addVectors(
              wheelEventState.axisMovement,
              wheelEventState.axisVelocity.map(function (velocity) {
                return projection(velocity);
              })
            );
          },
        },
        additionalData
      );
      dispatch(
        "wheel",
        _extends({}, wheelEventState, { previous: prevWheelEventState })
      ),
        (prevWheelEventState = wheelEventState);
    },
    shouldPreventDefault = function (deltaMaxAbs, axisDelta) {
      var _config = config,
        preventWheelAction = _config.preventWheelAction,
        deltaX = axisDelta[0],
        deltaY = axisDelta[1],
        deltaZ = axisDelta[2];
      if (typeof preventWheelAction == "boolean") return preventWheelAction;
      switch (preventWheelAction) {
        case "x":
          return Math.abs(deltaX) >= deltaMaxAbs;
        case "y":
          return Math.abs(deltaY) >= deltaMaxAbs;
        case "z":
          return Math.abs(deltaZ) >= deltaMaxAbs;
        default:
          return !1;
      }
    },
    processWheelEventData = function (wheelEvent) {
      var _clampAxisDelta = clampAxisDelta(
          reverseAxisDeltaSign(normalizeWheel(wheelEvent), config.reverseSign)
        ),
        axisDelta = _clampAxisDelta.axisDelta,
        timeStamp = _clampAxisDelta.timeStamp,
        deltaMaxAbs = absMax(axisDelta);
      if (
        (wheelEvent.preventDefault &&
          shouldPreventDefault(deltaMaxAbs, axisDelta) &&
          wheelEvent.preventDefault(),
        state.isStarted
          ? state.isMomentum &&
            deltaMaxAbs > Math.max(2, state.lastAbsDelta * 2) &&
            (end(!0), start())
          : start(),
        deltaMaxAbs === 0 && Object.is && Object.is(wheelEvent.deltaX, -0))
      ) {
        negativeZeroFingerUpSpecialEvent = !0;
        return;
      }
      (currentEvent = wheelEvent),
        (state.axisMovement = addVectors(state.axisMovement, axisDelta)),
        (state.lastAbsDelta = deltaMaxAbs),
        state.scrollPointsToMerge.push({ axisDelta, timeStamp }),
        mergeScrollPointsCalcVelocity(),
        publishWheel({ axisDelta, isStart: !state.isStartPublished }),
        (state.isStartPublished = !0),
        willEnd();
    },
    mergeScrollPointsCalcVelocity = function () {
      state.scrollPointsToMerge.length === WHEELEVENTS_TO_MERGE
        ? (state.scrollPoints.unshift({
            axisDeltaSum: state.scrollPointsToMerge
              .map(function (b) {
                return b.axisDelta;
              })
              .reduce(addVectors),
            timeStamp: average(
              state.scrollPointsToMerge.map(function (b) {
                return b.timeStamp;
              })
            ),
          }),
          updateVelocity(),
          (state.scrollPointsToMerge.length = 0),
          (state.scrollPoints.length = 1),
          state.isMomentum || detectMomentum())
        : state.isStartPublished || updateStartVelocity();
    },
    updateStartVelocity = function () {
      state.axisVelocity = lastOf(state.scrollPointsToMerge).axisDelta.map(
        function (d) {
          return d / state.willEndTimeout;
        }
      );
    },
    updateVelocity = function () {
      var _state$scrollPoints = state.scrollPoints,
        latestScrollPoint = _state$scrollPoints[0],
        prevScrollPoint = _state$scrollPoints[1];
      if (!(!prevScrollPoint || !latestScrollPoint)) {
        var deltaTime = latestScrollPoint.timeStamp - prevScrollPoint.timeStamp;
        if (!(deltaTime <= 0)) {
          var velocity = latestScrollPoint.axisDeltaSum.map(function (d) {
              return d / deltaTime;
            }),
            accelerationFactor = velocity.map(function (v, i) {
              return v / (state.axisVelocity[i] || 1);
            });
          (state.axisVelocity = velocity),
            state.accelerationFactors.push(accelerationFactor),
            updateWillEndTimeout(deltaTime);
        }
      }
    },
    updateWillEndTimeout = function (deltaTime) {
      var newTimeout = Math.ceil(deltaTime / 10) * 10 * 1.2;
      state.isMomentum || (newTimeout = Math.max(100, newTimeout * 2)),
        (state.willEndTimeout = Math.min(1e3, Math.round(newTimeout)));
    },
    accelerationFactorInMomentumRange = function (accFactor) {
      return accFactor === 0
        ? !0
        : accFactor <= ACC_FACTOR_MAX && accFactor >= ACC_FACTOR_MIN;
    },
    detectMomentum = function () {
      if (state.accelerationFactors.length >= WHEELEVENTS_TO_ANALAZE) {
        if (
          negativeZeroFingerUpSpecialEvent &&
          ((negativeZeroFingerUpSpecialEvent = !1),
          absMax(state.axisVelocity) >= 0.2)
        ) {
          recognizedMomentum();
          return;
        }
        var recentAccelerationFactors = state.accelerationFactors.slice(
            WHEELEVENTS_TO_ANALAZE * -1
          ),
          detectedMomentum = recentAccelerationFactors.every(function (accFac) {
            var sameAccFac = !!accFac.reduce(function (f1, f2) {
                return f1 && f1 < 1 && f1 === f2 ? 1 : 0;
              }),
              bothAreInRangeOrZero =
                accFac.filter(accelerationFactorInMomentumRange).length ===
                accFac.length;
            return sameAccFac || bothAreInRangeOrZero;
          });
        detectedMomentum && recognizedMomentum(),
          (state.accelerationFactors = recentAccelerationFactors);
      }
    },
    recognizedMomentum = function () {
      state.isMomentum = !0;
    },
    start = function () {
      (state = createWheelGesturesState()),
        (state.isStarted = !0),
        (state.startTime = Date.now()),
        (prevWheelEventState = void 0),
        (negativeZeroFingerUpSpecialEvent = !1);
    },
    willEnd = (function () {
      var willEndId;
      return function () {
        clearTimeout(willEndId),
          (willEndId = setTimeout(end, state.willEndTimeout));
      };
    })(),
    end = function (isMomentumCancel) {
      isMomentumCancel === void 0 && (isMomentumCancel = !1),
        state.isStarted &&
          (state.isMomentum && isMomentumCancel
            ? publishWheel({ isEnding: !0, isMomentumCancel: !0 })
            : publishWheel({ isEnding: !0 }),
          (state.isMomentum = !1),
          (state.isStarted = !1));
    },
    _WheelTargetObserver = WheelTargetObserver(feedWheel),
    observe = _WheelTargetObserver.observe,
    unobserve = _WheelTargetObserver.unobserve,
    disconnect = _WheelTargetObserver.disconnect;
  return (
    updateOptions(optionsParam),
    deepFreeze({
      on,
      off,
      observe,
      unobserve,
      disconnect,
      feedWheel,
      updateOptions,
    })
  );
}
var defaultOptions$2 = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0,
};
WheelGesturesPlugin.globalOptions = void 0;
function WheelGesturesPlugin(userOptions) {
  userOptions === void 0 && (userOptions = {});
  var options,
    cleanup = function () {};
  function init(embla, optionsHandler) {
    var _options$target,
      _options$forceWheelAx,
      mergeOptions = optionsHandler.mergeOptions,
      optionsAtMedia = optionsHandler.optionsAtMedia,
      optionsBase = mergeOptions(
        defaultOptions$2,
        WheelGesturesPlugin.globalOptions
      ),
      allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    var engine = embla.internalEngine(),
      targetNode =
        (_options$target = options.target) != null
          ? _options$target
          : embla.containerNode().parentNode,
      wheelAxis =
        (_options$forceWheelAx = options.forceWheelAxis) != null
          ? _options$forceWheelAx
          : engine.options.axis,
      wheelGestures = WheelGestures({
        preventWheelAction: wheelAxis,
        reverseSign: [!0, !0, !1],
      }),
      unobserveTargetNode = wheelGestures.observe(targetNode),
      offWheel = wheelGestures.on("wheel", handleWheel),
      isStarted = !1,
      startEvent;
    function wheelGestureStarted(state) {
      try {
        (startEvent = new MouseEvent("mousedown", state.event)),
          dispatchEvent(startEvent);
      } catch {
        return cleanup();
      }
      (isStarted = !0),
        addNativeMouseEventListeners(),
        options.wheelDraggingClass &&
          targetNode.classList.add(options.wheelDraggingClass);
    }
    function wheelGestureEnded(state) {
      (isStarted = !1),
        dispatchEvent(createRelativeMouseEvent("mouseup", state)),
        removeNativeMouseEventListeners(),
        options.wheelDraggingClass &&
          targetNode.classList.remove(options.wheelDraggingClass);
    }
    function addNativeMouseEventListeners() {
      document.documentElement.addEventListener(
        "mousemove",
        preventNativeMouseHandler,
        !0
      ),
        document.documentElement.addEventListener(
          "mouseup",
          preventNativeMouseHandler,
          !0
        ),
        document.documentElement.addEventListener(
          "mousedown",
          preventNativeMouseHandler,
          !0
        );
    }
    function removeNativeMouseEventListeners() {
      document.documentElement.removeEventListener(
        "mousemove",
        preventNativeMouseHandler,
        !0
      ),
        document.documentElement.removeEventListener(
          "mouseup",
          preventNativeMouseHandler,
          !0
        ),
        document.documentElement.removeEventListener(
          "mousedown",
          preventNativeMouseHandler,
          !0
        );
    }
    function preventNativeMouseHandler(e) {
      isStarted && e.isTrusted && e.stopImmediatePropagation();
    }
    function createRelativeMouseEvent(type, state) {
      var moveX, moveY;
      if (wheelAxis === engine.options.axis) {
        var _state$axisMovement = state.axisMovement;
        (moveX = _state$axisMovement[0]), (moveY = _state$axisMovement[1]);
      } else {
        var _state$axisMovement2 = state.axisMovement;
        (moveY = _state$axisMovement2[0]), (moveX = _state$axisMovement2[1]);
      }
      return new MouseEvent(type, {
        clientX: startEvent.clientX + moveX,
        clientY: startEvent.clientY + moveY,
        screenX: startEvent.screenX + moveX,
        screenY: startEvent.screenY + moveY,
        movementX: moveX,
        movementY: moveY,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0,
      });
    }
    function dispatchEvent(event) {
      embla.containerNode().dispatchEvent(event);
    }
    function handleWheel(state) {
      var _state$axisDelta = state.axisDelta,
        deltaX = _state$axisDelta[0],
        deltaY = _state$axisDelta[1],
        primaryAxisDelta = wheelAxis === "x" ? deltaX : deltaY,
        crossAxisDelta = wheelAxis === "x" ? deltaY : deltaX,
        isRelease =
          state.isMomentum && state.previous && !state.previous.isMomentum,
        isEndingOrRelease = (state.isEnding && !state.isMomentum) || isRelease,
        primaryAxisDeltaIsDominant =
          Math.abs(primaryAxisDelta) > Math.abs(crossAxisDelta);
      primaryAxisDeltaIsDominant &&
        !isStarted &&
        !state.isMomentum &&
        wheelGestureStarted(state),
        isStarted &&
          (isEndingOrRelease
            ? wheelGestureEnded(state)
            : dispatchEvent(createRelativeMouseEvent("mousemove", state)));
    }
    cleanup = function () {
      unobserveTargetNode(), offWheel(), removeNativeMouseEventListeners();
    };
  }
  var self = {
    name: "wheelGestures",
    options: userOptions,
    init,
    destroy: function () {
      return cleanup();
    },
  };
  return self;
}
function isNumber(subject) {
  return typeof subject == "number";
}
function isString(subject) {
  return typeof subject == "string";
}
function isBoolean(subject) {
  return typeof subject == "boolean";
}
function isObject(subject) {
  return Object.prototype.toString.call(subject) === "[object Object]";
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0 || mathAbs(valueB) <= mathAbs(valueA))
    return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function arrayKeys(array) {
  return objectKeys(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function objectKeys(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce(
    (mergedObjects, currentObject) => (
      objectKeys(currentObject).forEach((key) => {
        const valueA = mergedObjects[key],
          valueB = currentObject[key],
          areObjects = isObject(valueA) && isObject(valueB);
        mergedObjects[key] = areObjects
          ? objectsMergeDeep(valueA, valueB)
          : valueB;
      }),
      mergedObjects
    ),
    {}
  );
}
function isMouseEvent(evt, ownerWindow) {
  return (
    typeof ownerWindow.MouseEvent < "u" && evt instanceof ownerWindow.MouseEvent
  );
}
function Alignment(align, viewSize) {
  const predefined = { start, center, end };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function percent() {
    return viewSize * Number(align);
  }
  function measure(n) {
    return isNumber(align) ? percent() : predefined[align](n);
  }
  return { measure };
}
function Axis(axis, direction) {
  const scroll = axis === "y" ? "y" : "x",
    cross = axis === "y" ? "x" : "y",
    startEdge = getStartEdge(),
    endEdge = getEndEdge();
  function measureSize(rect) {
    const { width, height } = rect;
    return scroll === "x" ? width : height;
  }
  function getStartEdge() {
    return scroll === "y" ? "top" : direction === "rtl" ? "right" : "left";
  }
  function getEndEdge() {
    return scroll === "y" ? "bottom" : direction === "rtl" ? "left" : "right";
  }
  return { scroll, cross, startEdge, endEdge, measureSize };
}
function Limit(min2, max2) {
  const length = mathAbs(min2 - max2);
  function reachedMin(n) {
    return n < min2;
  }
  function reachedMax(n) {
    return n > max2;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    return reachedAny(n) ? (reachedMin(n) ? min2 : max2) : n;
  }
  function removeOffset(n) {
    return length ? n - length * Math.ceil((n - max2) / length) : n;
  }
  return {
    length,
    max: max2,
    min: min2,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset,
  };
}
function Counter(max2, start, loop) {
  const { constrain } = Limit(0, max2),
    loopEnd = max2 + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return loop ? mathAbs((loopEnd + n) % loopEnd) : constrain(n);
  }
  function get() {
    return counter;
  }
  function set(n) {
    return (counter = withinLimit(n)), self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max2, get(), loop);
  }
  const self = { get, set, add, clone };
  return self;
}
function Direction(direction) {
  const sign = direction === "rtl" ? -1 : 1;
  function apply(n) {
    return n * sign;
  }
  return { apply };
}
function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = { passive: !0 }) {
    return (
      node.addEventListener(type, handler, options),
      listeners.push(() => node.removeEventListener(type, handler, options)),
      self
    );
  }
  function clear() {
    listeners = listeners.filter((remove) => remove());
  }
  const self = { add, clear };
  return self;
}
function DragHandler(
  axis,
  direction,
  rootNode,
  ownerDocument,
  ownerWindow,
  target,
  dragTracker,
  location,
  animation,
  scrollTo,
  scrollBody,
  scrollTarget,
  index,
  eventHandler,
  percentOfView,
  dragFree,
  dragThreshold,
  skipSnaps,
  baseFriction
) {
  const { cross: crossAxis } = axis,
    focusNodes = ["INPUT", "SELECT", "TEXTAREA"],
    nonPassiveEvent = { passive: !1 },
    initEvents = EventStore(),
    dragEvents = EventStore(),
    goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20)),
    snapForceBoost = { mouse: 300, touch: 400 },
    freeForceBoost = { mouse: 500, touch: 600 },
    baseSpeed = dragFree ? 43 : 25;
  let isMoving = !1,
    startScroll = 0,
    startCross = 0,
    pointerIsDown = !1,
    preventScroll = !1,
    preventClick = !1,
    isMouse = !1;
  function init(emblaApi, watchDrag) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      (isBoolean(watchDrag) || watchDrag(emblaApi, evt)) && down(evt);
    }
    const node = rootNode;
    initEvents
      .add(node, "dragstart", (evt) => evt.preventDefault(), nonPassiveEvent)
      .add(node, "touchmove", () => {}, nonPassiveEvent)
      .add(node, "touchend", () => {})
      .add(node, "touchstart", downIfAllowed)
      .add(node, "mousedown", downIfAllowed)
      .add(node, "touchcancel", up)
      .add(node, "contextmenu", up)
      .add(node, "click", click, !0);
  }
  function destroy() {
    initEvents.clear(), dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents
      .add(node, "touchmove", move, nonPassiveEvent)
      .add(node, "touchend", up)
      .add(node, "mousemove", move, nonPassiveEvent)
      .add(node, "mouseup", up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || "";
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    return (dragFree ? freeForceBoost : snapForceBoost)[
      isMouse ? "mouse" : "touch"
    ];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1),
      baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    return dragFree || mathAbs(force) < goToNextThreshold
      ? baseForce
      : skipSnaps && targetChanged
      ? baseForce * 0.5
      : scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    (isMouse = isMouseEvt),
      !(isMouseEvt && evt.button !== 0) &&
        (isFocusNode(evt.target) ||
          ((preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving),
          (isMoving = deltaAbs(target.get(), location.get()) >= 2),
          (pointerIsDown = !0),
          dragTracker.pointerDown(evt),
          scrollBody.useFriction(0).useDuration(0),
          target.set(location),
          addDragEvents(),
          (startScroll = dragTracker.readPoint(evt)),
          (startCross = dragTracker.readPoint(evt, crossAxis)),
          eventHandler.emit("pointerDown")));
  }
  function move(evt) {
    const lastScroll = dragTracker.readPoint(evt),
      lastCross = dragTracker.readPoint(evt, crossAxis),
      diffScroll = deltaAbs(lastScroll, startScroll),
      diffCross = deltaAbs(lastCross, startCross);
    if (
      !preventScroll &&
      !isMouse &&
      (!evt.cancelable ||
        ((preventScroll = diffScroll > diffCross), !preventScroll))
    )
      return up(evt);
    const diff = dragTracker.pointerMove(evt);
    diffScroll > dragThreshold && (preventClick = !0),
      scrollBody.useFriction(0.3).useDuration(1),
      animation.start(),
      target.add(direction.apply(diff)),
      evt.preventDefault();
  }
  function up(evt) {
    const targetChanged = scrollTarget.byDistance(0, !1).index !== index.get(),
      rawForce = dragTracker.pointerUp(evt) * forceBoost(),
      force = allowedForce(direction.apply(rawForce), targetChanged),
      forceFactor = factorAbs(rawForce, force),
      speed = baseSpeed - 10 * forceFactor,
      friction = baseFriction + forceFactor / 50;
    (preventScroll = !1),
      (pointerIsDown = !1),
      dragEvents.clear(),
      scrollBody.useDuration(speed).useFriction(friction),
      scrollTo.distance(force, !dragFree),
      (isMouse = !1),
      eventHandler.emit("pointerUp");
  }
  function click(evt) {
    preventClick && (evt.stopPropagation(), evt.preventDefault());
  }
  function pointerDown() {
    return pointerIsDown;
  }
  return { init, pointerDown, destroy };
}
function DragTracker(axis, ownerWindow) {
  let startEvent, lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const coord = `client${(evtAxis || axis.scroll) === "x" ? "X" : "Y"}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    return (startEvent = evt), (lastEvent = evt), readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent),
      expired = readTime(evt) - readTime(startEvent) > 170;
    return (lastEvent = evt), expired && (startEvent = evt), diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent),
      diffTime = readTime(evt) - readTime(startEvent),
      expired = readTime(evt) - readTime(lastEvent) > 170,
      force = diffDrag / diffTime;
    return diffTime && !expired && mathAbs(force) > 0.1 ? force : 0;
  }
  return { pointerDown, pointerMove, pointerUp, readPoint };
}
function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  return { measure };
}
function ResizeHandler(container, eventHandler, ownerWindow, slides, axis) {
  let resizeObserver,
    containerSize,
    slideSizes = [],
    destroyed = !1;
  function readSize(node) {
    return axis.measureSize(node.getBoundingClientRect());
  }
  function init(emblaApi, watchResize) {
    if (!watchResize) return;
    (containerSize = readSize(container)), (slideSizes = slides.map(readSize));
    function defaultCallback(entries) {
      for (const entry of entries) {
        const isContainer = entry.target === container,
          slideIndex = slides.indexOf(entry.target),
          lastSize = isContainer ? containerSize : slideSizes[slideIndex],
          newSize = readSize(isContainer ? container : slides[slideIndex]);
        if (lastSize !== newSize) {
          ownerWindow.requestAnimationFrame(() => {
            emblaApi.reInit(), eventHandler.emit("resize");
          });
          break;
        }
      }
    }
    (resizeObserver = new ResizeObserver((entries) => {
      destroyed ||
        ((isBoolean(watchResize) || watchResize(emblaApi, entries)) &&
          defaultCallback(entries));
    })),
      [container]
        .concat(slides)
        .forEach((node) => resizeObserver.observe(node));
  }
  function destroy() {
    resizeObserver && resizeObserver.disconnect(), (destroyed = !0);
  }
  return { init, destroy };
}
function ScrollBody(location, target, baseDuration, baseFriction) {
  let hasSettled = !0,
    bodyVelocity = 0,
    scrollDirection = 0,
    scrollDuration = baseDuration,
    scrollFriction = baseFriction,
    rawLocation = location.get(),
    rawLocationPrevious = 0;
  function seek() {
    const diff = target.get() - location.get(),
      isInstant = !scrollDuration;
    let directionDiff = 0;
    return (
      isInstant
        ? ((bodyVelocity = 0), location.set(target), (directionDiff = diff))
        : ((bodyVelocity += diff / scrollDuration),
          (bodyVelocity *= scrollFriction),
          (rawLocation += bodyVelocity),
          location.add(bodyVelocity),
          (directionDiff = rawLocation - rawLocationPrevious)),
      (scrollDirection = mathSign(directionDiff)),
      (rawLocationPrevious = rawLocation),
      (hasSettled = mathAbs(diff) < 0.001),
      self
    );
  }
  function settled() {
    return hasSettled;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return bodyVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    return (scrollDuration = n), self;
  }
  function useFriction(n) {
    return (scrollFriction = n), self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration,
  };
  return self;
}
function ScrollBounds(limit, location, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10),
    edgeOffsetTolerance = percentOfView.measure(50),
    frictionLimit = Limit(0.1, 0.99);
  let disabled = !1;
  function shouldConstrain() {
    return !(
      disabled ||
      !limit.reachedAny(target.get()) ||
      !limit.reachedAny(location.get())
    );
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(location.get()) ? "min" : "max",
      diffToEdge = mathAbs(limit[edge] - location.get()),
      diffToTarget = target.get() - location.get(),
      friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction),
      !pointerDown &&
        mathAbs(diffToTarget) < pullBackThreshold &&
        (target.set(limit.constrain(target.get())),
        scrollBody.useDuration(25).useBaseFriction());
  }
  function toggleActive(active) {
    disabled = !active;
  }
  return { constrain, toggleActive };
}
function ScrollContain(viewSize, contentSize, snapsAligned, containScroll) {
  const scrollBounds = Limit(-contentSize + viewSize, snapsAligned[0]),
    snapsBounded = measureBounded(),
    snapsContained = measureContained();
  function findDuplicates() {
    const startSnap = snapsBounded[0],
      endSnap = arrayLast(snapsBounded),
      min2 = snapsBounded.lastIndexOf(startSnap),
      max2 = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min2, max2);
  }
  function measureBounded() {
    return snapsAligned
      .map(scrollBounds.constrain)
      .map((scrollBound) => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize) return [scrollBounds.max];
    if (containScroll === "keepSnaps") return snapsBounded;
    const { min: min2, max: max2 } = findDuplicates();
    return snapsBounded.slice(min2, max2);
  }
  return { snapsContained };
}
function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max2 = scrollSnaps[0],
    min2 = loop ? max2 - contentSize : arrayLast(scrollSnaps);
  return { limit: Limit(min2, max2) };
}
function ScrollLooper(contentSize, limit, offsetLocation, vectors) {
  const min2 = limit.min + 0.1,
    max2 = limit.max + 0.1,
    { reachedMin, reachedMax } = Limit(min2, max2);
  function shouldLoop(direction) {
    return direction === 1
      ? reachedMax(offsetLocation.get())
      : direction === -1
      ? reachedMin(offsetLocation.get())
      : !1;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach((v) => v.add(loopDistance));
  }
  return { loop };
}
function ScrollProgress(limit) {
  const { max: max2, length: scrollLength } = limit;
  function get(n) {
    return (n - max2) / -scrollLength;
  }
  return { get };
}
function ScrollSnaps(
  axis,
  alignment,
  containerRect,
  slideRects,
  slideSizesWithGaps,
  slidesToScroll,
  containScroll
) {
  const { startEdge, endEdge } = axis,
    { groupSlides } = slidesToScroll,
    alignments = measureSizes().map(alignment.measure),
    snaps = measureUnaligned(),
    snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects)
      .map((rects) => arrayLast(rects)[endEdge] - rects[0][startEdge])
      .map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects
      .map((rect) => containerRect[startEdge] - rect[startEdge])
      .map((snap) => -mathAbs(snap));
  }
  function measureAligned() {
    const containedEndSnap = arrayLast(snaps) - arrayLast(slideSizesWithGaps);
    return groupSlides(snaps)
      .map((g) => g[0])
      .map((snap, index, groupedSnaps) => {
        const isFirst = !index,
          isLast = index === arrayLastIndex(groupedSnaps);
        return containScroll && isFirst
          ? 0
          : containScroll && isLast
          ? containedEndSnap
          : snap + alignments[index];
      });
  }
  return { snaps, snapsAligned };
}
function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const { reachedAny, removeOffset, constrain } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target),
      ascDiffsToSnaps = scrollSnaps
        .map((scrollSnap) => scrollSnap - distance)
        .map((diffToSnap) => shortcut(diffToSnap, 0))
        .map((diff, i) => ({ diff, index: i }))
        .sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff)),
      { index } = ascDiffsToSnaps[0];
    return { index, distance };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return targets[0];
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter((t) => mathSign(t) === direction);
    return minDistance(matchingTargets);
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get(),
      distance = shortcut(diffToSnap, direction);
    return { index, distance };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance,
      { index, distance: targetSnapDistance } = findTargetSnap(target),
      reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return { index, distance };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance,
      snapDistance = distance + shortcut(diffToSnap, 0);
    return { index, distance: snapDistance };
  }
  return { byDistance, byIndex, shortcut };
}
function ScrollTo(
  animation,
  indexCurrent,
  indexPrevious,
  scrollTarget,
  scrollBody,
  targetVector,
  eventHandler
) {
  function scrollTo(target) {
    const distanceDiff = target.distance,
      indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff),
      distanceDiff &&
        (scrollBody.duration()
          ? animation.start()
          : (animation.update(), animation.render(1), animation.update())),
      indexDiff &&
        (indexPrevious.set(indexCurrent.get()),
        indexCurrent.set(target.index),
        eventHandler.emit("select"));
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n),
      target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  return { distance, index };
}
function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  return { get, set, add, subtract };
}
function Translate(axis, direction, container) {
  const translate = axis.scroll === "x" ? x : y,
    containerStyle = container.style;
  let disabled = !1;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    disabled || (containerStyle.transform = translate(direction.apply(target)));
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    disabled ||
      ((containerStyle.transform = ""),
      container.getAttribute("style") || container.removeAttribute("style"));
  }
  return { clear, to, toggleActive };
}
function SlideLooper(
  axis,
  direction,
  viewSize,
  contentSize,
  slideSizesWithGaps,
  scrollSnaps,
  slidesInView,
  offsetLocation,
  slides
) {
  const ascItems = arrayKeys(slideSizesWithGaps),
    descItems = arrayKeys(slideSizesWithGaps).reverse(),
    loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => a - slideSizesWithGaps[i], from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce(
      (a, i) => (removeSlideSizes(a, gap) > 0 ? a.concat([i]) : a),
      []
    );
  }
  function findLoopPoints(indexes, edge) {
    const isStartEdge = edge === "start",
      offset2 = isStartEdge ? -contentSize : contentSize,
      slideBounds = slidesInView.findSlideBounds([offset2]);
    return indexes.map((index) => {
      const initial = isStartEdge ? 0 : -contentSize,
        altered = isStartEdge ? contentSize : 0,
        loopPoint = slideBounds.filter((b) => b.index === index)[0][
          isStartEdge ? "end" : "start"
        ];
      return {
        index,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, direction, slides[index]),
        target: () => (offsetLocation.get() > loopPoint ? initial : altered),
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0] - 1,
      indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, "end");
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1,
      indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, "start");
  }
  function canLoop() {
    return loopPoints.every(({ index }) => {
      const otherIndexes = ascItems.filter((i) => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach((loopPoint) => {
      const { target, translate, slideLocation } = loopPoint,
        shiftLocation = target();
      shiftLocation !== slideLocation.get() &&
        (translate.to(shiftLocation), slideLocation.set(shiftLocation));
    });
  }
  function clear() {
    loopPoints.forEach((loopPoint) => loopPoint.translate.clear());
  }
  return { canLoop, clear, loop, loopPoints };
}
function SlidesHandler(container, eventHandler) {
  let mutationObserver,
    destroyed = !1;
  function init(emblaApi, watchSlides) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations)
        if (mutation.type === "childList") {
          emblaApi.reInit(), eventHandler.emit("slidesChanged");
          break;
        }
    }
    (mutationObserver = new MutationObserver((mutations) => {
      destroyed ||
        ((isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) &&
          defaultCallback(mutations));
    })),
      mutationObserver.observe(container, { childList: !0 });
  }
  function destroy() {
    mutationObserver && mutationObserver.disconnect(), (destroyed = !0);
  }
  return { init, destroy };
}
function SlidesInView(
  viewSize,
  contentSize,
  slideSizes,
  snaps,
  limit,
  loop,
  inViewThreshold
) {
  const { removeOffset, constrain } = limit,
    roundingSafety = 0.5,
    cachedOffsets = loop ? [0, contentSize, -contentSize] : [0],
    cachedBounds = findSlideBounds(cachedOffsets, inViewThreshold);
  function findSlideThresholds(threshold) {
    const slideThreshold = threshold || 0;
    return slideSizes.map((slideSize) =>
      Limit(roundingSafety, slideSize - roundingSafety).constrain(
        slideSize * slideThreshold
      )
    );
  }
  function findSlideBounds(offsets, threshold) {
    const slideOffsets = offsets || cachedOffsets,
      slideThresholds = findSlideThresholds(threshold);
    return slideOffsets.reduce((list, offset2) => {
      const bounds = snaps.map((snap, index) => ({
        start: snap - slideSizes[index] + slideThresholds[index] + offset2,
        end: snap + viewSize - slideThresholds[index] + offset2,
        index,
      }));
      return list.concat(bounds);
    }, []);
  }
  function check(location, bounds) {
    const limitedLocation = loop ? removeOffset(location) : constrain(location);
    return (bounds || cachedBounds).reduce((list, slideBound) => {
      const { index, start, end } = slideBound,
        inList = list.includes(index),
        inView = start < limitedLocation && end > limitedLocation;
      return !inList && inView ? list.concat([index]) : list;
    }, []);
  }
  return { check, findSlideBounds };
}
function SlideSizes(
  axis,
  containerRect,
  slideRects,
  slides,
  readEdgeGap,
  ownerWindow
) {
  const { measureSize, startEdge, endEdge } = axis,
    withEdgeGap = slideRects[0] && readEdgeGap,
    startGap = measureStartGap(),
    endGap = measureEndGap(),
    slideSizes = slideRects.map(measureSize),
    slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects
      .map((rect, index, rects) => {
        const isFirst = !index,
          isLast = index === arrayLastIndex(rects);
        return isFirst
          ? slideSizes[index] + startGap
          : isLast
          ? slideSizes[index] + endGap
          : rects[index + 1][startEdge] - rect[startEdge];
      })
      .map(mathAbs);
  }
  return { slideSizes, slideSizesWithGaps };
}
function SlidesToScroll(viewSize, slideSizesWithGaps, slidesToScroll) {
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array)
      .filter((i) => i % groupSize === 0)
      .map((i) => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    return arrayKeys(array)
      .reduce((groupSizes, i) => {
        const chunkSize = slideSizesWithGaps
          .slice(arrayLast(groupSizes), i + 1)
          .reduce((a, s) => a + s, 0);
        return !i || chunkSize > viewSize ? groupSizes.concat(i) : groupSizes;
      }, [])
      .map((start, i, groupSizes) => array.slice(start, groupSizes[i + 1]));
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  return { groupSlides };
}
function Engine(
  root,
  container,
  slides,
  ownerDocument,
  ownerWindow,
  options,
  eventHandler,
  animations
) {
  const {
      align,
      axis: scrollAxis,
      direction: contentDirection,
      startIndex,
      inViewThreshold,
      loop,
      duration,
      dragFree,
      dragThreshold,
      slidesToScroll: groupSlides,
      skipSnaps,
      containScroll,
    } = options,
    containerRect = container.getBoundingClientRect(),
    slideRects = slides.map((slide) => slide.getBoundingClientRect()),
    direction = Direction(contentDirection),
    axis = Axis(scrollAxis, contentDirection),
    viewSize = axis.measureSize(containerRect),
    percentOfView = PercentOfView(viewSize),
    alignment = Alignment(align, viewSize),
    containSnaps = !loop && !!containScroll,
    readEdgeGap = loop || !!containScroll,
    { slideSizes, slideSizesWithGaps } = SlideSizes(
      axis,
      containerRect,
      slideRects,
      slides,
      readEdgeGap,
      ownerWindow
    ),
    slidesToScroll = SlidesToScroll(viewSize, slideSizesWithGaps, groupSlides),
    { snaps, snapsAligned } = ScrollSnaps(
      axis,
      alignment,
      containerRect,
      slideRects,
      slideSizesWithGaps,
      slidesToScroll,
      containSnaps
    ),
    contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps),
    { snapsContained } = ScrollContain(
      viewSize,
      contentSize,
      snapsAligned,
      containScroll
    ),
    scrollSnaps = containSnaps ? snapsContained : snapsAligned,
    { limit } = ScrollLimit(contentSize, scrollSnaps, loop),
    index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop),
    indexPrevious = index.clone(),
    slideIndexes = arrayKeys(slides),
    update = ({
      dragHandler,
      scrollBody: scrollBody2,
      scrollBounds,
      eventHandler: eventHandler2,
      animation: animation2,
      options: { loop: loop2 },
    }) => {
      const pointerDown = dragHandler.pointerDown();
      loop2 || scrollBounds.constrain(pointerDown);
      const hasSettled = scrollBody2.seek().settled();
      hasSettled &&
        !pointerDown &&
        (animation2.stop(), eventHandler2.emit("settle")),
        hasSettled || eventHandler2.emit("scroll");
    },
    render = (
      {
        scrollBody: scrollBody2,
        translate,
        location: location2,
        offsetLocation: offsetLocation2,
        scrollLooper,
        slideLooper,
        options: { loop: loop2 },
      },
      lagOffset
    ) => {
      const velocity = scrollBody2.velocity();
      offsetLocation2.set(location2.get() - velocity + velocity * lagOffset),
        loop2 &&
          (scrollLooper.loop(scrollBody2.direction()), slideLooper.loop()),
        translate.to(offsetLocation2.get());
    },
    animation = {
      start: () => animations.start(engine),
      stop: () => animations.stop(engine),
      update: () => update(engine),
      render: (lagOffset) => render(engine, lagOffset),
    },
    friction = 0.68,
    startLocation = scrollSnaps[index.get()],
    location = Vector1D(startLocation),
    offsetLocation = Vector1D(startLocation),
    target = Vector1D(startLocation),
    scrollBody = ScrollBody(location, target, duration, friction),
    scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target),
    scrollTo = ScrollTo(
      animation,
      index,
      indexPrevious,
      scrollTarget,
      scrollBody,
      target,
      eventHandler
    ),
    slidesInView = SlidesInView(
      viewSize,
      contentSize,
      slideSizes,
      snaps,
      limit,
      loop,
      inViewThreshold
    ),
    engine = {
      ownerDocument,
      ownerWindow,
      eventHandler,
      containerRect,
      slideRects,
      animation,
      axis,
      direction,
      dragHandler: DragHandler(
        axis,
        direction,
        root,
        ownerDocument,
        ownerWindow,
        target,
        DragTracker(axis, ownerWindow),
        location,
        animation,
        scrollTo,
        scrollBody,
        scrollTarget,
        index,
        eventHandler,
        percentOfView,
        dragFree,
        dragThreshold,
        skipSnaps,
        friction
      ),
      eventStore: EventStore(),
      percentOfView,
      index,
      indexPrevious,
      limit,
      location,
      offsetLocation,
      options,
      resizeHandler: ResizeHandler(
        container,
        eventHandler,
        ownerWindow,
        slides,
        axis
      ),
      scrollBody,
      scrollBounds: ScrollBounds(
        limit,
        location,
        target,
        scrollBody,
        percentOfView
      ),
      scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [
        location,
        offsetLocation,
        target,
      ]),
      scrollProgress: ScrollProgress(limit),
      scrollSnaps,
      scrollTarget,
      scrollTo,
      slideLooper: SlideLooper(
        axis,
        direction,
        viewSize,
        contentSize,
        slideSizesWithGaps,
        scrollSnaps,
        slidesInView,
        offsetLocation,
        slides
      ),
      slidesHandler: SlidesHandler(container, eventHandler),
      slidesInView,
      slideIndexes,
      slidesToScroll,
      target,
      translate: Translate(axis, direction, container),
    };
  return engine;
}
function Animations(ownerWindow) {
  const timeStep = 16.666666666666668;
  let engines = [],
    lastTimeStamp = null,
    lag = 0,
    animationFrame = 0;
  function animate(timeStamp) {
    lastTimeStamp || (lastTimeStamp = timeStamp);
    const elapsed = timeStamp - lastTimeStamp;
    for (lastTimeStamp = timeStamp, lag += elapsed; lag >= timeStep; )
      engines.forEach(({ animation }) => animation.update()), (lag -= timeStep);
    const lagOffset = mathAbs(lag / timeStep);
    engines.forEach(({ animation }) => animation.render(lagOffset)),
      animationFrame && ownerWindow.requestAnimationFrame(animate);
  }
  function start(engine) {
    engines.includes(engine) || engines.push(engine),
      !animationFrame &&
        (animationFrame = ownerWindow.requestAnimationFrame(animate));
  }
  function stop(engine) {
    (engines = engines.filter((e) => e !== engine)),
      !engines.length &&
        (ownerWindow.cancelAnimationFrame(animationFrame),
        (lastTimeStamp = null),
        (lag = 0),
        (animationFrame = 0));
  }
  function reset() {
    (lastTimeStamp = null), (lag = 0);
  }
  return { start, stop, reset, window: ownerWindow };
}
function EventHandler() {
  const listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    return getListeners(evt).forEach((e) => e(api, evt)), self;
  }
  function on(evt, cb) {
    return (listeners[evt] = getListeners(evt).concat([cb])), self;
  }
  function off(evt, cb) {
    return (listeners[evt] = getListeners(evt).filter((e) => e !== cb)), self;
  }
  const self = { init, emit, off, on };
  return self;
}
const defaultOptions$1 = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  inViewThreshold: 0,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
};
function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia2 = options.breakpoints || {},
      matchedMediaOptions = objectKeys(optionsAtMedia2)
        .filter((media) => ownerWindow.matchMedia(media).matches)
        .map((media) => optionsAtMedia2[media])
        .reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList
      .map((options) => objectKeys(options.breakpoints || {}))
      .reduce((acc, mediaQueries) => acc.concat(mediaQueries), [])
      .map(ownerWindow.matchMedia);
  }
  return { mergeOptions, optionsAtMedia, optionsMediaQueries };
}
function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(plugins, emblaApi) {
    return (
      (activePlugins = plugins.filter(
        ({ options }) => optionsHandler.optionsAtMedia(options).active !== !1
      )),
      activePlugins.forEach((plugin) => plugin.init(emblaApi, optionsHandler)),
      plugins.reduce(
        (map, plugin) => Object.assign(map, { [plugin.name]: plugin }),
        {}
      )
    );
  }
  function destroy() {
    activePlugins = activePlugins.filter((plugin) => plugin.destroy());
  }
  return { init, destroy };
}
function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument,
    ownerWindow = ownerDocument.defaultView,
    optionsHandler = OptionsHandler(ownerWindow),
    pluginsHandler = PluginsHandler(optionsHandler),
    mediaHandlers = EventStore(),
    documentVisibleHandler = EventStore(),
    eventHandler = EventHandler(),
    { animationRealms } = EmblaCarousel,
    { mergeOptions, optionsAtMedia, optionsMediaQueries } = optionsHandler,
    { on, off, emit } = eventHandler,
    reInit = reActivate;
  let destroyed = !1,
    engine,
    optionsBase = mergeOptions(defaultOptions$1, EmblaCarousel.globalOptions),
    options = mergeOptions(optionsBase),
    pluginList = [],
    pluginApis,
    container,
    slides;
  function storeElements() {
    const { container: userContainer, slides: userSlides } = options;
    container =
      (isString(userContainer)
        ? root.querySelector(userContainer)
        : userContainer) || root.children[0];
    const customSlides = isString(userSlides)
      ? container.querySelectorAll(userSlides)
      : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options2, animations) {
    const engine2 = Engine(
      root,
      container,
      slides,
      ownerDocument,
      ownerWindow,
      options2,
      eventHandler,
      animations
    );
    if (options2.loop && !engine2.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options2, { loop: !1 });
      return createEngine(optionsWithoutLoop, animations);
    }
    return engine2;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    const animationRealm = animationRealms.find(
        (a) => a.window === ownerWindow
      ),
      animations = animationRealm || Animations(ownerWindow);
    animationRealm || animationRealms.push(animations),
      (optionsBase = mergeOptions(optionsBase, withOptions)),
      (options = optionsAtMedia(optionsBase)),
      (pluginList = withPlugins || pluginList),
      storeElements(),
      (engine = createEngine(options, animations)),
      optionsMediaQueries([
        optionsBase,
        ...pluginList.map(({ options: options2 }) => options2),
      ]).forEach((query) => mediaHandlers.add(query, "change", reActivate)),
      options.active &&
        (engine.translate.to(engine.location.get()),
        engine.eventHandler.init(self),
        engine.resizeHandler.init(self, options.watchResize),
        engine.slidesHandler.init(self, options.watchSlides),
        documentVisibleHandler.add(ownerDocument, "visibilitychange", () => {
          ownerDocument.hidden && animations.reset();
        }),
        engine.options.loop && engine.slideLooper.loop(),
        container.offsetParent &&
          slides.length &&
          engine.dragHandler.init(self, options.watchDrag),
        (pluginApis = pluginsHandler.init(pluginList, self)));
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate(),
      activate(mergeOptions({ startIndex }, withOptions), withPlugins),
      eventHandler.emit("reInit");
  }
  function deActivate() {
    engine.dragHandler.destroy(),
      engine.animation.stop(),
      engine.eventStore.clear(),
      engine.translate.clear(),
      engine.slideLooper.clear(),
      engine.resizeHandler.destroy(),
      engine.slidesHandler.destroy(),
      pluginsHandler.destroy(),
      mediaHandlers.clear(),
      documentVisibleHandler.clear();
  }
  function destroy() {
    destroyed ||
      ((destroyed = !0),
      mediaHandlers.clear(),
      deActivate(),
      eventHandler.emit("destroy"));
  }
  function slidesInView(target) {
    const location = engine[target ? "target" : "location"].get(),
      type = options.loop ? "removeOffset" : "constrain";
    return engine.slidesInView.check(engine.limit[type](location));
  }
  function slidesNotInView(target) {
    const inView = slidesInView(target);
    return engine.slideIndexes.filter((index) => !inView.includes(index));
  }
  function scrollTo(index, jump, direction) {
    !options.active ||
      destroyed ||
      (engine.scrollBody
        .useBaseFriction()
        .useDuration(jump ? 0 : options.duration),
      engine.scrollTo.index(index, direction || 0));
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump === !0, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump === !0, 1);
  }
  function canScrollNext() {
    return engine.index.add(1).get() !== selectedScrollSnap();
  }
  function canScrollPrev() {
    return engine.index.add(-1).get() !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnaps.map(engine.scrollProgress.get);
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.location.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView,
  };
  return (
    activate(userOptions, userPlugins),
    setTimeout(() => eventHandler.emit("init"), 0),
    self
  );
}
EmblaCarousel.animationRealms = [];
EmblaCarousel.globalOptions = void 0;
const defaultOptions = {
  active: !0,
  breakpoints: {},
  selected: "is-selected",
  draggable: "is-draggable",
  dragging: "is-dragging",
};
function removeClass(node, className) {
  const cl = node.classList;
  className && cl.contains(className) && cl.remove(className);
}
function addClass(node, className) {
  const cl = node.classList;
  className && !cl.contains(className) && cl.add(className);
}
function ClassNames(userOptions = {}) {
  let options, emblaApi, root, slides;
  const selectedEvents = ["select", "pointerUp"],
    draggingEvents = ["pointerDown", "pointerUp"];
  function init(emblaApiInstance, optionsHandler) {
    emblaApi = emblaApiInstance;
    const { mergeOptions, optionsAtMedia } = optionsHandler,
      optionsBase = mergeOptions(defaultOptions, ClassNames.globalOptions),
      allOptions = mergeOptions(optionsBase, userOptions);
    (options = optionsAtMedia(allOptions)),
      (root = emblaApi.rootNode()),
      (slides = emblaApi.slideNodes()),
      !!emblaApi.internalEngine().options.watchDrag &&
        addClass(root, options.draggable),
      options.dragging &&
        draggingEvents.forEach((evt) => emblaApi.on(evt, toggleDraggingClass)),
      options.selected &&
        (selectedEvents.forEach((evt) => emblaApi.on(evt, toggleSelectedClass)),
        toggleSelectedClass());
  }
  function destroy() {
    removeClass(root, options.draggable),
      draggingEvents.forEach((evt) => emblaApi.off(evt, toggleDraggingClass)),
      selectedEvents.forEach((evt) => emblaApi.off(evt, toggleSelectedClass)),
      slides.forEach((slide) => removeClass(slide, options.selected));
  }
  function toggleDraggingClass(_, evt) {
    evt === "pointerDown"
      ? addClass(root, options.dragging)
      : removeClass(root, options.dragging);
  }
  function toggleSelectedClass() {
    const inView = emblaApi.slidesInView(!0);
    emblaApi
      .slidesNotInView(!0)
      .forEach((index) => removeClass(slides[index], options.selected)),
      inView.forEach((index) => addClass(slides[index], options.selected));
  }
  return { name: "classNames", options: userOptions, init, destroy };
}
ClassNames.globalOptions = void 0;
const STATE = {
  idle: "idle",
  running: "running",
  paused: "paused",
  resumed: "resumed",
};
class IntervalTimer {
  constructor(callback, interval) {
    __publicField(this, "state", STATE.idle);
    __publicField(this, "pausedTime", 0);
    __publicField(this, "remainingTime", 0);
    __publicField(this, "lastFireTime");
    __publicField(this, "lastPauseTime");
    __publicField(this, "callback");
    __publicField(this, "interval");
    __publicField(this, "timerId");
    __publicField(this, "resumeId");
    (this.interval = interval), (this.callback = callback);
  }
  proxyCallback() {
    (this.lastFireTime = new Date().valueOf()), this.callback();
  }
  start() {
    (this.timerId = setInterval(() => this.proxyCallback(), this.interval)),
      (this.lastFireTime = new Date().valueOf()),
      (this.state = STATE.running);
  }
  pause() {
    (this.state !== STATE.running && this.state !== STATE.resumed) ||
      ((this.remainingTime =
        this.interval -
        (new Date().valueOf() - this.lastFireTime) +
        this.pausedTime),
      (this.lastPauseTime = new Date().valueOf()),
      clearInterval(this.timerId),
      clearTimeout(this.resumeId),
      (this.state = STATE.paused));
  }
  resume() {
    this.state === STATE.paused &&
      ((this.pausedTime += new Date().valueOf() - this.lastPauseTime),
      (this.state = STATE.resumed),
      (this.resumeId = setTimeout(
        () => this.timeoutCallback(),
        this.remainingTime
      )));
  }
  timeoutCallback() {
    this.state === STATE.resumed &&
      ((this.pausedTime = 0), this.proxyCallback(), this.start());
  }
  stop() {
    this.state !== STATE.idle &&
      (clearInterval(this.timerId),
      clearTimeout(this.resumeId),
      (this.state = STATE.idle));
  }
  setInterval(newInterval) {
    this.state === STATE.running
      ? (this.pause(), (this.interval = newInterval), this.resume())
      : (this.interval = newInterval);
  }
}
const oneAtTimeAutoPlay = (embla, interval) => {
    const next = () => {
        const lastSlideIndex = embla.scrollSnapList().length - 1;
        embla.selectedScrollSnap() === lastSlideIndex
          ? embla.scrollTo(0)
          : embla.scrollNext();
      },
      intervalTimer = new IntervalTimer(next, interval);
    return {
      play: () => {
        intervalTimer.resume();
      },
      stop: () => {
        intervalTimer.stop();
      },
      start: () => {
        intervalTimer.start();
      },
      pause: () => {
        intervalTimer.pause();
      },
    };
  },
  seamlessAutoPlay = (embla, interval) => {
    let tick = 0;
    const engine = embla.internalEngine(),
      distance = interval / -5,
      animate = () => {
        engine.scrollTo.distance(distance, !1),
          (tick = requestAnimationFrame(animate));
      };
    return {
      play: () => {
        tick = requestAnimationFrame(animate);
      },
      pause: () => {
        cancelAnimationFrame(tick);
      },
      stop: () => {
        cancelAnimationFrame(tick), (tick = 0);
      },
    };
  };
class CarouselComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "withSimpleAutoplay");
    __publicField(this, "withSeamlessAutoplay");
    __publicField(this, "withAutoplay");
    __publicField(this, "withFade");
    __publicField(this, "isTouching");
    __publicField(this, "isPlay");
    __publicField(this, "lastIsMobile");
    __publicField(this, "autoplay");
    __publicField(this, "embla");
    __publicField(this, "resizeObserver");
    __publicField(this, "handleKeydown", (event) => {
      if ((this.stop(), isTabKey(event))) {
        const targets = $list(getFocusTargets(), this).filter(
            (target) => target.clientWidth > 0
          ),
          index = targets.findIndex((target) => target === event.target),
          nextTarget = targets[index + 1],
          prevTarget = targets[index - 1];
        event.shiftKey
          ? prevTarget && this.focusScroll(prevTarget)
          : nextTarget && this.focusScroll(nextTarget);
      }
      isLeftKey(event) && this.embla.scrollPrev(),
        isRightKey(event) && this.embla.scrollNext();
    });
    __publicField(this, "handleCarouselResize", () => {
      this.lastIsMobile !== isMobile() && !this.isPlay && this.play(),
        (this.lastIsMobile = isMobile()),
        this.withFade ? this.resizeFade() : this.reInit();
    });
    __publicField(this, "focusScroll", (target) => {
      const slides = [...this.embla.slideNodes()],
        slideIndex = slides.findIndex((slide) => slide.contains(target));
      if (slideIndex === -1) return;
      const slidesInOneScroll = Math.floor(
          slides.length / this.embla.scrollSnapList().length
        ),
        snapIndex = Math.floor(slideIndex / slidesInOneScroll);
      this.embla.scrollTo(snapIndex, !0);
    });
    __publicField(this, "handleCarouselEnter", () => {
      var _a;
      isMobile() ||
        (this.isPlay === !0 && ((_a = this.autoplay) == null || _a.pause()));
    });
    __publicField(this, "handleCarouselLeave", () => {
      var _a;
      isMobile() ||
        (this.isPlay === !0 && ((_a = this.autoplay) == null || _a.play()));
    });
    __publicField(this, "handleCarouselSelect", () => {
      (this.dataset.startIndex = `${this.embla.selectedScrollSnap()}`),
        this.emit("carouselSelect", {});
    });
    __publicField(this, "handleCarouselScroll", () => {
      this.isTouching && this.stop(), this.emit("carouselSelect", {});
    });
    __publicField(this, "handleCarouselPointerUp", () => {
      this.isTouching = !1;
    });
    __publicField(this, "handleCarouselPointerDown", () => {
      this.isTouching = !0;
    });
    __publicField(
      this,
      "handleBlockSelect",
      ({ detail: { sectionId, blockId, load } }) => {
        if (this.dataset.sectionId !== sectionId) return;
        const slideIndex = this.embla
          .slideNodes()
          .findIndex(({ attributes }) => {
            var _a;
            return (
              ((_a = attributes["block-id"]) == null ? void 0 : _a.value) ===
              blockId
            );
          });
        slideIndex !== -1 &&
          (this.embla.scrollTo(slideIndex, load), this.stop());
      }
    );
    __publicField(this, "handleSectionLoad", ({ detail: { sectionId } }) => {
      this.dataset.sectionId === sectionId &&
        (this.stop(), this.withAutoplay && this.setAutoplay(), this.reInit());
    });
    __publicField(this, "getOptions", () => ({
      loop: this.hasAttribute("data-loop"),
      dragFree: this.hasAttribute("data-drag-free"),
      watchDrag: this.hasAttribute("data-draggable"),
      skipSnaps: this.hasAttribute("data-skip-snaps"),
      align: this.getAttribute("data-align"),
      containScroll: this.getAttribute("data-contain-scroll"),
      inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.75,
      axis: this.getAttribute("data-axis"),
      breakpoints: this.hasAttribute("data-breakpoints")
        ? JSON.parse(this.dataset.breakpoints)
        : void 0,
      slidesToScroll: +(this.getAttribute("data-slides-to-scroll") ?? 1),
      startIndex: this.hasAttribute("data-start-index")
        ? Number(this.dataset.startIndex)
        : 0,
      direction: this.hasAttribute("data-direction-rtl") ? "rtl" : "ltr",
    }));
    __publicField(this, "getPlugins", () => {
      const plugins = [ClassNames()];
      return (
        this.hasAttribute("data-with-wheel-gestures") &&
          plugins.push(
            WheelGesturesPlugin({
              forceWheelAxis: this.getAttribute("data-axis"),
            })
          ),
        plugins
      );
    });
    __publicField(this, "resizeFade", () => {
      this.classList.remove("carousel--with-fade"), this.reInit();
    });
    __publicField(this, "initFade", () => {
      const height = this.embla.slideNodes()[0].getBoundingClientRect().height;
      this.setAttribute("style", `--gsc-fade-height: ${height}px`),
        this.classList.add("carousel--with-fade");
    });
    __publicField(this, "reInit", (options = {}) => {
      this.embla.reInit(
        { ...this.getOptions(), ...options },
        this.getPlugins()
      );
    });
    (this.withSimpleAutoplay = this.dataset.autoplayMode === "one_at_time"),
      (this.withSeamlessAutoplay = this.dataset.autoplayMode === "seamless"),
      (this.withAutoplay =
        this.withSimpleAutoplay || this.withSeamlessAutoplay),
      (this.withFade = this.dataset.animation === "fade");
  }
  mountComponent() {
    this.setCarousel(),
      this.setAutoplay(),
      this.addListener(this, "keydown", this.handleKeydown),
      this.embla.on("select", this.handleCarouselSelect),
      this.embla.on("scroll", this.handleCarouselScroll),
      this.embla.on("pointerUp", this.handleCarouselPointerUp),
      this.embla.on("pointerDown", this.handleCarouselPointerDown),
      this.withFade
        ? (this.embla.on("init", this.initFade),
          this.embla.on("resize", this.resizeFade),
          this.embla.on("reInit", this.initFade),
          this.embla.internalEngine().translate.toggleActive(!1))
        : document.fonts.ready.then(() => {
            this.reInit();
          }),
      this.hasAttribute("with-hover-pause") &&
        this.isPlay &&
        (this.addListener(this, "mouseenter", this.handleCarouselEnter),
        this.addListener(this, "mouseleave", this.handleCarouselLeave)),
      this.isEditor &&
        ((this.resizeObserver = new ResizeObserver(this.handleCarouselResize)),
        this.resizeObserver.observe(this),
        this.editor.on("BLOCK_SELECT", this.handleBlockSelect),
        this.editor.on("SECTION_LOAD", this.handleSectionLoad));
  }
  unmountComponent() {
    this.embla.destroy(), this.isEditor && this.resizeObserver.disconnect();
  }
  setCarousel() {
    const viewport = $el("[data-carousel-viewport]", this);
    viewport &&
      (this.embla = EmblaCarousel(
        viewport,
        this.getOptions(),
        this.getPlugins()
      ));
  }
  setAutoplay() {
    if (this.autoplay) return;
    const autoplayInterval = +(this.dataset.autoplayInterval || 0);
    (this.isPlay = autoplayInterval > 0),
      this.withSimpleAutoplay &&
        ((this.autoplay = oneAtTimeAutoPlay(
          this.embla,
          autoplayInterval * 1e3
        )),
        this.autoplay.start()),
      this.withSeamlessAutoplay &&
        ((this.autoplay = seamlessAutoPlay(this.embla, autoplayInterval)),
        this.autoplay.play());
  }
  stop() {
    var _a;
    this.withAutoplay &&
      ((_a = this.autoplay) == null || _a.stop(),
      (this.isPlay = !1),
      this.emit("changePlayState", {}));
  }
  play() {
    this.withAutoplay &&
      (this.withSimpleAutoplay && this.autoplay.start(),
      this.withSeamlessAutoplay && this.autoplay.play(),
      (this.isPlay = !0),
      this.emit("changePlayState", {}));
  }
}
const CAROUSEL_COMPONENT_SELECTOR = "carousel-component",
  CAROUSEL_DOTS_SELECTOR = "carousel-dots",
  HIDE_INSIDE_DOTS_SELECTOR = "data-hide-inside-dots";
class CarouselButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "snaps", []);
    __publicField(this, "checkIfToHideButton", () => {
      $elParent(CAROUSEL_DOTS_SELECTOR, this).embla.slidesInView().length ===
      this.snaps.length
        ? this.hideButton(!0)
        : this.initButton();
    });
    __publicField(this, "initButton", () => {
      this.update(),
        this.addListener(this, "keydown", this.handleKeyDown),
        this.addListener(this, "click", this.handleButtonClick),
        this.carousel &&
          (this.carousel.embla.on("reInit", this.handleCarouselReInit),
          this.carousel.embla.on("select", this.handleCarouselSelect),
          this.carousel.embla.on("scroll", this.handleCarouselScroll));
    });
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.trigger();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.trigger());
    });
    __publicField(this, "handleCarouselReInit", () => {
      this.update();
    });
    __publicField(this, "handleCarouselSelect", () => {
      this.update();
    });
    __publicField(this, "handleCarouselScroll", () => {
      this.update();
    });
    __publicField(this, "updateDisable", () => {
      var _a, _b;
      const canScroll =
        this.dataset.direction === "next"
          ? (_a = this.carousel) == null
            ? void 0
            : _a.embla.canScrollNext()
          : (_b = this.carousel) == null
          ? void 0
          : _b.embla.canScrollPrev();
      this.toggleAttribute("disabled", !canScroll);
    });
    __publicField(this, "hideButton", (boolean) => {
      this.toggleAttribute("has-not-slides-not-in-view", boolean);
    });
  }
  mountComponent() {
    (this.snaps = [...Array(this.carousel.embla.slideNodes().length).keys()]),
      this.hasAttribute(HIDE_INSIDE_DOTS_SELECTOR)
        ? this.checkIfToHideButton()
        : this.initButton();
  }
  unmountComponent() {
    this.carousel &&
      (this.carousel.embla.off("reInit", this.handleCarouselReInit),
      this.carousel.embla.off("scroll", this.handleCarouselScroll),
      this.carousel.embla.off("select", this.handleCarouselSelect));
  }
  update() {
    this.updateDisable(), this.updateVisible();
  }
  updateVisible() {
    if (!this.carousel) return;
    const slides = this.carousel.embla.slidesInView(),
      index = this.dataset.direction === "next" ? this.snaps.length - 1 : 0;
    this.hideButton(slides.includes(index));
  }
  trigger() {
    var _a, _b, _c;
    this.dataset.direction === "next"
      ? (_a = this.carousel) == null || _a.embla.scrollNext()
      : (_b = this.carousel) == null || _b.embla.scrollPrev(),
      (_c = this.carousel) == null || _c.stop();
  }
  get carousel() {
    return $elParent(CAROUSEL_COMPONENT_SELECTOR, this);
  }
}
const CAROUSEL_SELECTOR$a = "carousel-component",
  CAROUSEL_DOT_SELECTOR = "[data-carousel-dot]";
class CarouselDots extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "embla");
    __publicField(this, "dots");
    __publicField(this, "handleDotClick", (event) => {
      const dot = $elParent(CAROUSEL_DOT_SELECTOR, event.target);
      dot && this.scrollToIndex(+dot.dataset.dotIndex);
    });
    __publicField(this, "handleKeydown", (event) => {
      if (isTabKey(event)) {
        const targets = $list(getFocusTargets(), this).filter(
            (target) => target.clientWidth > 0
          ),
          index = targets.findIndex((target) => target === event.target),
          nextTarget = targets[index + 1],
          prevTarget = targets[index - 1];
        event.shiftKey
          ? prevTarget && this.focusScroll(prevTarget)
          : nextTarget && this.focusScroll(nextTarget);
      }
      const dot = $elParent(CAROUSEL_DOT_SELECTOR, event.target);
      dot &&
        isEnterKey(event) &&
        (event.preventDefault(), this.scrollToIndex(+dot.dataset.dotIndex));
    });
    __publicField(this, "handleSettle", () => {
      this.update();
    });
    __publicField(this, "handleCarouselInit", () => {
      var _a, _b;
      this.setCarousel(),
        this.updateLoadAnimation(),
        this.addListener(this, "click", this.handleDotClick),
        this.addListener(this, "keydown", this.handleKeydown),
        (_a = this.carousel) == null ||
          _a.embla.on("reInit", this.handleCarouselReInit),
        (_b = this.carousel) == null ||
          _b.embla.on("select", this.handleCarouselSelect),
        this.embla.on("resize", this.handleResize),
        this.embla.on("settle", this.handleSettle),
        this.getAttribute("change-slide-on-scroll") &&
          this.embla.on("select", this.handleSelect);
    });
    __publicField(this, "handleSelect", () => {
      const selectedDotIndex = this.dots.findIndex((dot) =>
        dot.classList.contains("is-selected")
      );
      this.carousel.embla.scrollTo(selectedDotIndex);
    });
    __publicField(this, "handleCarouselReInit", () => {
      this.setCarousel();
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        this.update();
      }, 250)
    );
    __publicField(this, "handleCarouselSelect", () => {
      if (!this.carousel) return;
      const index = this.carousel.embla.selectedScrollSnap();
      this.embla.scrollTo(index),
        this.dots.forEach((dot) => {
          dot.classList.toggle("is-primary", +dot.dataset.dotIndex === index);
        });
    });
    __publicField(this, "handleChangePlayState", () => {
      this.updateLoadAnimation();
    });
    __publicField(this, "focusScroll", (target) => {
      const slideIndex = [...this.embla.slideNodes()].findIndex((slide) =>
        slide.contains(target)
      );
      slideIndex !== -1 && this.embla.scrollTo(slideIndex, !0);
    });
    __publicField(this, "getOptions", () => ({
      inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.5,
      containScroll: this.getAttribute("data-contain-scroll"),
      align: this.getAttribute("data-align"),
      skipSnaps: this.hasAttribute("data-skip-snaps"),
      watchDrag: this.hasAttribute("data-draggable"),
      dragFree: this.hasAttribute("data-drag-free"),
      axis: this.getAttribute("data-axis"),
    }));
    __publicField(this, "getPlugins", () => {
      const plugins = [ClassNames()];
      return (
        this.hasAttribute("data-with-wheel-gestures") &&
          plugins.push(
            WheelGesturesPlugin({
              forceWheelAxis: this.getAttribute("data-axis"),
            })
          ),
        plugins
      );
    });
  }
  mountComponent() {
    var _a;
    this.handleCarouselInit(),
      (_a = this.carousel) == null ||
        _a.on("changePlayState", this.handleChangePlayState);
  }
  unmountComponent() {
    var _a, _b, _c;
    (_a = this.carousel) == null ||
      _a.off("changePlayState", this.handleChangePlayState),
      (_b = this.carousel) == null ||
        _b.embla.off("reInit", this.handleCarouselReInit),
      (_c = this.carousel) == null ||
        _c.embla.off("select", this.handleCarouselSelect),
      this.embla.destroy();
  }
  updateLoadAnimation() {
    var _a;
    this.classList.toggle(
      "is-autoplaying",
      (_a = this.carousel) == null ? void 0 : _a.isPlay
    );
  }
  reInit() {
    this.embla.reInit(this.getOptions(), this.getPlugins());
  }
  scrollToIndex(index) {
    var _a, _b;
    (_a = this.carousel) == null || _a.embla.scrollTo(index),
      (_b = this.carousel) == null || _b.stop();
  }
  setCarousel() {
    const viewport = $el("[data-carousel-viewport]", this);
    viewport &&
      ((this.embla = EmblaCarousel(
        viewport,
        this.getOptions(),
        this.getPlugins()
      )),
      (this.dots = [...this.embla.slideNodes()]));
  }
  stop() {
    var _a;
    (_a = this.carousel) == null || _a.stop();
  }
  update() {
    const indexList = this.dots.map((_, index) => index),
      visibleIndexList = this.embla.slidesInView();
    this.dots.forEach((dot, index) => {
      const firstVisibleIndex = visibleIndexList[0],
        lastVisibleIndex = visibleIndexList[visibleIndexList.length - 1],
        firstIndex = indexList[0],
        lastIndex = indexList[indexList.length - 1],
        isLast = index === lastIndex,
        isLastVisible = index === lastVisibleIndex,
        isFirst = index === firstIndex,
        isFirstVisible = index === firstVisibleIndex;
      dot.classList.toggle(
        "is-prev-prev",
        (isFirstVisible || isLastVisible) && !isLast && !isFirst
      );
    });
  }
  get carousel() {
    return $elParent(CAROUSEL_SELECTOR$a, this);
  }
}
const BUTTON_SELECTOR$6 = "[data-carousel-play-button]",
  CAROUSEL_SELECTOR$9 = "carousel-component";
class CarouselPlayButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleChangePlayState", () => {
      this.update();
    });
    __publicField(this, "handleButtonClick", (event) => {
      event.stopPropagation(),
        this.carousel &&
          (this.carousel.isPlay ? this.carousel.stop() : this.carousel.play(),
          this.resetAnimation());
    });
  }
  mountComponent() {
    this.update(),
      this.addListener(this, "click", this.handleButtonClick),
      this.carousel &&
        (customElements.upgrade(this.carousel),
        whenDefined("carousel-component").then(() => {
          var _a;
          (_a = this.carousel) == null ||
            _a.on("changePlayState", this.handleChangePlayState);
        }));
  }
  unmountComponent() {
    this.carousel &&
      whenDefined("carousel-component").then(() => {
        var _a;
        (_a = this.carousel) == null ||
          _a.off("changePlayState", this.handleChangePlayState);
      });
  }
  update() {
    const button = $el(BUTTON_SELECTOR$6, this);
    !this.carousel ||
      !button ||
      button.toggleAttribute("data-autoplay-stopped", !this.carousel.isPlay);
  }
  resetAnimation() {
    this.carousel.classList.toggle(
      "is-reset-autoplay-loader-animation",
      !this.carousel.isPlay
    );
  }
  get carousel() {
    return $elParent(CAROUSEL_SELECTOR$9, this);
  }
}
const ANIMATE_IMAGES_ATTRIBUTE = "data-animate-images",
  SLIDE_ANIMATED_CLASSNAME = "slideshow__slide--animated";
class SlideshowComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "withImagesAnimated");
    __publicField(this, "handleCarouselSelect", (data) => {
      data
        .slideNodes()
        [data.previousScrollSnap()].classList.remove(SLIDE_ANIMATED_CLASSNAME),
        data
          .slideNodes()
          [data.selectedScrollSnap()].classList.add(SLIDE_ANIMATED_CLASSNAME);
    });
    this.withImagesAnimated = this.hasAttribute(ANIMATE_IMAGES_ATTRIBUTE);
  }
  mountComponent() {
    if (!this.withImagesAnimated) return;
    const carousel = $el("carousel-component", this);
    carousel &&
      (carousel.embla
        .slideNodes()
        [carousel.embla.selectedScrollSnap()].classList.add(
          SLIDE_ANIMATED_CLASSNAME
        ),
      carousel.embla.on("select", this.handleCarouselSelect));
  }
}
const CART_PAGE_SELECTOR$b = "cart-page",
  CART_DRAWER_SELECTOR$b = "cart-drawer",
  CART_POPUP_SELECTOR = "cart-notification-popup",
  NEW_COUNT_SELECTOR = "#NewCartCount";
class CartCount extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      const newNode = $el(NEW_COUNT_SELECTOR, node);
      replaceNodeChildren(this, newNode);
    });
  }
  mountComponent() {
    const cart = $el(CART_PAGE_SELECTOR$b),
      cartDrawer = $el(CART_DRAWER_SELECTOR$b),
      cartPopup = $el(CART_POPUP_SELECTOR);
    cart == null || cart.on("update-nodes", this.handleCartUpdate),
      cartDrawer == null ||
        cartDrawer.on("update-nodes", this.handleCartUpdate),
      cartPopup == null || cartPopup.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $el(CART_PAGE_SELECTOR$b),
      cartDrawer = $el(CART_DRAWER_SELECTOR$b),
      cartPopup = $el(CART_POPUP_SELECTOR);
    cart == null || cart.off("update-nodes", this.handleCartUpdate),
      cartDrawer == null ||
        cartDrawer.off("update-nodes", this.handleCartUpdate),
      cartPopup == null || cartPopup.off("update-nodes", this.handleCartUpdate);
  }
}
const BODY_ELEMENT_SELECTOR$b = "body-element";
class ModalComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "element");
    __publicField(this, "isOpen");
    __publicField(this, "withOutsideClick");
    __publicField(this, "skipTransitionWait");
    __publicField(this, "handleModalFocusout", (event) => {
      const bodyElement = $el(BODY_ELEMENT_SELECTOR$b),
        focusTarget = event.relatedTarget,
        isLastOpenedWindow = bodyElement.isLastOpenedWindow(this.id);
      if (
        (!focusTarget || !this.contains(focusTarget)) &&
        isLastOpenedWindow &&
        bodyElement.isUsingKeyboard
      ) {
        const { firstTarget } = getTargets(this.element);
        firstTarget.focus();
      }
    });
    __publicField(this, "handleKeydown", (event) => {
      !this.hasAttribute("data-ignore-esc-key") &&
        isEscKey(event) &&
        (event.preventDefault(), this.hide());
    });
    __publicField(this, "handleOutsideClick", (event) => {
      $elParent(BODY_ELEMENT_SELECTOR$b, event.target) &&
        this.isOpen &&
        this.hide();
    });
    (this.element = getTemplateFirstChild(
      $el(`[data-modal-template="${this.id}"]`, this)
    )),
      (this.withOutsideClick = this.hasAttribute("data-with-close-on-outside")),
      (this.skipTransitionWait = this.hasAttribute(
        "data-skip-transition-wait"
      ));
  }
  mountComponent() {
    super.mountComponent(),
      this.withOutsideClick &&
        this.addListener(window, "click", this.handleOutsideClick),
      this.isEditor && (this.isSection || this.hide(!0));
  }
  async show() {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$b);
    whenDefined("body-element").then(() => {
      bodyElement.addDialogWindow(this.id);
    }),
      this.mount(),
      await this.setOpenState(!0),
      this.skipTransitionWait || (await transitionToPromise(this));
    const videos = $list("video[autoplay]", this.element);
    if (
      (videos == null ||
        videos.forEach((video) => {
          video.play();
        }),
      window.self === window.top)
    ) {
      const { firstTarget } = getTargets(this.element);
      firstTarget == null || firstTarget.focus();
    }
    this.addListener(this, "focusout", this.handleModalFocusout),
      this.addListener(window, "keydown", this.handleKeydown),
      this.emit("show", {});
  }
  async hide(isInstant) {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$b);
    whenDefined("body-element").then(() => {
      bodyElement.removeDialogWindow(this.id);
    }),
      this.removeListener(window, "keydown", this.handleKeydown),
      this.removeListener(this, "focusout", this.handleModalFocusout),
      await this.setOpenState(!1),
      this.skipTransitionWait || isInstant
        ? this.unmount()
        : (await transitionToPromise(this), this.unmount()),
      this.emit("hide", {});
  }
  async toggle() {
    this.isOpen ? this.hide() : this.show();
  }
  mount() {
    this.replaceChildren(this.element);
  }
  unmount() {
    this.replaceChildren();
  }
  async setOpenState(isOpen) {
    if (((this.isOpen = isOpen), this.hasAttribute("data-with-overlay"))) {
      const bodyElement = $el(BODY_ELEMENT_SELECTOR$b),
        isImportant = this.hasAttribute("data-overlay-important"),
        hasCustomOpacity = this.hasAttribute("data-overlay-opacity");
      let styles = {};
      isImportant &&
        (styles = {
          ...styles,
          zIndex: parseFloat(getComputedStyle(this).zIndex) - 1,
        }),
        hasCustomOpacity &&
          (styles = {
            ...styles,
            "--gsc-body-overlay-opacity": +this.getAttribute(
              "data-overlay-opacity"
            ),
          }),
        await whenDefined("body-element").then(() => {
          isOpen
            ? bodyElement.showOverlay(this.id, styles)
            : bodyElement.hideOverlay(this.id);
        });
    }
    this.setVisible(isOpen);
  }
  setVisible(isOpened) {
    this.classList.toggle("is-opened", isOpened);
  }
  get isSection() {
    return this.hasAttribute("is-section");
  }
}
class ModalButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.trigger();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.trigger());
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeyDown),
      this.addListener(this, "click", this.handleButtonClick);
  }
  trigger() {
    const modal = $el(this.dataset.modal, document);
    if (modal)
      switch (this.dataset.action) {
        case "close":
          modal.hide();
          return;
        case "open":
          modal.show();
          return;
        case "toggle":
          modal.toggle();
          return;
      }
    this.emit("click", {});
  }
}
const HEADER_SELECTOR$4 = "header-component",
  HEADER_WITH_POPUP_CLASS = "shopify-section-header--with-cart-popup",
  SELECTOR_CONSENT_CHECKBOX$2 = ".checkbox--consent",
  SELECTOR_CHECKOUT_BUTTON = "button#checkout",
  SELECTOR_CONSENT_CHECKBOX_INPUT = ".checkbox--consent .checkbox__input";
class CartNotificationPopup extends ModalComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "wasHeaderHidden");
    __publicField(this, "handleConsentCheckboxChange", ({ target }) => {
      if (target.closest(SELECTOR_CONSENT_CHECKBOX$2)) {
        const checkoutButton = $el(SELECTOR_CHECKOUT_BUTTON, this);
        checkoutButton == null ||
          checkoutButton.toggleAttribute("disabled", !target.checked);
      }
    });
    __publicField(this, "resetContextCheckbox", () => {
      const consentCheckboxInput = $el(SELECTOR_CONSENT_CHECKBOX_INPUT, this);
      if (consentCheckboxInput) {
        const checkoutButton = $el(SELECTOR_CHECKOUT_BUTTON, this);
        checkoutButton == null ||
          checkoutButton.toggleAttribute("disabled", !0),
          (consentCheckboxInput.checked = !1);
      }
    });
    __publicField(this, "toggleMobileHeader", async (isToShow) => {
      if (isMobile()) {
        const header = $el(HEADER_SELECTOR$4);
        header == null ||
          header.parentElement.classList.toggle(
            HEADER_WITH_POPUP_CLASS,
            !isToShow
          ),
          this.wasHeaderHidden && header.setHidden(isToShow),
          await delay(300);
      }
    });
  }
  mountComponent() {
    super.mountComponent(),
      this.addListener(this, "change", this.handleConsentCheckboxChange);
  }
  unmountComponent() {
    super.unmountComponent(),
      this.removeListener(this, "change", this.handleConsentCheckboxChange);
  }
  purchaseHandler(html, parsedState) {
    const header = $el(HEADER_SELECTOR$4);
    if (((this.wasHeaderHidden = header.isHidden), this.element)) {
      const newNode = $el(`#CartNotificationPopupItem-${parsedState.id}`, html),
        node = $el("[data-cart-notification-popup]", this.element);
      replaceNodeChildren(node, newNode),
        this.toggleMobileHeader(!1).then(() => {
          this.show(),
            delay(5e3).then(() => {
              this.hide();
            });
        }),
        this.emit("update-nodes", { node, parsedState });
    }
  }
  mount() {
    super.mount(), this.resetContextCheckbox();
  }
  async hide() {
    await super.hide(),
      await transitionToPromise(this),
      this.toggleMobileHeader(!0);
  }
}
class ClipboardButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.copy();
    });
    __publicField(this, "handleButtonKeydown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.copy());
    });
    __publicField(this, "copy", () => {
      const value = this.dataset.value;
      value &&
        navigator.clipboard &&
        navigator.clipboard
          .writeText(value)
          .then(() => {
            this.showTooltip();
          })
          .catch((e) => {
            throw (window.Shopify.designMode && this.showTooltip(), e);
          });
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleButtonClick),
      this.addListener(this, "keydown", this.handleButtonKeydown);
  }
  showTooltip() {
    const tooltip = $el(`#${this.dataset.tooltipId}`);
    tooltip &&
      (tooltip.show(),
      delay(1e3).then(() => {
        tooltip.hide();
      }));
  }
}
const min = Math.min,
  max = Math.max,
  round = Math.round,
  floor = Math.floor,
  createCoords = (v) => ({ x: v, y: v }),
  oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom",
  },
  oppositeAlignmentMap = { start: "end", end: "start" };
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value == "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  rtl === void 0 && (rtl = !1);
  const alignment = getAlignment(placement),
    alignmentAxis = getAlignmentAxis(placement),
    length = getAxisLength(alignmentAxis);
  let mainAlignmentSide =
    alignmentAxis === "x"
      ? alignment === (rtl ? "end" : "start")
        ? "right"
        : "left"
      : alignment === "start"
      ? "bottom"
      : "top";
  return (
    rects.reference[length] > rects.floating[length] &&
      (mainAlignmentSide = getOppositePlacement(mainAlignmentSide)),
    [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)]
  );
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [
    getOppositeAlignmentPlacement(placement),
    oppositePlacement,
    getOppositeAlignmentPlacement(oppositePlacement),
  ];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(
    /start|end/g,
    (alignment) => oppositeAlignmentMap[alignment]
  );
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"],
    rl = ["right", "left"],
    tb = ["top", "bottom"],
    bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      return rtl ? (isStart ? rl : lr) : isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  return (
    alignment &&
      ((list = list.map((side) => side + "-" + alignment)),
      flipAlignment &&
        (list = list.concat(list.map(getOppositeAlignmentPlacement)))),
    list
  );
}
function getOppositePlacement(placement) {
  return placement.replace(
    /left|right|bottom|top/g,
    (side) => oppositeSideMap[side]
  );
}
function expandPaddingObject(padding) {
  return { top: 0, right: 0, bottom: 0, left: 0, ...padding };
}
function getPaddingObject(padding) {
  return typeof padding != "number"
    ? expandPaddingObject(padding)
    : { top: padding, right: padding, bottom: padding, left: padding };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height,
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let { reference, floating } = _ref;
  const sideAxis = getSideAxis(placement),
    alignmentAxis = getAlignmentAxis(placement),
    alignLength = getAxisLength(alignmentAxis),
    side = getSide(placement),
    isVertical = sideAxis === "y",
    commonX = reference.x + reference.width / 2 - floating.width / 2,
    commonY = reference.y + reference.height / 2 - floating.height / 2,
    commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = { x: commonX, y: reference.y - floating.height };
      break;
    case "bottom":
      coords = { x: commonX, y: reference.y + reference.height };
      break;
    case "right":
      coords = { x: reference.x + reference.width, y: commonY };
      break;
    case "left":
      coords = { x: reference.x - floating.width, y: commonY };
      break;
    default:
      coords = { x: reference.x, y: reference.y };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
      placement = "bottom",
      strategy = "absolute",
      middleware = [],
      platform: platform2,
    } = config,
    validMiddleware = middleware.filter(Boolean),
    rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
      reference,
      floating,
      strategy,
    }),
    { x, y } = computeCoordsFromPlacement(rects, placement, rtl),
    statefulPlacement = placement,
    middlewareData = {},
    resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const { name, fn } = validMiddleware[i],
      {
        x: nextX,
        y: nextY,
        data,
        reset,
      } = await fn({
        x,
        y,
        initialPlacement: placement,
        placement: statefulPlacement,
        strategy,
        middlewareData,
        rects,
        platform: platform2,
        elements: { reference, floating },
      });
    if (
      ((x = nextX ?? x),
      (y = nextY ?? y),
      (middlewareData = {
        ...middlewareData,
        [name]: { ...middlewareData[name], ...data },
      }),
      reset && resetCount <= 50)
    ) {
      resetCount++,
        typeof reset == "object" &&
          (reset.placement && (statefulPlacement = reset.placement),
          reset.rects &&
            (rects =
              reset.rects === !0
                ? await platform2.getElementRects({
                    reference,
                    floating,
                    strategy,
                  })
                : reset.rects),
          ({ x, y } = computeCoordsFromPlacement(
            rects,
            statefulPlacement,
            rtl
          ))),
        (i = -1);
      continue;
    }
  }
  return { x, y, placement: statefulPlacement, strategy, middlewareData };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  options === void 0 && (options = {});
  const { x, y, platform: platform2, rects, elements, strategy } = state,
    {
      boundary = "clippingAncestors",
      rootBoundary = "viewport",
      elementContext = "floating",
      altBoundary = !1,
      padding = 0,
    } = evaluate(options, state),
    paddingObject = getPaddingObject(padding),
    element =
      elements[
        altBoundary
          ? elementContext === "floating"
            ? "reference"
            : "floating"
          : elementContext
      ],
    clippingClientRect = rectToClientRect(
      await platform2.getClippingRect({
        element:
          (_await$platform$isEle = await (platform2.isElement == null
            ? void 0
            : platform2.isElement(element))) == null || _await$platform$isEle
            ? element
            : element.contextElement ||
              (await (platform2.getDocumentElement == null
                ? void 0
                : platform2.getDocumentElement(elements.floating))),
        boundary,
        rootBoundary,
        strategy,
      })
    ),
    rect =
      elementContext === "floating"
        ? { ...rects.floating, x, y }
        : rects.reference,
    offsetParent = await (platform2.getOffsetParent == null
      ? void 0
      : platform2.getOffsetParent(elements.floating)),
    offsetScale = (await (platform2.isElement == null
      ? void 0
      : platform2.isElement(offsetParent)))
      ? (await (platform2.getScale == null
          ? void 0
          : platform2.getScale(offsetParent))) || { x: 1, y: 1 }
      : { x: 1, y: 1 },
    elementClientRect = rectToClientRect(
      platform2.convertOffsetParentRelativeRectToViewportRelativeRect
        ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect(
            { rect, offsetParent, strategy }
          )
        : rect
    );
  return {
    top:
      (clippingClientRect.top - elementClientRect.top + paddingObject.top) /
      offsetScale.y,
    bottom:
      (elementClientRect.bottom -
        clippingClientRect.bottom +
        paddingObject.bottom) /
      offsetScale.y,
    left:
      (clippingClientRect.left - elementClientRect.left + paddingObject.left) /
      offsetScale.x,
    right:
      (elementClientRect.right -
        clippingClientRect.right +
        paddingObject.right) /
      offsetScale.x,
  };
}
const arrow = (options) => ({
    name: "arrow",
    options,
    async fn(state) {
      const {
          x,
          y,
          placement,
          rects,
          platform: platform2,
          elements,
          middlewareData,
        } = state,
        { element, padding = 0 } = evaluate(options, state) || {};
      if (element == null) return {};
      const paddingObject = getPaddingObject(padding),
        coords = { x, y },
        axis = getAlignmentAxis(placement),
        length = getAxisLength(axis),
        arrowDimensions = await platform2.getDimensions(element),
        isYAxis = axis === "y",
        minProp = isYAxis ? "top" : "left",
        maxProp = isYAxis ? "bottom" : "right",
        clientProp = isYAxis ? "clientHeight" : "clientWidth",
        endDiff =
          rects.reference[length] +
          rects.reference[axis] -
          coords[axis] -
          rects.floating[length],
        startDiff = coords[axis] - rects.reference[axis],
        arrowOffsetParent = await (platform2.getOffsetParent == null
          ? void 0
          : platform2.getOffsetParent(element));
      let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
      (!clientSize ||
        !(await (platform2.isElement == null
          ? void 0
          : platform2.isElement(arrowOffsetParent)))) &&
        (clientSize = elements.floating[clientProp] || rects.floating[length]);
      const centerToReference = endDiff / 2 - startDiff / 2,
        largestPossiblePadding =
          clientSize / 2 - arrowDimensions[length] / 2 - 1,
        minPadding = min(paddingObject[minProp], largestPossiblePadding),
        maxPadding = min(paddingObject[maxProp], largestPossiblePadding),
        min$1 = minPadding,
        max2 = clientSize - arrowDimensions[length] - maxPadding,
        center =
          clientSize / 2 - arrowDimensions[length] / 2 + centerToReference,
        offset2 = clamp(min$1, center, max2),
        shouldAddOffset =
          !middlewareData.arrow &&
          getAlignment(placement) != null &&
          center != offset2 &&
          rects.reference[length] / 2 -
            (center < min$1 ? minPadding : maxPadding) -
            arrowDimensions[length] / 2 <
            0,
        alignmentOffset = shouldAddOffset
          ? center < min$1
            ? center - min$1
            : center - max2
          : 0;
      return {
        [axis]: coords[axis] + alignmentOffset,
        data: {
          [axis]: offset2,
          centerOffset: center - offset2 - alignmentOffset,
          ...(shouldAddOffset && { alignmentOffset }),
        },
        reset: shouldAddOffset,
      };
    },
  }),
  flip = function (options) {
    return (
      options === void 0 && (options = {}),
      {
        name: "flip",
        options,
        async fn(state) {
          var _middlewareData$arrow, _middlewareData$flip;
          const {
              placement,
              middlewareData,
              rects,
              initialPlacement,
              platform: platform2,
              elements,
            } = state,
            {
              mainAxis: checkMainAxis = !0,
              crossAxis: checkCrossAxis = !0,
              fallbackPlacements: specifiedFallbackPlacements,
              fallbackStrategy = "bestFit",
              fallbackAxisSideDirection = "none",
              flipAlignment = !0,
              ...detectOverflowOptions
            } = evaluate(options, state);
          if (
            (_middlewareData$arrow = middlewareData.arrow) != null &&
            _middlewareData$arrow.alignmentOffset
          )
            return {};
          const side = getSide(placement),
            isBasePlacement = getSide(initialPlacement) === initialPlacement,
            rtl = await (platform2.isRTL == null
              ? void 0
              : platform2.isRTL(elements.floating)),
            fallbackPlacements =
              specifiedFallbackPlacements ||
              (isBasePlacement || !flipAlignment
                ? [getOppositePlacement(initialPlacement)]
                : getExpandedPlacements(initialPlacement));
          !specifiedFallbackPlacements &&
            fallbackAxisSideDirection !== "none" &&
            fallbackPlacements.push(
              ...getOppositeAxisPlacements(
                initialPlacement,
                flipAlignment,
                fallbackAxisSideDirection,
                rtl
              )
            );
          const placements = [initialPlacement, ...fallbackPlacements],
            overflow = await detectOverflow(state, detectOverflowOptions),
            overflows = [];
          let overflowsData =
            ((_middlewareData$flip = middlewareData.flip) == null
              ? void 0
              : _middlewareData$flip.overflows) || [];
          if (
            (checkMainAxis && overflows.push(overflow[side]), checkCrossAxis)
          ) {
            const sides = getAlignmentSides(placement, rects, rtl);
            overflows.push(overflow[sides[0]], overflow[sides[1]]);
          }
          if (
            ((overflowsData = [...overflowsData, { placement, overflows }]),
            !overflows.every((side2) => side2 <= 0))
          ) {
            var _middlewareData$flip2, _overflowsData$filter;
            const nextIndex =
                (((_middlewareData$flip2 = middlewareData.flip) == null
                  ? void 0
                  : _middlewareData$flip2.index) || 0) + 1,
              nextPlacement = placements[nextIndex];
            if (nextPlacement)
              return {
                data: { index: nextIndex, overflows: overflowsData },
                reset: { placement: nextPlacement },
              };
            let resetPlacement =
              (_overflowsData$filter = overflowsData
                .filter((d) => d.overflows[0] <= 0)
                .sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null
                ? void 0
                : _overflowsData$filter.placement;
            if (!resetPlacement)
              switch (fallbackStrategy) {
                case "bestFit": {
                  var _overflowsData$map$so;
                  const placement2 =
                    (_overflowsData$map$so = overflowsData
                      .map((d) => [
                        d.placement,
                        d.overflows
                          .filter((overflow2) => overflow2 > 0)
                          .reduce((acc, overflow2) => acc + overflow2, 0),
                      ])
                      .sort((a, b) => a[1] - b[1])[0]) == null
                      ? void 0
                      : _overflowsData$map$so[0];
                  placement2 && (resetPlacement = placement2);
                  break;
                }
                case "initialPlacement":
                  resetPlacement = initialPlacement;
                  break;
              }
            if (placement !== resetPlacement)
              return { reset: { placement: resetPlacement } };
          }
          return {};
        },
      }
    );
  };
async function convertValueToCoords(state, options) {
  const { placement, platform: platform2, elements } = state,
    rtl = await (platform2.isRTL == null
      ? void 0
      : platform2.isRTL(elements.floating)),
    side = getSide(placement),
    alignment = getAlignment(placement),
    isVertical = getSideAxis(placement) === "y",
    mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1,
    crossAxisMulti = rtl && isVertical ? -1 : 1,
    rawValue = evaluate(options, state);
  let { mainAxis, crossAxis, alignmentAxis } =
    typeof rawValue == "number"
      ? { mainAxis: rawValue, crossAxis: 0, alignmentAxis: null }
      : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...rawValue };
  return (
    alignment &&
      typeof alignmentAxis == "number" &&
      (crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis),
    isVertical
      ? { x: crossAxis * crossAxisMulti, y: mainAxis * mainAxisMulti }
      : { x: mainAxis * mainAxisMulti, y: crossAxis * crossAxisMulti }
  );
}
const offset = function (options) {
    return (
      options === void 0 && (options = 0),
      {
        name: "offset",
        options,
        async fn(state) {
          const { x, y } = state,
            diffCoords = await convertValueToCoords(state, options);
          return { x: x + diffCoords.x, y: y + diffCoords.y, data: diffCoords };
        },
      }
    );
  },
  shift = function (options) {
    return (
      options === void 0 && (options = {}),
      {
        name: "shift",
        options,
        async fn(state) {
          const { x, y, placement } = state,
            {
              mainAxis: checkMainAxis = !0,
              crossAxis: checkCrossAxis = !1,
              limiter = {
                fn: (_ref) => {
                  let { x: x2, y: y2 } = _ref;
                  return { x: x2, y: y2 };
                },
              },
              ...detectOverflowOptions
            } = evaluate(options, state),
            coords = { x, y },
            overflow = await detectOverflow(state, detectOverflowOptions),
            crossAxis = getSideAxis(getSide(placement)),
            mainAxis = getOppositeAxis(crossAxis);
          let mainAxisCoord = coords[mainAxis],
            crossAxisCoord = coords[crossAxis];
          if (checkMainAxis) {
            const minSide = mainAxis === "y" ? "top" : "left",
              maxSide = mainAxis === "y" ? "bottom" : "right",
              min2 = mainAxisCoord + overflow[minSide],
              max2 = mainAxisCoord - overflow[maxSide];
            mainAxisCoord = clamp(min2, mainAxisCoord, max2);
          }
          if (checkCrossAxis) {
            const minSide = crossAxis === "y" ? "top" : "left",
              maxSide = crossAxis === "y" ? "bottom" : "right",
              min2 = crossAxisCoord + overflow[minSide],
              max2 = crossAxisCoord - overflow[maxSide];
            crossAxisCoord = clamp(min2, crossAxisCoord, max2);
          }
          const limitedCoords = limiter.fn({
            ...state,
            [mainAxis]: mainAxisCoord,
            [crossAxis]: crossAxisCoord,
          });
          return {
            ...limitedCoords,
            data: { x: limitedCoords.x - x, y: limitedCoords.y - y },
          };
        },
      }
    );
  };
function getNodeName(node) {
  return isNode(node) ? (node.nodeName || "").toLowerCase() : "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (
    (node == null || (_node$ownerDocument = node.ownerDocument) == null
      ? void 0
      : _node$ownerDocument.defaultView) || window
  );
}
function getDocumentElement(node) {
  var _ref;
  return (_ref =
    (isNode(node) ? node.ownerDocument : node.document) || window.document) ==
    null
    ? void 0
    : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement$1(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return (
    value instanceof HTMLElement ||
    value instanceof getWindow(value).HTMLElement
  );
}
function isShadowRoot(value) {
  return typeof ShadowRoot > "u"
    ? !1
    : value instanceof ShadowRoot ||
        value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const { overflow, overflowX, overflowY, display } =
    getComputedStyle$1(element);
  return (
    /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) &&
    !["inline", "contents"].includes(display)
  );
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit(),
    css = getComputedStyle$1(element);
  return (
    css.transform !== "none" ||
    css.perspective !== "none" ||
    (css.containerType ? css.containerType !== "normal" : !1) ||
    (!webkit && (css.backdropFilter ? css.backdropFilter !== "none" : !1)) ||
    (!webkit && (css.filter ? css.filter !== "none" : !1)) ||
    ["transform", "perspective", "filter"].some((value) =>
      (css.willChange || "").includes(value)
    ) ||
    ["paint", "layout", "strict", "content"].some((value) =>
      (css.contain || "").includes(value)
    )
  );
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  for (; isHTMLElement(currentNode) && !isLastTraversableNode(currentNode); ) {
    if (isContainingBlock(currentNode)) return currentNode;
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports
    ? !1
    : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  return isElement$1(element)
    ? { scrollLeft: element.scrollLeft, scrollTop: element.scrollTop }
    : { scrollLeft: element.pageXOffset, scrollTop: element.pageYOffset };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") return node;
  const result =
    node.assignedSlot ||
    node.parentNode ||
    (isShadowRoot(node) && node.host) ||
    getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  return isLastTraversableNode(parentNode)
    ? node.ownerDocument
      ? node.ownerDocument.body
      : node.body
    : isHTMLElement(parentNode) && isOverflowElement(parentNode)
    ? parentNode
    : getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  list === void 0 && (list = []),
    traverseIframes === void 0 && (traverseIframes = !0);
  const scrollableAncestor = getNearestOverflowAncestor(node),
    isBody =
      scrollableAncestor ===
      ((_node$ownerDocument2 = node.ownerDocument) == null
        ? void 0
        : _node$ownerDocument2.body),
    win = getWindow(scrollableAncestor);
  return isBody
    ? list.concat(
        win,
        win.visualViewport || [],
        isOverflowElement(scrollableAncestor) ? scrollableAncestor : [],
        win.frameElement && traverseIframes
          ? getOverflowAncestors(win.frameElement)
          : []
      )
    : list.concat(
        scrollableAncestor,
        getOverflowAncestors(scrollableAncestor, [], traverseIframes)
      );
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0,
    height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element),
    offsetWidth = hasOffset ? element.offsetWidth : width,
    offsetHeight = hasOffset ? element.offsetHeight : height,
    shouldFallback =
      round(width) !== offsetWidth || round(height) !== offsetHeight;
  return (
    shouldFallback && ((width = offsetWidth), (height = offsetHeight)),
    { width, height, $: shouldFallback }
  );
}
function unwrapElement(element) {
  return isElement$1(element) ? element : element.contextElement;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) return createCoords(1);
  const rect = domElement.getBoundingClientRect(),
    { width, height, $ } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width,
    y = ($ ? round(rect.height) : rect.height) / height;
  return (
    (!x || !Number.isFinite(x)) && (x = 1),
    (!y || !Number.isFinite(y)) && (y = 1),
    { x, y }
  );
}
const noOffsets = createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  return !isWebKit() || !win.visualViewport
    ? noOffsets
    : { x: win.visualViewport.offsetLeft, y: win.visualViewport.offsetTop };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  return (
    isFixed === void 0 && (isFixed = !1),
    !floatingOffsetParent ||
    (isFixed && floatingOffsetParent !== getWindow(element))
      ? !1
      : isFixed
  );
}
function getBoundingClientRect(
  element,
  includeScale,
  isFixedStrategy,
  offsetParent
) {
  includeScale === void 0 && (includeScale = !1),
    isFixedStrategy === void 0 && (isFixedStrategy = !1);
  const clientRect = element.getBoundingClientRect(),
    domElement = unwrapElement(element);
  let scale = createCoords(1);
  includeScale &&
    (offsetParent
      ? isElement$1(offsetParent) && (scale = getScale(offsetParent))
      : (scale = getScale(element)));
  const visualOffsets = shouldAddVisualOffsets(
    domElement,
    isFixedStrategy,
    offsetParent
  )
    ? getVisualOffsets(domElement)
    : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x,
    y = (clientRect.top + visualOffsets.y) / scale.y,
    width = clientRect.width / scale.x,
    height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement),
      offsetWin =
        offsetParent && isElement$1(offsetParent)
          ? getWindow(offsetParent)
          : offsetParent;
    let currentIFrame = win.frameElement;
    for (; currentIFrame && offsetParent && offsetWin !== win; ) {
      const iframeScale = getScale(currentIFrame),
        iframeRect = currentIFrame.getBoundingClientRect(),
        css = getComputedStyle$1(currentIFrame),
        left =
          iframeRect.left +
          (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) *
            iframeScale.x,
        top =
          iframeRect.top +
          (currentIFrame.clientTop + parseFloat(css.paddingTop)) *
            iframeScale.y;
      (x *= iframeScale.x),
        (y *= iframeScale.y),
        (width *= iframeScale.x),
        (height *= iframeScale.y),
        (x += left),
        (y += top),
        (currentIFrame = getWindow(currentIFrame).frameElement);
    }
  }
  return rectToClientRect({ width, height, x, y });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let { rect, offsetParent, strategy } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent),
    documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) return rect;
  let scroll = { scrollLeft: 0, scrollTop: 0 },
    scale = createCoords(1);
  const offsets = createCoords(0);
  if (
    (isOffsetParentAnElement ||
      (!isOffsetParentAnElement && strategy !== "fixed")) &&
    ((getNodeName(offsetParent) !== "body" ||
      isOverflowElement(documentElement)) &&
      (scroll = getNodeScroll(offsetParent)),
    isHTMLElement(offsetParent))
  ) {
    const offsetRect = getBoundingClientRect(offsetParent);
    (scale = getScale(offsetParent)),
      (offsets.x = offsetRect.x + offsetParent.clientLeft),
      (offsets.y = offsetRect.y + offsetParent.clientTop);
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y,
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return (
    getBoundingClientRect(getDocumentElement(element)).left +
    getNodeScroll(element).scrollLeft
  );
}
function getDocumentRect(element) {
  const html = getDocumentElement(element),
    scroll = getNodeScroll(element),
    body = element.ownerDocument.body,
    width = max(
      html.scrollWidth,
      html.clientWidth,
      body.scrollWidth,
      body.clientWidth
    ),
    height = max(
      html.scrollHeight,
      html.clientHeight,
      body.scrollHeight,
      body.clientHeight
    );
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  return (
    getComputedStyle$1(body).direction === "rtl" &&
      (x += max(html.clientWidth, body.clientWidth) - width),
    { width, height, x, y }
  );
}
function getViewportRect(element, strategy) {
  const win = getWindow(element),
    html = getDocumentElement(element),
    visualViewport = win.visualViewport;
  let width = html.clientWidth,
    height = html.clientHeight,
    x = 0,
    y = 0;
  if (visualViewport) {
    (width = visualViewport.width), (height = visualViewport.height);
    const visualViewportBased = isWebKit();
    (!visualViewportBased || (visualViewportBased && strategy === "fixed")) &&
      ((x = visualViewport.offsetLeft), (y = visualViewport.offsetTop));
  }
  return { width, height, x, y };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, !0, strategy === "fixed"),
    top = clientRect.top + element.clientTop,
    left = clientRect.left + element.clientLeft,
    scale = isHTMLElement(element) ? getScale(element) : createCoords(1),
    width = element.clientWidth * scale.x,
    height = element.clientHeight * scale.y,
    x = left * scale.x,
    y = top * scale.y;
  return { width, height, x, y };
}
function getClientRectFromClippingAncestor(
  element,
  clippingAncestor,
  strategy
) {
  let rect;
  if (clippingAncestor === "viewport")
    rect = getViewportRect(element, strategy);
  else if (clippingAncestor === "document")
    rect = getDocumentRect(getDocumentElement(element));
  else if (isElement$1(clippingAncestor))
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  return parentNode === stopNode ||
    !isElement$1(parentNode) ||
    isLastTraversableNode(parentNode)
    ? !1
    : getComputedStyle$1(parentNode).position === "fixed" ||
        hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) return cachedResult;
  let result = getOverflowAncestors(element, [], !1).filter(
      (el) => isElement$1(el) && getNodeName(el) !== "body"
    ),
    currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  for (; isElement$1(currentNode) && !isLastTraversableNode(currentNode); ) {
    const computedStyle = getComputedStyle$1(currentNode),
      currentNodeIsContaining = isContainingBlock(currentNode);
    !currentNodeIsContaining &&
      computedStyle.position === "fixed" &&
      (currentContainingBlockComputedStyle = null),
      (
        elementIsFixed
          ? !currentNodeIsContaining && !currentContainingBlockComputedStyle
          : (!currentNodeIsContaining &&
              computedStyle.position === "static" &&
              !!currentContainingBlockComputedStyle &&
              ["absolute", "fixed"].includes(
                currentContainingBlockComputedStyle.position
              )) ||
            (isOverflowElement(currentNode) &&
              !currentNodeIsContaining &&
              hasFixedPositionAncestor(element, currentNode))
      )
        ? (result = result.filter((ancestor) => ancestor !== currentNode))
        : (currentContainingBlockComputedStyle = computedStyle),
      (currentNode = getParentNode(currentNode));
  }
  return cache.set(element, result), result;
}
function getClippingRect(_ref) {
  let { element, boundary, rootBoundary, strategy } = _ref;
  const clippingAncestors = [
      ...(boundary === "clippingAncestors"
        ? getClippingElementAncestors(element, this._c)
        : [].concat(boundary)),
      rootBoundary,
    ],
    firstClippingAncestor = clippingAncestors[0],
    clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
      const rect = getClientRectFromClippingAncestor(
        element,
        clippingAncestor,
        strategy
      );
      return (
        (accRect.top = max(rect.top, accRect.top)),
        (accRect.right = min(rect.right, accRect.right)),
        (accRect.bottom = min(rect.bottom, accRect.bottom)),
        (accRect.left = max(rect.left, accRect.left)),
        accRect
      );
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top,
  };
}
function getDimensions(element) {
  return getCssDimensions(element);
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent),
    documentElement = getDocumentElement(offsetParent),
    isFixed = strategy === "fixed",
    rect = getBoundingClientRect(element, !0, isFixed, offsetParent);
  let scroll = { scrollLeft: 0, scrollTop: 0 };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed))
    if (
      ((getNodeName(offsetParent) !== "body" ||
        isOverflowElement(documentElement)) &&
        (scroll = getNodeScroll(offsetParent)),
      isOffsetParentAnElement)
    ) {
      const offsetRect = getBoundingClientRect(
        offsetParent,
        !0,
        isFixed,
        offsetParent
      );
      (offsets.x = offsetRect.x + offsetParent.clientLeft),
        (offsets.y = offsetRect.y + offsetParent.clientTop);
    } else
      documentElement && (offsets.x = getWindowScrollBarX(documentElement));
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height,
  };
}
function getTrueOffsetParent(element, polyfill2) {
  return !isHTMLElement(element) ||
    getComputedStyle$1(element).position === "fixed"
    ? null
    : polyfill2
    ? polyfill2(element)
    : element.offsetParent;
}
function getOffsetParent(element, polyfill2) {
  const window2 = getWindow(element);
  if (!isHTMLElement(element)) return window2;
  let offsetParent = getTrueOffsetParent(element, polyfill2);
  for (
    ;
    offsetParent &&
    isTableElement(offsetParent) &&
    getComputedStyle$1(offsetParent).position === "static";

  )
    offsetParent = getTrueOffsetParent(offsetParent, polyfill2);
  return offsetParent &&
    (getNodeName(offsetParent) === "html" ||
      (getNodeName(offsetParent) === "body" &&
        getComputedStyle$1(offsetParent).position === "static" &&
        !isContainingBlock(offsetParent)))
    ? window2
    : offsetParent || getContainingBlock(element) || window2;
}
const getElementRects = async function (_ref) {
  let { reference, floating, strategy } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent,
    getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(
      reference,
      await getOffsetParentFn(floating),
      strategy
    ),
    floating: { x: 0, y: 0, ...(await getDimensionsFn(floating)) },
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL,
};
function observeMove(element, onMove) {
  let io = null,
    timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId), io && io.disconnect(), (io = null);
  }
  function refresh(skip, threshold) {
    skip === void 0 && (skip = !1),
      threshold === void 0 && (threshold = 1),
      cleanup();
    const { left, top, width, height } = element.getBoundingClientRect();
    if ((skip || onMove(), !width || !height)) return;
    const insetTop = floor(top),
      insetRight = floor(root.clientWidth - (left + width)),
      insetBottom = floor(root.clientHeight - (top + height)),
      insetLeft = floor(left),
      options = {
        rootMargin:
          -insetTop +
          "px " +
          -insetRight +
          "px " +
          -insetBottom +
          "px " +
          -insetLeft +
          "px",
        threshold: max(0, min(1, threshold)) || 1,
      };
    let isFirstUpdate = !0;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) return refresh();
        ratio
          ? refresh(!1, ratio)
          : (timeoutId = setTimeout(() => {
              refresh(!1, 1e-7);
            }, 100));
      }
      isFirstUpdate = !1;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        root: root.ownerDocument,
      });
    } catch {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  return refresh(!0), cleanup;
}
function autoUpdate(reference, floating, update, options) {
  options === void 0 && (options = {});
  const {
      ancestorScroll = !0,
      ancestorResize = !0,
      elementResize = typeof ResizeObserver == "function",
      layoutShift = typeof IntersectionObserver == "function",
      animationFrame = !1,
    } = options,
    referenceEl = unwrapElement(reference),
    ancestors =
      ancestorScroll || ancestorResize
        ? [
            ...(referenceEl ? getOverflowAncestors(referenceEl) : []),
            ...getOverflowAncestors(floating),
          ]
        : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll &&
      ancestor.addEventListener("scroll", update, { passive: !0 }),
      ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo =
    referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1,
    resizeObserver = null;
  elementResize &&
    ((resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      firstEntry &&
        firstEntry.target === referenceEl &&
        resizeObserver &&
        (resizeObserver.unobserve(floating),
        cancelAnimationFrame(reobserveFrame),
        (reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        }))),
        update();
    })),
    referenceEl && !animationFrame && resizeObserver.observe(referenceEl),
    resizeObserver.observe(floating));
  let frameId,
    prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  animationFrame && frameLoop();
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    prevRefRect &&
      (nextRefRect.x !== prevRefRect.x ||
        nextRefRect.y !== prevRefRect.y ||
        nextRefRect.width !== prevRefRect.width ||
        nextRefRect.height !== prevRefRect.height) &&
      update(),
      (prevRefRect = nextRefRect),
      (frameId = requestAnimationFrame(frameLoop));
  }
  return (
    update(),
    () => {
      ancestors.forEach((ancestor) => {
        ancestorScroll && ancestor.removeEventListener("scroll", update),
          ancestorResize && ancestor.removeEventListener("resize", update);
      }),
        cleanupIo && cleanupIo(),
        resizeObserver && resizeObserver.disconnect(),
        (resizeObserver = null),
        animationFrame && cancelAnimationFrame(frameId);
    }
  );
}
const computePosition = (reference, floating, options) => {
    const cache = new Map(),
      mergedOptions = { platform, ...options },
      platformWithCache = { ...mergedOptions.platform, _c: cache };
    return computePosition$1(reference, floating, {
      ...mergedOptions,
      platform: platformWithCache,
    });
  },
  ARROW_SELECTOR$1 = "[data-float-element-arrow]";
class ClipboardButtonTooltip extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "element");
    __publicField(this, "removeUpdate", () => {});
    __publicField(this, "show", () => {
      this.mount(), this.setVisible(!0), this.emit("show", {});
    });
    __publicField(this, "hide", () => {
      this.setVisible(!1), this.unmount(), this.emit("hide", {});
    });
    this.element = getTemplateFirstChild(
      $el(`[data-clipboard-button-tooltip-template="${this.id}"]`, this)
    );
  }
  updatePosition({ x, y }) {
    Object.assign(this.style, { left: `${x}px`, top: `${y}px` });
  }
  getOptions() {
    const arrowElement = $el(ARROW_SELECTOR$1, this.element),
      middleware = [
        offset({
          alignmentAxis: +(this.dataset.alignmentAxisOffset || 0),
          mainAxis: +(this.dataset.mainAxisOffset || 0),
        }),
        flip(),
        shift(),
      ];
    return (
      arrowElement && middleware.push(arrow({ element: arrowElement })),
      {
        placement: this.dataset.placement || "bottom-end",
        middleware,
        strategy: "fixed",
      }
    );
  }
  updateArrow({ placement, middlewareData }) {
    const arrowElement = $el(ARROW_SELECTOR$1, this.element);
    if (!arrowElement) return;
    const { x: arrowX, y: arrowY } = middlewareData.arrow,
      staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right",
      }[placement.split("-")[0]];
    Object.assign(arrowElement.style, {
      left: arrowX != null ? `${arrowX}px` : "",
      top: arrowY != null ? `${arrowY}px` : "",
      right: "",
      bottom: "",
      [staticSide]: "-5px",
    });
  }
  mount() {
    const floatElement = $el(
      `[data-clipboard-button-tooltip-target-id="${this.id}"]`
    );
    this.replaceChildren(this.element),
      floatElement &&
        (this.removeUpdate = autoUpdate(floatElement, this, () => {
          computePosition(floatElement, this, this.getOptions()).then(
            (data) => {
              this.updatePosition(data), this.updateArrow(data);
            }
          );
        }));
  }
  unmount() {
    this.replaceChildren(), this.removeUpdate();
  }
  setVisible(isVisible) {
    this.setAttribute("aria-hidden", isVisible ? "false" : "true");
  }
}
class CollapsedTags extends BaseComponent {
  constructor() {
    var _a;
    super();
    __publicField(this, "extendButton");
    __publicField(this, "tags");
    __publicField(this, "hiddenTags");
    __publicField(this, "extendButtonWidth");
    __publicField(this, "maxRightPoint");
    __publicField(this, "resizeObserver");
    __publicField(
      this,
      "handleContentResize",
      debounce(() => {
        this.setOffsets(), this.update();
      }, 200)
    );
    __publicField(this, "resetVisibility", () => {
      this.tags.forEach((tag) => {
        this.setTagVisible(tag, !1);
      });
    });
    (this.tags = $list("[data-tag]", this)),
      (this.hiddenTags =
        $el("[data-collapsed-tags]", this) ?? $el("#show_other_tags")),
      (this.extendButton = $el("[data-extend-button]", this)),
      (this.extendButtonWidth =
        ((_a = this.extendButton) == null ? void 0 : _a.offsetWidth) ?? 0),
      (this.maxRightPoint =
        this.getBoundingClientRect().right - this.extendButtonWidth - 20);
  }
  mountComponent() {
    (this.resizeObserver = new ResizeObserver(this.handleContentResize)),
      this.resizeObserver.observe(this);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  updateButtonVisible() {
    if (!this.extendButton) return;
    const hiddenTags = this.querySelectorAll("[tag-hidden]"),
      hasHiddenTags = hiddenTags.length > 0;
    if (hasHiddenTags) {
      const left = hiddenTags[0].style.left;
      this.extendButton.style.left = left;
    }
    this.extendButton.classList.toggle("hidden", !hasHiddenTags),
      this.setAttribute("data-is-collapsed", hasHiddenTags.toString());
  }
  setOffsets() {
    this.tags.forEach((tag) => {
      (tag.style.left = `${tag.offsetLeft}px`),
        (tag.style.top = `${tag.offsetTop}px`);
    });
  }
  updateTagsVisible() {
    var _a;
    const collapsedTagsFragment = document.createDocumentFragment();
    this.tags.forEach((tag) => {
      const isOverflowed =
        tag.getBoundingClientRect().right > this.maxRightPoint;
      if (isOverflowed) {
        const clone = tag.cloneNode(!0);
        this.setTagVisible(clone, !0), collapsedTagsFragment.appendChild(clone);
      }
      this.setTagVisible(tag, !isOverflowed);
    }),
      (_a = this.hiddenTags) == null ||
        _a.element.replaceChildren(collapsedTagsFragment);
  }
  setTagVisible(tag, isVisible) {
    tag.toggleAttribute("tag-hidden", !isVisible);
  }
  update() {
    var _a;
    (this.extendButtonWidth =
      ((_a = this.extendButton) == null ? void 0 : _a.offsetWidth) ?? 0),
      (this.maxRightPoint =
        this.getBoundingClientRect().right - this.extendButtonWidth - 20),
      this.updateTagsVisible(),
      this.updateButtonVisible(),
      this.setAttribute("visible", "");
  }
}
const COLLAPSED_TAGS_SELECTOR = "[data-collapsed-tags]",
  TAG_SELECTOR = "[data-tag]",
  EXTEND_BUTTON_SELECTOR = "[data-extend-button]";
class ArticleTags extends BaseComponent {
  constructor() {
    var _a;
    super();
    __publicField(this, "extendButton");
    __publicField(this, "extendButtonWidth");
    __publicField(this, "maxBottomPoint");
    __publicField(this, "resizeObserver");
    __publicField(
      this,
      "handleContentResize",
      debounce(() => {
        this.update();
      }, 200)
    );
    (this.extendButton = $el(EXTEND_BUTTON_SELECTOR, this)),
      (this.extendButtonWidth =
        ((_a = this.extendButton) == null ? void 0 : _a.offsetWidth) ?? 0);
  }
  mountComponent() {
    (this.resizeObserver = new ResizeObserver(this.handleContentResize)),
      this.resizeObserver.observe(this);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  updateButtonVisible() {
    if (!this.extendButton) return;
    const hiddenTags = this.querySelectorAll("[tag-hidden]"),
      hasHiddenTags = hiddenTags.length > 0;
    if (hasHiddenTags) {
      const left = hiddenTags[0].style.left;
      this.extendButton.style.left = left;
    }
    this.extendButton.classList.toggle("hidden", !hasHiddenTags);
  }
  updateTagsVisible() {
    const tags = $list(TAG_SELECTOR, this),
      isToCollapse = tags.findIndex(
        (tag) => tag.getBoundingClientRect().bottom > this.maxBottomPoint
      );
    if (isToCollapse === -1) return;
    const tagsToCollapse = tags.slice(isToCollapse - 1),
      hiddenTags = $el(COLLAPSED_TAGS_SELECTOR, this),
      collapsedTagsFragment = document.createDocumentFragment();
    tagsToCollapse.forEach((tag) => {
      const clone = tag.cloneNode(!0);
      tag.setAttribute("tag-hidden", ""),
        collapsedTagsFragment.appendChild(clone);
    }),
      hiddenTags == null ||
        hiddenTags.element.replaceChildren(collapsedTagsFragment);
  }
  update() {
    (this.maxBottomPoint = this.getBoundingClientRect().bottom),
      this.maxBottomPoint > 0 &&
        (this.updateTagsVisible(),
        this.updateButtonVisible(),
        this.setAttribute("visible", ""));
  }
}
const STORAGE_KEY = "AuroraTheme-Timer";
class TimerStorage {
  constructor(blockId) {
    __publicField(this, "_blockId");
    this._blockId = blockId;
  }
  parseData(data) {
    try {
      const obj = JSON.parse(data ?? "{}");
      return "endDate" in obj && "hash" in obj
        ? { endDate: new Date(+obj.endDate), hash: obj.hash }
        : null;
    } catch {
      return null;
    }
  }
  saveData(data) {
    try {
      localStorage.setItem(
        `${STORAGE_KEY}-${this._blockId}`,
        JSON.stringify({ endDate: data.endDate.getTime(), hash: data.hash })
      );
    } catch {}
  }
  loadData() {
    try {
      return this.parseData(
        localStorage.getItem(`${STORAGE_KEY}-${this._blockId}`)
      );
    } catch {
      return null;
    }
  }
}
var TimerMode = ((TimerMode2) => (
    (TimerMode2.Fixed = "fixed"),
    (TimerMode2.Evergreen = "evergreen"),
    TimerMode2
  ))(TimerMode || {}),
  TimerFinishStrategy = ((TimerFinishStrategy2) => (
    (TimerFinishStrategy2.None = "none"),
    (TimerFinishStrategy2.Hide = "hide"),
    (TimerFinishStrategy2.Restart = "restart"),
    (TimerFinishStrategy2.WaitOneDay = "wait_one_day"),
    TimerFinishStrategy2
  ))(TimerFinishStrategy || {});
const ONE_DAY_MS = 864e5,
  MONTHS = {
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11,
  },
  getEvergreenEndDate = (unit, value) => {
    const date = new Date();
    switch (unit) {
      case "day":
        date.setDate(date.getDate() + value);
        break;
      case "hour":
        date.setHours(date.getHours() + value);
        break;
      case "minute":
        date.setMinutes(date.getMinutes() + value);
        break;
      case "second":
        date.setSeconds(date.getSeconds() + value);
        break;
    }
    return date;
  };
class CountdownTimer extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "mode", TimerMode.Fixed);
    __publicField(this, "endDate", new Date());
    __publicField(this, "timerRef");
    __publicField(this, "finishStrategy", TimerFinishStrategy.None);
    __publicField(this, "timerStorage");
    __publicField(this, "evergreenUnit");
    __publicField(this, "evergreenValue");
    __publicField(this, "daysUnit");
    __publicField(this, "hoursUnit");
    __publicField(this, "minutesUnit");
    __publicField(this, "secondsUnit");
    __publicField(this, "daysUnitLabel");
    __publicField(this, "hoursUnitLabel");
    __publicField(this, "minutesUnitLabel");
    __publicField(this, "secondsUnitLabel");
    (this.daysUnit = $el("[data-timer-days]", this)),
      (this.hoursUnit = $el("[data-timer-hours]", this)),
      (this.minutesUnit = $el("[data-timer-minutes]", this)),
      (this.secondsUnit = $el("[data-timer-seconds]", this)),
      (this.daysUnitLabel = $el("[data-timer-days-label]", this)),
      (this.hoursUnitLabel = $el("[data-timer-hours-label]", this)),
      (this.minutesUnitLabel = $el("[data-timer-minutes-label]", this)),
      (this.secondsUnitLabel = $el("[data-timer-seconds-label]", this)),
      (this.evergreenUnit = this.dataset.evergreenUnit || "minute"),
      (this.evergreenValue = parseInt(this.dataset.evergreenValue || "0")),
      (this.mode = this.dataset.mode),
      this.mode === TimerMode.Fixed &&
        (this.finishStrategy =
          this.dataset.hideOnComplete === "true"
            ? TimerFinishStrategy.Hide
            : TimerFinishStrategy.None),
      this.mode === TimerMode.Evergreen &&
        ((this.finishStrategy =
          this.dataset.evergreenOnComplete || TimerFinishStrategy.Restart),
        (this.timerStorage = new TimerStorage(
          this.dataset.blockId || this.id
        )));
  }
  mountComponent() {
    this.start();
  }
  unmountComponent() {
    clearInterval(this.timerRef);
  }
  getHash() {
    return `${this.finishStrategy}-${this.evergreenUnit}-${this.evergreenValue}`;
  }
  start() {
    if (this.mode === TimerMode.Fixed) {
      const year = Number(this.dataset.year),
        month = MONTHS[this.dataset.month ?? "january"],
        day = Number(this.dataset.day),
        hour = Number(this.dataset.hour),
        minute = Number(this.dataset.minute);
      this.endDate = new Date(year, month, day, hour, minute);
    }
    if (this.mode === TimerMode.Evergreen) {
      const timerData = this.timerStorage.loadData();
      !timerData || timerData.hash !== this.getHash()
        ? this.updateEvergreenData()
        : (this.endDate = timerData.endDate);
    }
    (this.timerRef = window.setInterval(this.tick.bind(this), 1e3)),
      this.tick();
  }
  updateEvergreenData() {
    const endDate = getEvergreenEndDate(
      this.evergreenUnit,
      this.evergreenValue
    );
    this.timerStorage.saveData({ endDate, hash: this.getHash() }),
      (this.endDate = endDate);
  }
  finish() {
    switch ((clearInterval(this.timerRef), this.finishStrategy)) {
      case TimerFinishStrategy.Restart:
        this.timerStorage.saveData({
          endDate: getEvergreenEndDate(this.evergreenUnit, this.evergreenValue),
          hash: this.getHash(),
        }),
          this.start();
        break;
      case TimerFinishStrategy.WaitOneDay:
        if (new Date().getTime() - this.endDate.getTime() > ONE_DAY_MS) {
          const endDate = getEvergreenEndDate(
            this.evergreenUnit,
            this.evergreenValue
          );
          this.timerStorage.saveData({ endDate, hash: this.getHash() }),
            this.start();
        } else this.hide();
        break;
      case TimerFinishStrategy.None:
        this.show();
        break;
      default:
        this.hide();
    }
  }
  renderTime(days, hours, minutes, seconds) {
    !this.daysUnit ||
      !this.hoursUnit ||
      !this.minutesUnit ||
      !this.secondsUnit ||
      ((this.daysUnit.innerText = days.toString()),
      (this.hoursUnit.innerText = hours.toString()),
      (this.minutesUnit.innerText = minutes.toString()),
      (this.secondsUnit.innerText = seconds.toString()),
      this.renderLabels(days, hours, minutes, seconds));
  }
  renderLabels(days, hours, minutes, seconds) {
    !this.daysUnitLabel ||
      !this.hoursUnitLabel ||
      !this.minutesUnitLabel ||
      !this.secondsUnitLabel ||
      ((this.daysUnitLabel.innerText =
        days === 1
          ? window.auroraThemeLocales.countdownTimerString.day
          : window.auroraThemeLocales.countdownTimerString.days),
      (this.hoursUnitLabel.innerText =
        hours === 1
          ? window.auroraThemeLocales.countdownTimerString.hour
          : window.auroraThemeLocales.countdownTimerString.hours),
      (this.minutesUnitLabel.innerText =
        minutes === 1
          ? window.auroraThemeLocales.countdownTimerString.minute
          : window.auroraThemeLocales.countdownTimerString.minutes),
      (this.secondsUnitLabel.innerText =
        seconds === 1
          ? window.auroraThemeLocales.countdownTimerString.second
          : window.auroraThemeLocales.countdownTimerString.seconds));
  }
  tick() {
    const diff = this.endDate.getTime() - new Date().getTime();
    if (diff > 0) {
      this.show(),
        this.renderTime(
          Math.floor(diff / (1e3 * 60 * 60 * 24)),
          Math.floor((diff % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)),
          Math.floor((diff % (1e3 * 60 * 60)) / (1e3 * 60)),
          Math.floor((diff % (1e3 * 60)) / 1e3)
        );
      return;
    }
    this.renderTime(0, 0, 0, 0),
      this.finish(),
      window.Shopify.designMode && this.show();
  }
  show() {
    showElement(this),
      this.dataset.blockId &&
        showElement($el(`.block-${this.dataset.blockId}`));
  }
  hide() {
    window.Shopify.designMode ||
      (this.dataset.sectionId &&
        hideElement($el(`.section-${this.dataset.sectionId}`)),
      this.dataset.blockId &&
        hideElement($el(`.block-${this.dataset.blockId}`)),
      hideElement(this));
  }
}
const POSTER_SELECTOR$1 = '[id^="Deferred-Poster-"]',
  CAROUSEL_SELECTOR$8 = "carousel-component",
  SLIDE_ATTRIBUTE = "[data-media-id]",
  AUTOPLAY_ATTRIBUTE$1 = "data-autoplay",
  CONTROLS_ATTRIBUTE = "data-enable-controls";
class DeferredMedia extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "carousel");
    __publicField(this, "video");
    __publicField(this, "isTouched");
    __publicField(this, "handleCarouselSettle", () => {
      var _a;
      if (((_a = this.video) == null ? void 0 : _a.tagName) === "VIDEO") {
        const isSelected = $elParent(SLIDE_ATTRIBUTE, this).className.includes(
          "is-selected"
        );
        if (isSelected && this.isTouched) return;
        const withAutoplay = this.video.hasAttribute("autoplay");
        isSelected && withAutoplay
          ? this.video.play()
          : isSelected || (this.video.pause(), (this.isTouched = !1));
      }
    });
    __publicField(this, "handlePosterClick", (event) => {
      $elParent(POSTER_SELECTOR$1, event.target) && this.loadContent();
    });
    __publicField(this, "handleUncontrolledVideoClick", () => {
      this.video.paused ? this.video.play() : this.video.pause(),
        (this.isTouched = !0);
    });
  }
  mountComponent() {
    var _a;
    (this.carousel = $elParent(CAROUSEL_SELECTOR$8, this)),
      (_a = this.carousel) == null ||
        _a.embla.on("settle", this.handleCarouselSettle),
      this.hasAttribute(AUTOPLAY_ATTRIBUTE$1)
        ? this.loadContent()
        : this.addListener(this, "click", this.handlePosterClick);
  }
  unmountComponent() {
    var _a;
    (_a = this.carousel) == null ||
      _a.embla.off("settle", this.handleCarouselSettle);
  }
  loadContent() {
    this.getAttribute("loaded") ||
      (this.addVideo(), this.setAttribute("loaded", "true"));
  }
  removeVideo() {
    const video = $el("video,  iframe", this);
    video && (video.remove(), this.removeAttribute("loaded"));
  }
  addVideo() {
    const content = document.createElement("div"),
      template = $el("template", this),
      templateContent = template == null ? void 0 : template.content;
    if (!templateContent || !templateContent.firstElementChild) return;
    const firstChild = templateContent.firstElementChild.cloneNode(!0);
    content.appendChild(firstChild);
    const video = $el("video, model-viewer, iframe", content);
    video &&
      (this.appendChild(video),
      (this.video = video),
      video.tagName === "VIDEO" &&
        (this.video.play(),
        this.hasAttribute(CONTROLS_ATTRIBUTE) ||
          this.addListener(this, "click", this.handleUncontrolledVideoClick)));
  }
}
const HEADER_BUTTON_SELECTOR = "data-header-btn-with-backdrop",
  SET_FLOATING_WIDTH_SELECTOR = "data-set-width";
class DropdownOpener extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "hideTimeoutId");
    __publicField(this, "element");
    __publicField(this, "isHeaderBtn");
    __publicField(this, "floatElementId");
    __publicField(this, "setWidthBeforeOpen");
    __publicField(this, "handleBlur", () => {
      this.hideTimeoutId = setTimeout(() => {
        this.hideFloatElement();
      }, 0);
    });
    __publicField(this, "handleDropdownShow", () => {
      this.setTargetListeners("add");
    });
    __publicField(this, "handleDropdownHide", () => {
      this.setTargetListeners("remove"), clearTimeout(this.hideTimeoutId);
    });
    __publicField(this, "handleKeyDown", (event) => {
      const { firstTarget } = this.getTargets();
      isEnterKey(event) &&
        (event.preventDefault(),
        this.showFloatElement(),
        this.addListener(this.element, "blur", this.handleBlur)),
        isTabKey(event) &&
          firstTarget &&
          this.floatElement.isOpen &&
          !event.shiftKey &&
          (event.preventDefault(),
          firstTarget.focus(),
          clearTimeout(this.hideTimeoutId));
    });
    __publicField(this, "handleHeaderKeyDown", (event) => {
      isEscKey(event) &&
        (event.preventDefault(),
        this.floatElement.hide(),
        this.emit("openerClickOutside", { element: this, opener: this }),
        this.removeListener(window, "keydown", this.handleHeaderKeyDown));
    });
    __publicField(this, "handleFirstTargetFocus", () => {});
    __publicField(this, "handleTargetFocus", () => {
      clearTimeout(this.hideTimeoutId);
    });
    __publicField(this, "handleLastTargetBlur", () => {
      this.hideTimeoutId = setTimeout(() => {
        this.hideFloatElement(), this.focus();
      }, 0);
    });
    __publicField(this, "handleTrigger", (event) => {
      event.preventDefault(), this.trigger();
    });
    __publicField(
      this,
      "handleUntrigger",
      ({ clientX: x, clientY: y, target }) => {
        if (
          !this.floatElement ||
          (this.isHeaderBtn && target.closest(`[${HEADER_BUTTON_SELECTOR}]`))
        )
          return;
        let isToCloseDropDown;
        if (this.isHeaderBtn)
          isToCloseDropDown = !target.closest(
            "[data-header-float-element-template]"
          );
        else {
          const isCursorOutside = this.floatElement.checkCursorOutside(x, y),
            isOutsideFloatElements = this.isTargetOutsideFloatElements(target);
          isToCloseDropDown = isCursorOutside && isOutsideFloatElements;
        }
        isToCloseDropDown &&
          (this.floatElement.hide(),
          this.emit("openerClickOutside", { element: this, opener: this }),
          this.removeListener(window, "keydown", this.handleHeaderKeyDown));
      }
    );
    __publicField(this, "trigger", () => {
      this.floatElement &&
        (this.setWidthBeforeOpen &&
          (this.floatElement.style.width = `${this.offsetWidth}px`),
        this.floatElement.isOpen && !this.isHeaderBtn
          ? this.floatElement.hide()
          : this.floatElement.show(),
        this.addListener(window, "click", this.handleUntrigger),
        this.isHeaderBtn &&
          (this.emit("openerClick", { element: this, opener: this }),
          this.addListener(window, "keydown", this.handleHeaderKeyDown)));
    });
    (this.element = this.getElement()),
      (this.isHeaderBtn = this.hasAttribute(HEADER_BUTTON_SELECTOR)),
      this.isHeaderBtn &&
        (this.floatElementId = this.firstElementChild.getAttribute(
          "data-float-element-trigger"
        )),
      (this.setWidthBeforeOpen = this.hasAttribute(
        SET_FLOATING_WIDTH_SELECTOR
      ));
  }
  mountComponent() {
    var _a, _b;
    this.floatElement &&
      (customElements.upgrade(this.floatElement),
      (_a = this.floatElement) == null ||
        _a.on("show", this.handleDropdownShow),
      (_b = this.floatElement) == null ||
        _b.on("hide", this.handleDropdownHide)),
      this.addListener(this.element, "keydown", this.handleKeyDown),
      this.addListener(this.element, "click", this.handleTrigger);
  }
  unmountComponent() {
    var _a, _b;
    this.floatElement &&
      (customElements.upgrade(this.floatElement),
      (_a = this.floatElement) == null ||
        _a.off("show", this.handleDropdownShow),
      (_b = this.floatElement) == null ||
        _b.off("hide", this.handleDropdownHide)),
      clearTimeout(this.hideTimeoutId),
      this.removeListener(this.element, "blur", this.handleBlur);
  }
  hideFloatElement() {
    this.floatElement && this.floatElement.hide();
  }
  showFloatElement() {
    this.floatElement && this.floatElement.show();
  }
  setTargetListeners(action) {
    const { targets, firstTarget, lastTarget } = this.getTargets(),
      listenerSetter = action === "add" ? "addListener" : "removeListener";
    this[listenerSetter](firstTarget, "focus", this.handleFirstTargetFocus),
      targets.forEach((target) =>
        this[listenerSetter](target, "focus", this.handleTargetFocus)
      ),
      this[listenerSetter](lastTarget, "blur", this.handleLastTargetBlur),
      this[listenerSetter](window, "click", this.handleUntrigger);
  }
  getTargets() {
    if (!this.floatElement) return;
    const element = this.floatElement.element,
      targets = $list(getFocusTargets(), element),
      firstTarget = targets[0],
      lastTarget = targets[targets.length - 1];
    return { targets, firstTarget, lastTarget };
  }
  isTargetOutsideFloatElements(target) {
    if (!this.floatElement) return;
    const isInsideFloatElement = this.floatElement.contains(target),
      isInsideFloatElementBtn = this.contains(target);
    return !isInsideFloatElement && !isInsideFloatElementBtn;
  }
  getElement() {
    return (
      $el(
        `[data-float-element-trigger="${this.dataset.floatElementId}"]`,
        this
      ) || this
    );
  }
  setExpand(isExpanded) {
    this.setAttribute("data-aria-expanded", isExpanded);
  }
  get floatElement() {
    return $el(`#${this.dataset.floatElementId}`);
  }
}
const ARROW_SELECTOR = "[data-float-element-arrow]",
  BODY_ELEMENT_SELECTOR$a = "body-element";
class FloatElement extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "initialPlacement");
    __publicField(this, "element");
    __publicField(this, "arrow");
    __publicField(this, "removeUpdate", () => {});
    __publicField(this, "handleDropdownKeyDown", (event) => {
      isEscKey(event) && (event.preventDefault(), this.hide());
    });
    __publicField(this, "handleScroll", () => {
      this.dataset.type === "tooltip" &&
        (this.hide(), this.removeListener(window, "wheel", this.handleScroll));
    });
    __publicField(
      this,
      "handleBlockSelect",
      ({ detail: { blockId, sectionId } }) => {
        if (this.dataset.sectionId === sectionId) {
          const target = $el(`[block-id="${blockId}"]`, this.element),
            isTarget = this.getAttribute("block-id") === blockId || target,
            btn = $el(
              `[data-float-element-id="${this.id}"], [data-tooltip-id="${this.id}"]`
            );
          if (!isTarget) return;
          btn ? btn.trigger() : this.hide();
        }
      }
    );
    __publicField(
      this,
      "handleBlockDeselect",
      ({ detail: { blockId, sectionId } }) => {
        if (this.dataset.sectionId === sectionId) {
          const target = $el(`[block-id="${blockId}"]`, this.element);
          if (!(this.getAttribute("block-id") === blockId || target)) return;
          this.hide();
        }
      }
    );
    __publicField(this, "show", async () => {
      const bodyElement = $el(BODY_ELEMENT_SELECTOR$a);
      if (this.dataset.type === "tooltip" && bodyElement.isScrolling) return;
      this.mount(),
        this.setVisible(!0),
        await transitionToPromise(this),
        $list("lazy-video", this).forEach((video) => {
          video.initVideo();
        }),
        this.addListener(window, "wheel", this.handleScroll),
        this.addListener(window, "keydown", this.handleDropdownKeyDown),
        this.emit("show", { element: this.element });
    });
    __publicField(this, "hide", async () => {
      this.setVisible(!1),
        await transitionToPromise(this),
        this.isOpen ||
          (this.removeListener(window, "wheel", this.handleScroll),
          this.removeListener(window, "keydown", this.handleDropdownKeyDown),
          (this.dataset.placement = this.initialPlacement),
          this.unmount(),
          this.emit("hide", { element: this.element }));
    });
    __publicField(this, "setBtnExpand", (isVisible) => {
      const btn = $el(
        `[data-float-element-id="${this.id}"], [data-tooltip-id="${this.id}"]`
      );
      btn && btn.setExpand(isVisible);
    });
    (this.element = getTemplateFirstChild(
      $el(`[data-float-element-template="${this.id}"]`, this)
    )),
      (this.arrow = $el(ARROW_SELECTOR, this.element)),
      (this.initialPlacement = this.dataset.placement),
      this.hasAttribute("data-with-portal") &&
        createPortal(this, document.body);
  }
  mountComponent() {
    super.mountComponent(),
      this.isEditor &&
        (this.editor.on("BLOCK_SELECT", this.handleBlockSelect),
        this.editor.on("BLOCK_DESELECT", this.handleBlockDeselect));
  }
  unmountComponent() {
    super.unmountComponent(),
      this.isEditor &&
        (this.editor.off("BLOCK_SELECT", this.handleBlockSelect),
        this.editor.off("BLOCK_DESELECT", this.handleBlockDeselect));
  }
  updatePosition({ x, y }) {
    Object.assign(this.style, { left: `${x}px`, top: `${y}px` });
  }
  getOptions() {
    const middleware = [
      offset({
        alignmentAxis: +(this.dataset.alignmentAxisOffset || 0),
        mainAxis: +(this.dataset.mainAxisOffset || 0),
      }),
      flip(),
      shift(),
    ];
    return (
      this.arrow && middleware.push(arrow({ element: this.arrow })),
      {
        placement: this.dataset.placement,
        middleware,
        strategy: this.dataset.strategy || "absolute",
      }
    );
  }
  checkCursorOutside(x, y) {
    const offset2 = +(this.dataset.mainAxisOffset || 0),
      interactiveBorder = 2,
      boundaries = this.getBoundingClientRect(),
      exceedsTop = boundaries.top - (y + offset2) > interactiveBorder,
      exceedsBottom = y - boundaries.bottom - offset2 > interactiveBorder,
      exceedsLeft = boundaries.left - (x + offset2) > interactiveBorder,
      exceedsRight = x - boundaries.right - offset2 > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  }
  updateArrow({ placement, middlewareData }) {
    if (!this.arrow) return;
    const { x: arrowX, y: arrowY } = middlewareData.arrow,
      staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right",
      }[placement.split("-")[0]];
    Object.assign(this.arrow.style, {
      left: arrowX != null ? `${arrowX}px` : "",
      top: arrowY != null ? `${arrowY}px` : "",
      right: "",
      bottom: "",
      [staticSide]: "-5px",
    });
  }
  mount() {
    this.replaceChildren(this.element), this.setUpdate();
  }
  unmount() {
    this.removeUpdate(), this.replaceChildren();
  }
  setUpdate() {
    const btn = $el(
        `[data-float-element-id="${this.id}"], [data-tooltip-id="${this.id}"]`
      ),
      floatElement = $el(`#${this.dataset.floatingElementId}`) || btn;
    floatElement &&
      (this.removeUpdate = autoUpdate(floatElement, this, () => {
        computePosition(floatElement, this, this.getOptions()).then((data) => {
          this.dataset.placement !== data.placement &&
            (this.dataset.placement = data.placement),
            this.updatePosition(data),
            this.arrow && this.updateArrow(data);
        });
      }));
  }
  setVisible(isVisible) {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$a);
    this.setAttribute("aria-hidden", isVisible ? "false" : "true"),
      this.setBtnExpand(isVisible),
      this.hasAttribute("data-with-overlay") &&
        whenDefined("body-element").then(() => {
          this.isOpen
            ? bodyElement.showOverlay(this.id, {})
            : bodyElement.hideOverlay(this.id);
        });
  }
  get isOpen() {
    return this.getAttribute("aria-hidden") === "false";
  }
}
function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside2 = !1;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0],
      [xj, yj] = polygon[j] || [0, 0];
    yi >= y != yj >= y &&
      x <= ((xj - xi) * (y - yi)) / (yj - yi) + xi &&
      (isInside2 = !isInside2);
  }
  return isInside2;
}
function isInside(point, rect) {
  return (
    point[0] >= rect.x &&
    point[0] <= rect.x + rect.width &&
    point[1] >= rect.y &&
    point[1] <= rect.y + rect.height
  );
}
const contains = (parent, child) =>
    !parent || !child ? !1 : parent.contains(child),
  isElement = (value) =>
    value ? value instanceof (document.defaultView || window).Element : !1;
function getTarget(event) {
  return "composedPath" in event ? event.composedPath()[0] : event.target;
}
const safePolygon = () => {
  let timeoutId,
    hasLanded = !1,
    lastX = null,
    lastY = null,
    lastCursorTime = performance.now();
  const requireIntent = !0;
  function getCursorSpeed(x, y) {
    const currentTime = performance.now(),
      elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0)
      return (lastX = x), (lastY = y), (lastCursorTime = currentTime), null;
    const deltaX = x - lastX,
      deltaY = y - lastY,
      speed = Math.sqrt(deltaX * deltaX + deltaY * deltaY) / elapsedTime;
    return (lastX = x), (lastY = y), (lastCursorTime = currentTime), speed;
  }
  return ({ x, y, placement, elements, onClose, nodeId, tree }) =>
    function (event) {
      function close() {
        clearTimeout(timeoutId), onClose();
      }
      if (
        (clearTimeout(timeoutId),
        !elements.domReference ||
          !elements.floating ||
          placement == null ||
          x == null ||
          y == null)
      )
        return;
      const { clientX, clientY } = event,
        clientPoint = [clientX, clientY],
        target = getTarget(event),
        isLeave = event.type === "mouseleave",
        isOverFloatingEl = contains(elements.floating, target),
        isOverReferenceEl = contains(elements.domReference, target),
        refRect = elements.domReference.getBoundingClientRect(),
        rect = elements.floating.getBoundingClientRect(),
        side = placement.split("-")[0],
        cursorLeaveFromRight = x > rect.right - rect.width / 2,
        cursorLeaveFromBottom = y > rect.bottom - rect.height / 2,
        isOverReferenceRect = isInside(clientPoint, refRect),
        isFloatingWider = rect.width > refRect.width,
        isFloatingTaller = rect.height > refRect.height,
        left = (isFloatingWider ? refRect : rect).left,
        right = (isFloatingWider ? refRect : rect).right,
        top = (isFloatingTaller ? refRect : rect).top,
        bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl && ((hasLanded = !0), !isLeave)) return;
      if (
        (isOverReferenceEl && (hasLanded = !1), isOverReferenceEl && !isLeave)
      ) {
        hasLanded = !0;
        return;
      }
      if (
        (isLeave &&
          isElement(event.relatedTarget) &&
          contains(elements.floating, event.relatedTarget)) ||
        $el('float-element[aria-hidden="false"]', elements.floating)
      )
        return;
      if (
        (side === "top" && y >= refRect.bottom - 1) ||
        (side === "bottom" && y <= refRect.top + 1) ||
        (side === "left" && x >= refRect.right - 1) ||
        (side === "right" && x <= refRect.left + 1)
      )
        return close();
      let rectPoly = [];
      switch (side) {
        case "top":
          rectPoly = [
            [left, refRect.top + 1],
            [left, rect.bottom - 1],
            [right, rect.bottom - 1],
            [right, refRect.top + 1],
          ];
          break;
        case "bottom":
          rectPoly = [
            [left, rect.top + 1],
            [left, refRect.bottom - 1],
            [right, refRect.bottom - 1],
            [right, rect.top + 1],
          ];
          break;
        case "left":
          rectPoly = [
            [rect.right - 1, bottom],
            [rect.right - 1, top],
            [refRect.left + 1, top],
            [refRect.left + 1, bottom],
          ];
          break;
        case "right":
          rectPoly = [
            [refRect.right - 1, bottom],
            [refRect.right - 1, top],
            [rect.left + 1, top],
            [rect.left + 1, bottom],
          ];
          break;
      }
      function getPolygon([x2, y2]) {
        switch (side) {
          case "top": {
            const cursorPointOne = [
                isFloatingWider
                  ? x2 + 0.25
                  : cursorLeaveFromRight
                  ? x2 + 2
                  : x2 - 2,
                y2 + 0.5 + 1,
              ],
              cursorPointTwo = [
                isFloatingWider
                  ? x2 - 0.5 / 2
                  : cursorLeaveFromRight
                  ? x2 + 0.5 * 4
                  : x2 - 0.5 * 4,
                y2 + 0.5 + 1,
              ],
              commonPoints = [
                [
                  rect.left,
                  cursorLeaveFromRight || isFloatingWider
                    ? rect.bottom - 0.5
                    : rect.top,
                ],
                [
                  rect.right,
                  cursorLeaveFromRight
                    ? isFloatingWider
                      ? rect.bottom - 0.5
                      : rect.top
                    : rect.bottom - 0.5,
                ],
              ];
            return [cursorPointOne, cursorPointTwo, ...commonPoints];
          }
          case "bottom": {
            const cursorPointOne = [
                isFloatingWider
                  ? x2 + 0.25
                  : cursorLeaveFromRight
                  ? x2 + 2
                  : x2 - 2,
                y2 - 0.5,
              ],
              cursorPointTwo = [
                isFloatingWider
                  ? x2 - 0.5 / 2
                  : cursorLeaveFromRight
                  ? x2 + 0.5 * 4
                  : x2 - 0.5 * 4,
                y2 - 0.5,
              ],
              commonPoints = [
                [
                  rect.left,
                  cursorLeaveFromRight || isFloatingWider
                    ? rect.top + 0.5
                    : rect.bottom,
                ],
                [
                  rect.right,
                  cursorLeaveFromRight
                    ? isFloatingWider
                      ? rect.top + 0.5
                      : rect.bottom
                    : rect.top + 0.5,
                ],
              ];
            return [cursorPointOne, cursorPointTwo, ...commonPoints];
          }
          case "left": {
            const cursorPointOne = [
                x2 + 0.5 + 1,
                isFloatingTaller
                  ? y2 + 0.25
                  : cursorLeaveFromBottom
                  ? y2 + 2
                  : y2 - 2,
              ],
              cursorPointTwo = [
                x2 + 0.5 + 1,
                isFloatingTaller
                  ? y2 - 0.5 / 2
                  : cursorLeaveFromBottom
                  ? y2 + 0.5 * 4
                  : y2 - 0.5 * 4,
              ];
            return [
              ...[
                [
                  cursorLeaveFromBottom || isFloatingTaller
                    ? rect.right - 0.5
                    : rect.left,
                  rect.top,
                ],
                [
                  cursorLeaveFromBottom
                    ? isFloatingTaller
                      ? rect.right - 0.5
                      : rect.left
                    : rect.right - 0.5,
                  rect.bottom,
                ],
              ],
              cursorPointOne,
              cursorPointTwo,
            ];
          }
          case "right": {
            const cursorPointOne = [
                x2 - 0.5,
                isFloatingTaller
                  ? y2 + 0.25
                  : cursorLeaveFromBottom
                  ? y2 + 2
                  : y2 - 2,
              ],
              cursorPointTwo = [
                x2 - 0.5,
                isFloatingTaller
                  ? y2 - 0.5 / 2
                  : cursorLeaveFromBottom
                  ? y2 + 0.5 * 4
                  : y2 - 0.5 * 4,
              ],
              commonPoints = [
                [
                  cursorLeaveFromBottom || isFloatingTaller
                    ? rect.left + 0.5
                    : rect.right,
                  rect.top,
                ],
                [
                  cursorLeaveFromBottom
                    ? isFloatingTaller
                      ? rect.left + 0.5
                      : rect.right
                    : rect.left + 0.5,
                  rect.bottom,
                ],
              ];
            return [cursorPointOne, cursorPointTwo, ...commonPoints];
          }
        }
      }
      if (!isPointInPolygon([clientX, clientY], rectPoly)) {
        if (hasLanded && !isOverReferenceRect) return close();
        if (!isLeave && requireIntent) {
          const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
          if (cursorSpeed !== null && cursorSpeed < 0.1) return close();
        }
        isPointInPolygon([clientX, clientY], getPolygon([x, y]))
          ? !hasLanded &&
            requireIntent &&
            (timeoutId = window.setTimeout(close, 40))
          : close();
      }
    };
};
class FloatElementBtn extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "element");
    __publicField(this, "safePolygonFn");
    __publicField(this, "hideTimeoutId");
    __publicField(this, "handleKeyDown", (event) => {
      const { firstTarget } = getTargets(this.floatElement.element);
      isTabKey(event) &&
        !event.shiftKey &&
        (this.isOpen || (event.preventDefault(), this.floatElement.show()),
        firstTarget &&
          (event.preventDefault(),
          this.setTargetListeners("add"),
          firstTarget.focus()),
        this.addListener(this.element, "blur", this.handleBlur, { once: !0 }));
    });
    __publicField(this, "handleBlur", () => {
      this.hideTimeoutId = setTimeout(() => {
        this.hideFloatElement();
      }, 0);
    });
    __publicField(this, "handleFirstTargetFocus", () => {});
    __publicField(this, "handleTargetFocus", () => {
      clearTimeout(this.hideTimeoutId);
    });
    __publicField(this, "handleLastTargetBlur", ({ currentTarget }) => {
      this.emit("lastTargetBlured", { button: this }),
        (this.hideTimeoutId = setTimeout(() => {
          this.hideFloatElement();
        }, 0));
    });
    __publicField(this, "handleMouseEnter", (event) => {
      event.stopPropagation(), this.trigger();
    });
    __publicField(this, "handleElementClick", () => {
      this.trigger();
    });
    __publicField(this, "handleWindowClick", (event) => {
      const isCursorOutside = this.floatElement.checkCursorOutside(
          event.clientX,
          event.clientY
        ),
        isOutsideFloatElements = this.isTargetOutsideFloatElements(
          event.target
        );
      isCursorOutside &&
        isOutsideFloatElements &&
        this.floatElement.isOpen &&
        (this.removeListener(window, "click", this.handleWindowClick),
        this.floatElement.hide());
    });
    __publicField(this, "handleMouseLeave", (event) => {
      this.safePolygonFn &&
        this.removeListener(window, "mousemove", this.handleMouseMove),
        (this.safePolygonFn = safePolygon()({
          x: event.clientX,
          y: event.clientY,
          placement: this.floatElement.dataset.placement,
          onClose: () => {
            this.removeListener(window, "mousemove", this.handleMouseMove),
              this.floatElement &&
                this.floatElement.isOpen &&
                this.floatElement.hide();
          },
          elements: { domReference: this.element, floating: this.floatElement },
          nodeId: null,
          tree: null,
        })),
        this.safePolygonFn(event),
        this.addListener(window, "mousemove", this.handleMouseMove);
    });
    __publicField(this, "handleMouseMove", (event) => {
      this.safePolygonFn(event);
    });
    __publicField(this, "handleTouchend", (event) => {
      this.isOpen ||
        (event.preventDefault(),
        this.floatElement.show(),
        this.addListener(window, "click", this.handleWindowClick),
        $list('[data-aria-expanded="true"]').forEach((btn) => {
          btn !== this && btn.floatElement.hide();
        }));
    });
    __publicField(this, "trigger", () => {
      (this.dataset.trigger === "click" ? "click" : "mouseenter") === "click"
        ? (this.floatElement.isOpen
            ? this.floatElement.hide()
            : this.floatElement.show(),
          this.addListener(window, "click", this.handleWindowClick))
        : (this.floatElement.show(),
          this.addListener(this.element, "mouseleave", this.handleMouseLeave));
    });
    this.element = this.getElement();
  }
  mountComponent() {
    this.addListener(this.element, "keydown", this.handleKeyDown),
      this.dataset.trigger === "click"
        ? (this.addListener(window, "click", this.handleWindowClick),
          this.addListener(this.element, "click", this.handleElementClick))
        : (this.addListener(this.element, "mouseleave", this.handleMouseLeave),
          this.addListener(this.element, "mouseenter", this.handleMouseEnter),
          this.addListener(this.element, "touchend", this.handleTouchend));
  }
  hideFloatElement() {
    this.setTargetListeners("remove"), this.floatElement.hide();
  }
  setTargetListeners(action) {
    const { targets, firstTarget, lastTarget } = getTargets(
        this.floatElement.element
      ),
      listenerSetter = action === "add" ? "addListener" : "removeListener";
    this[listenerSetter](firstTarget, "focus", this.handleFirstTargetFocus),
      targets.forEach((target) => {
        this[listenerSetter](target, "focus", this.handleTargetFocus);
      }),
      this[listenerSetter](lastTarget, "blur", this.handleLastTargetBlur),
      this[listenerSetter](window, "click", this.handleWindowClick);
  }
  getElement() {
    return (
      $el(
        `[data-float-element-trigger="${this.dataset.floatElementId}"]`,
        this
      ) || this
    );
  }
  isTargetOutsideFloatElements(target) {
    return !this.floatElement.contains(target) && !this.contains(target);
  }
  setExpand(isExpanded) {
    this.setAttribute("data-aria-expanded", isExpanded);
  }
  get floatElement() {
    if (this.dataset.floatElementId)
      return $el(`#${this.dataset.floatElementId}`);
  }
  get isOpen() {
    return this.floatElement.isOpen;
  }
}
class TooltipTrigger extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleMouseEnter", () => {
      const floatElement = $el(`#${this.dataset.floatElementId}`);
      floatElement == null || floatElement.show();
    });
    __publicField(this, "handleMouseLeave", () => {
      const floatElement = $el(`#${this.dataset.floatElementId}`);
      floatElement == null || floatElement.hide();
    });
  }
  mountComponent() {
    this.addListener(this, "mouseenter", this.handleMouseEnter),
      this.addListener(this, "mouseleave", this.handleMouseLeave);
  }
  setExpand(isExpanded) {
    this.setAttribute("data-aria-expanded", isExpanded ? "true" : "false");
  }
}
const PROGRESS_BAR_DOTS = "[data-free-shipping-progress-bar-dots]",
  MESSAGE_NODE_SELECTOR = "[data-free-shipping-bar-message]";
class FreeShippingBar extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "setProgress", (value) => {
      const dots = $el(PROGRESS_BAR_DOTS, this);
      dots &&
        dots.setAttribute("style", `--gsc-freeshipping-bar-percent: ${value}%`);
    });
    __publicField(this, "setText", (text) => {
      const messageNode = $el(MESSAGE_NODE_SELECTOR, this);
      messageNode == null || messageNode.replaceChildren(text);
    });
  }
  connectedCallback() {
    const {
        cartTotal,
        currencyFormat,
        threshold,
        progressMessage,
        achievedMessage,
      } = this.dataset,
      thresholdRated = +threshold * +Shopify.currency.rate,
      diffNumber = (thresholdRated - +cartTotal).toFixed(
        currencyFormat.includes("no_decimals") ? 0 : 2
      ),
      diffPercent = (+cartTotal / thresholdRated) * 100;
    if (+diffNumber > 0) {
      const m = currencyFormat.replace(/{{.+?}}/g, `${diffNumber}`),
        withComma =
          currencyFormat.includes("amount_with_comma_separator") ||
          currencyFormat.includes("amount_with_space_separator");
      this.setText(
        progressMessage.replace("[value]", withComma ? m.replace(".", ",") : m)
      ),
        this.setProgress(diffPercent);
    } else this.setText(achievedMessage), this.setProgress(100);
  }
}
const INPUT_SELECTOR$7 = "[data-password-field-input]",
  BUTTON_SELECTOR$5 = "[data-password-field-button]";
class PasswordField extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.togglePasswordVisible();
    });
  }
  mountComponent() {
    const button = $el(BUTTON_SELECTOR$5, this);
    this.addListener(button, "click", this.handleButtonClick);
  }
  togglePasswordVisible() {
    const input = $el(INPUT_SELECTOR$7, this);
    if (input) {
      const isHidden = input.getAttribute("type") === "password";
      input.setAttribute("type", isHidden ? "text" : "password"),
        this.setHiddenButton(isHidden);
    }
  }
  setHiddenButton(isHidden) {
    const button = $el(BUTTON_SELECTOR$5, this);
    button == null || button.toggleAttribute("password-visible", isHidden);
  }
}
const INPUT_SELECTOR$6 = "[data-search-field-input]",
  RESET_BTN_SELECTOR$1 = "[data-search-field-reset-button]";
class SearchField extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleWindowClick", (event) => {
      const input = $el(INPUT_SELECTOR$6, this),
        target = event.target,
        isInputChild = $elParent("search-input", target);
      !(input === target) && !isInputChild && this.updateResetButtonVisible();
    });
    __publicField(this, "handleInputChange", () => {
      this.updateResetButtonVisible();
    });
    __publicField(this, "handleResetButtonClick", (event) => {
      event.preventDefault(), this.reset();
    });
  }
  mountComponent() {
    const resetButton = $el(RESET_BTN_SELECTOR$1, this),
      input = $el(INPUT_SELECTOR$6, this);
    this.addListener(input, "input", this.handleInputChange),
      this.addListener(window, "click", this.handleWindowClick),
      this.addListener(resetButton, "click", this.handleResetButtonClick);
  }
  reset() {
    const input = $el(INPUT_SELECTOR$6, this);
    input &&
      ((input.value = ""),
      input.dispatchEvent(new Event("input", { bubbles: !0 })),
      input.focus());
  }
  updateResetButtonVisible() {
    const resetButton = $el(RESET_BTN_SELECTOR$1, this);
    resetButton &&
      resetButton.classList.toggle("hidden", !this.hasInputValue());
  }
  hasInputValue() {
    const input = $el(INPUT_SELECTOR$6, this);
    return input ? input.value.trim().length > 0 : !1;
  }
  get value() {
    const input = $el(INPUT_SELECTOR$6, this);
    return input ? input.value : "";
  }
}
const INPUT_SELECTOR$5 = "[data-localization-input]",
  FORM_SELECTOR$6 = "form",
  SEARCH_FIELD_SELECTOR$1 = "[data-localization-search-field]",
  COUNTRY_SELECTOR = "data-country",
  RESET_BTN_SELECTOR = "[data-search-field-reset-button]";
class LocalizationSelector extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "labels");
    __publicField(this, "resetButton");
    __publicField(this, "handleSearchInput", ({ target }) => {
      this.labels.forEach((label) => {
        label.classList.toggle(
          "hidden",
          !label
            .getAttribute(COUNTRY_SELECTOR)
            .toLowerCase()
            .startsWith(target.value.toLowerCase())
        );
      }),
        this.resetButton.classList.toggle("hidden", !target.value.length);
    });
    __publicField(this, "handleResetButtonClick", () => {
      const input = $el(SEARCH_FIELD_SELECTOR$1, this);
      (input.value = ""),
        input.dispatchEvent(new Event("input", { bubbles: !0 })),
        input.focus();
    });
    __publicField(this, "handleClick", (event) => {
      event.preventDefault();
      const item = event.target.closest("[data-localization-item]");
      if (item) {
        const input = $el(INPUT_SELECTOR$5, this),
          form = $el(FORM_SELECTOR$6, this);
        if (!input || !form || !item.dataset.value) return;
        (input.value = item.dataset.value),
          form.submit(),
          this.closest("float-element").hide();
      }
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleClick);
    const searchField = $el(SEARCH_FIELD_SELECTOR$1, this);
    searchField &&
      (this.addListener(searchField, "input", this.handleSearchInput),
      (this.labels = $list(`[${COUNTRY_SELECTOR}]`, this)),
      (this.resetButton = $el(RESET_BTN_SELECTOR, this)),
      this.addListener(this.resetButton, "click", this.handleResetButtonClick));
  }
}
const LINE_CLAMP_SELECTOR = "[data-quote-line-clamp]",
  TARGET_SELECTOR$1 = "[data-quote-line-clamp-target]";
class MaxLinesComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        this.offsetHeight > 0 && this.update();
      }, 100)
    );
  }
  mountComponent() {
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  update() {
    const lineClamp = $el(LINE_CLAMP_SELECTOR, this),
      target = $el(TARGET_SELECTOR$1, this);
    if (!lineClamp || !target) return;
    const heightContainer = $el("[data-quote-height]", this),
      styles = getComputedStyle(target),
      lineHeight = parseFloat(styles.lineHeight),
      height = lineClamp.offsetHeight,
      containerHeight =
        (heightContainer == null ? void 0 : heightContainer.offsetHeight) ??
        height,
      diff = (containerHeight - height) / lineHeight;
    let maxLines = Math.floor(height / lineHeight);
    diff > 2 &&
      ((maxLines = Math.floor(containerHeight / lineHeight)),
      (lineClamp.style.maxHeight = `${containerHeight}px`)),
      (target.style["-webkit-line-clamp"] = maxLines),
      this.setAttribute("data-line-clamp-setter-is-ready", ""),
      this.emit("linesSetted", { target });
  }
}
const CLOSE_BUTTON_SELECTOR = "[data-notification-close-button]",
  NOTIFICATION_ALERT_SELECTOR = "[data-notification-alert]",
  ALERT_TEXT_SELECTOR = "[data-notification-alert-text]",
  SCREEN_READER_ALERT_TEXT_SELECTOR =
    "[data-notification-screen-reader-alert-text]";
class NotificationComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "showTimeoutId");
    __publicField(this, "handleClick", (event) => {
      event.preventDefault(),
        $elParent(CLOSE_BUTTON_SELECTOR, event.target) && this.hide();
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleClick);
  }
  unmountComponent() {
    clearTimeout(this.showTimeoutId);
  }
  show(errorText, variant = "warning", duration = 3e3) {
    this.setAlert(errorText, variant),
      this.showTimeoutId && clearTimeout(this.showTimeoutId),
      this.setVisible(!0),
      (this.showTimeoutId = setTimeout(() => {
        this.setVisible(!1);
      }, duration));
  }
  hide() {
    this.setVisible(!1);
  }
  setVisible(isVisible) {
    this.classList.toggle("is-visible", isVisible);
  }
  setAlert(errorText, variant) {
    const alert = $el(NOTIFICATION_ALERT_SELECTOR, this),
      text = $el(ALERT_TEXT_SELECTOR, this),
      screenReaderText = $el(SCREEN_READER_ALERT_TEXT_SELECTOR, this);
    alert &&
      text &&
      (alert.setAttribute("alert-type", variant),
      (text.innerHTML = errorText),
      (screenReaderText.innerHTML = errorText));
  }
}
const PAGINATION_COMPONENT_SELECTOR$2 = "pagination-component";
class PaginationComponent extends BaseComponent {
  updateTargetsFromHTML(html) {
    if (!this.dataset.containerId) return;
    const newResults = $el(`#${this.dataset.containerId}`, html),
      results = $el(`#${this.dataset.containerId}`);
    if (newResults && results) {
      const targets = $list(`.${this.dataset.target}`, newResults),
        fragment = document.createDocumentFragment();
      targets.forEach((target) => {
        fragment.appendChild(target);
      }),
        results.appendChild(fragment);
    }
  }
  updateResultsFromHTML(html) {
    if (!this.dataset.containerId) return;
    const newResults = $el(`#${this.dataset.containerId}`, html),
      results = $el(`#${this.dataset.containerId}`);
    newResults &&
      results &&
      (results.parentNode.replaceChild(newResults, results),
      isNotThemeStore() && newResults.scrollIntoView({ behavior: "smooth" }));
  }
  updateFromHTML(html) {
    const newPagination = $el(PAGINATION_COMPONENT_SELECTOR$2, html);
    replaceNodeChildren(this, newPagination);
  }
  get loadingOverlay() {
    return $el(`#${this.dataset.overlayId}`);
  }
}
const PRELOADER_SELECTOR$2 = ".loading-spinner",
  INTERSECTION_OBSERVER_OPTIONS$2 = {
    root: null,
    rootMargin: "0px 0px 200px 0px",
  };
class PaginationInfiniteScroll extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "intersectionObserver");
    __publicField(this, "handleIntersectionObserve", (entries) => {
      const preloader = $el(PRELOADER_SELECTOR$2, this),
        url = this.dataset.url;
      if (url) {
        if (!entries[0].isIntersecting) return;
        this.intersectionObserver.unobserve(this),
          preloader.classList.remove("hidden"),
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = parseHTML(responseText),
                pagination = $elParent("pagination-component", this);
              preloader.classList.add("hidden"),
                this.updateFromHTML(html),
                pagination && pagination.updateTargetsFromHTML(html);
            })
            .catch(() => {
              console.log("Error in infinite scroll component");
            });
      }
    });
  }
  mountComponent() {
    (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersectionObserve,
      INTERSECTION_OBSERVER_OPTIONS$2
    )),
      this.intersectionObserver.observe(this);
  }
  unmountComponent() {
    this.intersectionObserver.disconnect();
  }
  updateFromHTML(html) {
    const newPagination = $el("pagination-infinite-scroll", html);
    newPagination
      ? (this.setPaginationUrl(newPagination.dataset.url),
        this.intersectionObserver.observe(this))
      : this.removeAttribute("data-url");
  }
  setPaginationUrl(url) {
    this.dataset.url = url;
  }
}
const PAGINATION_COMPONENT_SELECTOR$1 = "pagination-component";
class PaginationLink extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleLinkClick", (event) => {
      event.preventDefault(), this.fetchResults();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.fetchResults());
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeyDown),
      this.addListener(this, "click", this.handleLinkClick);
  }
  fetchResults() {
    const pagination = $elParent(PAGINATION_COMPONENT_SELECTOR$1, this),
      url = this.dataset.url;
    pagination && url && this.getFromUrl(url);
  }
  getFromUrl(url) {
    const pagination = $elParent(PAGINATION_COMPONENT_SELECTOR$1, this);
    pagination &&
      (pagination.loadingOverlay.classList.remove("hidden"),
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          pagination.loadingOverlay.classList.add("hidden"),
            this.updatePaginationFromHTML(parseHTML(responseText)),
            history.pushState({ searchParams: url }, "", url);
        })
        .catch(() => {
          console.log("Error in pagination link component");
        }));
  }
  updatePaginationFromHTML(html) {
    const pagination = $elParent(PAGINATION_COMPONENT_SELECTOR$1, this);
    pagination &&
      (pagination.updateResultsFromHTML(html), pagination.updateFromHTML(html));
  }
}
const PAGINATION_COMPONENT_SELECTOR = "pagination-component",
  PAGINATION_LOAD_BUTTON_SELECTOR = "pagination-load-button";
class PaginationLoadButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.fetchResults();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.fetchResults());
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeyDown),
      this.addListener(this, "click", this.handleButtonClick);
  }
  fetchResults() {
    this.dataset.url &&
      (this.setLoading(!0),
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = parseHTML(responseText);
          this.setLoading(!1),
            this.updateFromHTML(html),
            this.updatePaginationFromHTML(html);
        })
        .catch(() => {
          console.log("Error in pagination load button component");
        }));
  }
  updatePaginationFromHTML(html) {
    const pagination = $elParent(PAGINATION_COMPONENT_SELECTOR, this);
    pagination == null || pagination.updateTargetsFromHTML(html),
      pagination == null || pagination.updateFromHTML(html);
  }
  setPaginationUrl(newUrl) {
    this.dataset.url = newUrl;
  }
  removePagination() {
    const pagination = $elParent(PAGINATION_COMPONENT_SELECTOR, this);
    pagination == null || pagination.remove();
  }
  updateFromHTML(html) {
    const newBtn = $el(PAGINATION_LOAD_BUTTON_SELECTOR, html);
    newBtn
      ? this.setPaginationUrl(newBtn.dataset.url)
      : this.removePagination();
  }
  setLoading(isLoading) {
    this.toggleAttribute("disabled", isLoading),
      this.classList.toggle("loading", isLoading);
  }
}
const INPUT_SELECTOR$4 = "[data-quantity-input]";
class QuantityComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "input");
    __publicField(this, "prevValue");
    __publicField(this, "stockValue");
    __publicField(this, "handleBlur", (event) => {
      if (this.input) {
        const value = event.target.value || "0";
        (this.input.value = value),
          this.updateButtonsDisable(),
          (this.prevValue = value);
      }
    });
    __publicField(this, "handleKeydown", (event) => {
      this.input &&
        isEnterKey(event) &&
        (event.preventDefault(), this.input.blur());
    });
    __publicField(this, "handleInput", (event) => {
      if (this.input) {
        const value = event.target.value;
        (this.input.value = this.isMoreThanStock ? this.stockValue : value),
          this.updateButtonsDisable(),
          (this.prevValue = value);
      }
    });
    (this.input = $el(INPUT_SELECTOR$4, this)),
      (this.prevValue = this.value),
      (this.stockValue = this.dataset.stock || "0");
  }
  mountComponent() {
    this.updateButtonsDisable(),
      this.addListener(this.input, "keypress", this.handleKeydown),
      this.addListener(this.input, "input", this.handleInput),
      this.addListener(this.input, "blur", this.handleBlur);
  }
  inputChange(action) {
    this.input &&
      (action === "minus" ? this.input.stepDown() : this.input.stepUp(),
      +this.prevValue != +this.value &&
        this.input.dispatchEvent(new Event("change", { bubbles: !0 })),
      this.updateButtonsDisable());
  }
  updateButtonsDisable() {
    this.updateButtonDisabled("minus", this.isLessThanMin),
      this.updateButtonDisabled("plus", this.isMoreThanStock);
  }
  setDisable(isDisabled) {
    this.updateButtonDisabled("minus", isDisabled),
      this.updateButtonDisabled("plus", isDisabled);
  }
  updateButtonDisabled(btnType, isDisabled) {
    const button = $el(`quantity-btn[data-action="${btnType}"]`, this);
    button == null || button.toggleAttribute("disabled", isDisabled);
  }
  get value() {
    return this.input ? this.input.value : "0";
  }
  get isLessThanMin() {
    return this.input ? +this.value <= +this.input.min : !1;
  }
  get isMoreThanStock() {
    return +this.value >= +this.stockValue;
  }
}
const QUANTITY_COMPONENT = "quantity-component";
class QuantityBtn extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.update();
    });
    __publicField(this, "handleKeyDown", (event) => {
      const target = event.target;
      isEnterKey(event) &&
        !target.hasAttribute("disabled") &&
        (event.preventDefault(), this.update());
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleButtonClick),
      this.addListener(this, "keydown", this.handleKeyDown);
  }
  update() {
    const quantity = $elParent(QUANTITY_COMPONENT, this),
      action = this.dataset.action;
    if (!(!quantity && !action)) {
      if (action === "minus" && quantity.value === "1") return this.remove();
      quantity.inputChange(action);
    }
  }
  remove() {
    const cart = $elParent("cart-page, cart-drawer", this);
    if (cart) {
      const index = $elParent("cart-item", this).dataset.index;
      cart.updateItem(+index, 0);
    }
  }
}
const colorNames = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgrey: "#d3d3d3",
    lightgreen: "#90ee90",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370d8",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#d87093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32",
  },
  colorHexs = Object.keys(colorNames).reduce(
    (acc, key) => ({ ...acc, [colorNames[key]]: key }),
    {}
  ),
  hexToColorName = (hex) => colorHexs[hex],
  SWATCH_SELECTOR = ".color-swatch";
class ShapeSwatch extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "element");
    (this.element = $el(SWATCH_SELECTOR, this) || this), this.setValue();
  }
  setValue() {
    if (this.hasAttribute("is-image")) return;
    const selectedValue = this.dataset.color.toLowerCase().trim(),
      patterns = this.dataset.colorsPatterns.split(`
`);
    this.isColor(selectedValue) || this.element.setAttribute("not-valid", ""),
      this.setPropertyValue(selectedValue),
      patterns.forEach((pattern) => {
        const config = pattern.split("::"),
          patternLabel = config[0],
          patternValue = config[1];
        if (patternLabel.toLowerCase().trim() === selectedValue) {
          this.setPropertyValue(patternValue);
          return;
        }
      });
  }
  getGradientValue(colors) {
    let gradientValue = "90deg, ",
      notValidColor = 0;
    const preparedPatterns = this.dataset.colorsPatterns
      .split(
        `
`
      )
      .reduce((acc, pattern) => {
        const config = pattern.split("::"),
          patternLabel = config[0],
          patternValue = config[1],
          patternLabelDowncase = patternLabel.toLowerCase().trim();
        return { ...acc, [patternLabelDowncase]: patternValue };
      }, {});
    return (
      colors.forEach((gradientColor, index) => {
        const percent = 100 / colors.length;
        let color = gradientColor.toLowerCase();
        preparedPatterns[color]
          ? (color = preparedPatterns[color])
          : this.isColor(color) || ((color = "white"), (notValidColor += 1));
        const startPoint = `${percent * index}%`,
          endPoint = `${percent * (index + 1)}%`,
          pointValue = `${color} ${startPoint}, ${color} ${endPoint}`;
        (gradientValue = `${gradientValue} ${pointValue}`),
          index !== colors.length - 1 && (gradientValue = `${gradientValue}, `);
      }),
      notValidColor === colors.length
        ? null
        : `linear-gradient(${gradientValue})`
    );
  }
  setPropertyValue(value) {
    const isImage = this.isImage(value),
      isUrl = this.isUrl(value),
      isGradient = this.isGradient(value),
      isValidColor = this.isColor(value),
      bgColorHex = this.dataset.sectionBackground,
      bgColorName = hexToColorName(bgColorHex);
    if (isUrl)
      this.element.removeAttribute("not-valid"),
        this.element.style.setProperty(
          "--gsc-color-swatch-value",
          `url(${value})`
        ),
        this.setSimilarlyBgColorStatus(!1);
    else if (isImage) this.setSimilarlyBgColorStatus(!1);
    else if (isGradient) {
      const gradientColors = value.split("/"),
        gradientValue = this.getGradientValue(gradientColors),
        isSimilarlyBgColor =
          value.includes(bgColorHex) || value.includes(bgColorName);
      gradientValue &&
        (this.element.removeAttribute("not-valid"),
        this.element.style.setProperty(
          "--gsc-color-swatch-value",
          gradientValue
        )),
        this.setSimilarlyBgColorStatus(isSimilarlyBgColor);
    } else {
      const isSimilarlyBgColor = value === bgColorHex || value === bgColorName;
      isValidColor && this.element.removeAttribute("not-valid"),
        this.setSimilarlyBgColorStatus(isSimilarlyBgColor),
        this.element.style.setProperty("--gsc-color-swatch-value", value);
    }
  }
  setSimilarlyBgColorStatus(isSimilarlyBgColor) {
    this.element.toggleAttribute(
      "section-background-color-equally",
      isSimilarlyBgColor
    );
  }
  isColor(color) {
    const style = new Option().style;
    return (style.color = color), style.color !== "";
  }
  isImage(value) {
    return value.includes(".png") || value.includes(".jp");
  }
  isUrl(value) {
    try {
      return new URL(value), !0;
    } catch {
      return !1;
    }
  }
  isGradient(value) {
    return value.includes("/");
  }
}
class ShareComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", (event) => {
      event.preventDefault(),
        navigator.share && navigator.share({ text: this.dataset.valueToCopy });
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleClick);
  }
}
const TEMPLATE_SELECTOR$1 = "[data-share-custom-template]",
  DEFAULT_TEMPLATE_SELECTOR = "[data-share-system-default-template]";
class ShareWrapper extends BaseComponent {
  mountComponent() {
    this.init();
  }
  init() {
    const customTemplate = $el(TEMPLATE_SELECTOR$1, this),
      systemDefaultTemplate = $el(DEFAULT_TEMPLATE_SELECTOR, this),
      template = navigator.share ? systemDefaultTemplate : customTemplate;
    this.replaceChildren(getTemplateContent(template));
  }
}
const BODY_ELEMENT_SELECTOR$9 = "body-element";
class SidebarComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "template");
    __publicField(this, "element");
    __publicField(this, "touchStartX");
    __publicField(this, "touchStartY");
    __publicField(this, "touchEndX");
    __publicField(this, "touchEndY");
    __publicField(this, "isOpen");
    __publicField(this, "isMobile");
    __publicField(this, "handleSidebarFocusout", (event) => {
      const bodyElement = $el(BODY_ELEMENT_SELECTOR$9),
        focusTarget = event.relatedTarget,
        isLastOpenedWindow = bodyElement.isLastOpenedWindow(this.id);
      if (
        (!focusTarget || !this.contains(focusTarget)) &&
        isLastOpenedWindow &&
        bodyElement.isUsingKeyboard
      ) {
        const { firstTarget } = getTargets(this.element);
        firstTarget == null || firstTarget.focus();
      }
    });
    __publicField(this, "handleSectionSelect", ({ detail: { sectionId } }) => {
      this.isSection && this.dataset.sectionId === sectionId && this.open();
    });
    __publicField(
      this,
      "handleSectionDeselect",
      ({ detail: { sectionId } }) => {
        this.isSection && this.dataset.sectionId === sectionId && this.hide();
      }
    );
    __publicField(this, "handleOutsideClick", (event) => {
      $elParent(BODY_ELEMENT_SELECTOR$9, event.target) &&
        this.isOpen &&
        this.hide();
    });
    __publicField(this, "handleTouchStart", (event) => {
      (this.touchStartX = event.targetTouches[0].clientX),
        (this.touchStartY = event.targetTouches[0].clientY);
    });
    __publicField(this, "handleTouchMove", (event) => {
      (this.touchEndX = event.targetTouches[0].clientX),
        (this.touchEndY = event.targetTouches[0].clientY);
    });
    __publicField(this, "handleTouchEnd", (event) => {
      const X_DIRECTION_THRESHOLD = this.offsetWidth / 2,
        Y_DIRECTION_THRESHOLD = 48,
        distanceX = Math.abs(this.touchStartX - this.touchEndX),
        distanceY = Math.abs(this.touchStartY - this.touchEndY),
        isCarousel =
          $elParent("[data-carousel-viewport]", event.target) ??
          event.target.closest("slider-grid"),
        isPriceRange = $elParent("price-range", event.target);
      if (isCarousel || isPriceRange) {
        this.cleanTouchPoints();
        return;
      }
      if (this.touchEndX === 0) {
        this.cleanTouchPoints();
        return;
      }
      if (distanceY > Y_DIRECTION_THRESHOLD) {
        this.cleanTouchPoints();
        return;
      }
      const isTrigger =
        this.dataset.openDirection === "right"
          ? this.touchStartX < this.touchEndX
          : this.touchStartX > this.touchEndX;
      this.isOpen &&
        distanceX > X_DIRECTION_THRESHOLD &&
        isTrigger &&
        this.hide(),
        this.cleanTouchPoints();
    });
    __publicField(this, "handleKeydown", (event) => {
      this.hasAttribute("data-with-close-on-escape") &&
        isEscKey(event) &&
        (event.preventDefault(), this.hide());
    });
    __publicField(this, "handleResize", () => {
      this.isOpen && this.isMobile !== isMobile() && this.hide(!0);
    });
    __publicField(this, "toggleOverlay", (isOpen) => {
      var _a;
      const overlayType = this.getAttribute("data-with-overlay"),
        bodyElement = $el(BODY_ELEMENT_SELECTOR$9);
      if (
        !bodyElement.isVisible &&
        isMobile() &&
        overlayType === "only-desktop"
      ) {
        isOpen
          ? bodyElement.setScrollLock()
          : (_a = bodyElement.unsetScrollLock) == null || _a.call(bodyElement);
        return;
      }
      if (overlayType !== null) {
        const isImportant = this.hasAttribute("data-overlay-important"),
          hasCustomOpacity = this.hasAttribute("data-overlay-opacity"),
          computedStyles = getComputedStyle(this);
        let styles = {};
        isImportant &&
          (styles = {
            ...styles,
            zIndex: parseFloat(computedStyles.zIndex) - 1,
          }),
          hasCustomOpacity &&
            (styles = {
              ...styles,
              "--gsc-body-overlay-opacity": +this.getAttribute(
                "data-overlay-opacity"
              ),
            }),
          whenDefined("body-element").then(() => {
            isOpen
              ? bodyElement.showOverlay(this.id, styles)
              : bodyElement.hideOverlay(this.id);
          });
      }
    });
    __publicField(this, "toggleCloseCursor", (event) => {
      const closeCursor = $el("close-cursor");
      whenDefined("close-cursor").then(() => {
        closeCursor == null || closeCursor.toggle(event);
      });
    });
    __publicField(this, "toggleListeners", (boolean) => {
      const withOutsideClick = this.hasAttribute("data-with-close-on-outside");
      boolean
        ? (this.addListener(window, "keydown", this.handleKeydown),
          this.addListener(this, "focusout", this.handleSidebarFocusout),
          this.addListener(this, "touchstart", this.handleTouchStart),
          this.addListener(this, "touchmove", this.handleTouchMove),
          this.addListener(this, "touchend", this.handleTouchEnd),
          withOutsideClick &&
            this.addListener(window, "click", this.handleOutsideClick))
        : (this.removeListener(window, "keydown", this.handleKeydown),
          this.removeListener(this, "focusout", this.handleSidebarFocusout),
          this.removeListener(this, "touchstart", this.handleTouchStart),
          this.removeListener(this, "touchmove", this.handleTouchMove),
          this.removeListener(this, "touchend", this.handleTouchEnd),
          withOutsideClick &&
            this.removeListener(window, "click", this.handleOutsideClick));
    });
    this.hasAttribute("is-open-on-init")
      ? (this.element = $el("[data-sidebar-body]", this))
      : (this.element = getTemplateFirstChild(
          $el(`[data-sidebar-template="${this.id}"]`, this)
        )),
      (this.isOpen = this.classList.contains("is-opened"));
  }
  mountComponent() {
    super.mountComponent(),
      this.isEditor &&
        (this.isSection || this.hide(!0),
        this.editor.on("SECTION_SELECT", this.handleSectionSelect),
        this.editor.on("SECTION_DESELECT", this.handleSectionDeselect));
  }
  cleanTouchPoints() {
    (this.touchStartX = 0),
      (this.touchEndX = 0),
      (this.touchStartY = 0),
      (this.touchEndY = 0);
  }
  async open(event) {
    this.isMobile = isMobile();
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$9);
    whenDefined("body-element").then(() => {
      bodyElement.addDialogWindow(this.id);
    }),
      this.mount(),
      this.setOpenState(!0),
      await transitionToPromise(this),
      $list("lazy-video, video", this).forEach((video) => {
        video.play ? video.play() : video.initVideo();
      }),
      this.toggleListeners(!0),
      this.isMobile || (this.initFocus(), this.toggleCloseCursor(event)),
      this.addListener(window, "resize", this.handleResize);
  }
  async hide(isInstant) {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$9);
    whenDefined("body-element").then(() => {
      bodyElement.removeDialogWindow(this.id);
    }),
      this.toggleListeners(!1),
      this.toggleCloseCursor(),
      this.setOpenState(!1),
      isInstant
        ? this.unmount()
        : (await transitionToPromise(this), this.unmount()),
      this.removeAttribute("header-shadow-visible"),
      this.removeListener(window, "resize", this.handleResize);
  }
  initFocus() {
    if (isNotIframe()) {
      const { firstTarget } = getTargets(this);
      firstTarget == null || firstTarget.focus();
    }
  }
  async toggle(event) {
    this.isOpen ? this.hide() : this.open(event);
  }
  mount() {
    this.replaceChildren(this.element);
  }
  unmount() {
    this.replaceChildren();
  }
  updateTemplate(template) {
    (this.element = getTemplateFirstChild(template)),
      this.replaceChildren(this.element);
  }
  setOpenState(isOpen) {
    (this.isOpen = isOpen),
      this.setVisible(isOpen),
      this.toggleOverlay(isOpen),
      $list(`[data-sidebar-button][data-sidebar-id="${this.id}"]`).forEach(
        (button) => {
          button.classList.toggle("is-opened", isOpen);
        }
      );
  }
  setVisible(isVisible) {
    this.classList.toggle("is-opened", isVisible);
  }
  get isSection() {
    return this.hasAttribute("data-sidebar-section");
  }
}
const BUTTON_SELECTOR$4 = "[data-sidebar-button]";
class SidebarButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.target.closest("[href]") ||
        (event.preventDefault(), this.toggle(event));
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.toggle(event));
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleButtonClick),
      this.addListener(this, "keydown", this.handleKeyDown);
  }
  toggle(event) {
    const button = $el(BUTTON_SELECTOR$4, this),
      sidebar = $el(`#${button.dataset.sidebarId}`);
    sidebar == null || sidebar.toggle(event),
      button == null ||
        button.classList.toggle(
          "is-opened",
          sidebar == null ? void 0 : sidebar.isOpen
        );
  }
}
const BUTTON_SELECTOR$3 = "[data-cart-sticky-button]",
  HEADER_SELECTOR$3 = ".shopify-section.shopify-section-header";
class StickyCartButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleWindowScroll", () => {
      const header = $el(HEADER_SELECTOR$3),
        button = $el(BUTTON_SELECTOR$3, this);
      if (header && button) {
        const rect = header.getBoundingClientRect();
        button.classList.toggle(
          "is-visible",
          rect.bottom + button.offsetHeight < 0
        );
      }
    });
  }
  mountComponent() {
    this.addListener(window, "scroll", this.handleWindowScroll);
  }
}
class TabComponent extends BaseComponent {
  async show() {
    await this.setVisible(!0);
  }
  async hide() {
    await this.setVisible(!1);
  }
  async setVisible(isVisible) {
    this.setAttribute("aria-hidden", isVisible ? "false" : "true"),
      await transitionToPromise(this);
  }
  get isVisible() {
    return this.getAttribute("aria-hidden") === "false";
  }
}
const CONTENT_SELECTOR$1 = "[data-tabs-element-content]";
class TabWithDynamicHeight extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "handleResize", () => {
      this.updateHeight();
    });
  }
  mountComponent() {
    const content = $el(CONTENT_SELECTOR$1, this);
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(content),
      this.updateHeight();
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.updateHeight();
  }
  async show() {
    this.setVisible(!0);
  }
  async hide() {
    this.setVisible(!1);
  }
  setVisible(isVisible) {
    this.setAttribute("aria-hidden", isVisible ? "false" : "true");
  }
  updateHeight() {
    const content = $el(CONTENT_SELECTOR$1, this);
    content &&
      (this.style.maxHeight = `${Math.ceil(
        this.isVisible ? content.offsetHeight : 0
      )}px`);
  }
  get isVisible() {
    return this.getAttribute("aria-hidden") === "false";
  }
  static get observedAttributes() {
    return ["aria-hidden"];
  }
}
const CONTAINER_SELECTOR$1 = "[data-tabs-container]",
  TEMPLATE_SELECTOR = "[data-tabs-elements-template]",
  TAB_SELECTOR = "tab-component, tab-with-dynamic-height",
  TAB_NAME_SELECTOR = "[data-tabs-name]";
class TabsComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "template");
    __publicField(this, "templateContent");
    __publicField(this, "tabs");
    __publicField(this, "handleNameClick", (event) => {
      event.preventDefault();
      const target = event.target.closest("[data-id]");
      target.dataset.id && this.selectTab(target.dataset.id);
    });
    __publicField(this, "handleKeyDown", (event) => {
      const target = event.target;
      target.dataset.id &&
        isEnterKey(event) &&
        (event.preventDefault(), this.selectTab(target.dataset.id));
    });
    (this.template = $el(TEMPLATE_SELECTOR, this)),
      (this.templateContent = getTemplateContent(this.template)),
      (this.tabs = [
        $el(TAB_SELECTOR, this),
        ...$list(TAB_SELECTOR, this.templateContent),
      ]);
  }
  mountComponent() {
    $list(TAB_NAME_SELECTOR, this).forEach((name) => {
      this.addListener(name, "keydown", this.handleKeyDown),
        this.addListener(name, "click", this.handleNameClick);
    });
  }
  generateTabMap() {
    return this.tabs.reduce((map, tab) => {
      const tabId = tab.dataset.id;
      return tabId ? { ...map, [tabId]: tab } : map;
    }, {});
  }
  async selectTab(tabId) {
    this.updateNameById(tabId), await this.showNextTab(tabId);
  }
  updateNameById(tabId) {
    $list(TAB_NAME_SELECTOR, this).forEach((name) => {
      name.classList.toggle("selected", tabId === name.getAttribute("data-id"));
    });
  }
  async showNextTab(tabId) {
    const tab = this.generateTabMap()[tabId],
      id = tab.getAttribute("data-id"),
      container = $el(CONTAINER_SELECTOR$1, this);
    if (!id || !container) return;
    (this.dataset.selectedTabId = id),
      container.replaceChildren(tab),
      await tab.show();
    const video = $el("video[autoplay]", tab);
    video == null || video.play(), this.emit("selectTab", { tabId, tab });
  }
  getNames() {
    return $list(TAB_NAME_SELECTOR, this);
  }
}
const BUTTON_SELECTOR$2 = "[data-before-after-images-button]",
  STEP = 20,
  WITH_TRANSITION_CLASS = "before-after--with-transition",
  SEPARATOR_SELECTOR = "[data-before-after-images-separator]";
class BeforeAfterImages extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "isMoving", !1);
    __publicField(this, "intersectionObserver");
    __publicField(this, "setInitialPosition", async () => {
      const separator = $el(SEPARATOR_SELECTOR, this);
      this.setPosition(Number(this.dataset.initialDragPosition)),
        await transitionToPromise(separator),
        this.classList.remove(WITH_TRANSITION_CLASS);
    });
    __publicField(this, "handleInViewport", (entries) => {
      entries.some((entry) => entry.isIntersecting) &&
        (this.intersectionObserver.disconnect(), this.setInitialPosition());
    });
    __publicField(this, "handleButtonMouseDown", (event) => {
      event.preventDefault(), this.startMove();
    });
    __publicField(this, "handleButtonMouseUp", () => {
      this.endMove();
    });
    __publicField(this, "handleMouseMove", (event) => {
      this.isMoving && this.move(event.pageX);
    });
    __publicField(this, "handleButtonKeyUp", (event) => {
      const button = $el(BUTTON_SELECTOR$2, this);
      if (!button || (!isLeftKey(event) && !isRightKey(event))) return;
      const rect = button.getBoundingClientRect(),
        point = rect.right - rect.width / 2,
        position = isLeftKey(event) ? point - STEP : point + STEP;
      this.move(position);
    });
    __publicField(this, "handleTouchStart", () => {
      this.startMove();
    });
    __publicField(this, "handleTouchEnd", () => {
      this.endMove();
    });
    __publicField(this, "handleTouchMove", (event) => {
      this.isMoving &&
        (event.preventDefault(), this.move(event.targetTouches[0].clientX));
    });
  }
  mountComponent() {
    const button = $el(BUTTON_SELECTOR$2, this);
    this.addListener(button, "keyup", this.handleButtonKeyUp),
      this.addListener(button, "mousedown", this.handleButtonMouseDown),
      this.addListener(document, "mouseup", this.handleButtonMouseUp),
      this.addListener(document, "mousemove", this.handleMouseMove),
      this.addListener(button, "touchstart", this.handleTouchStart),
      this.addListener(this, "touchmove", this.handleTouchMove),
      this.addListener(document, "touchend", this.handleTouchEnd),
      (this.intersectionObserver = new IntersectionObserver(
        this.handleInViewport,
        { rootMargin: "0px" }
      )),
      this.intersectionObserver.observe(this);
  }
  unmountComponent() {
    var _a;
    (_a = this.intersectionObserver) == null || _a.disconnect();
  }
  startMove() {
    this.isMoving = !0;
  }
  endMove() {
    this.isMoving = !1;
  }
  setPosition(position) {
    this.style.setProperty("--gsc-drag-position", `${position}%`);
  }
  move(newPosition) {
    const rect = this.getBoundingClientRect();
    if (newPosition <= rect.left) this.setPosition(0);
    else if (newPosition >= rect.right) this.setPosition(100);
    else {
      const position =
        Math.floor(((newPosition - rect.left) / this.offsetWidth) * 1e3) / 10;
      this.setPosition(position);
    }
  }
}
const CART_PAGE_SELECTOR$a = "cart-page";
class CartAppBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(`cart-app-block[block-id="${this.getAttribute("block-id")}"]`, node)
      );
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$a, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$a, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const CART_PAGE_SELECTOR$9 = "cart-page",
  CHECKOUT_BUTTON_SELECTOR$1 = "[data-cart-page-checkout-button]";
class CartButtonsBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleStartCartUpdate", () => {
      this.setLoading(!0);
    });
    __publicField(this, "handleCartUpdate", ({ node }) => {
      this.setLoading(!1),
        replaceNodeChildren(
          this,
          $el(
            `cart-buttons-block[block-id="${this.getAttribute("block-id")}"]`,
            node
          )
        );
    });
    __publicField(this, "handleStopUpdate", () => {
      this.setLoading(!1);
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$9, this);
    cart == null || cart.on("start-update", this.handleStartCartUpdate),
      cart == null || cart.on("stop-update", this.handleStopUpdate),
      cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$9, this);
    cart == null || cart.off("start-update", this.handleStartCartUpdate),
      cart == null || cart.off("stop-update", this.handleStopUpdate),
      cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
  setLoading(isLoading) {
    const button = $el(CHECKOUT_BUTTON_SELECTOR$1, this);
    button == null || button.toggleAttribute("disabled", isLoading),
      button == null || button.classList.toggle("loading", isLoading);
  }
}
const CART_PAGE_SELECTOR$8 = "cart-page";
class CartCountdownBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `cart-countdown-block[block-id="${this.getAttribute("block-id")}"]`,
          node
        )
      );
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$8, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$8, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const CART_PAGE_SELECTOR$7 = "cart-page",
  FREE_SHIPPING_BAR = "free-shipping-bar";
class CartFreeShippingBarBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", (data) => {
      const bar = $el(FREE_SHIPPING_BAR, this),
        newBar = $el(FREE_SHIPPING_BAR, data.node);
      !bar || !newBar || bar.replaceWith(newBar);
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$7, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$7, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const CART_PAGE_SELECTOR$6 = "cart-page";
class CartInCartBannerBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `cart-in-cart-banner-block[block-id="${this.getAttribute(
            "block-id"
          )}"]`,
          node
        )
      );
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$6, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$6, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const CHECKMARK_SELECTOR = "[data-cart-item-checkmark]",
  QUANTITY_SELECTOR = "[data-cart-item-quantity]";
class CartItem extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "handleResize", async () => {
      parseInt(this.style.maxHeight) > 0 && this.setHeight(this.scrollHeight);
    });
    __publicField(this, "showCheckmark", () => {
      const checkmark = $el(CHECKMARK_SELECTOR, this);
      checkmark == null || checkmark.classList.remove("hidden"),
        delay(2500).then(() => {
          checkmark == null || checkmark.classList.add("hidden");
        });
    });
    __publicField(this, "setLoading", (isLoading) => {
      this == null || this.toggleAttribute("is-loading", isLoading);
    });
  }
  mountComponent() {
    this.setHeight(this.hasAttribute("is-new") ? 0 : this.scrollHeight),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(document.body);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  async removeItem() {
    await this.collapse();
  }
  async expand() {
    this.setHeight(this.scrollHeight), await transitionToPromise(this);
  }
  async collapse() {
    this.setHeight(0), await transitionToPromise(this);
  }
  async showAsNew() {
    await this.expand(),
      this.removeAttribute("is-new"),
      this.dispatchEvent(new Event("showAsNew", { bubbles: !0 }));
  }
  setHeight(maxHeight) {
    this.style.maxHeight = `${Math.ceil(maxHeight)}px`;
  }
  setDisabled(isDisable) {
    const quantity = $el(QUANTITY_SELECTOR, this);
    quantity == null || quantity.setDisable(isDisable);
  }
}
const CART_PAGE_SELECTOR$5 = "cart-page";
class CartItemsBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `cart-items-block[block-id="${this.getAttribute("block-id")}"]`,
          node
        )
      ),
        isNotThemeStore() && this.scrollIntoView({ behavior: "smooth" });
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$5, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$5, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const fetchConfig = (type = "json") => ({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  }),
  { routes: routes$2 } = window;
class CartAPI {
  change(config) {
    return fetch(routes$2.cart_change_url, config).then((response) =>
      response.text()
    );
  }
  add(config) {
    return fetch(routes$2.cart_add_url, config).then((response) =>
      response.text()
    );
  }
  update(config) {
    return fetch(routes$2.cart_update_url, config);
  }
  get() {
    return fetch(routes$2.cart_url).then((response) => response.text());
  }
  getDrawer() {
    return fetch(routes$2.root_url).then((response) => response.text());
  }
  getCartState() {
    return fetch(routes$2.root_url + "cart.js").then((response) =>
      response.json()
    );
  }
}
const SELECTOR_APPLY_BUTTON = ".cart-note__apply-button",
  SELECTOR_TEXTAREA = ".cart-note__textarea",
  SELECTOR_BOTTOM_SHEET = ".bottom-sheet";
class CartNote extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "cartAPI", new CartAPI());
    __publicField(this, "textarea");
    __publicField(this, "applyButton");
    __publicField(this, "initialValue");
    __publicField(this, "handleTextareaBlur", () => this.saveCartNote());
    __publicField(this, "handleApplyButtonClick", () => {
      var _a;
      (_a = $elParent(SELECTOR_BOTTOM_SHEET, this)) == null || _a.hide(),
        this.saveCartNote();
    });
    __publicField(this, "getTextareaValue", () => this.textarea.value);
    __publicField(
      this,
      "saveCartNote",
      debounce(async () => {
        if (this.initialValue !== this.getTextareaValue())
          try {
            await this.cartAPI.update({
              ...fetchConfig(),
              body: JSON.stringify({ note: this.getTextareaValue() }),
            }),
              (this.initialValue = this.getTextareaValue());
          } catch (e) {
            console.error(e);
          }
      }, 500)
    );
  }
  mountComponent() {
    super.mountComponent(),
      (this.textarea = $el(SELECTOR_TEXTAREA, this)),
      (this.applyButton = $el(SELECTOR_APPLY_BUTTON, this)),
      (this.initialValue = this.getTextareaValue()),
      this.addListener(this.applyButton, "click", this.handleApplyButtonClick),
      this.addListener(this.textarea, "blur", this.handleTextareaBlur);
  }
  unmountComponent() {
    super.unmountComponent(),
      this.removeListener(
        this.applyButton,
        "click",
        this.handleApplyButtonClick
      ),
      this.removeListener(this.textarea, "blur", this.handleTextareaBlur);
  }
}
const CART_PAGE_SELECTOR$4 = "cart-page";
class CartOrderNotesBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `cart-order-notes-block[block-id="${this.getAttribute("block-id")}"]`,
          node
        )
      );
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$4, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$4, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const LOADING_OVERLAY_SELECTOR$1 = ".loading-overlay";
class CartRelatedProducts extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "prevUrl");
    __publicField(this, "updateByHTML", (node) => {
      const recommendations = $el(`#${this.id}`, node);
      replaceNodeChildren(this, recommendations);
      const products = $list("vertical-product-card", this);
      this.setReady(products.length > 0);
    });
  }
  mountComponent() {
    this.loadProducts();
  }
  erase() {
    this.replaceChildren(), this.setReady(!1);
  }
  loadProducts() {
    if (
      this.prevUrl !== this.dataset.url &&
      ((this.prevUrl = this.dataset.url), !!this.dataset.url)
    )
      return (
        this.showPreloader(),
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            this.hidePreloader(), this.updateByHTML(parseHTML(text));
          })
          .catch(() => {
            console.log("Error in cart related products");
          })
      );
  }
  setReady(isReady) {
    this.toggleAttribute("is-ready", isReady);
  }
  showPreloader() {
    const loadingOverlay = $el(LOADING_OVERLAY_SELECTOR$1, this);
    showElement(loadingOverlay);
  }
  hidePreloader() {
    const loadingOverlay = $el(LOADING_OVERLAY_SELECTOR$1, this);
    hideElement(loadingOverlay);
  }
}
const RELATED_PRODUCTS_SELECTOR$1 = "[data-cart-related-products]",
  CART_PAGE_SELECTOR$3 = "cart-page";
class CartRelatedProductsBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      const relatedProducts = $el(RELATED_PRODUCTS_SELECTOR$1, this),
        newRelatedProducts = $el(
          `cart-related-products-block[block-id="${this.getAttribute(
            "block-id"
          )}"] [data-cart-related-products]`,
          node
        ),
        isAuto = this.hasAttribute("is-auto-recommendations");
      if (!(!relatedProducts || !newRelatedProducts))
        if (isAuto) {
          const newUrl = newRelatedProducts.getAttribute("data-url");
          relatedProducts.setAttribute("data-url", newUrl),
            newUrl
              ? (relatedProducts.loadProducts(), showElement(this))
              : (relatedProducts.erase(), hideElement(this));
        } else replaceNodeChildren(relatedProducts, newRelatedProducts);
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$3, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$3, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
class CartRemoveButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.update();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.update());
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeyDown),
      this.addListener(this, "click", this.handleButtonClick);
  }
  update() {
    const cart = $elParent("cart-page, cart-drawer", this),
      index = this.dataset.index;
    cart && index && cart.updateItem(+index, 0);
  }
}
const CART_PAGE_SELECTOR$2 = "cart-page";
class CartSubtotalBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `cart-subtotal-block[block-id="${this.getAttribute("block-id")}"]`,
          node
        )
      );
    });
  }
  mountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$2, this);
    cart == null || cart.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cart = $elParent(CART_PAGE_SELECTOR$2, this);
    cart == null || cart.off("update-nodes", this.handleCartUpdate);
  }
}
const BODY_ELEMENT_SELECTOR$8 = "body-element",
  SELECTOR_CONSENT_CHECKBOX$1 = ".checkbox--consent",
  SELECTOR_BUTTONS_WRAPPER = ".cart-buttons-wrapper",
  SELECTOR_CONSENT_VERIFY$1 = "[data-consent-verify]";
class CartPage extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "cartAPI", new CartAPI());
    __publicField(this, "cartState");
    __publicField(this, "handleConsentCheckboxChange", ({ target }) => {
      const consentCheckbox = target.closest(SELECTOR_CONSENT_CHECKBOX$1);
      consentCheckbox &&
        $list(
          SELECTOR_CONSENT_VERIFY$1,
          $elParent(SELECTOR_BUTTONS_WRAPPER, consentCheckbox)
        ).forEach((consentVerifyItem) =>
          consentVerifyItem == null
            ? void 0
            : consentVerifyItem.setAttribute(
                "data-consent-verify",
                target.checked
              )
        );
    });
    __publicField(this, "handleItemChange", (event) => {
      const item = $el(`#CartItem-${+event.target.dataset.index}`, this);
      item == null || item.setLoading(!0), this.setLoadingStatus(!0);
    });
    __publicField(
      this,
      "handleCartChange",
      debounce((event) => {
        this.updateItem(+event.target.dataset.index, event.target.value);
      }, 500)
    );
    __publicField(this, "setCartState", () => {
      this.cartState = this.cloneNode(!0);
    });
    __publicField(this, "resetToPrevCartState", () => {
      this.replaceWith(this.cartState);
    });
  }
  mountComponent() {
    this.setCartState(),
      this.addListener(this, "change", this.handleCartChange),
      this.addListener(this, "change", this.handleItemChange),
      this.addListener(this, "change", this.handleConsentCheckboxChange);
  }
  updateItem(itemIndex, quantity) {
    const item = $el(`#CartItem-${itemIndex}`);
    if (!item) return;
    if (
      (this.setLoadingStatus(!0), +(item.dataset.quantity || 0) === +quantity)
    ) {
      item.setLoading(!1), this.setLoadingStatus(!1);
      return;
    }
    if (+quantity == 0) {
      const items = $list("cart-item", this);
      this.updateEmptyStatus(items.length === 1), item.removeItem();
    }
    this.emit("start-update", {}),
      item.setDisabled(!0),
      this.cartAPI
        .change({
          ...fetchConfig(),
          body: JSON.stringify({
            line: itemIndex + 1,
            quantity,
            sections: this.dataset.sectionId,
            sections_url: window.location.pathname,
          }),
        })
        .then((state) => {
          item.setDisabled(!1),
            item.setLoading(!1),
            this.setLoadingStatus(!1),
            this.emit("update-nodes", {
              node: parseHTML(
                JSON.parse(state).sections[this.dataset.sectionId]
              ),
            }),
            this.setCartState();
        })
        .catch(() => {
          this.showError(),
            item.setDisabled(!1),
            item.setLoading(!1),
            this.setLoadingStatus(!1),
            this.emit("stop-update", {}),
            this.resetToPrevCartState();
        });
  }
  setLoadingStatus(isLoading) {
    this.classList.toggle("is-cart-loading", isLoading);
  }
  async purchaseHandler(html, parsedState) {
    this.emit("update-nodes", { node: html });
    const item = $el(`cart-item[data-variant-id="${parsedState.id}"]`, this);
    item &&
      (parsedState.quantity === 1 && (await item.showAsNew()),
      item.showCheckmark());
  }
  showError() {
    $el(BODY_ELEMENT_SELECTOR$8).showNotification(
      window.auroraThemeLocales.cartStrings.error,
      "warning"
    );
  }
  updateEmptyStatus(isEmpty) {
    this.classList.toggle("is-empty", isEmpty),
      isEmpty && this.emit("cartIsEmpty", {});
  }
}
const { routes: routes$1 } = window,
  SELECTOR_COUNTRIES = "#ShippinCalculator-Countries",
  SELECTOR_PROVINCES = "#ShippinCalculator-Provinces",
  SELECTOR_POSTAL_CODE = "#ShippinCalculator-PostalCode",
  SELECTOR_CALCULATE_BUTTON = "#ShippinCalculator-CalculateButton",
  SELECTOR_FIELD = ".shipping-calculator__field",
  SELECTOR_RESULTS = ".shipping-calculator__results",
  SELECTOR_RESULTS_LIST = ".shipping-calculator__results ul",
  CLASS_LOADING$1 = "loading",
  CLASS_SUCCESS = "shipping-calculator--success",
  CLASS_ERRORS = "shipping-calculator--errors",
  SHIPPING_RATES_ENDPOINT = `${routes$1.cart_url}/shipping_rates.json`;
class ShippingCalculator extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "$countries");
    __publicField(this, "$provinces");
    __publicField(this, "$postalCode");
    __publicField(this, "$calculateBtn");
    __publicField(this, "$results");
    __publicField(this, "$resultsList");
    __publicField(this, "isFirstMount", !0);
    __publicField(this, "handlePostalCodeKeyUp", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.calculate());
    });
    __publicField(this, "handleCountryChange", (e) =>
      this.populateProvinceSelector(this.getProvinces(e.target))
    );
    __publicField(this, "selectDefaultAddress", () => {
      this.selectDefaultCountry(), this.selectDefaultProvince();
    });
    __publicField(this, "selectDefaultCountry", () => {
      const defaultCountry = this.$countries.dataset.defaultCountry;
      if (defaultCountry) {
        for (const countryOption of this.$countries.options)
          if (countryOption.textContent === defaultCountry) {
            (countryOption.selected = !0),
              this.$countries.dispatchEvent(new Event("change"));
            break;
          }
      }
    });
    __publicField(this, "selectDefaultProvince", () => {
      const defaultProvince = this.$provinces.dataset.defaultProvince;
      if (defaultProvince) {
        for (const provinceOption of this.$provinces.options)
          if (provinceOption.textContent === defaultProvince) {
            provinceOption.selected = !0;
            break;
          }
      }
    });
    __publicField(this, "getProvinces", (provincesSelector) => {
      const { options, selectedIndex } = provincesSelector,
        {
          dataset: { provinces },
        } = options[selectedIndex];
      return JSON.parse(provinces);
    });
    __publicField(this, "populateProvinceSelector", (provinces) => {
      this.$provinces.replaceChildren(...this.createProvinceOptions(provinces)),
        this.setHiddenProvinceField(!provinces.length);
    });
    __publicField(this, "createProvinceOptions", (provinces) =>
      provinces.map((province) => new Option(...province.reverse()))
    );
    __publicField(this, "setHiddenProvinceField", (hidden) =>
      this.$provinces.closest(SELECTOR_FIELD).toggleAttribute("hidden", hidden)
    );
    __publicField(this, "calculate", async () => {
      this.setButtonLoading(!0);
      try {
        const response = await fetch(SHIPPING_RATES_ENDPOINT, {
            ...fetchConfig(),
            body: JSON.stringify({
              shipping_address: {
                zip: this.$postalCode.value,
                country: this.$countries.value,
                province: this.$provinces.value,
              },
            }),
          }),
          json = await response.json();
        response.ok
          ? this.showResults(json.shipping_rates)
          : this.showErrors(json);
      } catch (e) {
        console.error(e);
      } finally {
        this.setButtonLoading(!1);
      }
    });
    __publicField(this, "showResults", (shippingRates) => {
      const results = [];
      for (const shippingRate of shippingRates) {
        const li = document.createElement("li");
        (li.textContent = `${shippingRate.name}: ${shippingRate.currency} ${shippingRate.price}`),
          results.push(li);
      }
      this.$resultsList.replaceChildren(...results),
        this.$results.classList.toggle(CLASS_SUCCESS, !0),
        this.$results.classList.toggle(CLASS_ERRORS, !1),
        this.$results.toggleAttribute("hidden", !1);
    });
    __publicField(this, "showErrors", (errors) => {
      const results = [];
      for (const [, message] of Object.entries(errors)) {
        const li = document.createElement("li");
        (li.textContent = message), results.push(li);
      }
      this.$resultsList.replaceChildren(...results),
        this.$results.classList.toggle(CLASS_SUCCESS, !1),
        this.$results.classList.toggle(CLASS_ERRORS, !0),
        this.$results.toggleAttribute("hidden", !1);
    });
    __publicField(this, "setButtonLoading", (loading) =>
      this.$calculateBtn.classList.toggle(CLASS_LOADING$1, loading)
    );
  }
  mountComponent() {
    super.mountComponent(),
      (this.$countries = $el(SELECTOR_COUNTRIES, this)),
      (this.$provinces = $el(SELECTOR_PROVINCES, this)),
      (this.$postalCode = $el(SELECTOR_POSTAL_CODE, this)),
      (this.$calculateBtn = $el(SELECTOR_CALCULATE_BUTTON, this)),
      (this.$results = $el(SELECTOR_RESULTS, this)),
      (this.$resultsList = $el(SELECTOR_RESULTS_LIST, this)),
      this.addListener(this.$countries, "change", this.handleCountryChange),
      this.addListener(this.$calculateBtn, "click", this.calculate),
      this.addListener(this.$postalCode, "keyup", this.handlePostalCodeKeyUp),
      this.isFirstMount &&
        (this.populateProvinceSelector(this.getProvinces(this.$countries)),
        this.selectDefaultAddress(),
        (this.isFirstMount = !1));
  }
  unmountComponent() {
    super.unmountComponent(),
      this.removeListener(this.$countries, "change", this.handleCountryChange),
      this.removeListener(this.$calculateBtn, "click", this.calculate),
      this.removeListener(
        this.$postalCode,
        "keyup",
        this.handlePostalCodeKeyUp
      );
  }
}
const { routes } = window;
class PredictiveSearchAPI {
  get(params) {
    const { searchQuery, sectionParam, limitParam, fieldsParam } = params,
      baseUrl = routes.predictive_search_url;
    return fetch(
      `${baseUrl}?q=${searchQuery}&${limitParam}&${sectionParam}&${fieldsParam}`
    ).then((response) => response.text());
  }
}
const CART_DRAWER_SELECTOR$a = "cart-drawer",
  CART_PAGE_SELECTOR$1 = "cart-page",
  FORM_SELECTOR$5 = "[data-cart-discount-code-form]",
  INPUT_SELECTOR$3 = "[data-cart-discount-code-input]",
  BUTTON_SELECTOR$1 = "[data-cart-discount-code-button]",
  EXISTING_DISCOUNT_SELECTOR = "data-discount-code",
  ERROR_SELECTOR = "[data-cart-discount-error]",
  REMOVE_BUTTON_SELECTOR = "data-remove-discount",
  CLASS_LOADING = "loading";
var _activeFetch;
class CartDiscountCode extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "cartAPI", new CartAPI());
    __publicField(this, "_cart");
    __privateAdd(this, _activeFetch, null);
    __publicField(this, "onSubmit", (e) => {
      e.preventDefault();
      const value = $el(INPUT_SELECTOR$3, this).value;
      value && this.applyDiscount(value);
    });
    __publicField(
      this,
      "applyDiscount",
      async (discountCodeValue, action = "apply") => {
        const existingDiscounts = this.existingDiscounts();
        if (
          !(action === "apply" && existingDiscounts.includes(discountCodeValue))
        )
          try {
            this.setButtonLoading(!0);
            const discountsList =
                action === "apply"
                  ? [...existingDiscounts, discountCodeValue]
                  : existingDiscounts.filter(
                      (title) => title !== discountCodeValue
                    ),
              config = this.getFetchConfig(discountsList),
              data = await (await this.cartAPI.update(config)).json();
            if (this.isCodeApplicable(data.discount_codes, discountCodeValue))
              return this.setError();
            this.updateCartContent(data.sections[this.cart.dataset.sectionId]);
          } catch (error) {
            console.error(error);
          } finally {
            this.setButtonLoading(!1), __privateSet(this, _activeFetch, null);
          }
      }
    );
    __publicField(this, "removeDiscount", async ({ currentTarget }) => {
      const discountCode = currentTarget.getAttribute(REMOVE_BUTTON_SELECTOR);
      discountCode && this.applyDiscount(discountCode, "remove");
    });
    __publicField(this, "setError", () => {
      $el(ERROR_SELECTOR, this).classList.remove("hidden");
    });
    __publicField(this, "getFetchConfig", (discountsList) => {
      const abortController = this.createAbortController();
      return {
        ...fetchConfig(),
        body: JSON.stringify({
          discount: discountsList.join(","),
          sections: [this.cart.dataset.sectionId],
        }),
        signal: abortController.signal,
      };
    });
    __publicField(this, "setButtonLoading", (loading) =>
      $el(BUTTON_SELECTOR$1, this).classList.toggle(CLASS_LOADING, loading)
    );
    __publicField(this, "isCodeApplicable", (list, discountCodeValue) =>
      list.find(
        (discount) =>
          discount.code === discountCodeValue && discount.applicable === !1
      )
    );
  }
  mountComponent() {
    const form = $el(FORM_SELECTOR$5, this);
    this.addListener(form, "submit", this.onSubmit),
      $list(`[${REMOVE_BUTTON_SELECTOR}]`, this).forEach((button) => {
        this.addListener(button, "click", this.removeDiscount);
      });
  }
  updateCartContent(htmlString) {
    const html = parseHTML(htmlString),
      cartDrawer = $el(CART_DRAWER_SELECTOR$a),
      cart = $el(CART_PAGE_SELECTOR$1);
    cartDrawer
      ? cartDrawer.replaceChildren(cartDrawer.getTemplateContent(html))
      : cart && cart.replaceWith($el(CART_PAGE_SELECTOR$1, html));
  }
  existingDiscounts() {
    return $list(`[${EXISTING_DISCOUNT_SELECTOR}]`, this).map((el) =>
      el.getAttribute(EXISTING_DISCOUNT_SELECTOR)
    );
  }
  createAbortController() {
    __privateGet(this, _activeFetch) &&
      __privateGet(this, _activeFetch).abort();
    const abortController = new AbortController();
    return __privateSet(this, _activeFetch, abortController), abortController;
  }
  get cart() {
    return (
      this._cart ??
      (this._cart =
        this.closest(CART_DRAWER_SELECTOR$a) ??
        this.closest(CART_PAGE_SELECTOR$1))
    );
  }
}
_activeFetch = new WeakMap();
const SELECTOR_ORDER_NOTE_BUTTON = ".cart-order-notes__button[data-order-note]",
  SELECTOR_SHIPPING_CALCULATOR_BUTTON =
    ".cart-order-notes__button[data-shipping-calculator]",
  SELECTOR_ORDER_NOTE_BOTTOM_SHEET = ".bottom-sheet:has(.cart-note)",
  SELECTOR_SHIPPING_CALCULATOR_BOTTOM_SHEET =
    ".bottom-sheet:has(.shipping-calculator)",
  SELECTOR_CONTENT_CHILDREN = ".cart-order-notes__content > *",
  SELECTOR_ORDER_NOTE = ".cart-note",
  SELECTOR_SHIPPING_CALCULATOR = ".shipping-calculator",
  CLASS_ORDER_NOTE_OPENED = "cart-order-notes--order-note-opened",
  CLASS_SHIPPING_CALCULATOR_OPENED =
    "cart-order-notes--shipping-calculator-opened",
  SELECTOR_DISCOUNT_BUTTON = ".cart-order-notes__button[data-discount-code]",
  SELECTOR_DISCOUNT_BOTTOM_SHEET = ".bottom-sheet:has(.cart-discount-code)",
  SELECTOR_DISCOUNT = ".cart-discount-code",
  CLASS_DISCOUNT_OPENED = "cart-order-notes--cart-discount-code-opened";
class CartOrderNotes extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "handleResize", (entities) => {
      entities.forEach((entity) => {
        const { target } = entity;
        target instanceof ShippingCalculator
          ? this.style.setProperty(
              "--shipping-calculator-height",
              `${entity.target.scrollHeight}px`
            )
          : target instanceof CartNote
          ? this.style.setProperty(
              "--order-note-height",
              `${entity.target.scrollHeight}px`
            )
          : target instanceof CartDiscountCode &&
            this.style.setProperty(
              "--cart-discount-code-height",
              `${entity.target.scrollHeight}px`
            );
      });
    });
    __publicField(this, "handleClick", (e) => {
      const target = e.target;
      target.closest(SELECTOR_ORDER_NOTE_BUTTON)
        ? this.handleOrderNoteButtonClick()
        : target.closest(SELECTOR_SHIPPING_CALCULATOR_BUTTON)
        ? this.handleShippingButtonClick()
        : target.closest(SELECTOR_DISCOUNT_BUTTON) &&
          this.handleDiscountButtonClick();
    });
    __publicField(this, "handleOrderNoteButtonClick", () => {
      if (this.viewMode == "popup")
        $el(SELECTOR_ORDER_NOTE_BOTTOM_SHEET, this).show();
      else {
        const orderNote = $el(SELECTOR_ORDER_NOTE, this);
        this.style.setProperty(
          "--order-note-height",
          `${orderNote.scrollHeight}px`
        ),
          this.classList.toggle(CLASS_ORDER_NOTE_OPENED),
          this.classList.toggle(CLASS_SHIPPING_CALCULATOR_OPENED, !1),
          this.classList.toggle(CLASS_DISCOUNT_OPENED, !1);
      }
    });
    __publicField(this, "handleDiscountButtonClick", () => {
      if (this.viewMode == "popup")
        $el(SELECTOR_DISCOUNT_BOTTOM_SHEET, this).show();
      else {
        const el = $el(SELECTOR_DISCOUNT, this);
        this.style.setProperty(
          "--cart-discount-code-height",
          `${el.scrollHeight}px`
        ),
          this.classList.toggle(CLASS_DISCOUNT_OPENED),
          this.classList.toggle(CLASS_ORDER_NOTE_OPENED, !1),
          this.classList.toggle(CLASS_SHIPPING_CALCULATOR_OPENED, !1);
      }
    });
    __publicField(this, "handleShippingButtonClick", () => {
      if (this.viewMode == "popup")
        $el(SELECTOR_SHIPPING_CALCULATOR_BOTTOM_SHEET, this).show();
      else {
        const shippingCalculator = $el(SELECTOR_SHIPPING_CALCULATOR, this);
        this.style.setProperty(
          "--shipping-calculator-height",
          `${shippingCalculator.scrollHeight}px`
        ),
          this.classList.toggle(CLASS_SHIPPING_CALCULATOR_OPENED),
          this.classList.toggle(CLASS_ORDER_NOTE_OPENED, !1),
          this.classList.toggle(CLASS_DISCOUNT_OPENED, !1);
      }
    });
  }
  mountComponent() {
    super.mountComponent(),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.addListener(this, "click", this.handleClick),
      $list(SELECTOR_CONTENT_CHILDREN, this).forEach((el) =>
        this.resizeObserver.observe(el)
      );
  }
  unmountComponent() {
    super.unmountComponent(),
      this.removeListener(this, "click", this.handleClick),
      this.resizeObserver.disconnect();
  }
  get viewMode() {
    return this.dataset.viewMode;
  }
}
const CART_DRAWER_SELECTOR$9 = "cart-drawer",
  CHECKOUT_BUTTON_SELECTOR = "[data-cart-checkout-button]";
class CartDrawerButtonsBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleStartCartUpdate", () => {
      this.setLoading(!0);
    });
    __publicField(this, "handleCartUpdate", () => {
      this.setLoading(!1);
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$9, this);
    cartDrawer == null ||
      cartDrawer.on("start-update", this.handleStartCartUpdate),
      cartDrawer == null || cartDrawer.on("stop-update", this.handleCartUpdate),
      cartDrawer == null ||
        cartDrawer.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$9, this);
    cartDrawer == null ||
      cartDrawer.off("start-update", this.handleStartCartUpdate),
      cartDrawer == null ||
        cartDrawer.off("update-nodes", this.handleCartUpdate);
  }
  setLoading(isLoading) {
    const button = $el(CHECKOUT_BUTTON_SELECTOR, this);
    button == null || button.toggleAttribute("disabled", isLoading),
      button == null || button.classList.toggle("loading", isLoading);
  }
}
const CART_DRAWER_SELECTOR$8 = "cart-drawer",
  CART_DRAWER_FOOTER_SELECTOR = "cart-drawer-footer";
class CartDrawerFooter extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartDrawerUpdate", ({ node }) => {
      replaceNodeChildren(this, $el(CART_DRAWER_FOOTER_SELECTOR, node));
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$8, this);
    cartDrawer == null ||
      cartDrawer.on("update-nodes", this.handleCartDrawerUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$8, this);
    cartDrawer == null ||
      cartDrawer.off("update-nodes", this.handleCartDrawerUpdate);
  }
}
const CART_DRAWER_SELECTOR$7 = "cart-drawer",
  FREE_SHIPPING_BAR_SELECTOR = "free-shipping-bar";
class CartDrawerFreeShippingBarBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartUpdate", (data) => {
      const bar = $el(FREE_SHIPPING_BAR_SELECTOR, this),
        newBar = $el(FREE_SHIPPING_BAR_SELECTOR, data.node);
      !bar || !newBar || bar.replaceWith(newBar);
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$7, this);
    cartDrawer == null || cartDrawer.on("update-nodes", this.handleCartUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$7, this);
    cartDrawer == null || cartDrawer.off("update-nodes", this.handleCartUpdate);
  }
}
const CART_DRAWER_SELECTOR$6 = "cart-drawer",
  CART_DRAWER_HEADER_SELECTOR = "cart-drawer-header";
class CartDrawerHeader extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartDrawerUpdate", ({ node }) => {
      replaceNodeChildren(this, $el(CART_DRAWER_HEADER_SELECTOR, node));
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$6, this);
    cartDrawer == null ||
      cartDrawer.on("update-nodes", this.handleCartDrawerUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$6, this);
    cartDrawer == null ||
      cartDrawer.off("update-nodes", this.handleCartDrawerUpdate);
  }
}
const CART_DRAWER_SELECTOR$5 = "cart-drawer",
  CART_DRAWER_IN_CART_BANNER_SELECTOR = "cart-drawer-in-cart-banner-block";
class CartDrawerInCartBannerBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartDrawerUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `${CART_DRAWER_IN_CART_BANNER_SELECTOR}[block-id="${this.getAttribute(
            "block-id"
          )}"]`,
          node
        )
      );
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$5, this);
    cartDrawer == null ||
      cartDrawer.on("update-nodes", this.handleCartDrawerUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$5, this);
    cartDrawer == null ||
      cartDrawer.off("update-nodes", this.handleCartDrawerUpdate);
  }
}
const CART_DRAWER_SELECTOR$4 = "cart-drawer",
  CART_DRAWER_ITEM_SELECTOR = "cart-drawer-items-block";
class CartDrawerItemsBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartDrawerUpdate", ({ node, parsedState }) => {
      const newCartItems = $el(
        `${CART_DRAWER_ITEM_SELECTOR}[block-id="${this.getAttribute(
          "block-id"
        )}"]`,
        node
      );
      parsedState &&
        parsedState.quantity === 1 &&
        $el(
          `cart-item[data-variant-id="${parsedState.id}"]`,
          newCartItems
        ).setAttribute("is-new", ""),
        replaceNodeChildren(this, newCartItems);
    });
    __publicField(
      this,
      "handleCartDrawerPurschase",
      async ({ parsedState }) => {
        const item = $el(
          `cart-item[data-variant-id="${parsedState.id}"]`,
          this
        );
        item && parsedState.quantity === 1 && (await item.showAsNew()),
          item == null || item.showCheckmark();
      }
    );
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$4, this);
    cartDrawer == null ||
      cartDrawer.on("update-nodes", this.handleCartDrawerUpdate),
      cartDrawer == null ||
        cartDrawer.on("purchase", this.handleCartDrawerPurschase);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$4, this);
    cartDrawer == null ||
      cartDrawer.off("update-nodes", this.handleCartDrawerUpdate),
      cartDrawer == null ||
        cartDrawer.off("purchase", this.handleCartDrawerPurschase);
  }
}
const LOADING_OVERLAY_SELECTOR = ".loading-overlay",
  IN_CART_RELATED_PRODUCTS_SELECTOR = "[in-cart-related-product]",
  CART_DRAWER_TEMPLATE_SELECTOR = '[data-sidebar-template="CartDrawer"]',
  BODY_ELEMENT_SELECTOR$7 = "body-element";
class CartDrawerRelatedProducts extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "prevUrl");
    __publicField(this, "updateByHTML", (node) => {
      const recommendations = $el(`#${this.id}`, node);
      replaceNodeChildren(this, recommendations);
      const products = $list(IN_CART_RELATED_PRODUCTS_SELECTOR, this);
      this.setReady(products.length > 0);
    });
  }
  mountComponent() {
    this.loadProducts();
  }
  erase() {
    this.replaceChildren(), this.setReady(!1);
  }
  loadProducts() {
    if (
      this.prevUrl !== this.dataset.url &&
      ((this.prevUrl = this.dataset.url), !!this.dataset.url)
    )
      return (
        this.showPreloader(),
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            this.hidePreloader();
            const template = $el(
                CART_DRAWER_TEMPLATE_SELECTOR,
                parseHTML(text)
              ),
              node = getTemplateFirstChild(template);
            this.updateByHTML(node);
          })
          .catch(() => {
            $el(BODY_ELEMENT_SELECTOR$7).showNotification(
              "Error in cart drawer related products",
              "warning"
            );
          })
      );
  }
  setReady(isReady) {
    this.toggleAttribute("is-ready", isReady);
  }
  showPreloader() {
    const preloader = $el(LOADING_OVERLAY_SELECTOR, this);
    showElement(preloader);
  }
  hidePreloader() {
    const preloader = $el(LOADING_OVERLAY_SELECTOR, this);
    hideElement(preloader);
  }
}
const RELATED_PRODUCTS_SELECTOR = "[data-cart-drawer-related-products]",
  CART_DRAWER_SELECTOR$3 = "cart-drawer",
  CART_DRAWER_RELATED_PRODUCTS_SELECTOR = "cart-drawer-related-products-block",
  CAROUSEL_SELECTOR$7 = "carousel-component";
class CartDrawerRelatedProductsBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartDrawerUpdate", ({ node }) => {
      const relatedProducts = $el(RELATED_PRODUCTS_SELECTOR, this);
      if (!relatedProducts) return;
      const newRelatedProducts = $el(
        `${CART_DRAWER_RELATED_PRODUCTS_SELECTOR}[block-id="${this.getAttribute(
          "block-id"
        )}"] [data-cart-drawer-related-products]`,
        node
      );
      if (!newRelatedProducts) return;
      if (this.hasAttribute("is-auto-recommendations")) {
        const newUrl = newRelatedProducts.getAttribute("data-url");
        relatedProducts.setAttribute("data-url", newUrl),
          newUrl
            ? relatedProducts.loadProducts()
            : (relatedProducts.erase(), this.checkHasAsideProducts());
      } else
        replaceNodeChildren(relatedProducts, newRelatedProducts),
          this.checkHasAsideProducts();
      this.updateVisibility(), this.reInitCarousel();
    });
    __publicField(this, "updateVisibility", () => {
      if (!this.hasAttribute("is-aside-related-products")) {
        const cartDrawer = $el("cart-drawer"),
          cartDrawerItems = !!$el("cart-item", cartDrawer);
        cartDrawer.toggleAttribute("empty-cart", !cartDrawerItems);
      }
    });
    __publicField(this, "reInitCarousel", () => {
      const carousel = $el(CAROUSEL_SELECTOR$7, this);
      carousel &&
        carousel.withAutoplay &&
        (carousel.setCarousel(), carousel.setAutoplay());
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$3, this);
    cartDrawer == null ||
      cartDrawer.on("update-nodes", this.handleCartDrawerUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$3, this);
    cartDrawer == null ||
      cartDrawer.off("update-nodes", this.handleCartDrawerUpdate);
  }
  checkHasAsideProducts() {
    if (this.hasAttribute("is-aside-related-products")) {
      const products = $list(
          "[is-aside-related-products] vertical-product-card, [is-aside-related-products] horizontal-product-card"
        ),
        cartDrawer = $el("cart-drawer"),
        hasAsideProducts = (products == null ? void 0 : products.length) > 0;
      cartDrawer &&
        cartDrawer.toggleAttribute("has-aside-products", hasAsideProducts);
    }
  }
}
const CART_DRAWER_SELECTOR$2 = "cart-drawer",
  CART_DRAWER_TIMER_BLOCK_SELECTOR = "cart-drawer-timer-block";
class CartDrawerTimerBlock extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCartDrawerUpdate", ({ node }) => {
      replaceNodeChildren(
        this,
        $el(
          `${CART_DRAWER_TIMER_BLOCK_SELECTOR}[block-id="${this.getAttribute(
            "block-id"
          )}"]`,
          node
        )
      );
    });
  }
  mountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$2, this);
    cartDrawer == null ||
      cartDrawer.on("update-nodes", this.handleCartDrawerUpdate);
  }
  unmountComponent() {
    const cartDrawer = $elParent(CART_DRAWER_SELECTOR$2, this);
    cartDrawer == null ||
      cartDrawer.off("update-nodes", this.handleCartDrawerUpdate);
  }
}
const VIEWPORT_SELECTOR$1 = "[data-cart-drawer-viewport]",
  RESULTS_SELECTOR = "[data-cart-drawer-results]",
  NOTIFICATION_SELECTOR = "#CartDrawerNotification",
  CART_ITEM_SELECTOR = "cart-item",
  SELECTOR_CONSENT_CHECKBOX = ".checkbox--consent",
  SELECTOR_CONSENT_VERIFY = "[data-consent-verify]";
class CartDrawer extends SidebarComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "cartAPI", new CartAPI());
    __publicField(this, "resizeObserver");
    __publicField(this, "lastDrawerBody");
    __publicField(this, "error");
    __publicField(this, "handleConsentCheckboxChange", ({ target }) => {
      target.closest(SELECTOR_CONSENT_CHECKBOX) &&
        $list(SELECTOR_CONSENT_VERIFY, this).forEach((consentVerifyItem) =>
          consentVerifyItem == null
            ? void 0
            : consentVerifyItem.setAttribute(
                "data-consent-verify",
                target.checked
              )
        );
    });
    __publicField(this, "handleItemChange", ({ target }) => {
      const item = $el(`#CartItem-${+target.dataset.index}`, this);
      item && (item.setLoading(!0), this.setLoadingStatus(!0));
    });
    __publicField(
      this,
      "handleCartChange",
      debounce(({ target }) => {
        this.updateItem(+target.dataset.index, +target.value);
      }, 500)
    );
    __publicField(
      this,
      "handleViewportScroll",
      debounce(() => {
        this.updateViewport();
      }, 25)
    );
    __publicField(
      this,
      "handleResultsResize",
      debounce(() => {
        this.updateViewport();
      }, 25)
    );
    __publicField(this, "updateLastDrawerBody", () => {
      this.lastDrawerBody = this.element.cloneNode(!0);
    });
  }
  mountComponent() {
    super.mountComponent();
    const viewport = $el(VIEWPORT_SELECTOR$1, this.element),
      results = $el(RESULTS_SELECTOR, this.element);
    results &&
      ((this.resizeObserver = new ResizeObserver(this.handleResultsResize)),
      this.resizeObserver.observe(results)),
      this.addListener(this, "change", this.handleCartChange),
      this.addListener(this, "change", this.handleItemChange),
      this.addListener(this, "change", this.handleConsentCheckboxChange),
      this.addListener(viewport, "scroll", this.handleViewportScroll);
  }
  unmountComponent() {
    super.unmountComponent(), this.resizeObserver.disconnect();
  }
  updateViewport() {
    const results = $el(RESULTS_SELECTOR, this.element),
      viewport = $el(VIEWPORT_SELECTOR$1, this.element);
    if (!results || !viewport) return;
    const isOverflow = results.offsetHeight > viewport.offsetHeight,
      isScrolled = viewport.scrollTop > 0,
      isBottom =
        results.offsetHeight - viewport.scrollTop === viewport.offsetHeight;
    this.classList.toggle("header-shadow-visible", isOverflow && isScrolled),
      this.classList.toggle("footer-shadow-visible", isOverflow && !isBottom);
  }
  update() {
    this.cartAPI
      .getDrawer()
      .then((responseText) => {
        this.lastDrawerBody = this.getTemplateContent(parseHTML(responseText));
      })
      .catch(() => {
        this.showError("");
      })
      .finally(() => {
        this.mount(),
          this.emit("update-nodes", { node: this.lastDrawerBody }),
          this.updateEmptyStatus();
      });
  }
  updateItem(itemIndex, quantity) {
    const item = $el(`#CartItem-${itemIndex}`, this);
    if (!item) return;
    if (
      (this.setLoadingStatus(!0), +(item.dataset.quantity || 0) === quantity)
    ) {
      item.setLoading(!1), this.setLoadingStatus(!1);
      return;
    }
    item.setDisabled(!0),
      quantity === 0 &&
        (item.removeItem(),
        whenTransitionEnds(item, () => {
          const items = $list(CART_ITEM_SELECTOR, this.element);
          this.setPreEmpty(items.length === 1);
        })),
      this.emit("start-update", {}),
      this.cartAPI
        .change({
          ...fetchConfig(),
          body: JSON.stringify({
            line: itemIndex + 1,
            quantity,
            sections: this.dataset.sectionId,
            sections_url: window.location.pathname,
          }),
        })
        .then((state) => {
          const data = JSON.parse(state);
          if (data.errors) throw new Error(data.errors);
          this.lastDrawerBody = this.getTemplateContent(
            parseHTML(data.sections[this.dataset.sectionId])
          );
        })
        .catch((error) => {
          this.error = error.message;
        })
        .finally(() => {
          this.mount(),
            this.emit("update-nodes", { node: this.lastDrawerBody }),
            this.updateEmptyStatus(),
            this.initFocus(),
            item.setLoading(!1),
            this.setLoadingStatus(!1),
            item.setDisabled(!1),
            this.error && (this.showError(this.error), (this.error = null));
        });
  }
  setLoadingStatus(isLoading) {
    this.classList.toggle("is-cart-loading", isLoading);
  }
  showError(text) {
    const notification = $el(NOTIFICATION_SELECTOR, this),
      message = text || window.auroraThemeLocales.cartStrings.error;
    notification == null || notification.show(message, "warning", 6e3);
  }
  async purchaseHandler(html, parsedState) {
    this.setPreEmpty(!1);
    const node = this.getTemplateContent(html);
    this.mount(),
      this.emit("update-nodes", { node, parsedState }),
      this.updateEmptyStatus(),
      await this.open(),
      this.emit("purchase", { parsedState }),
      this.addListener(this, "showAsNew", this.updateLastDrawerBody);
  }
  setPreEmpty(isEmpty) {
    this.classList.toggle("is-pre-empty", isEmpty);
  }
  getTemplateContent(html) {
    const newTemplate = $el(`[data-sidebar-template="${this.id}"]`, html);
    return getTemplateFirstChild(newTemplate);
  }
  updateEmptyStatus() {
    const items = $list(CART_ITEM_SELECTOR, this.element);
    this.hasAttribute("data-has-warning-placeholder") &&
      this.toggleAttribute("is-empty", items.length === 0),
      items.length === 0 && this.emit("cartIsEmpty", {});
  }
  updateAsideProductsByParsedState(parsedState) {
    this.toggleAttribute("has-aside-products", parsedState.quantity > 0);
  }
  async open() {
    await super.open(), (this.lastDrawerBody = this.element.cloneNode(!0));
  }
}
const ITEM_SELECTOR$2 = "[data-column-switcher-item]",
  TARGET_SELECTOR = "[data-column-switcher-target]";
class ColumnSwitcher extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleSectionLoad", (event) => {
      this.dataset.sectionId === event.detail.sectionId && this.reset();
    });
    __publicField(this, "handleItemClick", (event) => {
      event.preventDefault();
      const item = $elParent(ITEM_SELECTOR$2, event.target);
      item && this.updateByCount(+(item.dataset.value || 1));
    });
    __publicField(this, "handleKeyDown", (event) => {
      if (isEnterKey(event)) {
        event.preventDefault();
        const item = $elParent(ITEM_SELECTOR$2, event.target);
        item && this.updateByCount(+(item.dataset.value || 1));
      }
    });
  }
  mountComponent() {
    $list(ITEM_SELECTOR$2, this).forEach((item) => {
      this.addListener(item, "keydown", this.handleKeyDown),
        this.addListener(item, "click", this.handleItemClick);
    }),
      this.isEditor
        ? this.editor.on("SECTION_LOAD", this.handleSectionLoad)
        : this.init();
  }
  updateByCount(newCount) {
    this.setIndicator(newCount), this.updateGrid(newCount);
  }
  setIndicator(columnCount) {
    $list(ITEM_SELECTOR$2, this).forEach((item) => {
      const value = +(item.getAttribute("data-value") || 1);
      item.classList.toggle("selected", value === columnCount);
    });
  }
  updateGrid(value) {
    const target = $elParent(TARGET_SELECTOR, this);
    target &&
      (target.style.setProperty(
        `--gsc-${this.dataset.columnSwitcherCssVariable}`,
        value.toString()
      ),
      localStorage.setItem(
        `products-${this.dataset.columnSwitcherCssVariable}`,
        value.toString()
      ));
  }
  init() {
    const value = localStorage.getItem(
      `products-${this.dataset.columnSwitcherCssVariable}`
    );
    if (!value || value === "null") return;
    const preparedValue = Number(value);
    preparedValue > 0 && this.updateByCount(preparedValue);
  }
  reset() {
    this.dataset.default && this.updateByCount(Number(this.dataset.default));
  }
}
const ACTIVE_FILTERS_SELECTOR = "shop-active-filters",
  SHOP_COMPONENT_SELECTOR$1 = "shop-component";
class FilterRemoveBtn extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.update();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.update());
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeyDown),
      this.addListener(this, "click", this.handleButtonClick);
  }
  update() {
    this.updateShop(), this.updateActiveFilters();
  }
  updateShop() {
    const isResetButton = this.hasAttribute("data-filters-reset"),
      shop = $el(SHOP_COMPONENT_SELECTOR$1),
      url = this.dataset.url || "";
    let preparedSearchParams;
    shop &&
      (isResetButton
        ? ((preparedSearchParams = ""), shop.reset())
        : (preparedSearchParams =
            url.indexOf("?") === -1 ? "" : url.slice(url.indexOf("?") + 1)),
      shop.updateBySearchParams(preparedSearchParams));
  }
  updateActiveFilters() {
    const activeFilters = $el(ACTIVE_FILTERS_SELECTOR);
    if (activeFilters) {
      const isRemoveButton = this.hasAttribute("data-filter-remove-btn");
      this.hasAttribute("data-filters-reset") && activeFilters.reset(),
        isRemoveButton &&
          (activeFilters.buttons.length === 1
            ? activeFilters.reset()
            : (activeFilters.setDisable(), this.remove()));
    }
  }
}
const SHOP_COMPONENT_SELECTOR = "shop-component",
  SIDEBAR_COMPONENT_SELECTOR = "#SidebarFiltersMobile";
class FiltersSubmitBtn extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault();
      const shop = $el(SHOP_COMPONENT_SELECTOR),
        sidebar = $elParent(SIDEBAR_COMPONENT_SELECTOR, this);
      if (shop && sidebar) {
        const searchParams = [shop.filterQuery, shop.sortQuery].join("&"),
          preparedUrl = `${window.location.pathname}?${
            shop.formatParams(searchParams) || ""
          }`;
        shop.updateURL(searchParams, preparedUrl),
          shop.updateShop(preparedUrl),
          sidebar.hide();
      }
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handleButtonClick);
  }
}
const ITEM_SELECTOR$1 = "[data-list-item]",
  EXPAND_BTN_SELECTOR = 'list-btn[data-trigger="expand"]',
  COLLAPSE_BTN_SELECTOR = 'list-btn[data-trigger="collapse"]',
  VISIBLE_ITEM_SELECTOR = `${ITEM_SELECTOR$1}:not(.hidden)`,
  HIDDEN_ITEM_SELECTOR = `${ITEM_SELECTOR$1}.hidden`;
class ListComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "initialHeight");
    __publicField(this, "maxHeight");
    __publicField(this, "collapse", () => {
      const expandBtn = $el(EXPAND_BTN_SELECTOR, this),
        collapseBtn = $el(COLLAPSE_BTN_SELECTOR, this);
      this.hideItems(),
        hideElement(collapseBtn),
        showElement(expandBtn),
        expandBtn.focus();
    });
    __publicField(this, "expand", () => {
      const collapseBtn = $el(COLLAPSE_BTN_SELECTOR, this);
      this.initialHeight || this.setInitialHeight(),
        this.showItems(),
        this.tryHideExpandBtn(),
        showElement(collapseBtn),
        collapseBtn.focus(),
        this.setHeight();
    });
  }
  setInitialHeight() {
    (this.initialHeight = Math.ceil(this.offsetHeight)),
      (this.style.maxHeight = `${this.initialHeight}px`);
  }
  setHeight() {
    (this.maxHeight = Math.ceil(this.scrollHeight)),
      (this.style.maxHeight = `${this.maxHeight}px`);
  }
  hideItems() {
    const visibleItems = $list(VISIBLE_ITEM_SELECTOR, this);
    (this.style.maxHeight = `${this.initialHeight}px`),
      transitionToPromise(this).then(() => {
        visibleItems.forEach((node, index) => {
          const initialCount = this.dataset.initialCount
            ? +this.dataset.initialCount
            : 0;
          index + 1 > +initialCount && hideElement(node);
        });
      });
  }
  showItems() {
    $list(HIDDEN_ITEM_SELECTOR, this).forEach((node, index) => {
      const showCount = this.dataset.showCount ? this.dataset.showCount : 0;
      index + 1 < +showCount && showElement(node);
    }),
      (this.style.maxHeight = `${this.maxHeight}px`);
  }
  tryHideExpandBtn() {
    const expandBtn = $el(EXPAND_BTN_SELECTOR, this);
    $list(HIDDEN_ITEM_SELECTOR, this).length === 0 && hideElement(expandBtn);
  }
}
const LIST_SELECTOR = "list-component";
class ListBtn extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleButtonClick", (event) => {
      event.preventDefault(), this.update();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.update());
    });
  }
  mountComponent() {
    this.addListener(this, "keydown", this.handleKeyDown),
      this.addListener(this, "click", this.handleButtonClick);
  }
  update() {
    const list = $elParent(LIST_SELECTOR, this);
    this.dataset.trigger === "collapse"
      ? list == null || list.collapse()
      : list == null || list.expand();
  }
}
const MIN_RANGE_NUMBER_SELECTOR = "[data-price-min-range-number]",
  MAX_RANGE_NUMBER_SELECTOR = "[data-price-max-range-number]",
  RANGE_INPUTS_WRAPPER_SELECTOR = "[data-price-range-inputs-wrapper]",
  MIN_RANGE_INPUT_SELECTOR = "[data-price-min-range-input]",
  MAX_RANGE_INPUT_SELECTOR = "[data-price-max-range-input]",
  PRICE_RANGE_PROGRESS_SELECTOR = "[data-price-range-progress]";
class PriceRange extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "minNumberInput");
    __publicField(this, "maxNumberInput");
    __publicField(this, "rangeWrapper");
    __publicField(this, "minRangeInput");
    __publicField(this, "maxRangeInput");
    __publicField(this, "progress");
    __publicField(this, "currencyWithoutDecimals");
    __publicField(this, "numbersAfterComma");
    __publicField(this, "handleRangeInput", (event) => {
      const maxInput = $el("[data-price-range-max-input]", this),
        minInput = $el("[data-price-range-min-input]", this);
      if (this.progress && minInput && maxInput) {
        const middleOfProgress =
            this.progress.offsetLeft + this.progress.offsetWidth / 2,
          isMinInputClosest = event.offsetX < middleOfProgress;
        minInput.toggleAttribute("targeted", isMinInputClosest),
          maxInput.toggleAttribute("targeted", !isMinInputClosest);
      }
    });
    __publicField(this, "handleNumberChange", () => {
      if (this.minNumberInput && this.maxNumberInput) {
        const minPrice = parseFloat(this.minNumberInput.value),
          maxPrice = parseFloat(this.maxNumberInput.value);
        this.updateMinRangeInput(minPrice), this.updateMaxRangeInput(maxPrice);
      }
    });
    __publicField(this, "handleRangeChange", () => {
      if (this.minRangeInput && this.maxRangeInput) {
        const minVal = parseFloat(this.minRangeInput.value),
          maxVal = parseFloat(this.maxRangeInput.value);
        this.updateMaxPriceInput(maxVal),
          this.updateMaxRangeInput(maxVal),
          this.updateMinPriceInput(minVal),
          this.updateMinRangeInput(minVal);
      }
    });
    (this.minNumberInput = $el(MIN_RANGE_NUMBER_SELECTOR, this)),
      (this.maxNumberInput = $el(MAX_RANGE_NUMBER_SELECTOR, this)),
      (this.rangeWrapper = $el(RANGE_INPUTS_WRAPPER_SELECTOR, this)),
      (this.minRangeInput = $el(MIN_RANGE_INPUT_SELECTOR, this)),
      (this.maxRangeInput = $el(MAX_RANGE_INPUT_SELECTOR, this)),
      (this.progress = $el(PRICE_RANGE_PROGRESS_SELECTOR, this));
  }
  mountComponent() {
    this.minRangeInput &&
      (this.updateMinRangeInput(+this.minRangeInput.value),
      this.updateMinPriceInput(+this.minRangeInput.value)),
      this.maxRangeInput &&
        (this.updateMaxRangeInput(+this.maxRangeInput.value),
        this.updateMaxPriceInput(+this.maxRangeInput.value)),
      this.addListener(this.minNumberInput, "input", this.handleNumberChange),
      this.addListener(this.maxNumberInput, "input", this.handleNumberChange),
      this.addListener(this.minRangeInput, "input", this.handleRangeChange),
      this.addListener(this.maxRangeInput, "input", this.handleRangeChange),
      this.addListener(this.rangeWrapper, "mouseenter", this.handleRangeInput),
      this.addListener(this.rangeWrapper, "mousemove", this.handleRangeInput);
  }
  updateMaxRangeInput(newValue) {
    const value = Math.ceil(newValue);
    if (this.maxRangeInput && this.progress) {
      const rightPosition = 100 - (value / +this.maxRangeInput.max) * 100;
      (this.maxRangeInput.value = `${value}`),
        (this.progress.style.right = `${rightPosition}%`);
    }
  }
  updateMinRangeInput(newValue) {
    const value = Math.ceil(newValue);
    this.minRangeInput &&
      this.progress &&
      ((this.minRangeInput.value = `${value}`),
      (this.progress.style.left = `${
        (value / +this.minRangeInput.max) * 100
      }%`));
  }
  updateMaxPriceInput(newValue) {
    const value = Math.ceil(newValue);
    this.maxNumberInput && (this.maxNumberInput.value = value.toFixed(0));
  }
  updateMinPriceInput(newValue) {
    const value = Math.ceil(newValue);
    this.minNumberInput && (this.minNumberInput.value = value.toFixed(0));
  }
}
const ACTIVE_FILTERS_OPTIONS_SELECTOR = "[data-shop-active-filters-options]",
  ACTIVE_FILTERS_REMOVE_BTN_SELECTOR = "[data-filter-remove-btn]";
class ShopActiveFilters extends BaseComponent {
  reset() {
    this.replaceChildren();
  }
  setDisable() {
    const options = $el(ACTIVE_FILTERS_OPTIONS_SELECTOR, this);
    options == null || options.setAttribute("disabled", "");
  }
  get buttons() {
    return $list(ACTIVE_FILTERS_REMOVE_BTN_SELECTOR, this);
  }
}
const FORM_SELECTOR$4 = "[data-filters-form]",
  CHECKBOX_SELECTOR = "[data-filters-checkbox]",
  SHOP_SELECTOR$3 = "shop-component",
  HEADER_SELECTOR$2 = "[data-filters-header]",
  PRELOADER_SELECTOR$1 = "[data-filters-loading-overlay]";
class SidebarFilters extends SidebarComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleFormScroll", () => {
      const form = $el(FORM_SELECTOR$4, this.element);
      form && this.toggleAttribute("header-shadow-visible", form.scrollTop > 0);
    });
    __publicField(this, "handleClick", (event) => {
      const label = $elParent(CHECKBOX_SELECTOR, event.target);
      label && label.setAttribute("selected", "");
    });
    __publicField(this, "handleFormKeydown", (event) => {
      if (isEnterKey(event)) {
        event.preventDefault();
        const target = event.target;
        target.tagName === "INPUT" &&
          target.dispatchEvent(
            new MouseEvent("click", { button: 0, which: 1 })
          );
      }
    });
    __publicField(this, "handleInputChange", (event) => {
      event.target.tagName === "INPUT" && this.change();
    });
    __publicField(this, "reInitFocus", () => {});
  }
  mountComponent() {
    super.mountComponent();
    const form = $el(FORM_SELECTOR$4, this.element);
    this.addListener(form, "scroll", this.handleFormScroll),
      this.addListener(form, "change", this.handleInputChange),
      this.addListener(this, "click", this.handleClick),
      this.addListener(form, "keydown", this.handleFormKeydown),
      $el(SHOP_SELECTOR$3).on("filtersUpdated", this.reInitFocus);
  }
  createQuery() {
    const form = $el(FORM_SELECTOR$4, this.element),
      shop = $el(SHOP_SELECTOR$3);
    if (form && shop) {
      const formData = new FormData(form),
        filterQuery = new URLSearchParams(formData).toString();
      shop.filterQuery = filterQuery;
    }
  }
  updateHTML(html) {
    let newElement;
    const filterId = this.getAttribute("id"),
      newFilter = filterId ? $el(`#${filterId}`, html) : null;
    if (this.hasAttribute("is-open-on-init"))
      newElement = newFilter ? $el("[data-sidebar-body]", newFilter) : null;
    else {
      const newTemplate = newFilter
        ? $el(`[data-sidebar-template="${this.id}"]`, newFilter)
        : null;
      newTemplate && (newElement = getTemplateFirstChild(newTemplate));
    }
    newElement &&
      (this.updateFormByElement(newElement),
      this.updateHeaderByElement(newElement));
  }
  updateHeaderByElement(newElement) {
    const header = $el(HEADER_SELECTOR$2, this.element),
      newHeader = $el(HEADER_SELECTOR$2, newElement);
    replaceNodeChildren(header, newHeader);
  }
  updateFormByElement(newElement) {
    const form = $el(FORM_SELECTOR$4, this.element),
      newForm = $el(FORM_SELECTOR$4, newElement);
    replaceNodeChildren(form, newForm);
  }
  change() {}
  get searchParams() {
    const shop = $el(SHOP_SELECTOR$3);
    return shop ? [shop.filterQuery, shop.sortQuery].join("&") : "";
  }
  get preloader() {
    return $el(PRELOADER_SELECTOR$1, this.element);
  }
}
const SHOP_SELECTOR$2 = "shop-component",
  BODY_ELEMENT_SELECTOR$6 = "body-element";
class SidebarFiltersDesktop extends SidebarFilters {
  constructor() {
    super(...arguments);
    __publicField(this, "handleSectionLoad", () => {});
    __publicField(this, "handleSidebarFocusout", (event) => {
      const focusTarget = event.relatedTarget;
      if (
        !this.hasAttribute("is-embed-filters") &&
        (!focusTarget || !this.contains(focusTarget))
      ) {
        const { firstTarget } = getTargets(this.element);
        firstTarget.focus();
      }
    });
    __publicField(this, "reInitFocus", () => {
      if (!this.isOpen) return;
      const { firstTarget } = getTargets(this);
      firstTarget == null || firstTarget.focus();
    });
  }
  change() {
    const shop = $el(SHOP_SELECTOR$2);
    shop && (this.createQuery(), shop.updateBySearchParams(this.searchParams));
  }
  async open(event) {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$6);
    this.hasAttribute("is-embed-filters") && window.scrollY > 0
      ? (bodyElement.setScrollLock(),
        await super.open(event),
        bodyElement.unsetScrollLock())
      : await super.open(event);
  }
}
const FILTER_REMOVE_BUTTON_SELECTOR = "filter-remove-btn",
  SHOP_SELECTOR$1 = "shop-component";
class SidebarFiltersMobile extends SidebarFilters {
  change() {
    const shop = $el(SHOP_SELECTOR$1);
    if (shop) {
      this.createQuery(), shop.updateBySearchParams(this.searchParams);
      const preparedUrl = `${window.location.pathname}?${
        shop.formatParams(this.searchParams) || ""
      }`;
      shop.updateFilters(preparedUrl), this.setButtonForReset();
    }
  }
  setButtonForReset() {
    const button = $el(FILTER_REMOVE_BUTTON_SELECTOR, this.element);
    button && button.classList.contains("hidden") && showElement(button);
  }
}
const FOOTER_SELECTOR$2 = ".shopify-section-footer",
  PRODUCTS_SELECTOR = "#ShopProducts",
  THRESHOLD_FOR_EXTEND = 24;
class SidebarFiltersStickyMobileButton extends SidebarButton {
  constructor() {
    super(...arguments);
    __publicField(this, "prevScrollY");
    __publicField(this, "handleWindowScroll", () => {
      this.prevScrollY || (this.prevScrollY = window.scrollY),
        this.updateVisibleStatus(),
        this.updateExtendStatus();
    });
    __publicField(
      this,
      "updateExtendStatus",
      throttle(() => {
        Math.abs(window.scrollY - this.prevScrollY) > THRESHOLD_FOR_EXTEND &&
          this.toggleAttribute(
            "is-extended",
            this.prevScrollY > window.scrollY
          ),
          (this.prevScrollY = 0);
      }, 200)
    );
  }
  mountComponent() {
    super.mountComponent(),
      this.addListener(window, "scroll", this.handleWindowScroll);
  }
  updateVisibleStatus() {
    const products = $el(PRODUCTS_SELECTOR),
      footer = $el(FOOTER_SELECTOR$2),
      rect = products == null ? void 0 : products.getBoundingClientRect(),
      footerOffsetTop = footer ? footer.offsetTop : 0,
      isUnderFooter = window.innerHeight + window.scrollY < footerOffsetTop,
      isUnderProduct = rect.top < 0,
      isVisible = isUnderFooter && isUnderProduct;
    this.toggleAttribute("is-visible", isVisible),
      document.body.toggleAttribute("is-filters-button-fixed", isVisible);
  }
}
const LABEL_SELECTOR$1 = "[data-sort-list-label]",
  SHOP_SELECTOR = "shop-component",
  SIDEBAR_SELECTOR = "sidebar-component",
  FORM_SELECTOR$3 = "form",
  INPUT_SELECTOR$2 = "input";
class SortList extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(
      this,
      "handleFormInput",
      debounce((event) => {
        event.preventDefault();
        const shop = $el(SHOP_SELECTOR),
          sidebar = $elParent(SIDEBAR_SELECTOR, this),
          input = event.target;
        if ((sidebar && sidebar.hide(), shop && input)) {
          const sortQuery = this.getSortQuery(input);
          let searchParams = `${window.location.search
            .replace(shop.sortQuery, "")
            .replace("?", "")}&${sortQuery}`;
          shop.dataset.baseParams &&
            (searchParams = searchParams.replace(shop.dataset.baseParams, "")),
            (shop.sortQuery = sortQuery),
            shop.updateBySearchParams(searchParams);
        }
      }, 250)
    );
    __publicField(this, "handleLabelKeyDown", (event) => {
      if (isEnterKey(event)) {
        event.preventDefault();
        const input = $el(INPUT_SELECTOR$2, event.target);
        input &&
          input.dispatchEvent(new MouseEvent("click", { button: 0, which: 1 }));
      }
    });
  }
  mountComponent() {
    $list(LABEL_SELECTOR$1, this).forEach((label) => {
      this.addListener(label, "keydown", this.handleLabelKeyDown);
    }),
      this.addListener(this, "input", this.handleFormInput);
  }
  getSortQuery(input) {
    const form = $elParent(FORM_SELECTOR$3, input);
    return form ? new URLSearchParams(new FormData(form)).toString() : "";
  }
}
const ELEMENTS = [
    "ShopProducts",
    "ShopProductCount",
    "ShopSortList",
    "ShopActiveFilters",
  ],
  PRELOADER_SELECTOR = "#ShopProductsOverlay",
  MOBILE_FILTER_SELECTOR = "#SidebarFiltersMobile",
  DESKTOP_FILTER_SELECTOR = "#SidebarFiltersDesktop";
class ShopComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "searchParamsInitial");
    __publicField(this, "searchParamsPrev");
    __publicField(this, "sortQuery", "");
    __publicField(this, "filterQuery", "");
    __publicField(
      this,
      "handleHistoryChange",
      ({ state: { searchParams } }) => {
        const newSearchParams = searchParams || this.searchParamsInitial;
        newSearchParams !== this.searchParamsPrev &&
          this.updateBySearchParams(newSearchParams);
      }
    );
    (this.searchParamsInitial = window.location.search.slice(1)),
      (this.searchParamsPrev = this.searchParamsInitial);
  }
  mountComponent() {
    this.addListener(window, "popstate", this.handleHistoryChange);
  }
  formatParams(searchParams) {
    return (
      (this.searchParamsPrev = searchParams),
      `${
        this.dataset.baseParams ? `${this.dataset.baseParams}` : ""
      }${searchParams}`
    );
  }
  updateBySearchParams(searchParams) {
    const baseUrl = window.location.pathname,
      params = `${this.formatParams(searchParams ? `${searchParams}` : "")}`,
      url = baseUrl + "?" + params;
    this.updateURL(searchParams, url),
      this.updateShop(url),
      this.updateFilters(url);
  }
  async getFromUrl(url) {
    const preloaderElement = $el(PRELOADER_SELECTOR, this);
    return (
      preloaderElement.classList.remove("hidden"),
      fetch(url)
        .then((response) => response.text())
        .then(
          (responseText) => (
            preloaderElement.classList.add("hidden"), parseHTML(responseText)
          )
        )
        .catch(() => console.log("Error in shop component"))
    );
  }
  updateShop(url) {
    this.getFromUrl(url).then((html) => {
      ELEMENTS.forEach((elementId) => {
        const element = $el(`#${elementId}`),
          newElement = $el(`#${elementId}`, html);
        replaceNodeChildren(element, newElement);
      }),
        this.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
  updateFilters(url) {
    const filters = $list(
      `${MOBILE_FILTER_SELECTOR}, ${DESKTOP_FILTER_SELECTOR}`
    );
    filters.forEach((filter) => {
      filter.preloader.classList.remove("hidden");
    }),
      this.getFromUrl(url).then((html) => {
        filters.forEach((filter) => {
          filter.updateHTML(html), filter.preloader.classList.add("hidden");
        }),
          this.emit("filtersUpdated", {});
      });
  }
  updateURL(searchParams, url) {
    history.pushState({ searchParams }, "", url);
  }
  reset() {
    (this.sortQuery = ""), (this.filterQuery = "");
  }
}
const FORM_SELECTOR$2 = "[data-register-form]";
class RegisterComponent extends BaseComponent {
  mountComponent() {
    const form = $el(FORM_SELECTOR$2, this);
    this.addListener(form, "submit", this.handleSubmit);
  }
  handleSubmit() {
    localStorage.setItem("isRegistered", "true");
  }
}
const LOGIN_FORM_SELECTOR = "[data-login-form]";
class LoginComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", (event) => {
      const target = event.target;
      if (target.hasAttribute("data-login-form-button")) {
        const loginFormId = target.dataset.loginFormId || "";
        this.setFormVisibleById(loginFormId), this.updateFocus();
      }
    });
  }
  mountComponent() {
    this.updateFocus(), this.addListener(this, "click", this.handleClick);
  }
  setFormVisibleById(loginFormId) {
    $list(LOGIN_FORM_SELECTOR, this).forEach((form) => {
      const isTargetForm = form.getAttribute("data-login-form") === loginFormId;
      form.classList.toggle("hidden", !isTargetForm);
    });
  }
  updateFocus() {
    $list(LOGIN_FORM_SELECTOR, this).forEach((form) => {
      const isHidden = form.classList.contains("hidden"),
        emailInput = $el('[type="email"]', form);
      !isHidden && emailInput && emailInput.focus();
    });
  }
}
const FLOAT_ELEMENT_SELECTOR = "float-element",
  INPUT_SELECTOR$1 = "input",
  DROPDOWN_TOGGLE_LABEL_SELECTOR = ".dropdown__toggle-label",
  DROPDOWN_ITEM_SELECTOR = ".dropdown__item",
  DROPDOWN_SELECTOR = "float-element",
  DROPDOWN_OPTION_SELECTOR = "option";
class CountrySelector extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleItemClick", (event) => {
      const dropdown = $el(FLOAT_ELEMENT_SELECTOR, this),
        input = $el(INPUT_SELECTOR$1, this),
        dropdownBtnLabel = $el(DROPDOWN_TOGGLE_LABEL_SELECTOR, this),
        target = event.target;
      $elParent(DROPDOWN_ITEM_SELECTOR, target) &&
        (!input ||
          !dropdownBtnLabel ||
          !dropdown ||
          (input.setAttribute("value", target.dataset.value),
          this.setActiveItem(target.dataset.value),
          (dropdownBtnLabel.innerHTML = target.dataset.value),
          dropdown.hide()));
    });
  }
  mountComponent() {
    this.createItems(), this.addListener(this, "click", this.handleItemClick);
  }
  setActiveItem(activeCountryValue) {
    $list(DROPDOWN_ITEM_SELECTOR, this).forEach((item) => {
      item.classList.toggle(
        "active",
        item.dataset.value === activeCountryValue
      );
    });
  }
  createItems() {
    const dropdown = $el(DROPDOWN_SELECTOR, this),
      options = $list(DROPDOWN_OPTION_SELECTOR, this),
      fragment = document.createDocumentFragment();
    dropdown &&
      (options.forEach((option) => {
        const item = document.createElement("div"),
          clonedOption = option.cloneNode(!0);
        item.classList.add("dropdown__item"),
          item.setAttribute("tabindex", "0"),
          (item.dataset.value = option.value),
          (item.dataset.provinces = option.dataset.provinces),
          item.replaceChildren(...clonedOption.childNodes),
          fragment.appendChild(item);
      }),
      replaceNodeChildren(dropdown.element, fragment));
  }
}
const ADDRESS_DELETE_BUTTON_SELECTOR = "[data-addresses-delete-button]",
  postLink = function (path, options) {
    options = options || {};
    const method = options.method || "post",
      params = options.parameters || {},
      form = document.createElement("form");
    form.setAttribute("method", method), form.setAttribute("action", path);
    for (let key in params) {
      let hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden"),
        hiddenField.setAttribute("name", key),
        hiddenField.setAttribute("value", params[key]),
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form),
      form.submit(),
      document.body.removeChild(form);
  };
class AddressesComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleKeydown", (event) => {
      const target = event.target;
      target.getAttribute("type") === "checkbox" &&
        isEnterKey(event) &&
        (event.preventDefault(), (target.checked = !target.checked));
    });
    __publicField(this, "handleDeleteButtonClick", ({ currentTarget }) => {
      const text = currentTarget.getAttribute("data-confirm-message");
      confirm(text) &&
        postLink(currentTarget.dataset.target, {
          parameters: { _method: "delete" },
        });
    });
  }
  mountComponent() {
    $list(ADDRESS_DELETE_BUTTON_SELECTOR, this).forEach((element) => {
      this.addListener(element, "click", this.handleDeleteButtonClick);
    }),
      this.addListener(this, "keydown", this.handleKeydown);
  }
}
const ACCORDEON_SELECTOR = "accordeon-component";
class FaqSection extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleTabToggle", ({ blockId }) => {
      $list(ACCORDEON_SELECTOR, this).forEach((tab) => {
        tab.dataset.blockId !== blockId && tab.isExpanded && tab.hide();
      });
    });
  }
  mountComponent() {
    $list(ACCORDEON_SELECTOR, this).forEach((tab) => {
      whenDefined(ACCORDEON_SELECTOR).then(() => {
        tab.on("toggle", this.handleTabToggle);
      });
    });
  }
  unmountComponent() {
    $list(ACCORDEON_SELECTOR, this).forEach((tab) => {
      whenDefined(ACCORDEON_SELECTOR).then(() => {
        tab.off("toggle", this.handleTabToggle);
      });
    });
  }
}
const HEADER_TAGNAMES = ["HEADER-COMPONENT", "HEADER", "DRAWER-MENU"];
class AnnouncementBar extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "toggleStyleVariable", () => {
      if (getComputedStyle(this.parentElement).position !== "sticky") return;
      const { nextElementSibling, previousElementSibling } = this.parentElement,
        isAboveHeader = HEADER_TAGNAMES.includes(
          nextElementSibling == null ? void 0 : nextElementSibling.tagName
        ),
        isUnderHeader = HEADER_TAGNAMES.includes(
          previousElementSibling == null
            ? void 0
            : previousElementSibling.tagName
        ),
        isDesktop = !isMobile(),
        hasBackground = isDesktop
          ? this.classList.contains("section-background")
          : !0;
      if (isAboveHeader)
        setStyleVariable("sticky-bar-bottom", `${this.offsetHeight}px`);
      else if (isUnderHeader) {
        const hasHeaderBackground =
          $el(HEADER_TAGNAMES[0]).classList.contains(
            "header__container--with-bg"
          ) && isDesktop;
        this.parentElement.style.setProperty(
          "top",
          hasBackground && hasHeaderBackground
            ? "calc(min(var(--gsc-aside-padding-size, 0px), 24px) + var(--gsc-header-bottom-side))"
            : "var(--gsc-header-bottom-side)"
        );
      }
    });
    __publicField(this, "updateStyles", () => {
      this.parentElement.removeAttribute("style"),
        removeStyleVariable("sticky-bar-bottom"),
        this.toggleStyleVariable();
    });
    __publicField(this, "handleResize", debounce(this.updateStyles, 100));
    __publicField(
      this,
      "handleSectionLoad",
      debounce(({ detail: { sectionId } }) => {
        const header = $el(HEADER_TAGNAMES[0]);
        (this.dataset.sectionId === sectionId ||
          header.dataset.sectionId === sectionId) &&
          this.updateStyles();
      }, 100)
    );
  }
  mountComponent() {
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this),
      this.isEditor &&
        (this.editor.on("SECTION_LOAD", this.handleSectionLoad),
        this.editor.on("SECTION_UNLOAD", this.handleSectionLoad),
        this.editor.on("SECTION_REORDER", this.handleSectionLoad));
  }
  unmountComponent() {
    this.resizeObserver.disconnect(),
      this.isEditor &&
        (this.editor.off("SECTION_LOAD", this.handleSectionLoad),
        this.editor.off("SECTION_UNLOAD", this.handleSectionLoad));
  }
}
const HEADER_COMPONENT_SELECTOR = "header-component",
  DRAWER_MENU_PAGE_SELECTOR = "drawer-menu-page",
  TOGGLER_SELECTOR = "#DrawerMenuToggler";
class DrawerMenu extends SidebarComponent {
  constructor() {
    super();
    __publicField(this, "openedPage");
    __publicField(this, "pageMap");
    __publicField(this, "isCurrentModeMobile");
    __publicField(this, "resizeObserver");
    __publicField(this, "handleSetAsSection", () => {
      this.setAttribute("data-drawer-menu-is-section", "");
    });
    __publicField(this, "handleUnsetAsSection", () => {
      this.removeAttribute("data-drawer-menu-is-section"),
        this.isOpen && this.hide();
    });
    __publicField(this, "handleResize", () => {
      this.isCurrentModeMobile !== isMobile() && this.isOpen && this.hide(!0);
    });
    __publicField(this, "handleSectionSelect", ({ detail: { sectionId } }) => {
      this.isVisible &&
        this.dataset.sectionId === sectionId &&
        (this.open(), this.reset());
    });
    __publicField(
      this,
      "handleSectionDeselect",
      ({ detail: { sectionId } }) => {
        this.isVisible &&
          this.dataset.sectionId === sectionId &&
          (this.reset(), this.hide(!0));
      }
    );
    __publicField(
      this,
      "handleBlockSelect",
      ({ detail: { blockId, sectionId } }) => {
        if (this.isVisible && this.dataset.sectionId === sectionId) {
          const target = $list(DRAWER_MENU_PAGE_SELECTOR, this.element).find(
            (page) => page.querySelector(`[block-id='${blockId}']`)
          );
          if (!target) return;
          this.open(), this.setPage(target);
        }
      }
    );
    __publicField(
      this,
      "handleBlockDeselect",
      ({ detail: { blockId, sectionId } }) => {
        if (this.isVisible && this.dataset.sectionId === sectionId) {
          if (
            !$list(DRAWER_MENU_PAGE_SELECTOR, this.element).find((page) =>
              page.querySelector(`[block-id='${blockId}']`)
            )
          )
            return;
          this.hide(!0);
        }
      }
    );
    __publicField(this, "handlePageKeydown", (event) => {
      if (isMobile()) return;
      event.preventDefault();
      const target = event.target,
        page = $elParent(DRAWER_MENU_PAGE_SELECTOR, target);
      if (!page) return;
      const targets = $list(getFocusTargets(), page),
        isLast = target === targets[targets.length - 1],
        isFirst = target === targets[0],
        isShift = event.shiftKey;
      ((isShift && isFirst) || (!isShift && isLast)) && this.focusOnToggler();
    });
    this.pageMap = this.generatePageMap();
  }
  mountComponent() {
    super.mountComponent();
    const header = $el(HEADER_COMPONENT_SELECTOR);
    whenDefined(HEADER_COMPONENT_SELECTOR).then(() => {
      header.on("drawerActivated", this.handleSetAsSection),
        header.on("drawerUnActivated", this.handleUnsetAsSection);
    }),
      this.isEditor &&
        (this.editor.on("BLOCK_SELECT", this.handleBlockSelect),
        this.editor.on("BLOCK_DESELECT", this.handleBlockDeselect),
        this.editor.on("SECTION_SELECT", this.handleSectionSelect),
        this.editor.on("SECTION_DESELECT", this.handleSectionDeselect));
  }
  unmountComponent() {
    super.unmountComponent();
    const header = $el(HEADER_COMPONENT_SELECTOR);
    this.isEditor &&
      (this.editor.off("BLOCK_SELECT", this.handleBlockSelect),
      this.editor.off("BLOCK_DESELECT", this.handleBlockDeselect),
      this.editor.off("SECTION_SELECT", this.handleSectionSelect),
      this.editor.off("SECTION_DESELECT", this.handleSectionDeselect),
      header.off("headerNavFitted", this.handleSetAsSection)),
      header.off("headerNavUnfitted", this.handleUnsetAsSection);
  }
  mount() {
    super.mount(),
      this.addListener(this, "keydown", this.handlePageKeydown),
      (this.isCurrentModeMobile = isMobile()),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this);
  }
  unmount() {
    var _a;
    this.removeListener(this, "keydown", this.handlePageKeydown),
      (_a = this.resizeObserver) == null || _a.disconnect(),
      super.unmount();
  }
  focusOnToggler() {
    this.hide().then(() => {
      const toggler = $el(TOGGLER_SELECTOR);
      toggler == null || toggler.focus();
    });
  }
  generatePageMap() {
    return $list(DRAWER_MENU_PAGE_SELECTOR, this.element).reduce(
      (map, page) => {
        const pageId = page.dataset.pageId;
        return pageId ? { ...map, [pageId]: page } : map;
      },
      {}
    );
  }
  setPage(page) {
    var _a;
    const pageId = page.dataset.pageId,
      prevOpenedPageId =
        (_a = this.openedPage) == null ? void 0 : _a.dataset.prevPageId,
      isReturn = pageId === prevOpenedPageId;
    this.openedPage && isReturn && this.setPageVisible(this.openedPage, !1);
    const firstFocusTarget = $el(getFocusTargets(), page);
    firstFocusTarget && firstFocusTarget.focus(),
      this.setPageVisible(page, !0),
      (this.openedPage = page);
  }
  reset() {
    const pages = $list(DRAWER_MENU_PAGE_SELECTOR, this.element),
      homePage = this.pageMap.Menu;
    pages.forEach((page) => {
      this.setPageVisible(page, !1);
    }),
      this.setPageVisible(homePage, !0),
      (this.openedPage = homePage);
  }
  setPageVisible(page, isVisible) {
    page.setAttribute("aria-hidden", isVisible ? "false" : "true");
  }
  async open() {
    const header = $el(HEADER_COMPONENT_SELECTOR);
    header == null || header.updatePosition(),
      super.open(),
      await transitionToPromise(this),
      this.isEditor &&
        isMobile() &&
        document.body.style.top !== "" &&
        header != null &&
        header.isDynamicSticky &&
        (setStyleVariable("header-bottom-side", `${header.offsetHeight - 1}px`),
        header.section.classList.add("scrolled"),
        header.setHidden(!1));
  }
  async hide(isInstant) {
    this.reset(), super.hide(isInstant);
  }
  get isVisible() {
    const isLowResolution = matchMedia("(max-width: 992px)").matches;
    return this.hasAttribute("data-drawer-menu-is-section") || isLowResolution;
  }
}
const BLOCK_SELECTOR$1 = "[data-drawer-menu-content]";
class DrawerMenuPage extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleBlockScroll", () => {
      const block = $el(BLOCK_SELECTOR$1, this);
      block &&
        this.toggleAttribute("header-shadow-visible", block.scrollTop > 0);
    });
  }
  mountComponent() {
    const block = $el(BLOCK_SELECTOR$1, this);
    this.addListener(block, "scroll", this.handleBlockScroll);
  }
}
const DRAWER_MENU_SELECTOR = "drawer-menu";
class DrawerMenuPageLink extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handlePageLinkClick", (event) => {
      event.preventDefault(), this.setPage();
    });
    __publicField(this, "handleKeyDown", (event) => {
      isEnterKey(event) && (event.preventDefault(), this.setPage());
    });
  }
  mountComponent() {
    this.addListener(this, "click", this.handlePageLinkClick),
      this.addListener(this, "keyup", this.handleKeyDown);
  }
  setPage() {
    const drawerMenu = $elParent(DRAWER_MENU_SELECTOR, this);
    drawerMenu && drawerMenu.setPage(drawerMenu.pageMap[this.dataset.pageId]);
  }
}
const HEADER_NAV_SELECTOR = "[data-desktop-nav]",
  BURGER_ICON_SELECTOR = ".drawer-menu-toggle",
  HEADER_GRID_SELECTOR = ".header__grid",
  HEADER_DROPDOWN_BACKDROP_SELECTOR = "[data-header-dropdown-backdrop]",
  HEADER_DROPDOWN_WITH_BACKDROP_BTN_SELECTOR = "data-header-btn-with-backdrop",
  SECTION_SELECTOR = ".shopify-section-header",
  BODY_ELEMENT_SELECTOR$5 = "body-element";
class HeaderComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "headerGrid");
    __publicField(this, "navContainer");
    __publicField(this, "burgerIcon");
    __publicField(this, "dropdownsBackdrop");
    __publicField(this, "headerLinks");
    __publicField(this, "dropdowns");
    __publicField(this, "openers");
    __publicField(this, "openedElementId");
    __publicField(this, "lastScrollPosition", 0);
    __publicField(this, "headerSectionBottom");
    __publicField(this, "resizeObserver");
    __publicField(this, "isHidden");
    __publicField(this, "lastBottom");
    __publicField(this, "lastHeight");
    __publicField(this, "navScrollWidth");
    __publicField(this, "isSticky");
    __publicField(this, "isCurrentSticky");
    __publicField(this, "isDynamicSticky");
    __publicField(this, "isDynamicShowLocked");
    __publicField(this, "isTransparent");
    __publicField(this, "isCurrentTransparent");
    __publicField(this, "blockInEditorSelected");
    __publicField(this, "withGradient");
    __publicField(this, "handleBtnMouseEnter", ({ currentTarget }) => {
      this.handleButtonHover(currentTarget),
        this.addListener(document, "mousemove", this.handleMouseMove);
    });
    __publicField(this, "handleOpenerClick", ({ element, opener }) => {
      this.openers.forEach((el) => {
        el.setExpand(el === opener);
      }),
        this.openedElementId === element.floatElementId
          ? (this.handleMouseLeave(), opener.setExpand(!1))
          : this.handleButtonHover(element);
    });
    __publicField(this, "handleOpenerClickOutside", ({ element, opener }) => {
      this.handleMouseLeave(), opener.setExpand(!1);
    });
    __publicField(
      this,
      "handleMouseMove",
      debounce(({ target }) => {
        const isButton = target.closest(
            `[${HEADER_DROPDOWN_WITH_BACKDROP_BTN_SELECTOR}]`
          ),
          isInside2 =
            target.closest(".header__dropdown-menu") ||
            target.closest("#Portal");
        !isButton && !isInside2 && this.handleMouseLeave();
      }, 20)
    );
    __publicField(this, "handleButtonHover", (button) => {
      this.emit("headerButtonHover", { floatElementId: button.floatElementId });
      const height = this.getFloatElementHeight(button.floatElement);
      this.expandDropdownBackdrop(height),
        (this.openedElementId = button.floatElementId);
    });
    __publicField(
      this,
      "getFloatElementHeight",
      (floatElement) =>
        floatElement.maxHeight || floatElement.currentVisible.offsetHeight
    );
    __publicField(this, "handleMouseLeave", () => {
      (this.openedElementId = null),
        !(this.isEditor && this.blockInEditorSelected) &&
          (this.collapseDropdownBackdrop(),
          this.emit("mouseLeavedHeader", {}),
          this.removeListener(document, "mousemove", this.handleMouseMove));
    });
    __publicField(this, "expandDropdownBackdrop", (height) => {
      this.dropdownsBackdrop.setAttribute(
        "style",
        `--gsc-header-backdrop-height: ${height}px;`
      ),
        transitionToPromise(this.dropdownsBackdrop).then(() => {
          this.dropdownsBackdrop.setAttribute("with-opened-dropdown", "");
        });
    });
    __publicField(this, "collapseDropdownBackdrop", () => {
      this.dropdownsBackdrop.setAttribute(
        "style",
        "--gsc-header-backdrop-height: 0px;"
      ),
        this.dropdownsBackdrop.removeAttribute("with-opened-dropdown"),
        this.removeListener(
          this.navContainer,
          "mousemove",
          this.handleMouseMove
        );
    });
    __publicField(this, "setNavItems", () => {
      if (
        ((this.headerGrid = $el(HEADER_GRID_SELECTOR, this)),
        this.burgerIcon ||
          ((this.burgerIcon = $el(BURGER_ICON_SELECTOR, this).cloneNode(!0)),
          this.burgerIcon.setAttribute("mock", "")),
        !this.navScrollWidth)
      )
        if (this.headerGrid.className.includes("menu-bottom")) {
          const navItems = $list(".header__item", this.navContainer);
          this.navScrollWidth =
            navItems[navItems.length - 1].getBoundingClientRect().right -
            navItems[0].getBoundingClientRect().left +
            25;
        } else this.navScrollWidth = this.headerGrid.scrollWidth + 25;
    });
    __publicField(this, "checkIsNavContainerFitAllLinks", () => {
      if (!this.navContainer) return;
      let rafId = null;
      rafId && cancelAnimationFrame(rafId),
        (rafId = requestAnimationFrame(() => {
          const isOverflowing = this.navScrollWidth > this.offsetWidth;
          this.navContainer.toggleAttribute("hidden", isOverflowing),
            this.headerGrid.toggleAttribute("fit-nav", isOverflowing),
            isOverflowing
              ? (this.headerGrid.prepend(this.burgerIcon),
                this.emit("drawerActivated", {}))
              : (this.burgerIcon.firstElementChild.classList.remove(
                  "is-opened"
                ),
                this.burgerIcon.remove(),
                this.emit("drawerUnActivated", {})),
            (rafId = null);
        }));
    });
    __publicField(this, "moveDrawer", () => {
      const drawer = $el("drawer-menu", this.section);
      if (drawer) {
        if (this.isEditor) {
          const nextSibling = this.section.nextElementSibling;
          nextSibling.tagName === "DRAWER-MENU" && nextSibling.remove();
        }
        this.section.after(drawer);
      }
    });
    __publicField(
      this,
      "handleResize",
      debounce(async () => {
        this.section.removeAttribute("visible"),
          this.isTransparent && this.toggleTransparentHeader(),
          this.section.classList.remove("scrolled"),
          this.setHidden(!1),
          this.updatePosition();
        const rect = this.section.getBoundingClientRect();
        (this.headerSectionBottom = rect.top + window.scrollY),
          !isMobile() &&
            this.navContainer &&
            this.checkIsNavContainerFitAllLinks(),
          (this.isCurrentSticky = isMobile()
            ? this.hasAttribute("is-sticky-mobile")
            : this.hasAttribute("is-sticky")),
          this.isCurrentSticky ? this.setSticky() : this.removeSticky(),
          this.isCurrentTransparent && (await transitionToPromise(this)),
          this.section.setAttribute("visible", "");
      }, 100)
    );
    __publicField(
      this,
      "handleScroll",
      throttle(() => {
        this.isDynamicSticky && this.updateVisibleAfterScroll(),
          this.setScrollStatus();
      }, 200)
    );
    __publicField(
      this,
      "updateVisibleAfterScroll",
      debounce(() => {
        const bodyElement = $el(BODY_ELEMENT_SELECTOR$5);
        if (!this.section || bodyElement.isFixed) return;
        const scrollY = window.scrollY,
          threshold = 36,
          scrollDistance = scrollY - this.lastScrollPosition,
          isScrollUp = scrollDistance < 0,
          isScrollDown = scrollDistance > 0,
          isUnderHeader = scrollY > this.headerSectionBottom,
          showOnScrollUp =
            isScrollUp &&
            this.isHidden &&
            scrollDistance + threshold < 0 &&
            isUnderHeader,
          hideOnScrollDown =
            isScrollDown && scrollDistance > threshold && isUnderHeader;
        showOnScrollUp
          ? this.setHidden(!1)
          : hideOnScrollDown && this.setHidden(!0),
          (this.lastScrollPosition = scrollY);
      }, 20)
    );
    __publicField(this, "toggleLockDynamicShow", (bool) => {
      this.isDynamicShowLocked = bool;
    });
    __publicField(this, "toggleTransparentHeader", () => {
      var _a;
      const isCurrentMobile = isMobile(),
        transparentVisibility = this.getAttribute("transparent-visibility"),
        { height, bottom } = this.getBoundingClientRect(),
        isCurrentTransparent =
          ((_a = $el(".place-under-transparent-header")) == null
            ? void 0
            : _a.getBoundingClientRect().top) -
            bottom <
            100 &&
          ((transparentVisibility.includes("mobile") && isCurrentMobile) ||
            (transparentVisibility.includes("desktop") && !isCurrentMobile));
      isCurrentTransparent
        ? ((this.section.style.marginBottom = `-${height}px`),
          this.setGradient(),
          this.hasAttribute("with-sticky-colored") &&
            this.section.setAttribute("with-sticky-colored", ""))
        : (this.section.removeAttribute("style"),
          this.removeAttribute("style"),
          (this.withGradient = !1)),
        this.toggleAttribute("is-transparent", isCurrentTransparent),
        (this.isCurrentTransparent = isCurrentTransparent);
    });
    __publicField(this, "setGradient", () => {
      if (this.hasAttribute("data-gradient") && !this.withGradient) {
        const gradient = gradientOpacity(
          this.dataset.gradient,
          this.dataset.opacity
        );
        this.section.setAttribute(
          "style",
          `--gsc-transparent-background: ${gradient}`
        ),
          (this.withGradient = !0);
      }
    });
    __publicField(
      this,
      "handleSectionLoad",
      debounce(() => {
        this.isTransparent && this.toggleTransparentHeader();
      }, 100)
    );
  }
  mountComponent() {
    if (
      ((this.isTransparent = this.hasAttribute("transparent-visibility")),
      this.updatePosition(),
      this.addListener(window, "scroll", this.handleScroll),
      this.moveDrawer(),
      (this.navContainer = $el(HEADER_NAV_SELECTOR, this)),
      this.navContainer)
    )
      if (
        (this.setNavItems(),
        (this.dropdownsBackdrop = $el(HEADER_DROPDOWN_BACKDROP_SELECTOR, this)),
        this.hasAttribute("with-open-on-click"))
      )
        (this.openers = $list(
          "dropdown-opener[data-header-btn-with-backdrop]"
        )),
          customElements.whenDefined("dropdown-opener").then(() => {
            this.openers.forEach((opener) => {
              opener.on("openerClick", this.handleOpenerClick),
                opener.on("openerClickOutside", this.handleOpenerClickOutside);
            });
          });
      else {
        const btns = $list("[data-header-btn-with-backdrop]");
        customElements.whenDefined("header-float-element-btn").then(() => {
          btns.forEach((btn) => {
            this.addListener(btn, "mouseenter", this.handleBtnMouseEnter);
          });
        });
      }
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this),
      this.isEditor &&
        ((this.blockInEditorSelected = !1),
        this.editor.on("SECTION_LOAD", this.handleSectionLoad),
        this.editor.on("SECTION_UNLOAD", this.handleSectionLoad));
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  setScrollStatus() {
    if (!this.section) return;
    const savedScrollPosition = Math.abs(
        parseInt(document.body.style.top || "0")
      ),
      scrolled =
        (window.scrollY || savedScrollPosition) > this.headerSectionBottom;
    this.section.classList.toggle("scrolled", scrolled);
  }
  setHidden(isHidden) {
    !this.section ||
      this.isDynamicShowLocked ||
      ((this.isHidden = isHidden),
      this.section.setAttribute("aria-hidden", isHidden ? "true" : "false"));
  }
  setSticky() {
    const stickyVariant = isMobile()
      ? this.getAttribute("is-sticky-mobile")
      : this.getAttribute("is-sticky");
    stickyVariant == "static" &&
      (document.body.setAttribute("header-desktop-sticky", ""),
      this.section.removeAttribute("dynamic-sticky"),
      (this.isDynamicSticky = !1)),
      stickyVariant == "dynamic" &&
        (this.section.setAttribute("dynamic-sticky", ""),
        (this.isDynamicSticky = !0),
        this.toggleLockDynamicShow(!1));
  }
  removeSticky() {
    this.section.removeAttribute("dynamic-sticky"),
      document.body.removeAttribute("header-desktop-sticky"),
      (this.isDynamicSticky = !1),
      this.hasAttribute("with-sticky-colored") ||
        this.section.removeAttribute("with-sticky-colored");
  }
  updatePosition() {
    if (!this.section) return;
    const rect = this.getBoundingClientRect();
    if (
      (this.lastHeight !== rect.height &&
        (setStyleVariable("header-height", `${rect.height}px`),
        (this.lastHeight = rect.height)),
      this.lastBottom !== rect.bottom)
    ) {
      const bottomSide = rect.bottom;
      setStyleVariable("header-bottom-side", `${bottomSide}px`),
        (this.lastBottom = bottomSide);
    }
  }
  get section() {
    return $el(SECTION_SELECTOR);
  }
}
const MODAL_SELECTOR$1 = "modal-component",
  HOTSPOTS_FLOAT_ELEMENT = "hotspots-float-element",
  FLOAT_ELEMENT_BTN_SELECTOR = "float-element-btn";
class HotspotsComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "hasOpenFloatElement");
    __publicField(this, "handlePinBtnClick", (event) => {
      event.preventDefault(), this.setAttribute("animation-state", "pause");
    });
    __publicField(this, "handlePinBtnEnter", (event) => {
      event.preventDefault(), this.setAttribute("animation-state", "pause");
    });
    __publicField(this, "handlePinBtnLeave", (event) => {
      event.preventDefault(),
        !this.hasOpenFloatElement && this.removeAttribute("animation-state");
    });
    __publicField(this, "handleFloatElementShow", () => {
      this.hasOpenFloatElement = !0;
    });
    __publicField(this, "handleFloatElementHide", () => {
      (this.hasOpenFloatElement = !1), this.removeAttribute("animation-state");
    });
    __publicField(this, "handleModalOpen", () => {
      this.setAttribute("animation-state", "pause");
    });
    __publicField(this, "handleModalHide", () => {
      this.removeAttribute("animation-state");
    });
    __publicField(this, "handleEditorClick", (event) => {
      const isTriggerBtn = $elParent(FLOAT_ELEMENT_BTN_SELECTOR, event.target),
        isFloatElement = $elParent(HOTSPOTS_FLOAT_ELEMENT, event.target),
        floatElements = $list(HOTSPOTS_FLOAT_ELEMENT, this);
      isTriggerBtn ||
        isFloatElement ||
        floatElements.forEach((floatElement) => {
          floatElement.hide();
        });
    });
  }
  mountComponent() {
    const modals = $list(MODAL_SELECTOR$1, this),
      floatElements = $list(HOTSPOTS_FLOAT_ELEMENT, this),
      floatElementsBtns = $list(FLOAT_ELEMENT_BTN_SELECTOR, this);
    modals.forEach((modal) => {
      whenDefined("modal-component").then(() => {
        modal.on("show", this.handleModalOpen),
          modal.on("hide", this.handleModalHide);
      });
    }),
      floatElements.forEach((floatElement) => {
        whenDefined("hotspots-float-element").then(() => {
          floatElement.on("hide", this.handleFloatElementHide),
            floatElement.on("show", this.handleFloatElementShow);
        });
      }),
      floatElementsBtns.forEach((btn) => {
        this.addListener(btn, "mouseenter", this.handlePinBtnEnter),
          this.addListener(btn, "mouseleave", this.handlePinBtnLeave),
          this.addListener(btn, "click", this.handlePinBtnClick);
      }),
      this.isEditor &&
        this.addListener(window, "click", this.handleEditorClick);
  }
  unmountComponent() {
    const modals = $list(MODAL_SELECTOR$1, this),
      floatElements = $list(HOTSPOTS_FLOAT_ELEMENT, this);
    modals.forEach((modal) => {
      whenDefined("modal-component").then(() => {
        modal.off("show", this.handleModalOpen),
          modal.off("hide", this.handleModalHide);
      });
    }),
      floatElements.forEach((floatElement) => {
        whenDefined("hotspots-float-element").then(() => {
          floatElement.off("hide", this.handleFloatElementHide),
            floatElement.off("show", this.handleFloatElementShow);
        });
      });
  }
}
class HotspotsFloatElement extends FloatElement {
  mountComponent() {
    super.mountComponent(), this.mount();
  }
  unmount() {}
}
const LOOKBOOK_SELECTOR = "lookbook-component",
  CAROUSEL_SELECTOR$6 = "slider-grid:not([with-grid])";
class LookbookModal extends ModalComponent {
  async show() {
    await super.show();
    const lookbook = $elParent(LOOKBOOK_SELECTOR, this),
      carousel = $el(CAROUSEL_SELECTOR$6, this);
    !lookbook ||
      !carousel ||
      (carousel.snaps || carousel.init(),
      lookbook.showBlockById(lookbook.selectedPinId));
  }
  async unmount() {
    await transitionToPromise(this.firstElementChild), this.replaceChildren();
  }
}
const PIN_SELECTOR = "[data-lookbook-pin]",
  BLOCK_SELECTOR = "[data-lookbook-block]",
  MODAL_SELECTOR = "[data-lookbook-modal]",
  CAROUSEL_SELECTOR$5 = "slider-grid:not([with-grid])",
  CAROUSEL_TRACK_SELECTOR =
    "[data-lookbook-mobile-content] [slider-grid-track]",
  DESKTOP_CONTENT_SELECTOR = "[data-lookbook-desktop-content]",
  MOBILE_CONTENT_SELECTOR = "[data-lookbook-mobile-content]";
class LookbookComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "animationPausedAttribute", "animation-paused");
    __publicField(this, "selectedPinId");
    __publicField(this, "notHighlightedAttribute", "not-highlighted");
    __publicField(this, "pins");
    __publicField(this, "highlightedBlockId");
    __publicField(this, "resizeObserver");
    __publicField(this, "carouselTrack");
    __publicField(this, "handlePinEnter", () => {
      this.setAnimationPausedState(!0);
    });
    __publicField(this, "handlePinLeave", () => {
      this.highlightedBlockId || this.setAnimationPausedState(!1);
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        this.showBlockById(this.highlightedBlockId);
      }, 500)
    );
    __publicField(this, "handlePinClick", (event) => {
      const blockId = event.target.dataset.blockId;
      this.selectedPinId = blockId;
      const modal = isMobile() ? $el(MODAL_SELECTOR, this) : null;
      modal ? modal.show() : this.showBlockById(blockId), this.setListeners();
    });
    __publicField(this, "handleOutsideClick", (event) => {
      $elParent(PIN_SELECTOR, event.target) ||
        (this.showBlockById(), this.removeListeners());
    });
    __publicField(this, "handlePointerMove", () => {
      this.showBlockById(), this.removeListeners();
    });
    __publicField(this, "setListeners", () => {
      this.addListener(window, "click", this.handleOutsideClick),
        this.carouselTrack &&
          this.addListener(
            this.carouselTrack,
            "pointermove",
            this.handlePointerMove
          );
    });
    __publicField(this, "removeListeners", () => {
      this.removeListener(window, "click", this.handleOutsideClick),
        this.carouselTrack &&
          this.removeListener(
            this.carouselTrack,
            "pointermove",
            this.handlePointerMove
          );
    });
  }
  mountComponent() {
    $list(PIN_SELECTOR, this).forEach((pin) => {
      this.addListener(pin, "mouseenter", this.handlePinEnter),
        this.addListener(pin, "mouseleave", this.handlePinLeave),
        this.addListener(pin, "click", this.handlePinClick);
    }),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this),
      isMobile() && (this.carouselTrack = $el(CAROUSEL_TRACK_SELECTOR, this));
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
  showBlockById(blockId) {
    this.updateSelectedStateForPins(blockId),
      blockId
        ? (this.setHighlightBlockById(blockId),
          this.setAnimationPausedState(!0))
        : (this.resetHighlight(), this.setAnimationPausedState(!1)),
      (this.highlightedBlockId = blockId);
  }
  updateSelectedStateForPins(blockId) {
    $list(PIN_SELECTOR, this).forEach((pin) => {
      pin.toggleAttribute("is-selected", pin.dataset.blockId === blockId);
    });
  }
  setAnimationPausedState(isAnimationPaused) {
    this.toggleAttribute(this.animationPausedAttribute, isAnimationPaused);
  }
  setHighlightBlockById(blockId) {
    this.blocks.forEach((block, index) => {
      const isHighlighted = block.dataset.blockId === blockId;
      isHighlighted && this.scrollToProductByIndex(index),
        block.removeAttribute("style"),
        block.toggleAttribute(this.notHighlightedAttribute, !isHighlighted);
    });
  }
  scrollToProductByIndex(index) {
    const block = this.blocks[index],
      carousel = $elParent(CAROUSEL_SELECTOR$5, block);
    carousel
      ? carousel.scrollSlideIntoView(index)
      : isNotThemeStore() &&
        block.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  resetHighlight() {
    this.blocks.forEach((block) => {
      block.removeAttribute(this.notHighlightedAttribute);
    });
  }
  get blocks() {
    const desktopContent = $el(DESKTOP_CONTENT_SELECTOR, this),
      mobileContent = $el(MOBILE_CONTENT_SELECTOR, this),
      content = isMobile() ? mobileContent : desktopContent,
      modal = $el(MODAL_SELECTOR, content),
      node = modal ? modal.element : content;
    return $list(BLOCK_SELECTOR, node);
  }
}
class StoreLocator extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "mapSelector", "#map");
    __publicField(this, "storeElementSelector", "data-store");
    __publicField(this, "storeIdSelector", "data-block-id");
    __publicField(this, "storeNameSelector", "data-name");
    __publicField(this, "storeCoordinatesSelector", "data-coordinates");
    __publicField(this, "defaultImageSelector", "map-default-image");
    __publicField(this, "map");
    __publicField(this, "stores");
    __publicField(this, "generateLocationsData", () =>
      this.stores.map((store) => ({
        coordinates: store.getAttribute(this.storeCoordinatesSelector),
        id: store.getAttribute(this.storeIdSelector),
      }))
    );
    __publicField(this, "handleMarkerClick", ({ markerId }) => {
      const storeToScrollTo = this.stores.find(
        (store) => store.dataset.blockId === markerId
      );
      isNotThemeStore() &&
        (storeToScrollTo == null ||
          storeToScrollTo.scrollIntoView({
            behavior: "smooth",
            block: "center",
          })),
        storeToScrollTo == null || storeToScrollTo.show(),
        this.toggleStoreVisibility(markerId);
    });
    __publicField(this, "handleStoreClick", ({ currentTarget }) => {
      const storeId = currentTarget.getAttribute(this.storeIdSelector);
      this.toggleStoreVisibility(storeId),
        isMobile() &&
          currentTarget.isExpanded &&
          this.scrollToTabTop(currentTarget);
    });
    __publicField(this, "scrollToTabTop", async (element) => {
      await transitionToPromise(element);
      const top = element.getBoundingClientRect().top;
      top < 0 &&
        window.scrollBy({ top: top - 100, left: 0, behavior: "smooth" });
    });
    __publicField(this, "toggleStoreVisibility", (id) => {
      this.toggleStoreExpanded(id), this.toggleMarkerHighlighted(id);
    });
    __publicField(this, "toggleStoreExpanded", (id) => {
      this.stores.forEach((store) => {
        store.dataset.blockId !== id && store.isExpanded && store.hide();
      });
    });
    __publicField(this, "toggleMarkerHighlighted", (id) => {
      var _a, _b;
      this.stores.find((store) => store.isExpanded)
        ? (_a = this.map) == null || _a.highlightMarker(id)
        : (_b = this.map) == null || _b.highlightMarker(null);
    });
    __publicField(this, "setDefaultImage", () => {
      var _a;
      const template = $el(`[${this.defaultImageSelector}]`, this),
        image = template == null ? void 0 : template.content;
      (_a = this.map) == null || _a.replaceWith(image);
    });
    __publicField(this, "handleMapError", () => {
      this.setDefaultImage();
    });
    (this.map = $el(this.mapSelector, this)),
      (this.stores = $list(`[${this.storeElementSelector}]`, this));
  }
  mountComponent() {
    var _a, _b;
    this.map &&
      ((this.map.locationsData = this.generateLocationsData()),
      this.map.initMap(),
      (_a = this.map) == null || _a.on("markerClick", this.handleMarkerClick),
      (_b = this.map) == null || _b.on("mapError", this.handleMapError)),
      this.stores.forEach((store) => {
        this.addListener(store, "click", this.handleStoreClick);
      });
  }
  unmountComponent() {
    this.map &&
      (this.map.off("markerClick", this.handleMarkerClick),
      this.map.off("mapError", this.handleMapError));
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __awaiter(
  thisArg,
  _arguments,
  P,
  generator
) {
  function adopt(value) {
    return value instanceof P
      ? value
      : new P(function (resolve) {
          resolve(value);
        });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done
        ? resolve(result.value)
        : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, [])).next());
  });
}
var fastDeepEqual = function equal(a, b) {
  if (a === b) return !0;
  if (a && b && typeof a == "object" && typeof b == "object") {
    if (a.constructor !== b.constructor) return !1;
    var length, i, keys;
    if (Array.isArray(a)) {
      if (((length = a.length), length != b.length)) return !1;
      for (i = length; i-- !== 0; ) if (!equal(a[i], b[i])) return !1;
      return !0;
    }
    if (a.constructor === RegExp)
      return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b.toString();
    if (
      ((keys = Object.keys(a)),
      (length = keys.length),
      length !== Object.keys(b).length)
    )
      return !1;
    for (i = length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return !1;
    for (i = length; i-- !== 0; ) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return !1;
    }
    return !0;
  }
  return a !== a && b !== b;
};
const DEFAULT_ID = "__googleMapsScriptId";
var LoaderStatus;
(function (LoaderStatus2) {
  (LoaderStatus2[(LoaderStatus2.INITIALIZED = 0)] = "INITIALIZED"),
    (LoaderStatus2[(LoaderStatus2.LOADING = 1)] = "LOADING"),
    (LoaderStatus2[(LoaderStatus2.SUCCESS = 2)] = "SUCCESS"),
    (LoaderStatus2[(LoaderStatus2.FAILURE = 3)] = "FAILURE");
})(LoaderStatus || (LoaderStatus = {}));
class Loader {
  constructor({
    apiKey,
    authReferrerPolicy,
    channel,
    client,
    id = DEFAULT_ID,
    language,
    libraries = [],
    mapIds,
    nonce,
    region,
    retries = 3,
    url = "https://maps.googleapis.com/maps/api/js",
    version,
  }) {
    if (
      ((this.callbacks = []),
      (this.done = !1),
      (this.loading = !1),
      (this.errors = []),
      (this.apiKey = apiKey),
      (this.authReferrerPolicy = authReferrerPolicy),
      (this.channel = channel),
      (this.client = client),
      (this.id = id || DEFAULT_ID),
      (this.language = language),
      (this.libraries = libraries),
      (this.mapIds = mapIds),
      (this.nonce = nonce),
      (this.region = region),
      (this.retries = retries),
      (this.url = url),
      (this.version = version),
      Loader.instance)
    ) {
      if (!fastDeepEqual(this.options, Loader.instance.options))
        throw new Error(
          `Loader must not be called again with different options. ${JSON.stringify(
            this.options
          )} !== ${JSON.stringify(Loader.instance.options)}`
        );
      return Loader.instance;
    }
    Loader.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy,
    };
  }
  get status() {
    return this.errors.length
      ? LoaderStatus.FAILURE
      : this.done
      ? LoaderStatus.SUCCESS
      : this.loading
      ? LoaderStatus.LOADING
      : LoaderStatus.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  createUrl() {
    let url = this.url;
    return (
      (url += "?callback=__googleMapsCallback"),
      this.apiKey && (url += `&key=${this.apiKey}`),
      this.channel && (url += `&channel=${this.channel}`),
      this.client && (url += `&client=${this.client}`),
      this.libraries.length > 0 &&
        (url += `&libraries=${this.libraries.join(",")}`),
      this.language && (url += `&language=${this.language}`),
      this.region && (url += `&region=${this.region}`),
      this.version && (url += `&v=${this.version}`),
      this.mapIds && (url += `&map_ids=${this.mapIds.join(",")}`),
      this.authReferrerPolicy &&
        (url += `&auth_referrer_policy=${this.authReferrerPolicy}`),
      url
    );
  }
  deleteScript() {
    const script = document.getElementById(this.id);
    script && script.remove();
  }
  load() {
    return this.loadPromise();
  }
  loadPromise() {
    return new Promise((resolve, reject) => {
      this.loadCallback((err) => {
        err ? reject(err.error) : resolve(window.google);
      });
    });
  }
  importLibrary(name) {
    return this.execute(), google.maps.importLibrary(name);
  }
  loadCallback(fn) {
    this.callbacks.push(fn), this.execute();
  }
  setScript() {
    var _a, _b;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const params = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy,
    };
    Object.keys(params).forEach((key) => !params[key] && delete params[key]),
      (!(
        (_b =
          (_a = window == null ? void 0 : window.google) === null ||
          _a === void 0
            ? void 0
            : _a.maps) === null || _b === void 0
      ) &&
        _b.importLibrary) ||
        ((g) => {
          let h,
            a,
            k,
            p = "The Google Maps JavaScript API",
            c = "google",
            l = "importLibrary",
            q = "__ib__",
            m = document,
            b = window;
          b = b[c] || (b[c] = {});
          const d = b.maps || (b.maps = {}),
            r = new Set(),
            e = new URLSearchParams(),
            u = () =>
              h ||
              (h = new Promise((f, n) =>
                __awaiter(this, void 0, void 0, function* () {
                  var _a2;
                  yield (a = m.createElement("script")),
                    (a.id = this.id),
                    e.set("libraries", [...r] + "");
                  for (k in g)
                    e.set(
                      k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
                      g[k]
                    );
                  e.set("callback", c + ".maps." + q),
                    (a.src = this.url + "?" + e),
                    (d[q] = f),
                    (a.onerror = () => (h = n(Error(p + " could not load.")))),
                    (a.nonce =
                      this.nonce ||
                      ((_a2 = m.querySelector("script[nonce]")) === null ||
                      _a2 === void 0
                        ? void 0
                        : _a2.nonce) ||
                      ""),
                    m.head.append(a);
                })
              ));
          d[l]
            ? console.warn(p + " only loads once. Ignoring:", g)
            : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
        })(params);
    const libraryPromises = this.libraries.map((library) =>
      this.importLibrary(library)
    );
    libraryPromises.length || libraryPromises.push(this.importLibrary("core")),
      Promise.all(libraryPromises).then(
        () => this.callback(),
        (error) => {
          const event = new ErrorEvent("error", { error });
          this.loadErrorCallback(event);
        }
      );
  }
  reset() {
    this.deleteScript(),
      (this.done = !1),
      (this.loading = !1),
      (this.errors = []),
      (this.onerrorEvent = null);
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if ((this.errors.push(e), this.errors.length <= this.retries)) {
      const delay2 = this.errors.length * Math.pow(2, this.errors.length);
      console.error(
        `Failed to load Google Maps script, retrying in ${delay2} ms.`
      ),
        setTimeout(() => {
          this.deleteScript(), this.setScript();
        }, delay2);
    } else (this.onerrorEvent = e), this.callback();
  }
  callback() {
    (this.done = !0),
      (this.loading = !1),
      this.callbacks.forEach((cb) => {
        cb(this.onerrorEvent);
      }),
      (this.callbacks = []);
  }
  execute() {
    if ((this.resetIfRetryingFailed(), this.done)) this.callback();
    else {
      if (window.google && window.google.maps && window.google.maps.version) {
        console.warn(
          "Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."
        ),
          this.callback();
        return;
      }
      this.loading || ((this.loading = !0), this.setScript());
    }
  }
}
const mapStyles = {
  silver: [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ],
  retro: [
    { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ color: "#c9b2a6" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "geometry.stroke",
      stylers: [{ color: "#dcd2be" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#ae9e90" }],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#93817c" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#a5b076" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#447530" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#f5f1e6" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#fdfcf8" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#f8c967" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#e9bc62" }],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry",
      stylers: [{ color: "#e98d58" }],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry.stroke",
      stylers: [{ color: "#db8555" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#806b63" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "transit.line",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8f7d77" }],
    },
    {
      featureType: "transit.line",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#ebe3cd" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#b9d3c2" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#92998d" }],
    },
  ],
  dark: [
    { elementType: "geometry", stylers: [{ color: "#212121" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "administrative.country",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "administrative.land_parcel",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#181818" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#1b1b1b" }],
    },
    {
      featureType: "road",
      elementType: "geometry.fill",
      stylers: [{ color: "#2c2c2c" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8a8a8a" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#373737" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#3c3c3c" }],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry",
      stylers: [{ color: "#4e4e4e" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "transit",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#000000" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#3d3d3d" }],
    },
  ],
  night: [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ],
  aubergine: [
    { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [{ color: "#4b6878" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#64779e" }],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [{ color: "#4b6878" }],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.stroke",
      stylers: [{ color: "#334e87" }],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry",
      stylers: [{ color: "#023e58" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#283d6a" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6f9ba5" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#1d2c4d" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#023e58" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#3C7680" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#304a7d" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#98a5be" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#1d2c4d" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#2c6675" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#255763" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#b0d5ce" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#023e58" }],
    },
    {
      featureType: "transit",
      elementType: "labels.text.fill",
      stylers: [{ color: "#98a5be" }],
    },
    {
      featureType: "transit",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#1d2c4d" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry.fill",
      stylers: [{ color: "#283d6a" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#3a4762" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#0e1626" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#4e6d70" }],
    },
  ],
};
class MapComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "styleAttribute", "data-map-style");
    __publicField(this, "customStyleAttribute", "data-map-custom-style");
    __publicField(this, "zoomAttribute", "data-map-zoom");
    __publicField(this, "defaultZoom", 10);
    __publicField(this, "api_key");
    __publicField(this, "locationsData", []);
    __publicField(this, "locations", []);
    __publicField(this, "center", { lat: 0, lng: 0 });
    __publicField(this, "markers", []);
    __publicField(this, "mapStyle");
    __publicField(this, "mapCustomStyle");
    __publicField(this, "zoom");
    __publicField(this, "map");
    __publicField(this, "initMap", async () => {
      try {
        await new Loader({ apiKey: this.api_key, version: "weekly" }).load(),
          (this.locations = this.generateMapLocations()),
          this.calcMapCenter(),
          this.setMap(),
          this.setMarkers();
      } catch (error) {
        this.handleErrors(error);
      }
    });
    __publicField(this, "generateMapLocations", () => {
      const data = [];
      for (const store of this.locationsData) {
        const { id, coordinates } = store,
          location = this.generateCoordinatesFromString(coordinates);
        location && data.push({ id, location });
      }
      return data;
    });
    __publicField(this, "setMap", () => {
      const map = new google.maps.Map(this, {
        zoom: this.locations.length > 0 ? this.zoom : 0,
        center: this.center,
        styles: this.mapCustomStyle ?? mapStyles[this.mapStyle],
      });
      this.map = map;
    });
    __publicField(this, "setMarkers", () => {
      this.locations.length !== 0 &&
        this.locations.map((location) => {
          const marker = new google.maps.Marker({
            map: this.map,
            position: location.location,
            id: location.id,
          });
          this.locations.length > 1 &&
            marker.addListener("click", (event) => {
              this.emit("markerClick", { markerId: location.id });
            }),
            this.markers.push(marker);
        });
    });
    __publicField(this, "generateCoordinatesFromString", (string) => {
      const array = string.split(","),
        lat = +array[0],
        lng = +array[1];
      if (!(!lat || !lng)) return { lat, lng };
    });
    __publicField(this, "toJSON", (str) => {
      try {
        return JSON.parse(str);
      } catch {
        return null;
      }
    });
    __publicField(this, "handleErrors", (error) => {
      console.log(error), this.emit("mapError", {});
    });
    (this.api_key = this.dataset.key),
      (this.mapStyle = this.getAttribute(this.styleAttribute)),
      (this.mapCustomStyle = this.toJSON(
        this.getAttribute(this.customStyleAttribute)
      )),
      (this.zoom = +this.getAttribute(this.zoomAttribute) || this.defaultZoom);
  }
  async mountComponent() {
    (window.gm_authFailure = this.handleErrors),
      this.locationsData.length > 0 && (await this.initMap());
  }
  unmountComponent() {
    window.gm_authFailure = null;
  }
  calcMapCenter() {
    const locationsLength = this.locations.length;
    if (locationsLength > 0) {
      const center = { lat: 0, lng: 0 };
      this.locations.forEach((location) => {
        (center.lat = center.lat + location.location.lat),
          (center.lng = center.lng + location.location.lng);
      }),
        (center.lat = center.lat / locationsLength),
        (center.lng = center.lng / locationsLength),
        (this.center = center);
    }
  }
  highlightMarker(id) {
    this.markers.forEach((marker) => {
      if (!id) {
        marker.setOpacity(1);
        return;
      }
      marker.id === id ? marker.setOpacity(1) : marker.setOpacity(0.5);
    });
  }
}
const INPUT_SELECTOR = "[password-modal-input]";
class PasswordModal extends ModalComponent {
  async show() {
    var _a;
    super.show(), (_a = $el(INPUT_SELECTOR, this)) == null || _a.focus();
  }
}
class PasswordModalButton extends ModalButton {
  mountComponent() {
    super.mountComponent(), this.focus();
  }
}
const POPUP_STORAGE_KEY = "AuroraTheme-Popup",
  POPUP_CLASSNAMES = {
    lightboxActive: "popup--active",
    lightboxClosing: "popup--closing",
    success: "popup--success",
    showImage: "popup--show-image",
  };
class PopupStorage {
  constructor(blockId, storageVariant = "localStorage") {
    __publicField(this, "_blockId");
    __publicField(this, "_storageVariant");
    (this._blockId = blockId), (this._storageVariant = storageVariant);
  }
  parseData(data) {
    if (!data) return null;
    try {
      return JSON.parse(data ?? "{}");
    } catch {
      return null;
    }
  }
  saveData(data) {
    try {
      this.storageType.setItem(
        `${POPUP_STORAGE_KEY}-${this._blockId}`,
        JSON.stringify(data)
      );
    } catch {}
  }
  loadData() {
    try {
      return this.parseData(
        this.storageType.getItem(`${POPUP_STORAGE_KEY}-${this._blockId}`)
      );
    } catch {
      return null;
    }
  }
  get storageType() {
    return this._storageVariant === "sessionStorage"
      ? sessionStorage
      : localStorage;
  }
}
var PopupType = ((PopupType2) => (
  (PopupType2.AgeVerifier = "age"),
  (PopupType2.Promo = "promo"),
  (PopupType2.Signup = "signup"),
  PopupType2
))(PopupType || {});
const timeDelayToMs = (delay2) => {
    switch (delay2) {
      case "none":
        return 0;
      case "3sec":
        return 3e3;
      case "5sec":
        return 5e3;
      case "15sec":
        return 15e3;
      case "30sec":
        return 3e4;
      case "1min":
        return 6e4;
      case "2min":
        return 12e4;
    }
  },
  frequencyToMs = (delay2) => {
    switch (delay2) {
      case "1h":
        return 60 * 60 * 1e3;
      case "12h":
        return 12 * 60 * 60 * 1e3;
      case "1d":
        return 24 * 60 * 60 * 1e3;
      case "3d":
        return 3 * 24 * 60 * 60 * 1e3;
      case "1w":
        return 7 * 24 * 60 * 60 * 1e3;
      case "2w":
        return 14 * 24 * 60 * 60 * 1e3;
      default:
        return 0;
    }
  },
  SCROLL_THRESHOLD = { 25: 20, 50: 40, 75: 55, 100: 99 },
  clearTag = (str) => str.toLowerCase().replace(/\s+/g, "");
class ConditionRuntime {
  constructor(dataset, lastShowDate, show) {
    __publicField(this, "whenShow");
    __publicField(this, "pageCondition");
    __publicField(this, "pages");
    __publicField(this, "timeDelay");
    __publicField(this, "pageScroll");
    __publicField(this, "exitIntent");
    __publicField(this, "frequency");
    __publicField(this, "lastShowDate");
    __publicField(this, "productTags");
    __publicField(this, "showCallback");
    __publicField(this, "startDate");
    __publicField(this, "timerRef");
    __publicField(this, "_shouldShowOnThisPage", () => {
      var _a;
      if (this.pageCondition === "target") {
        const urls =
          ((_a = this.pages) == null
            ? void 0
            : _a
                .split(
                  `
`
                )
                .map((sourceUrl) => {
                  try {
                    return new URL(sourceUrl);
                  } catch {
                    return !1;
                  }
                })
                .filter(Boolean)
                .map((url) => url.pathname)) ?? [];
        for (let i = 0; i < urls.length; i++) {
          const wildcard = urls[i];
          if (wildcardToRegExp(wildcard).test(window.location.pathname))
            return !0;
        }
        return !1;
      }
      if (this.pageCondition === "tags") {
        const currentProductTags = window.auroraProductTags;
        return !currentProductTags ||
          !Array.isArray(currentProductTags) ||
          currentProductTags.length === 0
          ? !1
          : currentProductTags
              .map(clearTag)
              .some((tag) => this.productTags.includes(tag));
      }
      return !0;
    });
    __publicField(this, "run", () => {
      this._shouldShowOnThisPage() &&
        ((this.frequency === "once" && this.lastShowDate) ||
          (this.frequency !== "unlimited" &&
            this.lastShowDate &&
            Date.now() - frequencyToMs(this.frequency) <
              this.lastShowDate.getTime()) ||
          ((this.startDate = new Date()),
          (this.timerRef = window.setInterval(() => {
            this._tick();
          }, 1e3)),
          this._tick(),
          this.exitIntent &&
            !isMobile() &&
            document.addEventListener("mouseout", this._handleMouseLeave),
          this.pageScroll &&
            (window.addEventListener("scroll", this._handleWindowScroll),
            this._handleWindowScroll())));
    });
    __publicField(this, "_tick", () => {
      if (this.whenShow === "immediately") {
        this._show();
        return;
      }
      this.timeDelay &&
        Date.now() - timeDelayToMs(this.timeDelay) >=
          this.startDate.getTime() &&
        this._show();
    });
    __publicField(this, "_handleWindowScroll", () => {
      const scrollTop = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent =
          docHeight === winHeight ? 1 : scrollTop / (docHeight - winHeight);
      Math.round(scrollPercent * 100) >= SCROLL_THRESHOLD[this.pageScroll] &&
        this._show();
    });
    __publicField(this, "_handleMouseLeave", (e) => {
      !e.toElement && !e.relatedTarget && this._show();
    });
    __publicField(this, "_show", () => {
      this.showCallback(), this.cleanup();
    });
    __publicField(this, "cleanup", () => {
      clearInterval(this.timerRef),
        this.pageScroll &&
          window.removeEventListener("scroll", this._handleWindowScroll),
        this.exitIntent &&
          !isMobile() &&
          document.removeEventListener("mouseout", this._handleMouseLeave);
    });
    (this.showCallback = show),
      (this.pageCondition = dataset.pageCondition ?? "all"),
      (this.whenShow = dataset.whenShow ?? "immediately"),
      (this.pages = dataset.pages),
      (this.timeDelay =
        dataset.timeDelay === "none" ? null : dataset.timeDelay),
      (this.pageScroll =
        dataset.pageScroll === "none" ? null : dataset.pageScroll),
      (this.exitIntent = dataset.exitIntent === "true"),
      (this.frequency = dataset.frequency ?? "unlimited"),
      (this.productTags = (dataset.productTags || "")
        .split(",")
        .map(clearTag)
        .filter((str) => str.length > 0)),
      (this.lastShowDate = lastShowDate);
  }
}
const BODY_ELEMENT_SELECTOR$4 = "body-element";
class PopupAgeVerifier extends ModalComponent {
  constructor() {
    super();
    __publicField(this, "storage");
    __publicField(this, "conditionRuntime");
    __publicField(this, "hasImage");
    __publicField(this, "hideImgOnMobile");
    __publicField(this, "_handleBlockSelect", ({ detail: { blockId } }) => {
      this.dataset.blockId === blockId && this.show();
    });
    __publicField(this, "_handleBlockDeselect", ({ detail: { blockId } }) => {
      this.dataset.blockId === blockId && this.hide();
    });
    __publicField(this, "show", async () => {
      const withGradient = !!this.dataset.overlayGradient,
        bodyElement = $el(BODY_ELEMENT_SELECTOR$4),
        background = withGradient
          ? gradientOpacity(
              this.dataset.overlayGradient,
              this.dataset.overlayOpacity
            )
          : `color-mix(in srgb, ${this.dataset.overlaySolid} ${
              Number(this.dataset.overlayOpacity) * 100
            }%, transparent)`,
        blurFilter = `blur(${this.dataset.overlayBlur}px)`;
      if (
        (whenDefined("body-element").then(() => {
          bodyElement.showOverlay(this.id, {
            zIndex: 8888,
            background,
            backdropFilter: blurFilter,
            "-webkit-backdrop-filter": blurFilter,
            transitionDuration: "0s",
          });
        }),
        await super.show(),
        this.classList.add(POPUP_CLASSNAMES.lightboxActive),
        this.addListener(this._verifyBtn, "click", this.onVerify),
        this.hasImage)
      ) {
        if (this.hideImgOnMobile && isMobile()) return;
        setTimeout(() => {
          this.classList.add(POPUP_CLASSNAMES.showImage);
        }, POPUP_ANIMATION_DELAY);
      }
    });
    __publicField(this, "hide", async () => {
      var _a;
      const bodyElement = $el(BODY_ELEMENT_SELECTOR$4);
      whenDefined("body-element").then(() => {
        bodyElement.hideOverlay(this.id);
      }),
        (_a = this.conditionRuntime) == null || _a.cleanup(),
        this.classList.remove(POPUP_CLASSNAMES.lightboxActive),
        this.classList.add(POPUP_CLASSNAMES.lightboxClosing),
        await super.hide(),
        this.classList.remove(POPUP_CLASSNAMES.showImage),
        this.classList.remove(POPUP_CLASSNAMES.lightboxClosing);
    });
    __publicField(this, "onVerify", () => {
      this.isEditor ||
        this.storage.saveData({ type: PopupType.AgeVerifier, verified: !0 }),
        this.removeListener(this._verifyBtn, "click", this.onVerify),
        this.hide();
    });
    const showOnSession = this.dataset.showCondition === "session";
    (this.storage = new PopupStorage(
      this.dataset.blockId ?? this.id,
      showOnSession ? "sessionStorage" : "localStorage"
    )),
      (this.hasImage = this.dataset.hasImage === "true"),
      (this.hideImgOnMobile = this.dataset.hideImgMobile === "true");
  }
  mountComponent() {
    const data = this.storage.loadData();
    if (this.isEditor) {
      this.editor.on("BLOCK_SELECT", this._handleBlockSelect),
        this.editor.on("BLOCK_DESELECT", this._handleBlockDeselect);
      return;
    }
    (!data || (data.type === PopupType.AgeVerifier && !data.verified)) &&
      ((this.conditionRuntime = new ConditionRuntime(
        this.dataset,
        null,
        this.show
      )),
      this.conditionRuntime.run());
  }
  unmountComponent() {
    var _a;
    (_a = this.conditionRuntime) == null || _a.cleanup();
  }
  get _verifyBtn() {
    return this.isOpen ? $el("[data-verify-btn]", this) : null;
  }
}
const BODY_ELEMENT_SELECTOR$3 = "body-element";
class PopupPromo extends ModalComponent {
  constructor() {
    super();
    __publicField(this, "storage");
    __publicField(this, "conditionRuntime");
    __publicField(this, "variant");
    __publicField(this, "hasImage");
    __publicField(this, "hideImgOnMobile");
    __publicField(this, "_handleBlockSelect", ({ detail: { blockId } }) => {
      this.dataset.blockId === blockId && this.show();
    });
    __publicField(this, "_handleBlockDeselect", ({ detail: { blockId } }) => {
      this.dataset.blockId === blockId && this.hide();
    });
    __publicField(this, "show", async () => {
      if (this.variant === "lightbox") {
        const withGradient = !!this.dataset.overlayGradient,
          bodyElement = $el(BODY_ELEMENT_SELECTOR$3),
          background = withGradient
            ? gradientOpacity(
                this.dataset.overlayGradient,
                this.dataset.overlayOpacity
              )
            : `color-mix(in srgb, ${this.dataset.overlaySolid} ${
                Number(this.dataset.overlayOpacity) * 100
              }%, transparent)`,
          blurFilter = `blur(${this.dataset.overlayBlur}px)`;
        whenDefined("body-element").then(() => {
          bodyElement.showOverlay(this.id, {
            zIndex: 8888,
            background,
            backdropFilter: blurFilter,
            "-webkit-backdrop-filter": blurFilter,
            transitionDuration: `${POPUP_ANIMATION_DELAY}ms`,
          });
        });
      }
      this.emit("popupShown", {}),
        await super.show(),
        this.variant === "lightbox" &&
          this.classList.add(POPUP_CLASSNAMES.lightboxActive),
        this.hasImage &&
          !(this.hideImgOnMobile && isMobile()) &&
          setTimeout(() => {
            this.classList.add(POPUP_CLASSNAMES.showImage);
          }, POPUP_ANIMATION_DELAY);
      const closeBtn = this.selectBtn("close-small");
      closeBtn && (closeBtn.style.display = "flex"),
        this.addListener(this.selectBtn("close"), "click", this.hide),
        this.addListener(this.selectBtn("close-small"), "click", this.hide),
        this.addListener(this.selectBtn("promo"), "click", this.onTouch);
    });
    __publicField(this, "hide", async () => {
      var _a;
      if ((this.onTouch(), this.variant === "lightbox")) {
        const bodyElement = $el(BODY_ELEMENT_SELECTOR$3);
        whenDefined("body-element").then(() => {
          bodyElement.hideOverlay(this.id);
        });
      }
      (_a = this.conditionRuntime) == null || _a.cleanup(),
        this.removeListener(this.selectBtn("close"), "click", this.hide),
        this.removeListener(this.selectBtn("close-small"), "click", this.hide),
        this.removeListener(this.selectBtn("promo"), "click", this.onTouch),
        this.variant === "lightbox" &&
          (this.classList.remove(POPUP_CLASSNAMES.lightboxActive),
          this.classList.add(POPUP_CLASSNAMES.lightboxClosing)),
        await super.hide(),
        this.classList.remove(POPUP_CLASSNAMES.showImage),
        this.classList.remove(POPUP_CLASSNAMES.lightboxClosing),
        this.emit("popupHidden", {});
    });
    __publicField(this, "onTouch", () => {
      this.storage.saveData({ type: PopupType.Promo, lastShow: new Date() });
    });
    (this.storage = new PopupStorage(this.dataset.blockId ?? this.id)),
      (this.variant = this.dataset.variant),
      (this.hasImage = this.dataset.hasImage === "true"),
      (this.hideImgOnMobile = this.dataset.hideImgMobile === "true");
  }
  mountComponent() {
    if (this.isEditor) {
      this.editor.on("BLOCK_SELECT", this._handleBlockSelect),
        this.editor.on("BLOCK_DESELECT", this._handleBlockDeselect);
      return;
    }
    const data = this.storage.loadData();
    if (!data || data.type === PopupType.Promo) {
      if (data != null && data.lastShow)
        try {
          data.lastShow = new Date(data.lastShow);
        } catch {
          data.lastShow = null;
        }
      (this.conditionRuntime = new ConditionRuntime(
        this.dataset,
        (data == null ? void 0 : data.lastShow) ?? null,
        this.show
      )),
        this.conditionRuntime.run();
    }
  }
  unmountComponent() {
    var _a;
    (_a = this.conditionRuntime) == null || _a.cleanup();
  }
  selectBtn(type) {
    return this.isOpen ? $el(`[data-${type}-btn]`, this) : null;
  }
}
const BODY_ELEMENT_SELECTOR$2 = "body-element";
class PopupSignup extends ModalComponent {
  constructor() {
    super();
    __publicField(this, "storage");
    __publicField(this, "conditionRuntime");
    __publicField(this, "variant");
    __publicField(this, "hasImage");
    __publicField(this, "hideImgOnMobile");
    __publicField(this, "isSuccessMessage", !1);
    __publicField(this, "signupCheckbox");
    __publicField(this, "submitButton");
    __publicField(this, "handleSignupCheckboxToggle", ({ currentTarget }) => {
      this.submitButton.toggleAttribute("disabled", !currentTarget.checked);
    });
    __publicField(this, "_handleBlockSelect", ({ detail: { blockId } }) => {
      this.dataset.blockId === blockId && this.show();
    });
    __publicField(this, "_handleBlockDeselect", ({ detail: { blockId } }) => {
      this.dataset.blockId === blockId && this.hide();
    });
    __publicField(this, "show", async () => {
      if (this.variant === "lightbox") {
        const withGradient = !!this.dataset.overlayGradient,
          bodyElement = $el(BODY_ELEMENT_SELECTOR$2),
          background = withGradient
            ? gradientOpacity(
                this.dataset.overlayGradient,
                this.dataset.overlayOpacity
              )
            : `color-mix(in srgb, ${this.dataset.overlaySolid} ${
                Number(this.dataset.overlayOpacity) * 100
              }%, transparent)`,
          blurFilter = `blur(${this.dataset.overlayBlur}px)`;
        whenDefined("body-element").then(() => {
          bodyElement.showOverlay(this.id, {
            zIndex: 8888,
            background,
            backdropFilter: blurFilter,
            "-webkit-backdrop-filter": blurFilter,
            transitionDuration: `${POPUP_ANIMATION_DELAY}ms`,
          });
        });
      }
      this.emit("popupShown", {}), await super.show(), this.saveLastShowData();
      const closeBtn = this.selectBtn("close-small");
      if (
        (closeBtn && (closeBtn.style.display = "flex"),
        this.addListener(this.selectBtn("close"), "click", this.hide),
        this.addListener(this.selectBtn("close-small"), "click", this.hide),
        this.addListener(this.selectBtn("submit"), "click", this.onSubmit),
        this.variant === "lightbox" &&
          this.classList.add(POPUP_CLASSNAMES.lightboxActive),
        this.hasImage)
      ) {
        if ((this.hideImgOnMobile && isMobile()) || this.isSuccessMessage)
          return;
        setTimeout(() => {
          this.classList.add(POPUP_CLASSNAMES.showImage);
        }, POPUP_ANIMATION_DELAY);
      }
    });
    __publicField(this, "hide", async () => {
      var _a;
      if ((this.saveLastShowData(), this.variant === "lightbox")) {
        const bodyElement = $el(BODY_ELEMENT_SELECTOR$2);
        whenDefined("body-element").then(() => {
          bodyElement.hideOverlay(this.id);
        });
      }
      (_a = this.conditionRuntime) == null || _a.cleanup(),
        this.removeListener(this.selectBtn("close"), "click", this.hide),
        this.removeListener(this.selectBtn("close-small"), "click", this.hide),
        this.removeListener(this.selectBtn("submit"), "click", this.onSubmit),
        this.variant === "lightbox" &&
          (this.classList.remove(POPUP_CLASSNAMES.lightboxActive),
          this.classList.add(POPUP_CLASSNAMES.lightboxClosing)),
        await super.hide(),
        this.classList.remove(POPUP_CLASSNAMES.showImage),
        this.classList.remove(POPUP_CLASSNAMES.lightboxClosing),
        this.emit("popupHidden", {});
    });
    __publicField(this, "onSubmit", () => {
      window.sessionStorage.setItem(
        "customer-posted-block-id",
        this.dataset.blockId
      );
    });
    __publicField(this, "saveLastShowData", () => {
      this.storage.saveData({ type: PopupType.Signup, lastShow: new Date() });
    });
    (this.storage = new PopupStorage(this.dataset.blockId ?? this.id)),
      (this.variant = this.dataset.variant),
      (this.hasImage = this.dataset.hasImage === "true"),
      (this.hideImgOnMobile = this.dataset.hideImgMobile === "true");
  }
  mountComponent() {
    if (this.isEditor) {
      this.editor.on("BLOCK_SELECT", this._handleBlockSelect),
        this.editor.on("BLOCK_DESELECT", this._handleBlockDeselect);
      return;
    }
    const data = this.storage.loadData();
    if (!window.location.pathname.includes("challenge")) {
      if (
        this.dataset.showSuccessMessage === "true" &&
        window.sessionStorage.getItem("customer-posted-block-id") ===
          this.dataset.blockId
      ) {
        this.show(),
          window.sessionStorage.removeItem("customer-posted-block-id"),
          this.classList.add(POPUP_CLASSNAMES.success),
          (this.isSuccessMessage = !0);
        return;
      }
      if (!data || data.type === PopupType.Signup) {
        if (data != null && data.lastShow)
          try {
            data.lastShow = new Date(data.lastShow);
          } catch {
            data.lastShow = null;
          }
        (this.conditionRuntime = new ConditionRuntime(
          this.dataset,
          (data == null ? void 0 : data.lastShow) ?? null,
          this.show
        )),
          this.conditionRuntime.run();
      }
    }
  }
  unmountComponent() {
    var _a;
    (_a = this.conditionRuntime) == null || _a.cleanup();
  }
  selectBtn(type) {
    return this.isOpen ? $el(`[data-${type}-btn]`, this) : null;
  }
}
const TARGET_POPUP_ATTRIBUTE = "data-target-popup-id",
  CAN_BE_CLOSED_ATTRIBUTE = "data-can-be-closed-on",
  CLOSE_BTN_SELECTOR = "[data-popup-teaser-close]",
  ANIMATION_OPTIONS = {
    duration: 750,
    easing: "ease-in-out",
    fill: "forwards",
  };
class PopupTeaser extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "targetPopup");
    __publicField(this, "canBeClosedOn");
    __publicField(this, "removePermanently");
    __publicField(this, "withGradient");
    __publicField(this, "showTeaser", async () => {
      await this.animate({ [this.getTeaserPosition()]: "0" }, ANIMATION_OPTIONS)
        .finished;
    });
    __publicField(this, "hideTeaser", async () => {
      await this.animate(
        { [this.getTeaserPosition()]: "-100%" },
        ANIMATION_OPTIONS
      ).finished,
        this.removePermanently && this.remove();
    });
    __publicField(this, "getTeaserPosition", () => {
      const { left, right, bottom } = getComputedStyle(this);
      if (parseInt(bottom) < 0) return "bottom";
      const isLeft = parseInt(left) < 1,
        isRight = parseInt(right) < 1;
      return isLeft ? "left" : isRight ? "right" : "bottom";
    });
    __publicField(this, "handleTeaserClick", ({ target }) => {
      target.closest(CLOSE_BTN_SELECTOR)
        ? ((this.removePermanently = !0), this.hideTeaser())
        : this.showPopup();
    });
    __publicField(this, "showPopup", () => {
      var _a, _b;
      this.targetPopup.show();
      const isNowMobile = isMobile();
      (this.removePermanently =
        (isNowMobile &&
          !((_a = this.canBeClosedOn) != null && _a.includes("mobile"))) ||
        (!isNowMobile &&
          !((_b = this.canBeClosedOn) != null && _b.includes("desktop")))),
        this.hideTeaser();
    });
    __publicField(this, "setCloseBtnGradient", () => {
      if (this.hasAttribute("data-gradient") && !this.withGradient) {
        const btn = $el(CLOSE_BTN_SELECTOR, this);
        btn == null ||
          btn.setAttribute(
            "style",
            `--gsc-teaser-close-background-color: ${gradientOpacity(
              this.dataset.gradient,
              this.dataset.opacity
            )}`
          ),
          (this.withGradient = !0);
      }
    });
    __publicField(this, "handleBlockSelect", ({ detail: { blockId } }) => {
      this.dataset.targetPopupId === blockId &&
        ((this.style.zIndex = "10001"), this.showTeaser());
    });
    __publicField(this, "handleBlockDeselect", ({ detail: { blockId } }) => {
      this.dataset.targetPopupId === blockId &&
        (this.hideTeaser(), this.removeAttribute("style"));
    });
  }
  mountComponent() {
    (this.removePermanently = !1),
      (this.canBeClosedOn = this.getAttribute(CAN_BE_CLOSED_ATTRIBUTE)),
      (this.targetPopup = $el(
        `[data-block-id="${this.getAttribute(TARGET_POPUP_ATTRIBUTE)}"]`,
        this.parentElement
      )),
      this.addListener(this, "click", this.handleTeaserClick),
      this.targetPopup.on("popupHidden", this.showTeaser),
      this.targetPopup.on("popupShown", this.hideTeaser),
      this.setCloseBtnGradient(),
      this.isEditor &&
        (this.editor.on("BLOCK_SELECT", this.handleBlockSelect),
        this.editor.on("BLOCK_DESELECT", this.handleBlockDeselect));
  }
  unmountComponent() {
    this.removeListener(this, "click", this.handleTeaserClick),
      this.targetPopup.off("popupHidden", this.showTeaser),
      this.targetPopup.off("popupShown", this.hideTeaser),
      this.isEditor &&
        (this.editor.off("BLOCK_SELECT", this.handleBlockSelect),
        this.editor.off("BLOCK_DESELECT", this.handleBlockDeselect));
  }
}
const CAROUSEL_SELECTOR$4 = "[data-product-modal-carousel]",
  CAROUSEL_BUTTONS_SELECTOR = "[data-product-modal-carousel-button]",
  CAROUSEL_SLIDE_SELECTOR = "[data-product-modal-slide]",
  CAROUSEL_SELECTED_SLIDE_NUMBER_SELECTOR =
    "[data-product-modal-selected-slide-number]",
  ZOOM_CURSOR_SELECTOR = "zoom-cursor";
class ProductModal extends ModalComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "carousel");
    __publicField(this, "mediaIndexMap");
    __publicField(this, "isZoomed", !1);
    __publicField(this, "zoomedImage");
    __publicField(this, "handleKeydown", (event) => {
      isEscKey(event) &&
        (this.isZoomed ? this.zoomedImage.reset() : this.hide());
    });
    __publicField(this, "handleCarouselInit", () => {
      this.updateCarouselDraggableState();
    });
    __publicField(this, "handleCarouselSelect", () => {
      this.updateSelectedSlideNumber();
    });
  }
  openAndShowMediaById(mediaId) {
    if ((this.show(), !this.carousel)) return;
    const mediaIndex = this.mediaIndexMap[mediaId];
    this.carousel.embla.scrollTo(mediaIndex, !0);
    const carouselButtons = $list(CAROUSEL_BUTTONS_SELECTOR, this.carousel);
    carouselButtons[0] && carouselButtons[0].focus(),
      this.updateSelectedSlideNumber();
  }
  initCarousel() {
    var _a, _b;
    (this.mediaIndexMap = this.createMediaIndexMap()),
      this.element && (this.carousel = $el(CAROUSEL_SELECTOR$4, this.element)),
      (_a = this.carousel) == null ||
        _a.embla.on("select", this.handleCarouselSelect),
      (_b = this.carousel) == null ||
        _b.embla.on("init", this.handleCarouselInit);
  }
  resetCarousel() {
    var _a, _b;
    (_a = this.carousel) == null ||
      _a.embla.off("select", this.handleCarouselSelect),
      (_b = this.carousel) == null ||
        _b.embla.off("init", this.handleCarouselInit);
  }
  hide() {
    this.resetCarousel(),
      super.hide(),
      (this.isZoomed = !1),
      this.updateModal(),
      this.emit("hide", {});
  }
  show() {
    super.show(), this.initCarousel();
  }
  updateSelectedSlideNumber() {
    const selectedSlideNumber = $el(
      CAROUSEL_SELECTED_SLIDE_NUMBER_SELECTOR,
      this.element
    );
    if (!selectedSlideNumber || !this.carousel) return;
    const newSlideNumber = this.carousel.embla.selectedScrollSnap() + 1;
    selectedSlideNumber.textContent = String(newSlideNumber);
  }
  updateModal() {
    this.updateCarouselDraggableState(),
      this.updateZoomCursorState(),
      this.updateZoomState();
  }
  createMediaIndexMap() {
    return $list(CAROUSEL_SLIDE_SELECTOR, this.element).reduce(
      (acc, slide, index) =>
        slide.dataset.mediaId
          ? { ...acc, [slide.dataset.mediaId]: index }
          : acc,
      {}
    );
  }
  updateCarouselDraggableState() {
    if (this.carousel) {
      if (!isMobile()) {
        this.carousel.reInit({ watchDrag: !1 });
        return;
      }
      this.carousel.reInit({ watchDrag: !this.isZoomed });
    }
  }
  updateZoomCursorState() {
    const zoomCursor = $el(ZOOM_CURSOR_SELECTOR);
    zoomCursor != null &&
      zoomCursor.updateState &&
      zoomCursor.updateState(this.isZoomed);
  }
  updateZoomState() {
    this.toggleAttribute("zoom-enabled", this.isZoomed);
  }
}
class ProductModalButton extends ModalButton {
  trigger() {
    super.trigger();
    const modal = $el(this.dataset.modal);
    modal == null || modal.openAndShowMediaById(this.dataset.mediaId);
  }
}
class PickupAvailability extends BaseComponent {
  mountComponent() {
    this.fetchAvailability();
  }
  fetchAvailability() {
    const url = `${this.dataset.baseUrl}variants/${this.dataset.variantId}/?section_id=pickup-availability`;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = $el(".shopify-section", parseHTML(text));
        this.updateSidebarFromHTML(html), this.updateContentFromHTML(html);
      })
      .catch(() => {
        console.log("Error in pickup availability component");
      });
  }
  updateVariantId(newVariantId) {
    this.dataset.variantId = newVariantId;
  }
  updateContentFromHTML(section) {
    const content = $el("pickup-availability-content", this),
      newContent = $el("pickup-availability-content", section);
    replaceNodeChildren(content, newContent);
  }
  updateSidebarFromHTML(section) {
    const drawer = $el("#pickup-availability-sidebar");
    if (!drawer) return;
    const newTemplate = $el(`[data-sidebar-template="${drawer.id}"]`, section);
    newTemplate && drawer.updateTemplate(newTemplate);
  }
}
const PRODUCT_BLOCK_SELECTOR = "data-product-block",
  PRODUCT_MEDIA_SELECTOR = "data-product-media-container",
  OPTION_INPUTS_SELECTOR = "[data-variant-picker-option-inputs]",
  OPTION_LABELS_SELECTOR = "[data-variant-picker-option-labels]",
  IS_TO_FILTER_MEDIA_SELECTOR$1 = "data-product-media-filtering-option",
  SELECTED_VARIANT_IMAGE_SELECTOR = "data-selected-variant-image-id",
  ARROW_KEYS = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"],
  HEADER_SELECTOR$1 = "header-component";
class VariantPicker extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "variant");
    __publicField(this, "quickView");
    __publicField(this, "handleVariantChange", (event) => {
      this.swapProduct(this.getFetchUrl(event.target));
    });
    __publicField(this, "toggleHeaderDynamicShow", (bool) => {
      $el(HEADER_SELECTOR$1).toggleLockDynamicShow(bool);
    });
    __publicField(this, "updateDom", (responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      if (this.quickView) this.quickView.setProductFromHTML(html);
      else {
        const { newProduct, newVariantPicker } = this.getNewProductData(html);
        this.removeAnimationClass(newProduct), this.updateURL(newVariantPicker);
        const shouldSwapProduct = this.shouldSwapProduct(newVariantPicker);
        this.updateElements(newProduct, shouldSwapProduct);
      }
    });
    __publicField(this, "shouldSwapProduct", (newVariantPicker) => {
      const isToFilterMedia =
        newVariantPicker.hasAttribute(IS_TO_FILTER_MEDIA_SELECTOR$1) ||
        this.hasAttribute(IS_TO_FILTER_MEDIA_SELECTOR$1);
      return (
        this.dataset.url !== newVariantPicker.dataset.url || isToFilterMedia
      );
    });
    __publicField(this, "getNewProductData", (html) => {
      const newProduct = html.getElementById(
          `shopify-section-${this.dataset.sectionIdWithoutPrefix}`
        ),
        newVariantPicker = $el("variant-picker", newProduct);
      return { newProduct, newVariantPicker };
    });
    __publicField(this, "handleLabelKeydown", (event) => {
      if (isEnterKey(event)) {
        event.preventDefault();
        const target = event.target,
          input = $el(`input[id="${target.getAttribute("for")}"]`, this);
        input &&
          input.dispatchEvent(new MouseEvent("click", { button: 0, which: 1 }));
      }
    });
    __publicField(this, "handleKeydown", (event) => {
      if (!ARROW_KEYS.includes(event.key) && !isTabKey(event)) return;
      const target = event.target,
        labelContainer = $elParent(OPTION_LABELS_SELECTOR, target);
      if (!labelContainer) {
        this.removeListener(document, "keydown", this.handleLabelKeydown);
        return;
      }
      const labels = $list("label", labelContainer),
        index = labels.findIndex((label) => label === event.target),
        currentLabel = labels[index],
        firstLabel = labels[0],
        lastLabel = labels[labels.length - 1],
        nextLabel = labels[index + 1],
        prevLabel = labels[index - 1],
        setActiveLabel = (newLabel) => {
          currentLabel == null || currentLabel.removeAttribute("tabindex"),
            newLabel.setAttribute("tabindex", 0),
            newLabel.focus(),
            event.preventDefault();
        },
        changeActiveLabelOnNext = () => {
          setActiveLabel(nextLabel || firstLabel);
        },
        changeActiveLabelOnPrev = () => {
          setActiveLabel(prevLabel || lastLabel);
        },
        callback = {
          ArrowLeft: changeActiveLabelOnPrev,
          ArrowRight: changeActiveLabelOnNext,
          ArrowUp: changeActiveLabelOnPrev,
          ArrowDown: changeActiveLabelOnNext,
        }[event.key];
      isTabKey(event)
        ? prevLabel && event.shiftKey
          ? changeActiveLabelOnPrev()
          : nextLabel && !event.shiftKey && changeActiveLabelOnNext()
        : callback();
    });
    (this.variant = JSON.parse(
      $el("[data-selected-variant-json]", this).textContent
    )),
      (this.quickView = this.closest("quick-view"));
  }
  mountComponent() {
    this.setFirstMediaByVariant(), this.setListeners();
  }
  getFetchUrl(clickedInputEl) {
    const selectedOptionsIds = $list(OPTION_INPUTS_SELECTOR, this).map(
        (option) => this.getCheckedInput($list("input", option)).dataset.valueId
      ),
      params =
        selectedOptionsIds.length > 0
          ? `option_values=${selectedOptionsIds.join(",")}`
          : "";
    return `${
      (clickedInputEl == null ? void 0 : clickedInputEl.dataset.productUrl) ||
      this.dataset.url
    }${this.quickView ? "/gsc-quick-view" : ""}?section_id=${
      this.dataset.sectionIdWithoutPrefix
    }&${params}`;
  }
  swapProduct(url) {
    this.getForm().setDisable(!0),
      this.getForm().setLoading(!0),
      fetch(url)
        .then((response) => response.text())
        .then(this.updateDom);
  }
  updateElements(html, shouldSwapProduct) {
    const product = this.closest(".shopify-section");
    shouldSwapProduct &&
      $list(`[${PRODUCT_MEDIA_SELECTOR}]`, product).forEach((block) =>
        block.replaceWith($el(`[${PRODUCT_MEDIA_SELECTOR}]`, html))
      ),
      $list(`[${PRODUCT_BLOCK_SELECTOR}]`, product).forEach((block) => {
        block.replaceWith(
          $el(
            `[${PRODUCT_BLOCK_SELECTOR}='${block.getAttribute(
              PRODUCT_BLOCK_SELECTOR
            )}']`,
            html
          )
        );
      });
  }
  updateURL(html) {
    if (this.dataset.updateUrl === "false") return;
    const newUrl = html.dataset.url,
      newVariant = html.dataset.selectedVariant;
    window.history.replaceState(
      {},
      "",
      `${newUrl}${newVariant ? `?variant=${newVariant}` : ""}`

    );
    $el(`input[data-product-form-variant]`, document).value=newVariant
  }
  removeAnimationClass(el) {
    $list(".scroll-trigger", el).forEach((el2) => {
      el2.classList.remove("scroll-trigger");
    });
  }
  setListeners() {
    const dropdownLabels = $list("float-element", this)
        .map((dropdown) => $list("label", dropdown.element))
        .flat(1),
      simpleLabels = $list("label", this),
      labels = [...dropdownLabels, ...simpleLabels];
    this.addListener(this, "keydown", this.handleKeydown),
      labels.forEach((label) => {
        this.addListener(label, "keydown", this.handleLabelKeydown);
      }),
      this.addListener(this, "change", this.handleVariantChange);
  }
  async getDropdownElementBySelector(selector) {
    const dropdowns = $list("float-element", this);
    let elementBySelector;
    return (
      await whenDefined("float-element").then(() => {
        elementBySelector = $el(
          selector,
          dropdowns.find((dropdown) => $el(selector, dropdown.element)).element
        );
      }),
      elementBySelector
    );
  }
  setFirstMediaByVariant() {
    this.hasAttribute(SELECTED_VARIANT_IMAGE_SELECTOR) &&
      $list(
        `#product-media-${this.dataset.productId}-${this.dataset.section}`
      ).forEach((media) =>
        media.updateFirstMediaByVariant(
          this.getAttribute(SELECTED_VARIANT_IMAGE_SELECTOR)
        )
      );
  }
  getCheckedInput(inputs) {
    return inputs.find(({ checked }) => checked);
  }
  getForm() {
    return $el(
      `#product-form-component-${this.dataset.productId}-${this.dataset.section}`
    );
  }
}
const defaultCardsLimit = 50,
  defaultCardImgRatio = "portrait",
  defaultCardAlignment = "left",
  containerAttribute = "[recently-viewed-container]",
  localStorageSelector = "AuroraTheme-RecentlyViewed",
  cardTemplateSelector = "product-card-template",
  cardSelector = "product-card",
  cardInnerSelector = "[data-product-card-inner]";
class RecentlyViewed extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "cardLimit");
    __publicField(this, "cardImgRatio");
    __publicField(this, "cardAlignment");
    __publicField(this, "cardAlignmentClass");
    __publicField(this, "shapeClass");
    __publicField(this, "products");
    __publicField(this, "container");
    __publicField(this, "fetchItems", async () => {
      var _a;
      const { origin } = window.location,
        locale = window.Shopify.routes.root ?? "/",
        currentSavedProducts =
          (_a = JSON.parse(localStorage.getItem(localStorageSelector))) == null
            ? void 0
            : _a.slice(0, this.cardLimit);
      if (currentSavedProducts)
        try {
          for (const handle of currentSavedProducts) {
            const section = await fetch(
                `${origin}${locale}products/${handle}?sections=product-card-template`
              ).then((res) => res.json()),
              node = this.createNodeByString(section[cardTemplateSelector]);
            node && this.products.push(node);
          }
        } catch (error) {
          console.log(error);
        }
    });
    __publicField(this, "setItems", () => {
      this.container.replaceChildren(...this.products);
    });
    (this.cardLimit = +this.dataset.cardLimit),
      (this.cardImgRatio = this.dataset.imgRatio ?? defaultCardImgRatio),
      (this.cardAlignment = this.dataset.cardAlignment ?? defaultCardAlignment),
      (this.cardAlignmentClass = `product-card--${this.cardAlignment}-alignment`),
      (this.shapeClass = `shape--${this.cardImgRatio}`),
      (this.products = []),
      (this.container = $el(containerAttribute, this));
  }
  async mountComponent() {
    await this.fetchItems(),
      this.products.length > 0 && (this.setItems(), this.setVisible(!0));
  }
  setVisible(isVisible) {
    this.classList.toggle("hidden", !isVisible);
  }
  createNodeByString(productString) {
    var _a, _b, _c;
    const html = new DOMParser().parseFromString(productString, "text/html"),
      node = $el(`.${cardTemplateSelector}`, html);
    (_a = $el(cardSelector, node)) == null ||
      _a.classList.add(this.cardAlignmentClass),
      (_b = $el(cardInnerSelector, node)) == null ||
        _b.classList.add(this.shapeClass),
      this.shapeClass.includes("fit") &&
        ((_c = $el(cardInnerSelector, node)) == null ||
          _c.classList.add("shape--fit"));
    const productCard = node.querySelector("product-card");
    if (productCard) {
      const slide = document.createElement("div"),
        cardToAdd = productCard.cloneNode(!0);
      return (
        slide.classList.add("slider-grid__slide"),
        slide.setAttribute("slider-grid-slide", ""),
        slide.append(cardToAdd),
        slide
      );
    } else return null;
  }
  static updateProductsInLocalStorage(handle) {
    if (!handle) return;
    const currentSavedProducts =
        JSON.parse(localStorage.getItem(localStorageSelector)) ?? [],
      newProducts = (
        currentSavedProducts == null
          ? void 0
          : currentSavedProducts.find((item) => item === handle)
      )
        ? currentSavedProducts
        : [handle, ...currentSavedProducts].slice(0, defaultCardsLimit);
    localStorage.setItem(localStorageSelector, JSON.stringify(newProducts));
  }
}
const { Shopify: Shopify$2 } = window,
  SELECTOR_QUICK_VIEW_MEDIA_CAROUSEL = ".quick-view__media-carousel",
  SELECTOR_QUICK_VIEW_MEDIA = ".quick-view__media",
  SELECTOR_QUICK_PRODUCT_CONTENT = ".product__content",
  SELECTOR_VARIANT_PICKER = "variant-picker",
  SELECTOR_PRODUCT_INFO = ".product__info-wrapper",
  SELECTOR_QUICK_VIEW_SCROLL_CONTENT = "[data-quick-view-scroll-content]",
  ATTRIBUTE_TOP_SHADOW_VISIBLE = "top-shadow-visible",
  SELECTOR_DOTS = ".dynamic-dots",
  ATTRIBUTE_DOTS_CLASS = "data-dots-class",
  IS_TO_FILTER_MEDIA_SELECTOR = "data-product-media-filtering-option",
  MEDIA_MODAL_SELECTOR = "product-modal";
class QuickView extends SidebarComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "cache", {});
    __publicField(this, "rendered");
    __publicField(this, "scrollContent");
    __publicField(this, "productContent");
    __publicField(this, "mediaContent");
    __publicField(this, "dotsClass", this.getAttribute(ATTRIBUTE_DOTS_CLASS));
    __publicField(this, "resizeObserver");
    __publicField(
      this,
      "handleResize",
      throttle(() => {
        this.reInitCarousel();
      }, 200)
    );
    __publicField(
      this,
      "handleSectionSelect",
      async ({ detail: { sectionId } }) => {
        if (this.isSection && this.dataset.sectionId === sectionId) {
          const url = this.dataset.defaultProductUrl,
            id = this.dataset.defaultProductId;
          if (!url || !id) return;
          this.toggleOverlay(!0),
            this.requestProductFromUrl(url, id, !0),
            await this.openAndRenderProductByUrl(url);
        }
      }
    );
    __publicField(
      this,
      "handleSectionDeselect",
      ({ detail: { sectionId } }) => {
        this.isSection && this.dataset.sectionId === sectionId && this.hide();
      }
    );
    __publicField(this, "getFetchUrl", (url) => {
      const questionMarkIndex = url.indexOf("?");
      return questionMarkIndex !== -1
        ? url.slice(0, questionMarkIndex) +
            "/gsc-quick-view" +
            url.slice(questionMarkIndex)
        : url + "/gsc-quick-view";
    });
    __publicField(this, "fetchProduct", (fetchUrl) =>
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => parseHTML(responseText))
        .catch(() => console.log("error in quick view"))
    );
    __publicField(this, "openAndRenderProductByUrl", async (url) => {
      var _a;
      if (this.cache[url]) {
        const html = await this.cache[url];
        this.rendered && this.rendered.replaceChildren(),
          this.isOpen && (await this.hide()),
          this.setProductFromHTML(html),
          (_a = Shopify$2 == null ? void 0 : Shopify$2.PaymentButton) == null ||
            _a.init(),
          await this.open(),
          this.dataset.viewType == "drawer"
            ? this.reInitCarousel()
            : Promise.all(
                this.getAnimations({ subtree: !0 }).map(
                  (animation) => animation.finished
                )
              ).then(() => this.reInitCarousel());
      }
    });
    __publicField(this, "updateElements", (clonedTarget, html) => {
      const currentVariantPicker = $el(SELECTOR_VARIANT_PICKER, this.element),
        newVariantPicker = $el(SELECTOR_VARIANT_PICKER, clonedTarget);
      ((currentVariantPicker == null
        ? void 0
        : currentVariantPicker.dataset.url) !== newVariantPicker.dataset.url ||
        newVariantPicker.hasAttribute(IS_TO_FILTER_MEDIA_SELECTOR) ||
        this.hasAttribute(IS_TO_FILTER_MEDIA_SELECTOR)) &&
        ($el(SELECTOR_QUICK_VIEW_MEDIA, this.element).replaceWith(
          $el(SELECTOR_QUICK_VIEW_MEDIA, clonedTarget)
        ),
        $el(MEDIA_MODAL_SELECTOR, this.element).replaceWith(
          $el(MEDIA_MODAL_SELECTOR, clonedTarget)
        ),
        this.reInitCarousel()),
        $el(SELECTOR_PRODUCT_INFO, this.element).replaceWith(
          $el(SELECTOR_PRODUCT_INFO, clonedTarget)
        );
    });
  }
  mount() {
    super.mount(),
      (this.scrollContent = $el(
        SELECTOR_QUICK_VIEW_SCROLL_CONTENT,
        this.element
      )),
      (this.mediaContent = $el(SELECTOR_QUICK_VIEW_MEDIA, this.element)),
      (this.productContent = $el(SELECTOR_QUICK_PRODUCT_CONTENT, this.element)),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this.scrollContent);
  }
  unmount() {
    super.unmount(),
      this.resizeObserver.disconnect(),
      this.toggleAttribute(ATTRIBUTE_TOP_SHADOW_VISIBLE, !1);
  }
  requestProductFromUrl(url, id, disableCache = !1) {
    const fetchUrl = this.getFetchUrl(url);
    if (disableCache) {
      this.cache[url] = this.fetchProduct(fetchUrl);
      return;
    }
    this.cache[url] ||
      ((this.rendered = $el(
        `.shopify-section [data-quick-view-product-id="${id}"]`
      )),
      this.rendered && this.rendered.dataset.quickViewProductUrl === url
        ? (this.cache[url] = delay(0).then(() => this.rendered))
        : (this.cache[url] = this.fetchProduct(fetchUrl)));
  }
  setProductFromHTML(html) {
    if (!this.dataset.targetId) return;
    const target = $el(`#${this.dataset.targetId}`, html);
    if (!target) return;
    const targetClass = target.getAttribute("class") || "",
      clonedTarget = target.cloneNode(!0);
    this.element.setAttribute("class", targetClass);
    const dots = $el(SELECTOR_DOTS, clonedTarget);
    dots && this.dotsClass
      ? dots.setAttribute("class", this.dotsClass)
      : dots && dots.remove(),
      this.isOpen
        ? this.updateElements(clonedTarget, html)
        : this.element.replaceChildren(...clonedTarget.childNodes),
      RecentlyViewed.updateProductsInLocalStorage(target.dataset.productHandle);
  }
  reInitCarousel() {
    const mediaCarousel = this.querySelector(
      SELECTOR_QUICK_VIEW_MEDIA_CAROUSEL
    );
    this.dataset.viewType == "drawer"
      ? (mediaCarousel.setAttribute("data-axis", isMobile() ? "x" : "y"),
        mediaCarousel.reInit({
          axis: "y",
          breakpoints: {
            "(max-width: 768px)": { axis: "x", dragFree: !1 },
            "(min-width: 768px)": { axis: "y", dragFree: !0 },
          },
        }))
      : mediaCarousel.reInit({ axis: "x" });
    const variantPicker = $el(SELECTOR_VARIANT_PICKER, this);
    variantPicker == null || variantPicker.setFirstMediaByVariant();
  }
}
const RECIPIENT_FORM_CHECKBOX_SELECTOR = "[data-recipient-form-checkbox]",
  RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR =
    "[data-recipient-form-timezone-input]",
  RECIPIENT_FORM_INPUT_SELECTOR = "[data-recipient-form-input]",
  RECIPIENT_FORM_FIELDS_SELECTOR = "[data-recipient-form-fields]";
class RecipientForm extends BaseComponent {
  mountComponent() {
    this.addListener(this, "change", this.handleChange);
  }
  handleChange() {
    const checkbox = $el(RECIPIENT_FORM_CHECKBOX_SELECTOR, this);
    this.updateHeight(checkbox.checked),
      this.updateDisable(!checkbox.checked),
      checkbox.checked || this.clearInputs();
  }
  clearInputs() {
    $list(
      `${RECIPIENT_FORM_INPUT_SELECTOR}, ${RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR}`,
      this
    ).forEach((input) => {
      input.value = "";
    });
  }
  updateDisable(isDisabled) {
    $list(
      `${RECIPIENT_FORM_INPUT_SELECTOR}, ${RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR}`,
      this
    ).forEach((field) => {
      field.disabled = isDisabled;
    });
  }
  reset() {
    const checkbox = $el(RECIPIENT_FORM_CHECKBOX_SELECTOR, this);
    (checkbox.checked = !1), this.clearInputs();
  }
  updateHeight(isChecked) {
    const fields = $el(RECIPIENT_FORM_FIELDS_SELECTOR, this);
    fields &&
      (fields.style.maxHeight = `${isChecked ? fields.scrollHeight : 0}px`);
  }
  setTimezone() {
    const timezoneInput = $el(RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR, this);
    timezoneInput.value = String(new Date().getTimezoneOffset());
  }
}
class ProductRelatedBlock extends BaseComponent {
  mountComponent() {
    this.loadProducts();
  }
  loadProducts() {
    return (
      this.setAttribute("is-loading", ""),
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          this.updateByHTML(parseHTML(text)),
            this.removeAttribute("is-loading");
        })
        .catch(() => {
          console.log("Error in product recommendations component");
        })
    );
  }
  updateByHTML(html) {
    const recommendations = $el(`#${this.id}`, html);
    replaceNodeChildren(this, recommendations),
      this.toggleAttribute("is-ready", this.hasChildNodes());
  }
}
const ZOOM_TARGET_SELECTOR = "[data-zoom-cursor-target]";
class ZoomCursor extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "mutationObserver");
    __publicField(this, "handleMutations", (mutations) => {
      mutations.forEach((mutation) => {
        mutation.type === "attributes" &&
          this.setVisible(mutation.target.matches(ZOOM_TARGET_SELECTOR));
      });
    });
    __publicField(this, "handleMouseMove", (event) => {
      const target = event.target,
        isTarget = !!$elParent(ZOOM_TARGET_SELECTOR, target);
      isMobile() ||
        (this.setVisible(isTarget),
        this.isVisible &&
          (this.style.transform = `translate(calc(-50% + ${event.clientX}px), calc(-50% + ${event.clientY}px))`)),
        isTarget
          ? this.mutationObserver.observe(target, { attributes: !0 })
          : this.mutationObserver.disconnect();
    });
    this.mutationObserver = new MutationObserver(this.handleMutations);
  }
  mountComponent() {
    this.addListener(window, "mousemove", this.handleMouseMove);
  }
  unmountComponent() {
    this.mutationObserver.disconnect();
  }
  setVisible(isVisible) {
    this.classList.toggle("is-visible", isVisible),
      (document.body.style.cursor = isVisible ? "none" : "");
  }
  updateState(isZoomed) {
    this.toggleAttribute("zoomed", isZoomed);
  }
  get isVisible() {
    return this.classList.contains("is-visible");
  }
}
const ACTIVE_VALUE_SELECTOR = "[data-color-swatches-picker-active-value]",
  LABEL_SELECTOR = "[data-color-swatches-picker-label]";
class ColorSwatchesPicker extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleFormChange", () => {
      this.setSelected();
    });
    __publicField(this, "handleMouseEnter", (event) => {
      event.preventDefault();
      const target = event.target;
      this.setHovered(target.dataset.value);
    });
    __publicField(this, "handleMouseLeave", (event) => {
      event.preventDefault(), this.setSelected();
    });
  }
  mountComponent() {
    var _a;
    const labels = $list(LABEL_SELECTOR, this),
      form =
        (_a = $elParent("variant-picker", this)) == null
          ? void 0
          : _a.getForm();
    form && this.addListener(form, "change", this.handleFormChange),
      labels.forEach((label) => {
        this.addListener(label, "mouseenter", this.handleMouseEnter),
          this.addListener(label, "mouseleave", this.handleMouseLeave);
      });
  }
  setSelected() {
    const swatch = $el(`${LABEL_SELECTOR}.selected`, this);
    this.setHovered(
      (swatch == null ? void 0 : swatch.getAttribute("data-value")) || ""
    );
  }
  setHovered(value) {
    const label = $el(ACTIVE_VALUE_SELECTOR, this);
    label && (label.textContent = value);
  }
}
const TABS_COMPONENT_SELECTOR = "tabs-component",
  CAROUSEL_SELECTOR$3 = "carousel-component";
class ProductDetails extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "isMobile", isMobile());
    __publicField(this, "resizeObserver");
    __publicField(this, "activeTab");
    __publicField(this, "activeTabIndex");
    __publicField(this, "nextTargetTab");
    __publicField(this, "lastInnerTarget");
    __publicField(this, "handleTabSelect", ({ tabId, tab }) => {
      (this.activeTab = tab),
        (this.activeTabIndex = +tabId - 1),
        this.scrollToActiveTab();
      const targets = this.getInnerTargets();
      targets.length > 0 && this.setTabContentTargets(targets);
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        isMobile() !== this.isMobile && (this.isMobile = isMobile()),
          isMobile() && this.scrollToActiveTab();
      }, 100)
    );
    __publicField(this, "scrollToActiveTab", () => {
      const carousel = $el(CAROUSEL_SELECTOR$3, this);
      carousel == null || carousel.embla.scrollTo(this.activeTabIndex);
    });
    __publicField(this, "getInnerTargets", () =>
      $list(getFocusTargets(), this.activeTab)
    );
    __publicField(this, "setTabContentTargets", (targets) => {
      const tabs = $el(TABS_COMPONENT_SELECTOR, this)
        .getNames()
        .filter((tab) => tab.offsetWidth > 0);
      (this.nextTargetTab = tabs[this.activeTabIndex + 1] ?? null),
        (this.lastInnerTarget = targets[targets.length - 1]),
        this.addListener(
          this.lastInnerTarget,
          "blur",
          this.handleLastTargetBlur
        ),
        targets[0].focus();
    });
    __publicField(this, "handleLastTargetBlur", () => {
      this.nextTargetTab.focus(),
        this.removeListener(
          this.lastInnerTarget,
          "blur",
          this.handleLastTargetBlur
        ),
        (this.lastInnerTarget = null),
        (this.nextTargetTab = null);
    });
  }
  mountComponent() {
    const tabs = $el(TABS_COMPONENT_SELECTOR, this);
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this),
      whenDefined(TABS_COMPONENT_SELECTOR).then(() => {
        tabs == null || tabs.on("selectTab", this.handleTabSelect);
      });
  }
  unmountComponent() {
    const tabs = $el(TABS_COMPONENT_SELECTOR, this);
    whenDefined(TABS_COMPONENT_SELECTOR).then(() => {
      tabs == null || tabs.off("selectTab", this.handleTabSelect);
    }),
      this.resizeObserver.disconnect();
  }
}
const CART_DRAWER_SELECTOR$1 = "#CartDrawer",
  CART_PAGE_SELECTOR = "cart-page",
  CART_NOTIFICATION_POPUP_SELECTOR = "#CartNotificationPopup",
  FORM_SELECTOR$1 = "form",
  VARIANT_INPUT_SELECTOR = "[data-product-form-variant]",
  QUICK_VIEW = "#Quick-view",
  BODY_ELEMENT_SELECTOR$1 = "body-element";
class ProductForm extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "cartApi", new CartAPI());
    __publicField(this, "lastParsedState");
    __publicField(this, "handleFormSubmit", async (event) => {
      event.preventDefault();
      const config = this.getQueryConfig();
      this.setDisable(!0),
        this.setLoading(!0),
        await this.cartApi
          .add(config)
          .then(async (state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.description) {
              await this.getCartOnError(), this.showError(parsedState);
              return;
            }
            (this.lastParsedState = parsedState),
              this.updateCartItems(
                parseHTML(parsedState.sections[this.cartId])
              );
          })
          .catch((err) => console.log("Error in product form component", err))
          .finally(() => {
            this.setDisable(!1), this.setLoading(!1);
          });
    });
    __publicField(this, "getCartOnError", async () => {
      const [state, cart] = await Promise.all([
        this.cartApi.getCartState(),
        this.cartApi.getDrawer(),
      ]);
      (this.lastParsedState = state.items[0]),
        this.updateCartItems(parseHTML(cart));
    });
  }
  mountComponent() {
    const form = $el(FORM_SELECTOR$1, this);
    this.addListener(form, "submit", this.handleFormSubmit);
  }
  updateCartItems(html) {
    const cartDrawer = $el(CART_DRAWER_SELECTOR$1),
      cart = $el(CART_PAGE_SELECTOR),
      popup = $el(CART_NOTIFICATION_POPUP_SELECTOR);
    cart
      ? this.updateCart(html)
      : cartDrawer
      ? this.updateCartDrawer(html)
      : popup
      ? this.updatePopup(html)
      : this.updateCartCount(html);
  }
  updateCartCount(html) {
    const newCount = $el("#NewCartCount", html),
      currentCounts = $list("#CartCount");
    this.onUpdateCartItems(() => {
      currentCounts.forEach((currentCount) => {
        replaceNodeChildren(currentCount, newCount);
      });
    });
  }
  updateCart(html) {
    const cart = $el(CART_PAGE_SELECTOR);
    cart == null || cart.updateEmptyStatus(!1),
      this.onUpdateCartItems(() => {
        cart == null || cart.purchaseHandler(html, this.lastParsedState);
      });
  }
  updateCartDrawer(html) {
    const cartDrawer = $el(CART_DRAWER_SELECTOR$1);
    cartDrawer == null ||
      cartDrawer.updateAsideProductsByParsedState(this.lastParsedState),
      cartDrawer == null || cartDrawer.updateEmptyStatus(),
      this.onUpdateCartItems(() => {
        cartDrawer == null ||
          cartDrawer.purchaseHandler(html, this.lastParsedState);
      });
  }
  updatePopup(html) {
    this.onUpdateCartItems(() => {
      const popup = $el(CART_NOTIFICATION_POPUP_SELECTOR);
      popup == null || popup.purchaseHandler(html, this.lastParsedState);
    });
  }
  async onUpdateCartItems(callback) {
    const quickView = $el(QUICK_VIEW);
    quickView != null && quickView.isOpen
      ? quickView.hide().then(callback)
      : callback();
  }
  showError(parsedState) {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR$1),
      error =
        typeof parsedState.description == "object"
          ? this.getErrorFromObject(parsedState.description)
          : parsedState.description;
    bodyElement.showNotification(error, "warning");
  }
  getErrorFromObject(errorObject) {
    return Object.keys(errorObject)
      .map((key) => `${key}: ${errorObject[key]}`)
      .join(" , ");
  }
  getQueryConfig() {
    const form = $el(FORM_SELECTOR$1, this),
      config = fetchConfig("javascript"),
      formData = new FormData(form);
    return (
      (config.headers["X-Requested-With"] = "XMLHttpRequest"),
      delete config.headers["Content-Type"],
      formData.append("sections", [this.cartId]),
      formData.append("sections_url", window.location.pathname),
      (config.body = formData),
      config
    );
  }
  setLoading(isLoading) {
    $list('button[type="submit"]', this).forEach((button) =>
      button.classList.toggle("loading", isLoading)
    );
  }
  setDisable(isDisable) {
    $list('button[type="submit"]', this).forEach((button) =>
      button.toggleAttribute("disabled", isDisable)
    );
  }
  setButtonText(text) {
    $list('button[type="submit"]', this).forEach(
      (button) => (button.textContent = text)
    );
  }
  getVeriantInput() {
    const form = $el(FORM_SELECTOR$1, this);
    return $el(VARIANT_INPUT_SELECTOR, form);
  }
  get cartId() {
    const cartDrawer = $el(CART_DRAWER_SELECTOR$1),
      cart = $el(CART_PAGE_SELECTOR);
    return cartDrawer
      ? cartDrawer.dataset.sectionId
      : cart
      ? cart.dataset.sectionId
      : "cart-notification-popup-content";
  }
}
const FOOTER_SELECTOR$1 = ".shopify-section.shopify-section-footer",
  FORM_SELECTOR = "product-form";
class ProductFormButton extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleWindowScroll", () => {
      const form = $elParent(FORM_SELECTOR, this);
      if (!form) return;
      const footer = $el(FOOTER_SELECTOR$1),
        point = form.offsetTop + form.offsetHeight,
        footerOffsetTop = footer ? footer.offsetTop : 0,
        isVisible =
          window.innerHeight + window.scrollY < footerOffsetTop &&
          window.scrollY > point;
      this.classList.toggle("is-visible", isVisible),
        document.body.toggleAttribute(
          "is-product-form-button-fixed",
          isVisible
        );
    });
  }
  mountComponent() {
    this.addListener(window, "scroll", this.handleWindowScroll);
  }
}
const VIEWPORT_SELECTOR = "[data-product-information-drawer-viewport]";
class ProductInformationDrawer extends SidebarComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleViewportScroll", () => {
      const viewport = $el(VIEWPORT_SELECTOR, this.element);
      viewport &&
        this.toggleAttribute("header-shadow-visible", viewport.scrollTop > 0);
    });
  }
  mountComponent() {
    super.mountComponent();
    const viewport = $el(VIEWPORT_SELECTOR, this.element);
    this.addListener(viewport, "scroll", this.handleViewportScroll);
  }
  unmountComponent() {
    super.unmountComponent();
    const viewport = $el(VIEWPORT_SELECTOR, this.element);
    this.removeListener(viewport, "scroll", this.handleViewportScroll);
  }
}
const scrollOptions = (jump) => ({
  behavior: jump ? "auto" : "smooth",
  block: "nearest",
});
class ProductMedia extends BaseComponent {
  mountComponent() {
    this.setReady();
  }
  updateFirstMediaByVariant(imageId, jump = !1) {
    isNotThemeStore() &&
      imageId &&
      ($el(`[data-media-id="${imageId}"]`, this) ?? this).scrollIntoView(
        scrollOptions(jump)
      );
  }
  setReady() {
    this.setAttribute("ready", "");
  }
}
const CAROUSEL_SELECTOR$2 = "[data-product-media-carousel-component]";
class ProductMediaCarousel extends BaseComponent {
  mountComponent() {
    this.setReady();
  }
  updateFirstMediaByVariant(imageId, jump = !1) {
    const carousel = $el(CAROUSEL_SELECTOR$2, this);
    if (imageId && carousel) {
      const slideIndex = carousel.embla
        .slideNodes()
        .findIndex((slide) =>
          slide.dataset.mediaId ? +slide.dataset.mediaId == +imageId : !1
        );
      if (
        this.closest(".quick-view--drawer .quick-view--two-columns") &&
        !isMobile()
      ) {
        const index = slideIndex % 2 === 0 ? slideIndex : slideIndex - 1;
        carousel.embla.scrollTo(index, jump);
      } else carousel.embla.scrollTo(slideIndex, jump);
    }
  }
  setReady() {
    this.setAttribute("ready", "");
  }
}
const INTERSECTION_OBSERVER_OPTIONS$1 = {
  root: null,
  rootMargin: "0px 0px 200px 0px",
};
class ProductRecommendations extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "observer");
    __publicField(this, "onIntersecting", (entries, observer) => {
      entries[0].isIntersecting && (observer.unobserve(this), this.update());
    });
    __publicField(this, "update", () => {
      const url = this.dataset.url;
      url &&
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            this.updateByHTML(parseHTML(text));
          })
          .catch(() => {
            console.log("Error in product recommendations component");
          });
    });
  }
  mountComponent() {
    (this.observer = new IntersectionObserver(
      this.onIntersecting,
      INTERSECTION_OBSERVER_OPTIONS$1
    )),
      this.observer.observe(this);
  }
  unmountComponent() {
    var _a;
    (_a = this.observer) == null || _a.unobserve(this);
  }
  updateByHTML(html) {
    const recommendations = $el(
      `product-recommendations[id="${this.id}"]`,
      html
    );
    replaceNodeChildren(this, recommendations);
  }
}
class ProductModalImageWrap extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "image");
    __publicField(this, "modal");
    __publicField(this, "carousel");
    __publicField(this, "preloader");
    __publicField(this, "currentSettedScale");
    __publicField(this, "isDragging");
    __publicField(this, "offsetX");
    __publicField(this, "offsetY");
    __publicField(this, "startDragPoint");
    __publicField(this, "maxScale");
    __publicField(this, "minScale");
    __publicField(this, "isTapped");
    __publicField(this, "tapTimeout");
    __publicField(this, "lastGesture");
    __publicField(this, "zoomTimeoutId");
    __publicField(this, "isTappedTimeout");
    __publicField(this, "isDoubleTapped");
    __publicField(this, "firstMove");
    __publicField(this, "fingers");
    __publicField(this, "startMoveTouches");
    __publicField(this, "lastDistanceBetweenTouches");
    __publicField(this, "dragStartPointY");
    __publicField(this, "dragStartPointX");
    __publicField(this, "isPinchScaling");
    __publicField(this, "index");
    __publicField(this, "boundingClientRectCahed");
    __publicField(this, "handleImageLoad", () => {
      this.setPreloaderVisible(!1);
    });
    __publicField(this, "handleModalHide", () => {
      this.reset();
    });
    __publicField(this, "handleCarouselSelect", () => {
      this.reset();
    });
    __publicField(this, "handleTouchStart", (event) => {
      event.preventDefault(),
        this.carousel.embla.selectedScrollSnap() === this.index &&
          ((this.boundingClientRectCahed = this.modal.getBoundingClientRect()),
          (this.fingers = event.touches.length),
          (this.firstMove = !0),
          this.detectDoubleTap(event));
    });
    __publicField(this, "handleTouchMove", (event) => {
      if ((event.preventDefault(), !this.isDoubleTapped)) {
        if (this.firstMove)
          this.updateGesture(event),
            (this.startMoveTouches = event.touches.length);
        else if (this.lastGesture)
          switch (this.lastGesture) {
            case "zoom":
              this.startMoveTouches === 2 &&
                event.touches.length === 2 &&
                this.pinch(event);
              break;
            case "drag":
              if (this.startMoveTouches === 1 && event.touches.length === 1) {
                const { clientX, clientY } = event.targetTouches[0],
                  { x, y } = this.boundingClientRectCahed;
                this.drag(clientX - x, clientY - y);
              }
              break;
          }
        else this.setGesture("none", event);
        this.firstMove = !1;
      }
    });
    __publicField(this, "handleTouchEnd", (event) => {
      event.preventDefault(),
        (this.fingers = event.touches.length),
        this.updateGesture(event);
    });
    __publicField(this, "handleMouseDown", (event) => {
      event.preventDefault(),
        (this.boundingClientRectCahed = this.modal.getBoundingClientRect());
      const { x, y } = this.boundingClientRectCahed;
      this.startDrag(event.clientX - x, event.clientY - y),
        this.setDragging(!0);
    });
    __publicField(this, "handleMouseUp", (event) => {
      this.setDragging(!1);
      const time = this.modal.isZoomed ? 75 : 0,
        { x, y } = this.boundingClientRectCahed;
      this.zoomTimeoutId = setTimeout(() => {
        this.touchZoom(event.clientX - x, event.clientY - y);
      }, time);
    });
    __publicField(this, "handleMouseMove", (event) => {
      if (
        (event.preventDefault(),
        clearTimeout(this.zoomTimeoutId),
        this.isDragging && this.modal.isZoomed)
      ) {
        const { clientX, clientY } = event,
          { x, y } = this.boundingClientRectCahed;
        this.drag(clientX - x, clientY - y);
      }
    });
    (this.image = $el("img", this)),
      (this.modal = $elParent("product-modal", this)),
      (this.preloader = $el("[data-product-modal-image-preloader]", this)),
      (this.currentSettedScale = 1),
      (this.isDragging = !1),
      (this.offsetX = 0),
      (this.offsetY = 0),
      (this.startDragPoint = { x: 0, y: 0 }),
      (this.maxScale = 3),
      (this.minScale = 1),
      (this.isTapped = !1),
      (this.tapTimeout = 300),
      (this.lastGesture = null),
      this.setZoomCursorVisible(!0);
  }
  mountComponent() {
    var _a;
    (this.carousel = this.modal.carousel),
      this.addListener(this.image, "mousedown", this.handleMouseDown),
      this.addListener(this.image, "mouseup", this.handleMouseUp),
      this.addListener(this.image, "mousemove", this.handleMouseMove),
      this.addListener(this.image, "touchstart", this.handleTouchStart),
      this.addListener(this.image, "touchend", this.handleTouchEnd),
      this.addListener(this.image, "touchmove", this.handleTouchMove),
      this.addListener(this.image, "load", this.handleImageLoad),
      whenDefined("product-modal").then(() => {
        this.modal.on("hide", this.handleModalHide),
          (this.index =
            this.modal.mediaIndexMap[
              this.closest(".carousel__slide").dataset.mediaId
            ]);
      }),
      (_a = this.carousel) == null ||
        _a.embla.on("select", this.handleCarouselSelect);
  }
  unmountComponent() {
    var _a, _b;
    (_a = this.modal) == null || _a.off("hide", this.handleModalHide),
      (_b = this.carousel) == null ||
        _b.embla.off("select", this.handleCarouselSelect),
      clearTimeout(this.zoomTimeoutId),
      clearTimeout(this.isTappedTimeout);
  }
  detectDoubleTap(event) {
    if (this.isTappedTimeout && this.fingers === 1) {
      clearTimeout(this.isTappedTimeout),
        (this.isTappedTimeout = null),
        (this.isDoubleTapped = !0);
      const { x, y } = this.modal.getBoundingClientRect();
      switch (
        (this.touchZoom(
          event.changedTouches[0].clientX - x,
          event.changedTouches[0].clientY - y
        ),
        this.lastGesture)
      ) {
        case "zoom":
          this.setPinchScaling(!1);
          break;
        case "drag":
          this.setDragging(!1);
          break;
      }
    } else
      this.isTappedTimeout = setTimeout(() => {
        (this.isTappedTimeout = null), (this.isDoubleTapped = !1);
      }, this.tapTimeout);
  }
  updateGesture(event) {
    this.fingers === 2
      ? this.setGesture("zoom", event)
      : this.fingers === 1
      ? this.setGesture("drag", event)
      : this.setGesture("none", event);
  }
  setGesture(newGesture, event) {
    if (this.lastGesture !== newGesture) {
      if (this.lastGesture && !newGesture)
        switch (this.lastGesture) {
          case "zoom":
            this.setPinchScaling(!1);
            break;
          case "drag":
            this.setDragging(!1);
            break;
        }
      switch (newGesture) {
        case "zoom":
          this.setPinchScaling(!0);
          break;
        case "drag":
          const { x, y } = this.modal.getBoundingClientRect();
          this.startDrag(
            event.changedTouches[0].clientX - x,
            event.changedTouches[0].clientY - y
          ),
            this.setDragging(!0);
          break;
        case "none":
          this.setDragging(!1), this.setPinchScaling(!1);
          break;
      }
    }
    this.lastGesture = newGesture;
  }
  pinch(event) {
    const distanceBetweenTouches = this.getDistanceBetweenTouches(event),
      isZoomIn = distanceBetweenTouches > this.lastDistanceBetweenTouches,
      factor = isZoomIn ? 0.125 : -0.125,
      newScale = this.getNewScale(this.currentScale + factor),
      midPoint = this.getTouchCenter(event),
      xs = (midPoint.x - this.offsetX) / this.currentScale,
      ys = (midPoint.y - this.offsetY) / this.currentScale;
    if (
      ((this.lastDistanceBetweenTouches = distanceBetweenTouches),
      !isZoomIn && newScale === 1)
    ) {
      this.reset();
      return;
    }
    this.setTransform({
      scale: newScale,
      offsetX: midPoint.x - xs * newScale,
      offsetY: midPoint.y - ys * newScale,
    });
  }
  getDistanceBetweenTouches(event) {
    return Math.hypot(
      event.touches[0].pageX - event.touches[1].pageX,
      event.touches[0].pageY - event.touches[1].pageY
    );
  }
  startDrag(clientX, clientY) {
    (this.startDragPoint = {
      x: clientX - this.offsetX,
      y: clientY - this.offsetY,
    }),
      (this.dragStartPointX = clientX),
      (this.dragStartPointY = clientY);
  }
  drag(clientX, clientY) {
    const isRightDrag = this.dragStartPointX > clientX,
      isBottomDrag = this.dragStartPointY > clientY,
      newScale = this.getNewScale(this.currentScale);
    let newOffsetX = clientX - this.startDragPoint.x,
      newOffsetY = clientY - this.startDragPoint.y;
    const isIntersectBounds = this.getIntersectBounds({
      isRightDrag,
      isBottomDrag,
    });
    (isIntersectBounds.right || isIntersectBounds.left) &&
      (newOffsetX = this.offsetX),
      (isIntersectBounds.bottom || isIntersectBounds.top) &&
        (newOffsetY = this.offsetY),
      this.setTransform({
        scale: newScale,
        offsetX: newOffsetX,
        offsetY: newOffsetY,
      });
  }
  getIntersectBounds({ isRightDrag, isBottomDrag }) {
    const imageRect = this.image.getBoundingClientRect(),
      delta = 8,
      deltaX = isRightDrag ? -1 * delta : delta,
      deltaY = isBottomDrag ? -1 * delta : delta,
      right = isRightDrag && imageRect.right + deltaX < window.innerWidth,
      left = !isRightDrag && imageRect.left + deltaX > 0,
      bottom = isBottomDrag && imageRect.bottom + deltaY < window.innerHeight,
      top = !isBottomDrag && imageRect.top + deltaY > 0;
    return { right, left, bottom, top };
  }
  getTouchCenter(event) {
    const sum = (a, b) => a + b,
      touches = [...event.touches],
      touchCount = touches.length;
    return {
      x: touches.map((touch) => touch.pageX).reduce(sum) / touchCount,
      y: touches.map((touch) => touch.pageY).reduce(sum) / touchCount,
    };
  }
  setTransform({ offsetX, offsetY, scale }) {
    (this.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) scale3d(${scale}, ${scale}, 1)`),
      (this.offsetX = offsetX),
      (this.offsetY = offsetY),
      (this.currentScale = scale);
  }
  touchZoom(clientX, clientY) {
    const xs = (clientX - this.offsetX) / this.currentScale,
      ys = (clientY - this.offsetY) / this.currentScale;
    let newScale, newOffsetX, newOffsetY;
    this.modal.isZoomed
      ? ((newScale = this.getNewScale(1)), (newOffsetX = 0), (newOffsetY = 0))
      : ((newScale = this.getNewScale(3)),
        (newOffsetX = clientX - xs * newScale),
        (newOffsetY = clientY - ys * newScale)),
      (this.style.cursor = this.modal.isZoomed ? "" : "grab"),
      this.setZoomCursorVisible(this.modal.isZoomed),
      this.setTransform({
        scale: newScale,
        offsetX: newOffsetX,
        offsetY: newOffsetY,
      });
  }
  reset() {
    this.setTransform({ scale: 1, offsetX: 0, offsetY: 0 });
  }
  getNewScale(newScale) {
    return Math.max(this.minScale, Math.min(this.maxScale, newScale));
  }
  setPinchScaling(isPinchScaling) {
    this.toggleAttribute("is-pinch-scaling", isPinchScaling),
      (this.isPinchScaling = isPinchScaling);
  }
  setDragging(isDragging) {
    this.toggleAttribute("is-dragging", isDragging),
      (this.isDragging = isDragging);
  }
  setZoomCursorVisible(isVisible) {
    var _a;
    (_a = this.image) == null ||
      _a.toggleAttribute("data-zoom-cursor-target", isVisible);
  }
  setModalZoom(isZoomed) {
    (this.modal.isZoomed = isZoomed),
      this.modal.isZoomed && (this.modal.zoomedImage = this),
      this.modal.updateModal();
  }
  setPreloaderVisible(isVisible) {
    var _a;
    this.preloader.classList.toggle("hidden", !isVisible),
      (_a = this.image) == null || _a.toggleAttribute("is-loaded", !isVisible);
  }
  set currentScale(value) {
    this.currentSettedScale !== value &&
      (this.setModalZoom(value > 1), (this.currentSettedScale = value));
  }
  get currentScale() {
    return this.currentSettedScale;
  }
}
const { Shopify: Shopify$1 } = window,
  POSTER_SELECTOR = '[id^="Deferred-Poster-"]';
class ProductModel extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "modelViewerUI");
    __publicField(this, "handlePosterClick", () => {
      this.loadContent();
    });
    __publicField(this, "handleCarouselSelect", () => {
      this.carousel && this.setCarouselDraggable(!0);
    });
  }
  mountComponent() {
    var _a;
    const poster = $el(POSTER_SELECTOR, this);
    this.addListener(poster, "click", this.handlePosterClick),
      (_a = this.carousel) == null ||
        _a.embla.on("settle", this.handleCarouselSelect);
  }
  unmountComponent() {
    var _a;
    (_a = this.carousel) == null ||
      _a.embla.off("settle", this.handleCarouselSelect);
  }
  loadContent() {
    this.getAttribute("loaded") ||
      (this.addModel(),
      this.setAttribute("loaded", "true"),
      this.carousel && this.setCarouselDraggable(!1)),
      Shopify$1.loadFeatures(
        [
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ],
        () => {}
      );
  }
  addModel() {
    const template = $el("template", this);
    if (!template || !template.content) return;
    const templateContent = template.content,
      content = document.createElement("div");
    content.appendChild(templateContent.firstElementChild.cloneNode(!0));
    const modelViewer = $el("model-viewer", content);
    this.appendChild(modelViewer);
  }
  setupModelViewerUI(errors) {
    errors ||
      (this.modelViewerUI = new Shopify$1.ModelViewerUI(
        $el("model-viewer", this)
      ));
  }
  setCarouselDraggable(isDraggable) {
    const modelViewer = $el(".shopify-model-viewer-ui", this);
    (this.carousel.dataset.draggable = isDraggable ? "true" : "false"),
      this.carousel.reInit({ watchDrag: isDraggable }),
      isDraggable &&
        modelViewer &&
        (modelViewer.remove(), this.removeAttribute("loaded"));
  }
  get carousel() {
    return $elParent("carousel-component", this);
  }
}
window.ProductModel = {
  loadShopifyXR() {
    Shopify$1.loadFeatures(
      [
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ],
      () => {}
    );
  },
  setupShopifyXR(errors) {
    if (!errors) {
      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", () =>
          this.setupShopifyXR()
        );
        return;
      }
      $list('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent)),
          modelJSON.remove();
      }),
        window.ShopifyXR.setupXRElements();
    }
  },
};
window.addEventListener("DOMContentLoaded", () => {
  Shopify$1.designMode &&
    $list("[data-shopify-xr-hidden]").forEach((element) =>
      element.classList.add("hidden")
    ),
    window.ProductModel && window.ProductModel.loadShopifyXR();
});
const CONTAINER_SELECTOR = "[data-scrolling-text-container]",
  LINE_SELECTOR = "scrolling-text-line",
  CROSSED_LAYOUT_SELECTOR = ".block-wrapper--crossed";
class ScrollingText extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "isCrossed");
    __publicField(this, "isInitialMobile");
    __publicField(this, "heightPercent");
    __publicField(this, "width");
    __publicField(this, "calcHeight", () => {
      const lines = $list(LINE_SELECTOR, this);
      let heightToSet;
      const firstLineRect = lines[0].getBoundingClientRect();
      if (lines.length > 1) {
        const coordsTop = [],
          coordsBottom = [],
          lastLineRect = lines[lines.length - 1].getBoundingClientRect();
        coordsTop.push(firstLineRect.top),
          coordsTop.push(lastLineRect.top),
          coordsBottom.push(firstLineRect.bottom),
          coordsBottom.push(lastLineRect.bottom),
          (heightToSet =
            coordsBottom.sort((a, b) => b - a)[0] -
            coordsTop.sort((a, b) => a - b)[0]);
      } else heightToSet = firstLineRect.height;
      return (this.heightPercent = heightToSet / this.offsetWidth), heightToSet;
    });
    __publicField(this, "setHeight", (value) => {
      this.style.setProperty(
        "--gsc-section-height",
        `${value ?? this.calcHeight()}px`
      );
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        if (this.width !== this.offsetWidth) {
          if (this.isCrossed) {
            const h = isMobile()
              ? this.heightPercent * this.offsetWidth +
                (this.isInitialMobile ? 0 : 30)
              : this.heightPercent * this.offsetWidth -
                (this.isInitialMobile ? 80 : 0);
            this.setHeight(h);
          } else this.setHeight();
          this.width = this.offsetWidth;
        }
      }, 200)
    );
  }
  mountComponent() {
    const container = $el(CONTAINER_SELECTOR, this);
    (this.width = this.offsetWidth),
      (this.isInitialMobile = isMobile()),
      (this.isCrossed = !!$el(CROSSED_LAYOUT_SELECTOR, this)),
      this.setHeight(),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(container);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
}
const ANNOUNCEMENT_SELECTOR = "[data-scrolling-text-line]",
  LINE_LINK_SELECTOR = "[data-scrolling-text-anchor]",
  ANIMATION_CLASS = "scrolling-text--animated",
  FONT_MIXED_ATTRIBUTE = "with-font-mixed",
  FONT_OUTLINE_CLASS = "scrolling-text__text--font-outline";
class ScrollingTextLine extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "announcement");
    __publicField(this, "initialScreenWidth", 0);
    __publicField(this, "isWithFontMixed");
    __publicField(this, "screenSizeMultiply", 2);
    __publicField(this, "resizeObserver");
    __publicField(this, "getDimentions", () => {
      const announcement = $el(ANNOUNCEMENT_SELECTOR, this);
      if (!announcement) return;
      const screenWidth = document.body.clientWidth,
        announcementWidth = announcement.clientWidth;
      return (
        (this.initialScreenWidth = screenWidth),
        { screenWidth, announcementWidth }
      );
    });
    __publicField(
      this,
      "calcQuantityToRender",
      (screenWidth, announcementWidth) => {
        const blocksToRender = Math.ceil(
          (screenWidth * this.screenSizeMultiply) / announcementWidth
        );
        return blocksToRender % 2 === 0 ? blocksToRender : blocksToRender + 1;
      }
    );
    __publicField(this, "renderNodes", (blocksNumberToRender) => {
      this.announcement ||
        (this.announcement = $el(ANNOUNCEMENT_SELECTOR, this).cloneNode(!0));
      const announcement = this.announcement.cloneNode(!0),
        link = $el(LINE_LINK_SELECTOR, this);
      if (!announcement) return;
      const nodes = this.isWithFontMixed
        ? this.getFragmentWithMixedFont(blocksNumberToRender, announcement)
        : this.getFragment(blocksNumberToRender, announcement);
      link && nodes.appendChild(link), this.replaceChildren(nodes);
    });
    __publicField(this, "getFragment", (blocksNumberToRender, announcement) => {
      const fragment = document.createDocumentFragment(),
        announcements = [];
      for (let i = 0; i < blocksNumberToRender; i++) {
        const clonedAnnouncement = announcement.cloneNode(!0);
        let newClass = ANIMATION_CLASS;
        this.isWithFontMixed &&
          i % 2 === 0 &&
          (newClass += ` ${FONT_OUTLINE_CLASS}`),
          clonedAnnouncement.classList.add(newClass),
          announcements.push(clonedAnnouncement);
      }
      return fragment.replaceChildren(...announcements), fragment;
    });
    __publicField(
      this,
      "getFragmentWithMixedFont",
      (blocksNumberToRender, announcement) => {
        const fragment = document.createDocumentFragment(),
          announcements = [];
        for (let i = 0; i < blocksNumberToRender - 1; i++) {
          const clonedAnnouncement1 = announcement.cloneNode(!0),
            clonedAnnouncement2 = announcement.cloneNode(!0),
            div = document.createElement("div");
          clonedAnnouncement1.classList.add(FONT_OUTLINE_CLASS),
            div.replaceChildren(clonedAnnouncement1, clonedAnnouncement2),
            div.classList.add(ANIMATION_CLASS),
            announcements.push(div);
        }
        return fragment.replaceChildren(...announcements), fragment;
      }
    );
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        document.body.clientWidth > this.initialScreenWidth && this.render(),
          this.setAttribute("data-is-rendered", "true");
      }, 100)
    );
    __publicField(this, "render", () => {
      const { screenWidth, announcementWidth } = this.getDimentions(),
        blocksNumberToRender = this.calcQuantityToRender(
          screenWidth,
          announcementWidth
        );
      this.renderNodes(blocksNumberToRender);
    });
    this.isWithFontMixed = this.hasAttribute(FONT_MIXED_ATTRIBUTE);
  }
  mountComponent() {
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(document.body);
  }
  unmountComponent() {
    this.resizeObserver.disconnect();
  }
}
const SEARCH_INPUT_SELECTOR = "[data-sidebar-search-input]",
  CONTENT_SELECTOR = "[data-sidebar-search-content]",
  CONTENT_RESULTS_SELECTOR$1 = "[data-sidebar-search-content-results]";
class SearchSidebar extends SidebarComponent {
  constructor() {
    super();
    __publicField(this, "searchInput");
    __publicField(this, "resizeObserver");
    __publicField(this, "isInputFocused");
    __publicField(this, "defaultStateElement");
    __publicField(this, "handleClick", (event) => {
      const target = event.target,
        isInput = target === this.searchInput,
        queryElement = $elParent("[data-sidebar-search-query]", target);
      if (this.searchInput && queryElement) {
        const event2 = new Event("input", { bubbles: !0 });
        (this.searchInput.value = `${queryElement.getAttribute(
          "data-sidebar-search-query"
        )}`),
          this.searchInput.dispatchEvent(event2),
          this.searchInput.focus();
      }
      isMobile() && isInput && (this.isInputFocused = !0),
        !isInput && this.isInputFocused && (this.isInputFocused = !1);
    });
    __publicField(this, "handleInputFocus", () => {
      isMobile() && (this.isInputFocused = !0);
    });
    __publicField(this, "handleSearchSidebarTouchEnd", (event) => {
      const target = event.target,
        distanceX = Math.abs(this.touchStartX - this.touchEndX),
        distanceY = Math.abs(this.touchStartY - this.touchEndY),
        isOverThreshold = distanceX > 12 || distanceY > 12;
      this.isInputFocused &&
        isOverThreshold &&
        this.searchInput &&
        (target.tagName === "A" && event.preventDefault(),
        this.searchInput.blur(),
        (this.isInputFocused = !1)),
        this.cleanTouchPoints();
    });
    __publicField(this, "handleContentResultsResize", () => {
      this.toggleAttribute("footer-shadow-visible", this.isContentOverlow());
    });
    __publicField(this, "handleContentScroll", () => {
      const content = $el(CONTENT_SELECTOR, this.element);
      content &&
        this.toggleAttribute(
          "header-shadow-visible",
          this.isContentOverlow() && content.scrollTop > 0
        );
    });
    (this.searchInput = $el(SEARCH_INPUT_SELECTOR, this.element)),
      (this.defaultStateElement = this.element.cloneNode(!0));
  }
  mountComponent() {
    super.mountComponent();
    const content = $el(CONTENT_SELECTOR, this.element),
      contentResults = $el(CONTENT_RESULTS_SELECTOR$1, this.element);
    contentResults &&
      ((this.resizeObserver = new ResizeObserver(
        this.handleContentResultsResize
      )),
      this.resizeObserver.observe(contentResults)),
      this.addListener(content, "scroll", this.handleContentScroll),
      this.addListener(this, "click", this.handleClick),
      this.addListener(this, "touchend", this.handleSearchSidebarTouchEnd),
      this.addListener(this.searchInput, "focus", this.handleInputFocus);
  }
  unmountComponent() {
    this.resizeObserver.disconnect(), super.unmountComponent();
  }
  async open(event) {
    await super.open(event),
      this.searchInput && !this.isEditor && this.searchInput.focus();
  }
  isContentOverlow() {
    const content = $el(CONTENT_SELECTOR, this.element),
      contentResults = $el(CONTENT_RESULTS_SELECTOR$1, this.element);
    return !contentResults || !content
      ? !1
      : contentResults.offsetHeight > content.offsetHeight;
  }
}
const SEARCH_FIELD_SELECTOR = "[data-sidebar-search-input-component]",
  CONTENT_RESULTS_SELECTOR = "[data-sidebar-search-content-results]",
  FOOTER_SELECTOR = "[data-sidebar-search-footer]",
  ITEM_SELECTOR = "[data-sidebar-search-item]",
  SEARCH_SIDEBAR_SELECTOR = "#SearchSidebar";
class SearchSidebarFormWrapper extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "predictiveSearchAPI", new PredictiveSearchAPI());
    __publicField(
      this,
      "handleInputChange",
      debounce(() => {
        this.searchQuery ? this.renderResults() : this.resetResults();
      }, 500)
    );
  }
  mountComponent() {
    this.addListener(this, "input", this.handleInputChange);
  }
  renderResults() {
    this.renderFromUrl(this.searchQuery);
  }
  resetResults() {
    const sidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this);
    sidebar && this.updateResultsFromHTML(sidebar.defaultStateElement);
  }
  renderFromUrl(queryKey) {
    const sidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this),
      sectionId =
        (sidebar == null ? void 0 : sidebar.dataset.sectionId) ||
        "search-sidebar",
      limitParam = "resources[limit]=999",
      sectionParam = `section_id=${sectionId}` || "",
      fieldsParam =
        sidebar != null && sidebar.hasAttribute("enable-extended-search")
          ? "resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor"
          : "resources[options][fields]=title,product_type,variants.title,vendor";
    this.predictiveSearchAPI
      .get({ searchQuery: queryKey, limitParam, sectionParam, fieldsParam })
      .then((text) => {
        this.updateResultsFromHTML(parseHTML(text).body);
      })
      .catch(() => {
        console.log("Error in search component");
      });
  }
  updateResultsFromHTML(html) {
    const newSidebar = $el(SEARCH_SIDEBAR_SELECTOR, html);
    let element;
    if (newSidebar) {
      const template = $el(
        '[data-sidebar-template="SearchSidebar"]',
        newSidebar
      );
      element = getTemplateFirstChild(template);
    } else element = html;
    const sidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this),
      newResults = $el(CONTENT_RESULTS_SELECTOR, element),
      results = $el(
        CONTENT_RESULTS_SELECTOR,
        sidebar == null ? void 0 : sidebar.element
      );
    replaceNodeChildren(results, newResults), this.updateFooterVisible();
  }
  updateFooterVisible() {
    const sidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this);
    if (sidebar) {
      const footer = $el(FOOTER_SELECTOR, sidebar.element);
      if (footer) {
        const renderedItems = $list(ITEM_SELECTOR, sidebar.element);
        footer.classList.toggle("hidden", renderedItems.length === 0);
      }
    }
  }
  get searchQuery() {
    const sidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this),
      searchField = $el(SEARCH_FIELD_SELECTOR, sidebar);
    return searchField ? searchField.value.trim() : "";
  }
}
const BANNER_POSTER_SELECTOR = "[data-video-banner-poster]";
class VideoBanner extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "isControlsEnabled");
    __publicField(this, "isAutoplayEnabled");
    __publicField(this, "hasMobileVideo");
    __publicField(this, "handleClick", (event) => {
      const video = $elParent("video", event.target),
        poster = $elParent(BANNER_POSTER_SELECTOR, event.target);
      if (video) {
        const video2 = event.target;
        !this.isControlsEnabled &&
          video2 &&
          (video2.paused ? video2.play() : video2.pause());
      }
      poster && this.loadContent();
    });
    __publicField(this, "removePoster", (isMobileVideo) => {
      const poster = $el(BANNER_POSTER_SELECTOR, this);
      poster &&
        (this.hasMobileVideo
          ? poster.classList.add(
              `${isMobileVideo ? "mobile-hide" : "desktop-hide"}`
            )
          : poster.remove());
    });
    (this.isControlsEnabled = this.hasAttribute("data-enable-controls")),
      (this.isAutoplayEnabled = this.hasAttribute("data-enable-autoplay"));
  }
  mountComponent() {
    (this.hasMobileVideo = this.hasAttribute("data-has-mobile-video")),
      this.isAutoplayEnabled && this.loadContent(),
      this.addListener(this, "click", this.handleClick);
  }
  loadContent() {
    this.addVideo(), this.setAttribute("loaded", "true");
  }
  removeVideo() {
    const video = $el("video,  iframe", this);
    video && (video.remove(), this.removeAttribute("loaded"));
  }
  addVideo() {
    const isMobileVideo = isMobile(),
      videoEl = this.getVideo(isMobileVideo);
    if (!videoEl) return;
    const content = document.createElement("div"),
      container = $el("[data-video-banner-container]", this),
      firstChild = videoEl.cloneNode(!0);
    this.removePoster(isMobileVideo), content.appendChild(firstChild);
    const video = $el("video, iframe", content);
    video &&
      (container.appendChild(video), video.tagName === "VIDEO" && video.play());
  }
  getVideo(isMobileVideo) {
    const template = $el(
      `[data-video-banner-media-template-${
        this.hasMobileVideo && isMobileVideo ? "mobile" : "desktop"
      }]`,
      this
    );
    return template == null
      ? void 0
      : template.content.firstElementChild.cloneNode(!0);
  }
}
class ImageSlider extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "withRotateImages");
    __publicField(this, "withVerticalScrollText");
    __publicField(this, "withVerticalScrollImage");
    __publicField(this, "carousel");
    __publicField(this, "images");
    __publicField(this, "captions");
    __publicField(this, "dots");
    __publicField(this, "length");
    __publicField(this, "imagesLength");
    __publicField(this, "captionsLength");
    __publicField(this, "activeIndex");
    __publicField(this, "imagesContainer");
    __publicField(this, "captionHeight");
    __publicField(this, "touchStartX");
    __publicField(this, "intersectionObserver");
    __publicField(this, "resizeObserver");
    __publicField(this, "isMobile");
    __publicField(this, "windowClientHeight");
    __publicField(this, "scrollTriggerTop");
    __publicField(this, "scrollTriggerBottom");
    __publicField(this, "scrollDirection");
    __publicField(this, "lastScroll");
    __publicField(this, "autoplayCarousel");
    __publicField(this, "isAutoplayPlaying");
    __publicField(this, "requestFrameId");
    __publicField(this, "handleCarouselSelect", (data) => {
      const newIndex = data.selectedScrollSnap();
      this.activeIndex = newIndex;
    });
    __publicField(this, "handleVerticalImageFocusout", (event) => {
      const focusTarget = event.relatedTarget;
      if (this.contains(focusTarget)) {
        const blockId = focusTarget
            .closest("[data-image-slider-caption]")
            .getAttribute("data-image-slider-caption"),
          imageSlider = $el(`[data-image-slider-image="${blockId}"]`);
        imageSlider &&
          isNotThemeStore() &&
          imageSlider.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
    __publicField(this, "handleVerticalScroll", (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const inViewIndex = Number(
            entry.target.parentElement.getAttribute("data-image-slider-caption")
          );
          if (inViewIndex === this.activeIndex) return;
          if (this.imagesLength === 1) {
            this.activeIndex = inViewIndex;
            return;
          }
          if (this.withRotateImages) {
            const direction = inViewIndex > this.activeIndex ? "next" : "prev";
            this.changeSlides(direction, inViewIndex);
          } else
            this.images.forEach((img, index) => {
              index === inViewIndex
                ? (img.setAttribute("visible", ""),
                  img.removeAttribute("prev"),
                  img.removeAttribute("next"))
                : index < inViewIndex
                ? (img.setAttribute("prev", ""),
                  img.removeAttribute("visible"),
                  img.removeAttribute("next"))
                : index > inViewIndex &&
                  (img.setAttribute("next", ""),
                  img.removeAttribute("visible"),
                  img.removeAttribute("prev"));
            });
          this.activeIndex = inViewIndex;
        }
      });
    });
    __publicField(this, "setObserversForVerticalScroll", () => {
      const { topToSet, imagesHeight } = this.setContainerTop();
      (this.scrollTriggerTop = topToSet),
        (this.scrollTriggerBottom =
          this.windowClientHeight - this.scrollTriggerTop - imagesHeight),
        (this.intersectionObserver = new IntersectionObserver(
          this.handleVerticalScroll,
          { rootMargin: `0px 0px -${this.scrollTriggerBottom + 30}px 0px` }
        )),
        this.captions.forEach((caption) => {
          (caption.style.minHeight = `${this.captionHeight}px`),
            caption.firstElementChild &&
              this.intersectionObserver.observe(caption.firstElementChild);
        }),
        this.imagesLength === 1 &&
          this.images.forEach((img, index) => {
            img.firstElementChild.tagName !== "svg"
              ? (img.setAttribute("visible", ""),
                img.removeAttribute("prev"),
                img.removeAttribute("next"))
              : (img.removeAttribute("next"),
                img.removeAttribute("visible"),
                img.removeAttribute("prev"),
                (img.style.opacity = "0"));
          }),
        (this.resizeObserver = new ResizeObserver(
          this.handleResizeVerticalScroll
        )),
        this.resizeObserver.observe(this),
        this.setObserveScroll();
    });
    __publicField(this, "setContainerTop", () => {
      let imagesHeight = this.imagesContainer.getBoundingClientRect().height;
      (this.windowClientHeight = document.documentElement.clientHeight),
        imagesHeight > this.windowClientHeight &&
          (this.images.forEach((image) => {
            image.style.maxHeight = `${this.windowClientHeight - 30}px`;
          }),
          (imagesHeight = this.imagesContainer.getBoundingClientRect().height));
      const topToSet = (this.windowClientHeight - imagesHeight) / 2;
      return (
        (this.imagesContainer.style.top = `${topToSet}px`),
        { topToSet, imagesHeight }
      );
    });
    __publicField(this, "setObserveScroll", () => {
      (this.lastScroll = 0),
        window.addEventListener("scroll", this.handleChangeOpacity);
    });
    __publicField(this, "handleChangeOpacity", () => {
      const scrollTop = document.documentElement.scrollTop,
        scrollDirection = this.lastScroll > scrollTop ? "up" : "down";
      (this.lastScroll = scrollTop),
        this.captions.forEach((caption, index) => {
          const bottom =
              caption.lastElementChild.getBoundingClientRect().bottom,
            top = caption.firstElementChild.getBoundingClientRect().top;
          if (
            bottom < 0 ||
            top > this.windowClientHeight ||
            (index === this.captions.length - 1 &&
              this.windowClientHeight - bottom > this.scrollTriggerBottom &&
              scrollDirection === "down")
          ) {
            caption.setAttribute("dont-set-opacity", ""),
              (caption.style.opacity = "1");
            return;
          }
          const captionHeight = bottom - top,
            persentToTop = (bottom - this.scrollTriggerTop) / captionHeight,
            persentToBottom =
              (this.windowClientHeight - top - this.scrollTriggerBottom) /
              captionHeight;
          caption.hasAttribute("dont-set-opacity") ||
            (caption.style.opacity =
              top < this.scrollTriggerTop
                ? `${persentToTop}`
                : `${persentToBottom}`);
          const bottomLimit =
            caption.getBoundingClientRect().height <
            this.imagesContainer.getBoundingClientRect().height
              ? this.scrollTriggerBottom
              : this.scrollTriggerBottom -
                (caption.getBoundingClientRect().height -
                  this.imagesContainer.getBoundingClientRect().height +
                  20);
          caption.hasAttribute("dont-set-opacity") &&
            this.windowClientHeight - bottom > bottomLimit &&
            top > this.scrollTriggerTop &&
            caption.removeAttribute("dont-set-opacity");
        });
    });
    __publicField(this, "handleVerticalScrollImage", (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const inViewIndex = Number(
            entry.target.getAttribute("data-image-slider-image")
          );
          if (inViewIndex === this.activeIndex) return;
          this.images[inViewIndex].setAttribute("visible", ""),
            this.images[this.activeIndex].removeAttribute("visible"),
            this.captionsLength > 1 &&
              (this.captions[inViewIndex].setAttribute("visible", ""),
              this.captions[this.activeIndex].removeAttribute("visible")),
            (this.activeIndex = inViewIndex);
        }
      });
    });
    __publicField(this, "setObserversForVerticalScrollImage", () => {
      const windowHeight = document.documentElement.clientHeight;
      this.intersectionObserver = new IntersectionObserver(
        this.handleVerticalScrollImage,
        { rootMargin: "-40% 0% -50% 0%" }
      );
      let captionMaxHeight = 0;
      this.captions.forEach((caption, index) => {
        const top = caption.firstElementChild.getBoundingClientRect().top,
          height =
            caption.lastElementChild.getBoundingClientRect().bottom - top;
        captionMaxHeight < height && (captionMaxHeight = height),
          height < this.images[index].getBoundingClientRect().height &&
            (caption.style.height =
              this.images[index].getBoundingClientRect().height + "px");
      }),
        this.images.find(
          (image) => image.getBoundingClientRect().height < captionMaxHeight
        ) &&
          (this.imagesContainer.style.gap =
            (captionMaxHeight - this.images[0].getBoundingClientRect().height) *
              2 +
            "px");
      const captionsParent = this.captions[0].parentElement;
      if (captionMaxHeight < windowHeight) {
        const parentHeight = captionsParent.getBoundingClientRect().height,
          topToSet = (windowHeight - parentHeight) / 2;
        captionsParent.style.top = `${topToSet}px`;
      } else captionsParent.style.top = "0px";
      this.images.forEach((image) => {
        this.intersectionObserver.observe(image);
      }),
        this.captionsLength === 1 &&
          this.captions[0].setAttribute("visible", "");
    });
    __publicField(this, "handleDotsClick", ({ target }) => {
      const index = +target
        .closest("[data-dot-index]")
        .getAttribute("data-dot-index");
      if (index === this.activeIndex) return;
      let direction = index > this.activeIndex ? "next" : "prev";
      this.activeIndex === 0 && index === this.length && (direction = "prev"),
        index - this.activeIndex > 1 && (direction = "prev"),
        this.activeIndex === this.length && index === 0 && (direction = "next"),
        this.changeSlides(direction, index);
    });
    __publicField(this, "changeNoRotateSlides", (direction, newIndex) => {
      this.carousel.embla.scrollTo(newIndex), (this.activeIndex = newIndex);
    });
    __publicField(this, "changeSlides", (direction, newIndex) => {
      const currentCaption = this.captions[this.activeIndex];
      currentCaption.addEventListener(
        "transitionend",
        this.animationCaptionEnd
      ),
        currentCaption.removeAttribute("visible");
      const imageToAnimate =
        direction === "next"
          ? this.images[this.activeIndex]
          : this.images[newIndex];
      imageToAnimate.addEventListener("animationend", this.animationImageEnd),
        direction === "next"
          ? imageToAnimate.setAttribute("animating-forward", "")
          : imageToAnimate.setAttribute("animating-backward", ""),
        (this.activeIndex = newIndex),
        this.dots.updateDots(newIndex);
    });
    __publicField(this, "animationCaptionEnd", (event) => {
      const element = event.currentTarget;
      this.captions[this.activeIndex].setAttribute("visible", ""),
        element.removeEventListener("transitionend", this.animationCaptionEnd);
    });
    __publicField(this, "animationImageEnd", (event) => {
      const element = event.currentTarget;
      element.removeAttribute("animating-forward"),
        element.removeAttribute("animating-backward"),
        element.removeEventListener("animationend", this.animationImageEnd),
        this.stackImages();
    });
    __publicField(this, "stackImages", () => {
      this.images.forEach((img, index) => {
        index === this.activeIndex
          ? (img.style.zIndex = String(0))
          : index > this.activeIndex
          ? (img.style.zIndex = String(this.activeIndex - index))
          : index < this.activeIndex &&
            (img.style.zIndex = String(-this.length - index + 1));
      });
    });
    __publicField(this, "stackImagesForVerticalScroll", () => {
      this.images.forEach((img, index) => {
        img.style.zIndex = this.withRotateImages ? `-${index}` : `${index}`;
      });
    });
    __publicField(
      this,
      "handleResizeVerticalScroll",
      debounce(() => {
        this.setContainerTop(),
          (this.captionHeight = this.images[0].offsetHeight),
          this.captions.forEach((caption) => {
            caption.style.minHeight = `${this.captionHeight}px`;
          });
      }, 300)
    );
    __publicField(this, "rotateImages", () => {
      if (this.withVerticalScrollImage)
        this.images.forEach((img, index) => {
          img.style.transform =
            index % 2 === 0 ? `rotate(${1.7}deg)` : `rotate(-${1.7}deg)`;
        });
      else {
        let prevMinus = 0,
          prevPlus = 0;
        this.images.forEach((img, index) => {
          if ((index + 1) % 3 === 0) {
            const deg = prevMinus + 2.5;
            (img.style.transform = `rotate(${deg}deg)`), (prevMinus = deg);
          } else {
            const deg = prevPlus - 1.5;
            (img.style.transform = `rotate(${deg}deg)`), (prevPlus = deg);
          }
        });
      }
    });
    __publicField(this, "getSelectedScrollSnap", () => {
      var _a;
      return (
        ((_a = this.carousel) == null
          ? void 0
          : _a.embla.selectedScrollSnap()) ?? this.activeIndex
      );
    });
    __publicField(this, "setComponentVisible", () => {
      this.setAttribute("visible", "");
    });
    __publicField(
      this,
      "handleDragStart",
      (event) => (event.preventDefault(), !1)
    );
    __publicField(this, "handleTouchStart", (event) => {
      (this.touchStartX = event.clientX ?? event.touches[0].clientX),
        this.isAutoplayPlaying && this.stopAutoplay();
    });
    __publicField(this, "handleTouchEnd", (event) => {
      var _a;
      if (this.touchStartX === 0) return;
      const currentX = event.clientX ?? event.changedTouches[0].clientX,
        swipeLeft = currentX - this.touchStartX < -20,
        swipeRight = currentX - this.touchStartX > 20;
      swipeLeft && this.activeIndex !== this.length && this.handleSwipe("next"),
        swipeRight && this.activeIndex !== 0 && this.handleSwipe("prev"),
        (_a = this.carousel) != null && _a.isPlay && this.carousel.stop(),
        (this.touchStartX = 0);
    });
    __publicField(this, "handleSwipe", (direction) => {
      let newIndex;
      direction === "next"
        ? (newIndex =
            this.activeIndex === this.length ? 0 : this.activeIndex + 1)
        : (newIndex =
            this.activeIndex - 1 < 0 ? this.length : this.activeIndex - 1),
        this.withRotateImages || this.changeNoRotateSlides(direction, newIndex),
        this.withRotateImages && this.changeSlides(direction, newIndex);
    });
    __publicField(this, "stopAutoplay", () => {
      cancelAnimationFrame(this.requestFrameId), (this.isAutoplayPlaying = !1);
    });
    __publicField(this, "startAutoplay", async () => {
      const interval =
        +this.autoplayCarousel.getAttribute("data-autoplay-interval") * 1e3;
      let last;
      const tick = (timestamp) => {
        last || (last = timestamp),
          timestamp - last > interval &&
            (this.handleSwipe("next"), (last = timestamp)),
          (this.requestFrameId = requestAnimationFrame(tick));
      };
      (this.requestFrameId = requestAnimationFrame(tick)),
        (this.isAutoplayPlaying = !0);
    });
    (this.withRotateImages = this.hasAttribute("with-rotate-images")),
      (this.withVerticalScrollText = this.hasAttribute("with-vertical-scroll")),
      (this.withVerticalScrollImage = this.hasAttribute(
        "with-vertical-scroll-image"
      )),
      (this.autoplayCarousel = $el("[data-autoplay-with-rotate]", this)),
      (this.carousel = $el("carousel-component", this)),
      this.withRotateImages &&
        ((this.images = $list("[data-image-slider-image]", this)),
        (this.captions = $list("[data-image-slider-caption]", this)),
        (this.dots = $el("carousel-dynamic-dots", this)),
        (this.length = this.images.length - 1),
        (this.activeIndex = 0)),
      this.withRotateImages ||
        ((this.images = $list("[data-image-slider-image]", this)),
        (this.captions = $list(".image-slider__slide", this)),
        (this.activeIndex = 0),
        (this.length = this.images.length - 1)),
      (this.withVerticalScrollText || this.withVerticalScrollImage) &&
        ((this.imagesContainer = this.querySelector(
          "[data-carousel-viewport]"
        )),
        (this.images = $list("[data-image-slider-image]", this)),
        (this.captions = $list("[data-image-slider-caption]", this)),
        (this.captionHeight = this.images[0].offsetHeight),
        (this.imagesLength = this.images.filter(
          (img) => img.firstElementChild.tagName !== "svg"
        ).length),
        (this.captionsLength = this.captions.length),
        (this.activeIndex = 0)),
      this.autoplayCarousel && this.startAutoplay();
  }
  mountComponent() {
    var _a, _b, _c;
    this.withRotateImages &&
      (this.withVerticalScrollText || this.stackImages(),
      (_a = this.dots) == null ||
        _a.addEventListener("click", this.handleDotsClick),
      this.rotateImages()),
      this.setAttribute("draggable", "true"),
      this.addEventListener("dragstart", this.handleDragStart),
      this.addEventListener("mousedown", this.handleTouchStart),
      this.addEventListener("touchstart", this.handleTouchStart),
      this.addEventListener("mouseup", this.handleTouchEnd),
      this.addEventListener("touchend", this.handleTouchEnd),
      this.withVerticalScrollText &&
        this.captions.length > 0 &&
        (this.stackImagesForVerticalScroll(),
        this.setObserversForVerticalScroll()),
      this.withVerticalScrollImage &&
        this.captions.length > 0 &&
        (this.setObserversForVerticalScrollImage(),
        this.addListener(this, "focusout", this.handleVerticalImageFocusout)),
      (_c = (_b = this.carousel) == null ? void 0 : _b.embla) == null ||
        _c.on("select", this.handleCarouselSelect),
      this.setComponentVisible();
  }
  unmountComponent() {
    var _a, _b, _c;
    this.withRotateImages &&
      ((_a = this.dots) == null ||
        _a.removeEventListener("click", this.handleDotsClick)),
      this.removeEventListener("dragstart", this.handleTouchStart),
      this.removeEventListener("mousedown", this.handleTouchStart),
      this.removeEventListener("touchstart", this.handleTouchStart),
      this.removeEventListener("mouseup", this.handleTouchEnd),
      this.removeEventListener("touchend", this.handleTouchEnd),
      this.withVerticalScrollText &&
        (this.intersectionObserver.disconnect(),
        this.resizeObserver.disconnect()),
      (_c = (_b = this.carousel) == null ? void 0 : _b.embla) == null ||
        _c.off("select", this.handleCarouselSelect),
      window.removeEventListener("scroll", this.handleChangeOpacity);
  }
}
class TimelineComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        var _a;
        const markers = $el("[data-timeline-markers]", this),
          width =
            this.offsetLeft +
            (((_a = markers.lastElementChild) == null
              ? void 0
              : _a.offsetLeft) ?? 0);
        markers.setAttribute(
          "style",
          `--gsc-timeline-markers-width: ${width}px`
        );
      }, 200)
    );
  }
  mountComponent() {
    (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this);
  }
}
const OVERLAY_SELECTOR = "body-element";
class CloseCursor extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "overlaySelector");
    __publicField(this, "isInited");
    __publicField(this, "overlay");
    __publicField(this, "handleMouseMove", (event) => {
      this.toggleVisibility(event);
    });
    __publicField(this, "toggleVisibility", (event) => {
      const target = event.target;
      this.checkIsOnOverlay(target) ? this.setVisible(event) : this.setHidden();
    });
    __publicField(this, "setInitialVisibility", (clickEvent) => {
      const { clientY, clientX } = clickEvent,
        target = document.elementFromPoint(clientX, clientY);
      this.checkIsOnOverlay(target) && this.setVisible(clickEvent);
    });
    __publicField(this, "init", (clickEvent) => {
      window.addEventListener("mousemove", this.handleMouseMove),
        clickEvent != null &&
          clickEvent.clientX &&
          this.setInitialVisibility(clickEvent),
        (this.isInited = !0);
    });
    (this.isInited = !1), (this.overlay = $el(OVERLAY_SELECTOR));
  }
  setVisible(event) {
    this.setAttribute("visible", "");
    const { clientY: top, clientX: left } = event;
    this.style.transform = `translate(calc(-50% + ${left}px), calc(-50% + ${top}px))`;
  }
  setHidden() {
    this.removeAttribute("visible");
  }
  toggle(clickEvent) {
    !isMobile() &&
      this.overlay.isVisible &&
      (this.isInited ? this.deInit() : this.init(clickEvent));
  }
  deInit() {
    window.removeEventListener("mousemove", this.handleMouseMove),
      this.setHidden(),
      (this.isInited = !1);
  }
  checkIsOnOverlay(target) {
    return target === this.overlay;
  }
}
class QuoteComponent extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "sidebarButtonSelector");
    __publicField(this, "quoteLinkAttribute");
    __publicField(this, "quoteProductLinkAttribute");
    __publicField(this, "quoteLinkTemplateAttribute");
    __publicField(this, "targetAttribute");
    __publicField(this, "quoteWithProductClass");
    __publicField(this, "quoteLink");
    __publicField(this, "quoteProductLink");
    __publicField(this, "quoteLinkTemplate");
    __publicField(this, "sidebarButton");
    __publicField(this, "target");
    __publicField(this, "setLinks", () => {
      var _a;
      const targetHeight = this.target.offsetHeight;
      if (!(this.target.firstElementChild.offsetHeight > targetHeight)) {
        if (this.quoteLink) this.quoteLink.href = this.quoteProductLink.href;
        else {
          const clone = getTemplateFirstChild(this.quoteLinkTemplate);
          (clone.href =
            (_a = this.quoteProductLink) == null ? void 0 : _a.href),
            this.appendChild(clone);
        }
        this.sidebarButton && this.sidebarButton.destroyListeners(),
          this.classList.add(this.quoteWithProductClass);
      }
    });
    (this.sidebarButtonSelector = "sidebar-button"),
      (this.quoteLinkAttribute = "[data-quote-link]"),
      (this.quoteProductLinkAttribute = "[data-quote-product-link]"),
      (this.quoteLinkTemplateAttribute = "[data-quote-link-template]"),
      (this.targetAttribute = "[data-quote-line-clamp-target]"),
      (this.quoteWithProductClass = "quote--with-product-link"),
      (this.quoteLink = this.querySelector(this.quoteLinkAttribute)),
      (this.quoteProductLink = this.querySelector(
        this.quoteProductLinkAttribute
      )),
      (this.quoteLinkTemplate = this.querySelector(
        this.quoteLinkTemplateAttribute
      )),
      (this.sidebarButton = this.closest(this.sidebarButtonSelector)),
      (this.target = this.querySelector(this.targetAttribute));
  }
  connectedCallback() {
    this.quoteProductLink && this.target && this.setLinks();
  }
}
class TestimonialsComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "resizeObserver");
    __publicField(this, "blockId");
    __publicField(this, "gridElements");
    __publicField(this, "carousels");
    __publicField(this, "handleSectionLoad", () => {
      this.blockId && this.scrollToSelectedBlock();
    });
    __publicField(
      this,
      "handleBlockSelect",
      ({ detail: { sectionId, blockId, load } }) => {
        this.dataset.sectionId === sectionId &&
          ((this.blockId = blockId), this.scrollToSelectedBlock());
      }
    );
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        this.blockId && this.scrollToSelectedBlock();
      }, 100)
    );
    __publicField(this, "scrollToSelectedBlock", () => {
      (!isMobile() && this.dataset.desktopLayout.includes("grid")) ||
      (isMobile() && this.dataset.mobileLayout.includes("column"))
        ? this.scrollGrid()
        : this.scrollCarousel();
    });
    __publicField(this, "scrollCarousel", () => {
      const carousel = $list("carousel-component", this).filter(
          (carousel2) => carousel2.offsetWidth > 0
        )[0],
        dots = $el("carousel-dots", carousel),
        slideIndex = carousel.embla.slideNodes().findIndex(({ attributes }) => {
          var _a;
          return (
            ((_a = attributes["block-id"]) == null ? void 0 : _a.value) ===
            this.blockId
          );
        }),
        scrollToIndex =
          slideIndex % +this.dataset.desktopColumns === 0
            ? Math.floor(slideIndex / +this.dataset.desktopColumns)
            : Math.floor((slideIndex - 1) / +this.dataset.desktopColumns);
      scrollToIndex !== -1 &&
        (carousel.embla.scrollTo(isMobile() ? slideIndex : scrollToIndex, !1),
        carousel.stop(),
        dots == null || dots.handleCarouselSelect());
    });
    __publicField(this, "scrollGrid", () => {
      const block = this.gridElements
        .filter((el) => el.offsetWidth > 0)
        .find(({ attributes }) => {
          var _a;
          return (
            ((_a = attributes["block-id"]) == null ? void 0 : _a.value) ===
            this.blockId
          );
        });
      isNotThemeStore() &&
        (block == null ||
          block.scrollIntoView({ block: "center", behavior: "smooth" }));
    });
  }
  mountComponent() {
    this.isEditor &&
      ((this.gridElements = $list("quote-component", this)),
      (this.carousels = $list("carousel-component", this)),
      this.carousels.forEach((carousel) => {
        carousel.editor.destroy(),
          (carousel.handleBlockSelect = this.handleBlockSelect);
      }),
      this.editor.on("BLOCK_SELECT", this.handleBlockSelect),
      this.editor.on("SECTION_LOAD", this.handleSectionLoad),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this),
      this.blockId && this.scrollToSelectedBlock());
  }
}
const INTERSECTION_OBSERVER_OPTIONS = {
  root: null,
  rootMargin: "0px 0px 200px 0px",
};
class LazyVideo extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "intersectionObserver");
    __publicField(this, "handleWindowLoad", () => {
      (this.intersectionObserver = new IntersectionObserver(
        this.handleIntersectionObserve,
        INTERSECTION_OBSERVER_OPTIONS
      )),
        this.intersectionObserver.observe(this);
    });
    __publicField(this, "handleIntersectionObserve", (entries) => {
      entries[0].isIntersecting &&
        (this.intersectionObserver.unobserve(this),
        this.intersectionObserver.disconnect(),
        this.initVideo());
    });
    __publicField(this, "initVideo", () => {
      const parentNode = this.parentNode,
        withAutoplay = this.hasAttribute("with-autoplay");
      if (!parentNode) return;
      const video = this.querySelector("video");
      video.load();
      const handleTouch = () => {
          video.paused && withAutoplay && (video.load(), video.play()),
            this.removeListener(window, "touchstart", handleTouch);
        },
        handleCanPlay = () => {
          parentNode.replaceChild(video, this),
            withAutoplay && video.play(),
            this.removeListener(video, "canplaythrough", handleCanPlay);
        };
      this.addListener(video, "canplaythrough", handleCanPlay),
        this.addListener(window, "touchstart", handleTouch);
    });
  }
  mountComponent() {
    document.readyState === "complete"
      ? this.handleWindowLoad()
      : this.addListener(window, "load", this.handleWindowLoad);
  }
  unmountComponent() {
    var _a;
    this.removeListener(window, "load", this.handleWindowLoad),
      (_a = this.intersectionObserver) == null || _a.disconnect();
  }
}
class HeaderFloatElementBtn extends FloatElementBtn {
  constructor() {
    super();
    __publicField(this, "floatElementContainerId");
    __publicField(this, "floatElementId");
    __publicField(this, "isFocused");
    __publicField(this, "isTouched");
    __publicField(this, "handleTouchend", (event) => {
      this.isOpen ||
        (this.addListener(document, "touchend", this.handleWindowClick),
        $list('[data-aria-expanded="true"]').forEach((btn) => {
          btn !== this && btn.floatElement.hide();
        })),
        this.isTouched ||
          (event.preventDefault(),
          this.header.handleButtonHover(this),
          this.setExpand(!0),
          (this.isTouched = !0));
    });
    __publicField(this, "handleWindowClick", ({ target }) => {
      if (target.closest(".header__dropdown-menu")) return;
      const isButton = target.closest("header-float-element-btn");
      isButton !== this && (this.isTouched = !1),
        isButton ||
          (this.header.handleMouseLeave(),
          this.setExpand(!1),
          this.removeListener(document, "touchend", this.handleWindowClick),
          (this.isTouched = !1));
    });
    __publicField(this, "handleMouseLeave", (event) => {
      event.stopPropagation();
    });
    __publicField(this, "handleMouseEnter", (event) => {
      event.stopPropagation();
    });
    __publicField(this, "handleKeyDown", (event) => {
      if (isTabKey(event) && !event.shiftKey) {
        if (
          (event.preventDefault(),
          this.emit("focused", { button: this }),
          !this.isOpen)
        ) {
          this.closest("header-component").handleButtonHover(this),
            this.setExpand(!0);
          return;
        }
        const { targets, lastTarget } = getTargets(
            this.floatElement.currentVisible,
            !1
          ),
          firstTarget = targets.find((el) => !el.hasAttribute("disabled"));
        firstTarget &&
          !this.isFocused &&
          (this.addListener(lastTarget, "blur", this.handleLastTargetBlur),
          firstTarget.focus(),
          (this.isFocused = !0));
      }
    });
    __publicField(this, "handleLastTargetBlur", ({ currentTarget }) => {
      var _a;
      const header = this.closest("header-component");
      header.handleMouseLeave();
      let nextToFocus;
      this.hasAttribute("data-is-last-menu-item")
        ? (nextToFocus = getTargets(
            header.navContainer.nextElementSibling
          ).firstTarget)
        : (nextToFocus =
            (_a = this.nextElementSibling) != null && _a.hasAttribute("href")
              ? this.nextElementSibling
              : this.nextElementSibling.firstElementChild),
        nextToFocus == null || nextToFocus.focus(),
        this.setExpand(!1),
        (this.isFocused = !1),
        this.removeListener(currentTarget, "blur", this.handleLastTargetBlur);
    });
    __publicField(this, "handleBlur", () => {
      this.emit("blured", { button: this });
    });
    __publicField(this, "trigger", () => {});
    (this.floatElementContainerId = this.dataset.floatElementId),
      (this.element = this.firstElementChild),
      (this.floatElementId = this.element.dataset.headerFloatElementTrigger),
      this.addListener(this.element, "touchend", this.handleTouchend);
  }
  setExpand(isExpanded) {
    this.setAttribute("data-aria-expanded", isExpanded);
  }
  get isOpen() {
    return this.dataset.ariaExpanded === "true";
  }
  get header() {
    return this.closest("header-component");
  }
}
const BODY_ELEMENT_SELECTOR = "body-element";
class HeaderFloatElement extends FloatElement {
  constructor() {
    super();
    __publicField(this, "currentVisible");
    __publicField(this, "mounted");
    __publicField(this, "handleMouseLeave", () => {
      this.isOpen || (this.hide(), this.toggleVideos(!1));
    });
    __publicField(this, "handleButtonHover", ({ floatElementId }) => {
      this.toggleElementVisible(floatElementId),
        this.show(),
        this.toggleVideos(!0);
    });
    __publicField(this, "toggleVideos", (isToPlay) => {
      $list("video", this).forEach((video) => {
        isToPlay ? video.play() : video.pause();
      });
    });
    __publicField(this, "toggleElementVisible", (floatElementId) => {
      this.currentVisible &&
        (this.currentVisible.removeAttribute("visible"),
        this.currentVisible.setAttribute("inert", ""));
      const visible = (this.mounted ? this : this.element).querySelector(
        `[data-header-float-element-template=${floatElementId}]`
      );
      visible.removeAttribute("inert"),
        visible.setAttribute("visible", ""),
        (this.currentVisible = visible),
        this.emit("dropDownVisible", { el: this.currentVisible });
    });
    __publicField(this, "handleDropdownKeyDown", (event) => {
      isEscKey(event) && event.preventDefault();
    });
    __publicField(this, "setBtnExpand", (isVisible) => {});
    __publicField(
      this,
      "handleBlockSelect",
      debounce(({ detail: { blockId, sectionId } }) => {
        if (this.dataset.sectionId === sectionId) {
          if (
            !this.header.navContainer ||
            this.header.navContainer.hasAttribute("hidden")
          )
            return;
          const target = this.getTargetWhenBlockChange(blockId);
          if (!target) {
            this.header.handleMouseLeave();
            return;
          }
          const floatElementId = target.getAttribute(
              "data-header-float-element-template"
            ),
            targetButton = $list("[data-header-btn-with-backdrop]").find(
              (btn) =>
                btn.floatElementId
                  ? btn.floatElementId === floatElementId
                  : btn.firstElementChild.getAttribute(
                      "data-float-element-trigger"
                    ) === floatElementId
            );
          (this.header.blockInEditorSelected = !0),
            this.header.handleButtonHover(targetButton),
            this.addListener(document, "click", this.handleOutsideClick);
        }
      }, 50)
    );
    __publicField(
      this,
      "handleBlockDeselect",
      debounce(({ detail: { blockId, sectionId } }) => {
        if (this.dataset.sectionId === sectionId) {
          if (
            !this.header.navContainer ||
            this.header.navContainer.hasAttribute("hidden")
          )
            return;
          this.getTargetWhenBlockChange(blockId) === this.currentVisible &&
            ((this.header.blockInEditorSelected = !1),
            this.header.handleMouseLeave(),
            this.removeListener(document, "click", this.handleOutsideClick));
        }
      }, 100)
    );
    __publicField(this, "getTargetWhenBlockChange", (blockId) => {
      const parent = this.mounted ? this : this.element;
      return $el(`[block-id="${blockId}"]`, parent);
    });
    __publicField(this, "handleOutsideClick", ({ clientY, clientX }) => {
      const target = document.elementFromPoint(clientX, clientY),
        bodyElement = $el(BODY_ELEMENT_SELECTOR);
      target === bodyElement &&
        ((this.header.blockInEditorSelected = !1),
        this.header.handleMouseLeave(),
        this.removeListener(document, "click", this.handleOutsideClick));
    });
    const templates = $list("template", this),
      fragment = document.createDocumentFragment();
    templates.forEach((template) => {
      const content = getTemplateFirstChild(template);
      content.setAttribute(
        "data-header-float-element-template",
        template.dataset.headerFloatElementTemplate
      ),
        content.setAttribute("inert", ""),
        fragment.appendChild(content);
    }),
      (this.element = fragment),
      (this.mounted = !1),
      (this.initialPlacement = this.dataset.placement);
  }
  mountComponent() {
    super.mountComponent();
    const header = $el("header-component");
    customElements.whenDefined("header-component").then(() => {
      header.on("headerButtonHover", this.handleButtonHover),
        header.on("mouseLeavedHeader", this.handleMouseLeave);
    });
  }
  unmountComponent() {
    super.unmountComponent();
  }
  setVisible(isVisible) {
    const bodyElement = $el(BODY_ELEMENT_SELECTOR);
    this.setAttribute("aria-hidden", isVisible ? "false" : "true");
    const styles = { zIndex: 2 };
    isVisible
      ? bodyElement.showOverlay(this.id, styles)
      : bodyElement.hideOverlay(this.id);
  }
  mount() {
    this.mounted || this.replaceChildren(this.element),
      this.setUpdate(),
      (this.mounted = !0);
  }
  unmount() {
    this.removeUpdate();
  }
  get isOpen() {
    return this.parentElement.hasAttribute("with-opened-dropdown");
  }
  get header() {
    return $el("header-component");
  }
}
const SCROLLTRACK_ATTRIBUTE = "data-with-scrolltrack",
  HEADER_SELECTOR = "header-component",
  SMALL_CLASS = "product__info-wrapper--small",
  WIDE_CLASS = "product__info-wrapper--wide",
  WIDE_PLUS_CLASS = "product__info-wrapper--wide-plus";
class ProductInfo extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "headerHeight");
    __publicField(this, "defaultTopSpace");
    __publicField(this, "infoHeight");
    __publicField(this, "isToSetMoreHeight");
    __publicField(this, "resizeObserver");
    __publicField(this, "setDimentions", () => {
      (this.defaultTopSpace = 16),
        (this.infoHeight = this.getBoundingClientRect().height);
      const header = $el(HEADER_SELECTOR),
        headerSection = header.section;
      (this.headerHeight = headerSection.offsetHeight),
        (this.isToSetMoreHeight =
          header.getAttribute("is-sticky") === "static");
    });
    __publicField(this, "handleScroll", () => {
      const topSpace = this.isToSetMoreHeight
          ? this.defaultTopSpace + this.headerHeight
          : this.defaultTopSpace,
        viewportHeight = window.innerHeight - topSpace;
      window.scrollY > 0 && this.infoHeight > viewportHeight
        ? (this.style.top = `${viewportHeight - this.infoHeight}px`)
        : (this.style.top = `${topSpace}px`);
    });
    __publicField(this, "handleSectionLoad", () => {
      this.setDimentions();
    });
    __publicField(
      this,
      "handleResize",
      debounce(() => {
        isMobile() || (this.toggleWidthClasses(), this.setDimentions());
      }, 50)
    );
    __publicField(this, "toggleWidthClasses", () => {
      const infoWidth = this.getBoundingClientRect().width;
      this.classList.toggle(SMALL_CLASS, infoWidth < 380),
        this.classList.toggle(WIDE_CLASS, infoWidth > 480),
        this.classList.toggle(WIDE_PLUS_CLASS, infoWidth > 740);
    });
  }
  mountComponent() {
    this.hasAttribute(SCROLLTRACK_ATTRIBUTE) &&
      (customElements.whenDefined("header-component").then(() => {
        this.addListener(window, "scroll", this.handleScroll);
      }),
      this.isEditor && this.editor.on("SECTION_LOAD", this.handleSectionLoad)),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this);
  }
}
const CART_DRAWER_SELECTOR = "cart-drawer",
  TRACK_SELECTOR = "[slider-grid-track]",
  SLIDE_SELECTOR = "slider-grid-slide",
  AUTOPLAY_ATTRIBUTE = "autoplay-mode",
  AUTOPLAY_INTERVAL_ATTRIBUTE = "autoplay-interval",
  ONE_AT_TIME_AUTOPLAY_RUNNING_ATTRIBUTE = "autoplay-running",
  SEAMLESS_AUTOPLAY_RUNNING_ATTRIBUTE = "seamless-autoplay-running",
  SEAMLESS_AUTOPLAY_PAUSED_ATTRIBUTE = "seamless-autoplay-paused",
  BUTTON_SELECTOR = "button[data-direction]",
  BUTTON_DIRECTION_SELECTOR = "data-direction",
  PROGRESS_BAR_SELECTOR = "[slider-grid-progress]",
  DESKTOP_DISABLED_ATTRIBUTE = "desktop-disabled",
  MOBILE_DISABLED_ATTRIBUTE = "mobile-disabled";
class SliderGrid extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "activeSlide");
    __publicField(this, "lastSlideIndex");
    __publicField(this, "track");
    __publicField(this, "trackWidth");
    __publicField(this, "navButtons");
    __publicField(this, "buttonsInited");
    __publicField(this, "withProgressBar");
    __publicField(this, "dots");
    __publicField(this, "slides");
    __publicField(this, "withDots");
    __publicField(this, "snaps");
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "autoplay");
    __publicField(this, "requestFrameId");
    __publicField(this, "seamlessRunning");
    __publicField(this, "pausedAt");
    __publicField(this, "resizeObserver");
    __publicField(this, "intersectionObserver");
    __publicField(this, "autoplayIntersectionObserver");
    __publicField(this, "autoplayForcedStopped");
    __publicField(this, "isMobile");
    __publicField(this, "desktopDisabled");
    __publicField(this, "mobileDisabled");
    __publicField(this, "forceDeactivated");
    __publicField(this, "sidebar");
    __publicField(this, "isFocused");
    __publicField(this, "sectionWidth");
    __publicField(this, "init", () => {
      if (
        ((this.isMobile = isMobile()),
        (this.forceDeactivated = !1),
        (this.isMobile && this.mobileDisabled) ||
          (!this.isMobile && this.desktopDisabled))
      ) {
        this.toggleListeners(!1), this.stopAutoplay();
        return;
      }
      (this.activeSlide = 0),
        this.setSnaps(),
        this.forceDeactivated
          ? (this.toggleListeners(!1), this.setButtonsInactive())
          : (this.initButtons(),
            this.toggleButtonsActive(),
            this.initProgressBar(),
            this.initDots(),
            this.initAutoplay(),
            this.toggleListeners(!0));
    });
    __publicField(
      this,
      "handleResize",
      debounce(async (entries) => {
        const { inlineSize } = entries[0].borderBoxSize[0];
        if (this.sectionWidth === inlineSize) return !0;
        this.toggleListeners(!1),
          this.track.removeAttribute("style"),
          this.stopAutoplay(),
          await transitionToPromise(this.track),
          this.init(),
          (this.sectionWidth = inlineSize);
      }, 50)
    );
    __publicField(this, "setSnaps", () => {
      const slides = $list(`[${SLIDE_SELECTOR}]`, this),
        viewportWidth = this.track.getBoundingClientRect().width + 1,
        { left: firstSlideLeft, width: slideWidth } =
          slides[0].getBoundingClientRect(),
        lastSlideRight =
          slides[slides.length - 1].getBoundingClientRect().right,
        slidesPerView = Math.floor(viewportWidth / slideWidth),
        snapsCount = slides.length - slidesPerView;
      if (snapsCount < 1) {
        this.forceDeactivated = !0;
        return;
      }
      (this.snaps = slides.reduce((acc, slide, index) => {
        if (
          index === snapsCount ||
          (index < snapsCount && index % slidesPerView === 0)
        ) {
          let snapPosition =
            firstSlideLeft - slide.getBoundingClientRect().left;
          return (
            index === snapsCount &&
              snapPosition < viewportWidth &&
              (snapPosition = this.isMobile
                ? -(lastSlideRight - viewportWidth + firstSlideLeft)
                : -(lastSlideRight - viewportWidth - firstSlideLeft)),
            [...acc, snapPosition]
          );
        } else return acc;
      }, [])),
        (this.lastSlideIndex = this.snaps.length - 1),
        (this.trackWidth = firstSlideLeft + lastSlideRight);
    });
    __publicField(this, "toggleListeners", (enable) => {
      enable
        ? (this.addListener(this, "mousedown", this.handleMouseDown),
          this.addListener(this, "mouseup", this.handleMouseUp),
          this.addListener(this, "dragstart", this.handleDragStart),
          this.addListener(this, "keydown", this.handleKeydown))
        : (this.removeListener(this, "mousedown", this.handleMouseDown),
          this.removeListener(this, "mouseup", this.handleMouseUp),
          this.removeListener(this, "dragstart", this.handleDragStart),
          this.removeListener(this, "keydown", this.handleKeydown),
          this.removeListener(this, "focusin", this.handleFocus));
    });
    __publicField(this, "handleKeydown", (event) => {
      if (!this.isFocused) {
        this.stopAutoplay();
        const { lastTarget } = getTargets(this, !1);
        this.addListener(lastTarget, "focusout", this.handleFocusOut),
          this.addListener(this, "focusin", this.handleFocus);
      }
      isLeftKey(event) && this.scrollPrev(),
        isRightKey(event) && this.scrollNext(),
        (this.isFocused = !0);
    });
    __publicField(this, "handleFocus", (event) => {
      const targetLeft = event.target.getBoundingClientRect().left,
        thisRight = this.getBoundingClientRect().right;
      targetLeft > thisRight && this.scrollNext(),
        targetLeft < 0 && (this.scrollTo(0), (this.activeSlide = 0)),
        this.toggleButtonsActive();
    });
    __publicField(this, "handleFocusOut", ({ currentTarget }) => {
      this.removeListener(currentTarget, "focusout", this.handleFocusOut),
        this.removeListener(this, "focusin", this.handleFocus);
    });
    __publicField(this, "handleMouseDown", ({ x }) => {
      this.addListener(this, "mousemove", this.handleMouseMove),
        (this.x = x),
        this.stopAutoplay(),
        (this.autoplayForcedStopped = !0);
    });
    __publicField(this, "handleMouseUp", ({ x }) => {
      this.isSwipeRight(x) && this.scrollNext(),
        this.isSwipeLeft(x) && this.scrollPrev(),
        this.classList.remove("dragging"),
        this.removeListener(this, "mousemove", this.handleMouseMove);
    });
    __publicField(this, "handleMouseMove", ({ x }) => {
      (this.isSwipeRight(x) || this.isSwipeLeft(x)) &&
        this.classList.add("dragging");
    });
    __publicField(
      this,
      "handleDragStart",
      (event) => (event.preventDefault(), !1)
    );
    __publicField(this, "handleTouchStart", () => {
      var _a;
      const translated =
        (_a = this.track.getAttribute("style")) == null
          ? void 0
          : _a.replace("transform: translateX(", "").replace("px);", "");
      this.stopAutoplay(),
        this.track.removeAttribute("style"),
        this.track.scrollTo({ left: Math.abs(+translated) }),
        (this.autoplayForcedStopped = !0);
    });
    __publicField(this, "isSwipeRight", (x) => this.x - x > 0);
    __publicField(this, "isSwipeLeft", (x) => this.x - x < 0);
    __publicField(this, "handleMouseEnterAutoplay", () => {
      this.pauseAutoplay();
    });
    __publicField(this, "handleMouseLeaveAutoplay", () => {
      this.seamlessRunning && (this.seamlessRunning = !1), this.startAutoplay();
    });
    __publicField(this, "scrollNext", () => {
      if (!this.canScrollNext()) return;
      const nextIndex = this.activeSlide + 1;
      (this.activeSlide = nextIndex), this.scrollTo(this.snaps[nextIndex]);
    });
    __publicField(this, "scrollPrev", () => {
      if (this.seamlessRunning && !this.canScrollPrev()) return;
      const nextIndex = this.activeSlide < 1 ? 0 : this.activeSlide - 1;
      (this.activeSlide = nextIndex), this.scrollTo(this.snaps[nextIndex]);
    });
    __publicField(this, "scrollTo", (value) => {
      this.track.setAttribute("style", `transform: translateX(${value}px);`),
        this.toggleNavItems(),
        this.emit("select", { activeIndex: this.activeSlide });
    });
    __publicField(
      this,
      "canScrollNext",
      () => this.activeSlide !== this.lastSlideIndex
    );
    __publicField(
      this,
      "canScrollPrev",
      () => this.seamlessRunning || this.activeSlide !== 0
    );
    __publicField(this, "scrollSlideIntoView", (slideIndex) => {
      if (slideIndex !== this.activeSlide) {
        if (this.isMobile)
          this.isEditor
            ? this.scrollTo(this.snaps[slideIndex])
            : this.track.scrollTo({
                left: Math.abs(this.snaps[slideIndex]),
                behavior: "smooth",
              });
        else {
          const snapToScroll =
            slideIndex > this.lastSlideIndex ? this.lastSlideIndex : slideIndex;
          this.scrollTo(this.snaps[snapToScroll]);
        }
        (this.activeSlide = slideIndex), this.toggleNavItems();
      }
    });
    __publicField(this, "toggleNavItems", () => {
      this.toggleButtonsActive(), this.withProgressBar && this.setProgress();
    });
    __publicField(this, "initAutoplay", () => {
      this.autoplay &&
        !this.autoplayForcedStopped &&
        (this.isMobile
          ? this.addListener(this, "touchstart", this.handleTouchStart)
          : (this.addListener(
              this,
              "mouseenter",
              this.handleMouseEnterAutoplay
            ),
            this.addListener(
              this,
              "mouseleave",
              this.handleMouseLeaveAutoplay
            )),
        (this.autoplayIntersectionObserver = new IntersectionObserver(
          this.toggleAutoplayOnIntersection
        )),
        this.autoplayIntersectionObserver.observe(this));
    });
    __publicField(this, "toggleAutoplayOnIntersection", (elements) => {
      elements[0].isIntersecting
        ? this.autoplayForcedStopped || this.startAutoplay()
        : (this.pauseAutoplay(),
          this.autoplayForcedStopped &&
            this.autoplayIntersectionObserver.disconnect());
    });
    __publicField(this, "startAutoplay", () => {
      this.autoplay === "one_at_time"
        ? this.startOneAtTimeAutoPlay()
        : this.autoplay === "seamless" &&
          (this.startSeamlessAutoPlay(), this.toggleButtonsActive());
    });
    __publicField(this, "stopAutoplay", () => {
      this.removeAutoplayState(),
        this.removeListener(this, "touchstart", this.handleTouchStart),
        this.removeListener(this, "mouseenter", this.handleMouseEnterAutoplay),
        this.removeListener(this, "mouseleave", this.handleMouseLeaveAutoplay);
    });
    __publicField(this, "pauseAutoplay", () => {
      this.removeAutoplayState(),
        this.autoplay === "seamless" &&
          ((this.pausedAt = +this.track.style.transform
            .replace("translateX(", "")
            .replace("px)", "")),
          (this.seamlessRunning = !1));
    });
    __publicField(this, "removeAutoplayState", () => {
      cancelAnimationFrame(this.requestFrameId),
        this.removeAttribute(ONE_AT_TIME_AUTOPLAY_RUNNING_ATTRIBUTE),
        this.removeAttribute(SEAMLESS_AUTOPLAY_RUNNING_ATTRIBUTE);
    });
    __publicField(this, "startOneAtTimeAutoPlay", async () => {
      this.sidebar &&
        (await transitionToPromise(this.sidebar), this.setSnaps()),
        this.removeAttribute(ONE_AT_TIME_AUTOPLAY_RUNNING_ATTRIBUTE);
      const interval = +this.getAttribute(AUTOPLAY_INTERVAL_ATTRIBUTE) * 1e3;
      let last;
      const tick = (timestamp) => {
        last || (last = timestamp),
          timestamp - last > interval &&
            (this.canScrollNext()
              ? this.scrollNext()
              : ((this.activeSlide = -1), this.scrollNext()),
            (last = timestamp)),
          (this.requestFrameId = requestAnimationFrame(tick));
      };
      (this.requestFrameId = requestAnimationFrame(tick)),
        this.setAttribute(ONE_AT_TIME_AUTOPLAY_RUNNING_ATTRIBUTE, "");
    });
    __publicField(this, "startSeamlessAutoPlay", async () => {
      if (this.seamlessRunning) return;
      this.sidebar &&
        (await transitionToPromise(this.sidebar), this.setSnaps()),
        this.setAttribute(SEAMLESS_AUTOPLAY_RUNNING_ATTRIBUTE, "");
      const distance = this.snaps[this.snaps.length - 1],
        interval = 0.2 * +this.getAttribute(AUTOPLAY_INTERVAL_ATTRIBUTE);
      let scrolled = this.pausedAt ?? 0;
      const tick = () => {
        if (
          ((scrolled = Math.max(scrolled - interval, distance)),
          this.scrollTo(scrolled),
          scrolled != distance)
        ) {
          this.requestFrameId = requestAnimationFrame(tick);
          const currentSnap = this.snaps.findIndex((val) => {
            const diff = scrolled - val;
            return diff > 0 && diff < 20;
          });
          currentSnap > 0 && (this.activeSlide = currentSnap),
            this.withProgressBar &&
              this.setProgress(Math.abs(scrolled / distance) * 100);
        } else this.restartSeamlessAutoplay();
      };
      (this.requestFrameId = requestAnimationFrame(tick)),
        (this.seamlessRunning = !0),
        (this.pausedAt = 0);
    });
    __publicField(this, "restartSeamlessAutoplay", async () => {
      this.setAttribute(SEAMLESS_AUTOPLAY_PAUSED_ATTRIBUTE, ""),
        await transitionToPromise(this.track),
        this.isMobile ||
          this.removeAttribute(SEAMLESS_AUTOPLAY_RUNNING_ATTRIBUTE),
        cancelAnimationFrame(this.requestFrameId),
        this.track.removeAttribute("style"),
        this.withProgressBar && this.setProgress(0),
        await transitionToPromise(this.track),
        this.removeAttribute(SEAMLESS_AUTOPLAY_PAUSED_ATTRIBUTE),
        await delay(500),
        (this.pausedAt = 0),
        (this.activeSlide = 0),
        this.startSeamlessAutoPlay();
    });
    __publicField(this, "initButtons", () => {
      this.buttonsInited &&
        this.navButtons.forEach((btn) => {
          this.removeListener(btn, "click", this.handleButtonClick);
        }),
        (this.navButtons = $list(BUTTON_SELECTOR, this)),
        this.navButtons.length &&
          (this.navButtons.forEach((btn) => {
            this.addListener(btn, "click", this.handleButtonClick);
          }),
          (this.buttonsInited = !0));
    });
    __publicField(this, "handleButtonClick", ({ currentTarget }) => {
      currentTarget.getAttribute(BUTTON_DIRECTION_SELECTOR) === "next"
        ? this.scrollNext()
        : this.scrollPrev();
    });
    __publicField(this, "toggleButtonsActive", () => {
      this.buttonsInited &&
        (this.navButtons[0].toggleAttribute("disabled", !this.canScrollPrev()),
        this.navButtons[1].toggleAttribute("disabled", !this.canScrollNext()));
    });
    __publicField(this, "setButtonsInactive", () => {
      $list(BUTTON_SELECTOR, this).forEach((btn) => {
        btn.setAttribute("disabled", "");
      });
    });
    __publicField(this, "initProgressBar", () => {
      if (this.withProgressBar) {
        this.setProgress(0);
        return;
      }
      $el(PROGRESS_BAR_SELECTOR, this) &&
        (this.setProgress(),
        (this.withProgressBar = !0),
        this.isMobile &&
          this.addListener(this.track, "scroll", this.handleProgressOnMobile));
    });
    __publicField(this, "setProgress", (value) => {
      const progress = value ?? (this.activeSlide / this.lastSlideIndex) * 100;
      this.setAttribute("style", `--gsc-slider-grid-progress: ${progress}%;`);
    });
    __publicField(this, "handleProgressOnMobile", ({ target }) => {
      this.setProgress((target.scrollLeft / this.trackWidth) * 100);
    });
    __publicField(this, "initDots", () => {
      var _a;
      this.withDots &&
        ((_a = this.intersectionObserver) == null || _a.disconnect()),
        this.isMobile
          ? this.initMobileDots()
          : this.withDots &&
            this.track.scrollTo({ left: 0, behavior: "smooth" });
    });
    __publicField(this, "initMobileDots", () => {
      (this.intersectionObserver = new IntersectionObserver(
        this.observeSlides,
        { rootMargin: "4000px 0px 4000px 0px", root: this }
      )),
        $list(`[${SLIDE_SELECTOR}]`, this).forEach((slide) => {
          this.intersectionObserver.observe(slide);
        }),
        (this.withDots = !0);
    });
    __publicField(
      this,
      "observeSlides",
      debounce((entries) => {
        this.isMobile &&
          entries.forEach((entry) => {
            entry.isIntersecting &&
              this.emit("select", {
                activeIndex: +entry.target.getAttribute("index"),
              });
          });
      }, 50)
    );
    (this.activeSlide = 0),
      (this.autoplay = this.getAttribute(AUTOPLAY_ATTRIBUTE)),
      (this.desktopDisabled = this.hasAttribute(DESKTOP_DISABLED_ATTRIBUTE)),
      (this.mobileDisabled = this.hasAttribute(MOBILE_DISABLED_ATTRIBUTE)),
      (this.sidebar = this.closest(CART_DRAWER_SELECTOR));
  }
  mountComponent() {
    (this.track = $el(TRACK_SELECTOR, this)),
      (this.resizeObserver = new ResizeObserver(this.handleResize)),
      this.resizeObserver.observe(this);
  }
  unmountComponent() {
    var _a, _b;
    this.stopAutoplay(),
      this.resizeObserver.disconnect(),
      (_a = this.intersectionObserver) == null || _a.disconnect(),
      (_b = this.autoplayIntersectionObserver) == null || _b.disconnect(),
      (this.sectionWidth = 0);
  }
}
class VideoElement extends BaseComponent {
  constructor() {
    super();
    __publicField(this, "video");
    __publicField(this, "handleClick", () => {
      this.video.paused ? this.video.play() : this.video.pause();
    });
  }
  mountComponent() {
    const video = $el("video", this);
    video.hasAttribute("controls") ||
      (this.addListener(this.parentElement, "click", this.handleClick),
      (this.video = video));
  }
}
const DOTS_TRACK_SELECTOR = "[data-dots-track]",
  VISIBLE_DOTS_COUNT_ATTRIBUTE = "dots-count",
  DOT_SELECTOR$2 = "[data-dot-index]",
  DOT_ACTIVE_CLASS = "--active",
  CAN_SCROLL_CLASS = "--scrollable";
class DynamicDots extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "track");
    __publicField(this, "_dots");
    __publicField(this, "visibleDotsCount");
    __publicField(this, "sideDotsThreshold");
    __publicField(this, "activeIndex");
    __publicField(this, "dotWidth");
    __publicField(this, "scrollTrack", (selectedIndex) => {
      const scrollPoint =
        selectedIndex < this.sideDotsThreshold + 1
          ? 0
          : selectedIndex > this.dots.length - this.sideDotsThreshold
          ? this.track.offsetWidth
          : (selectedIndex - this.sideDotsThreshold) * this.dotWidth;
      this.track.parentElement.scrollTo({
        left: scrollPoint,
        behavior: "smooth",
      });
    });
    __publicField(this, "changeVisibleDots", (visibleDotsCount) => {
      this.visibleDotsCount < visibleDotsCount &&
        (visibleDotsCount = this.visibleDotsCount),
        this.style.setProperty("--gsc-dots-count", visibleDotsCount.toString());
    });
    __publicField(this, "updateDots", (selectedIndex) => {
      this.dots.forEach((dot, index, { length }) => {
        if (
          (dot.classList.toggle(DOT_ACTIVE_CLASS, index === selectedIndex),
          index > 0 && index < length - 1)
        ) {
          let isPrev;
          selectedIndex < this.sideDotsThreshold
            ? (isPrev = index === this.visibleDotsCount - 1)
            : selectedIndex > length - 1 - this.sideDotsThreshold
            ? (isPrev = index === length - this.visibleDotsCount)
            : (isPrev =
                selectedIndex - this.sideDotsThreshold === index ||
                selectedIndex + this.sideDotsThreshold === index),
            dot.classList.toggle(CAN_SCROLL_CLASS, isPrev);
        }
      }),
        this.scrollTrack(selectedIndex),
        (this.activeIndex = selectedIndex);
    });
  }
  mountComponent() {
    (this.activeIndex = 0),
      (this.visibleDotsCount =
        +this.getAttribute(VISIBLE_DOTS_COUNT_ATTRIBUTE) || 3),
      (this.sideDotsThreshold = this.visibleDotsCount === 3 ? 1 : 2),
      (this.track = $el(DOTS_TRACK_SELECTOR, this)),
      (this.dotWidth = this.track.lastChild.offsetWidth);
  }
  get dots() {
    return (this._dots = this._dots || [...$list(DOT_SELECTOR$2, this)]);
  }
  get targetSelector() {
    return this.dataset.targetSelector;
  }
}
const CAROUSEL_SELECTOR$1 = "carousel-component",
  DOT_SELECTOR$1 = "[data-dot-index]";
class CarouselDynamicDots extends DynamicDots {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCarouselSelect", () => {
      var _a;
      const selectedIndex =
        (_a = this.carousel) == null ? void 0 : _a.embla.selectedScrollSnap();
      this.updateDots(selectedIndex);
    });
    __publicField(this, "scrollCarouselToSlide", (index) => {
      var _a;
      index !== this.activeIndex &&
        ((_a = this.carousel) == null || _a.embla.scrollTo(index));
    });
    __publicField(this, "handleDotClick", (event) => {
      const dot = event.target.closest(DOT_SELECTOR$1);
      dot && this.scrollCarouselToSlide(+dot.dataset.dotIndex);
    });
  }
  mountComponent() {
    var _a;
    super.mountComponent(),
      (_a = this.carousel) == null ||
        _a.embla.on("select", this.handleCarouselSelect),
      this.addListener(this.track, "click", this.handleDotClick);
  }
  unmountComponent() {
    var _a;
    (_a = this.carousel) == null ||
      _a.embla.off("select", this.handleCarouselSelect);
  }
  get carousel() {
    return this.targetSelector
      ? $el(this.targetSelector)
      : $elParent(CAROUSEL_SELECTOR$1, this);
  }
}
const CAROUSEL_SELECTOR = "slider-grid",
  DOT_SELECTOR = "[data-dot-index]";
class CustomDynamicDots extends DynamicDots {
  constructor() {
    super(...arguments);
    __publicField(this, "handleCarouselSelect", ({ activeIndex }) => {
      this.updateDots(activeIndex);
    });
    __publicField(this, "scrollCarouselToSlide", (index) => {
      index !== this.activeIndex &&
        (this.carousel.scrollSlideIntoView(index),
        this.updateDots(index),
        (this.activeIndex = index));
    });
    __publicField(this, "handleDotClick", (event) => {
      const dot = event.target.closest(DOT_SELECTOR);
      dot && this.scrollCarouselToSlide(+dot.dataset.dotIndex);
    });
  }
  mountComponent() {
    var _a;
    super.mountComponent(),
      (_a = this.carousel) == null ||
        _a.on("select", this.handleCarouselSelect),
      this.addListener(this.track, "click", this.handleDotClick);
  }
  unmountComponent() {
    var _a;
    (_a = this.carousel) == null || _a.off("select", this.handleCarouselSelect);
  }
  get carousel() {
    return $elParent(CAROUSEL_SELECTOR, this);
  }
}
const CLASS_IS_OPENED = "is-opened",
  CLASS_IS_ANIMATING = "is-animating",
  SELECTOR_OVERLAY = ".bottom-sheet__overlay",
  SELECTOR_CONTENT = ".bottom-sheet__content",
  SELECTOR_CLOSE_BUTTON = ".bottom-sheet__close-button",
  TOUCH_MOVE_THRESHOLD = 45;
class BottomSheet extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "content");
    __publicField(this, "contentTouchStart");
    __publicField(this, "contentTouchEnd");
    __publicField(this, "handleContentTouchStart", (e) => {
      (this.contentTouchStart = e.targetTouches[0].clientY),
        (this.contentTouchEnd = 0);
    });
    __publicField(
      this,
      "handleContentTouchMove",
      (e) => (this.contentTouchEnd = e.targetTouches[0].clientY)
    );
    __publicField(this, "handleContentTouchEnd", (e) => {
      this.contentTouchEnd - this.contentTouchStart > TOUCH_MOVE_THRESHOLD &&
        this.hide();
    });
    __publicField(this, "handleClick", (e) => {
      const target = e.target;
      target.closest(SELECTOR_OVERLAY)
        ? this.handleOverlayClick()
        : target.closest(SELECTOR_CLOSE_BUTTON) &&
          this.handleCloseButtonClick();
    });
    __publicField(this, "handleOverlayClick", () => {
      this.closeOnOverlay && this.hide();
    });
    __publicField(this, "handleCloseButtonClick", () => this.hide());
    __publicField(this, "show", async () => {
      const { classList } = this;
      classList.toggle(CLASS_IS_ANIMATING, !0),
        await requestAnimationFrameAfterStyleAndLayout(),
        classList.toggle(CLASS_IS_ANIMATING, !1),
        classList.toggle(CLASS_IS_OPENED, !0);
    });
    __publicField(this, "hide", async () => {
      const { classList } = this;
      classList.toggle(CLASS_IS_ANIMATING, !0),
        classList.toggle(CLASS_IS_OPENED, !1),
        await Promise.all([
          transitionToPromise($el(SELECTOR_OVERLAY)),
          transitionToPromise($el(SELECTOR_CONTENT)),
        ]),
        classList.toggle(CLASS_IS_ANIMATING, !1);
    });
    __publicField(this, "toggle", async () => {
      this.classList.contains(CLASS_IS_OPENED)
        ? await this.hide()
        : await this.show();
    });
  }
  mountComponent() {
    super.mountComponent(),
      (this.content = $el(SELECTOR_CONTENT, this)),
      this.addListener(this, "click", this.handleClick),
      this.addListener(
        this.content,
        "touchstart",
        this.handleContentTouchStart
      ),
      this.addListener(this.content, "touchmove", this.handleContentTouchMove),
      this.addListener(this.content, "touchend", this.handleContentTouchEnd);
  }
  unmountComponent() {
    super.unmountComponent(),
      this.removeListener(this, "click", this.handleClick),
      this.removeListener(
        this.content,
        "touchstart",
        this.handleContentTouchStart
      ),
      this.removeListener(
        this.content,
        "touchmove",
        this.handleContentTouchMove
      ),
      this.removeListener(this.content, "touchend", this.handleContentTouchEnd);
  }
  get closeOnOverlay() {
    return strToBool(this.dataset.closeOnOverlay);
  }
}
const CLASS_OPENED = "custom-select--opened",
  SELECTOR_SELECT = ".custom-select > select";
class CustomSelect extends BaseComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "$select");
    __publicField(this, "handleMouseDown", () => {
      isTouch() ||
        (this.classList.toggle(CLASS_OPENED, !0),
        this.addListener(window, "click", this.handleWindowClick, {
          once: !0,
        }));
    });
    __publicField(this, "handleWindowClick", () => {
      this.classList.toggle(CLASS_OPENED, !1);
    });
  }
  mountComponent() {
    super.mountComponent(),
      (this.$select = $el(SELECTOR_SELECT, this)),
      this.addListener(this.$select, "mousedown", this.handleMouseDown);
  }
  unmountComponent() {
    super.unmountComponent(),
      this.removeListener(this.$select, "mousedown", this.handleMouseDown);
  }
}
const components = [
  AnnouncementBar,
  HeaderFloatElementBtn,
  HeaderFloatElement,
  LazyVideo,
  BackToTopButton,
  StickyCartButton,
  QuantityComponent,
  QuantityBtn,
  LocalizationSelector,
  NotificationComponent,
  TabsComponent,
  TabComponent,
  ListComponent,
  ListBtn,
  FloatElement,
  HotspotsFloatElement,
  HotspotsComponent,
  FloatElementBtn,
  DropdownOpener,
  TooltipTrigger,
  FaqSection,
  AccordeonComponent,
  AccordeonButton,
  ProductMediaTabs,
  ColorSwatches,
  ModalComponent,
  PasswordModal,
  PasswordModalButton,
  CartNotificationPopup,
  ModalButton,
  SidebarButton,
  SidebarComponent,
  SearchSidebar,
  SearchSidebarFormWrapper,
  QuickView,
  SliderGrid,
  CarouselComponent,
  CarouselPlayButton,
  CarouselDots,
  CarouselDynamicDots,
  CustomDynamicDots,
  CarouselButton,
  SlideshowComponent,
  HeaderComponent,
  DrawerMenu,
  DrawerMenuPage,
  DrawerMenuPageLink,
  PaginationComponent,
  PaginationLoadButton,
  PaginationLink,
  PaginationInfiniteScroll,
  DeferredMedia,
  PickupAvailability,
  ProductForm,
  ProductFormButton,
  ProductDetails,
  ProductModel,
  CartPage,
  CartDrawer,
  CartDrawerItemsBlock,
  CartDrawerInCartBannerBlock,
  CartDrawerRelatedProducts,
  CartDrawerRelatedProductsBlock,
  CartDrawerTimerBlock,
  CartDrawerHeader,
  CartDrawerFooter,
  CartDrawerFreeShippingBarBlock,
  CartDrawerButtonsBlock,
  FreeShippingBar,
  ProductMedia,
  ProductMediaCarousel,
  VariantPicker,
  ColorSwatchesPicker,
  ProductModal,
  ProductModalImageWrap,
  ProductModalButton,
  ProductRecommendations,
  ProductRelatedBlock,
  RecentlyViewed,
  ClipboardButton,
  ClipboardButtonTooltip,
  ProductCard,
  HorizontalProductCard,
  VerticalProductCard,
  MaxLinesComponent,
  SearchField,
  PasswordField,
  ZoomCursor,
  ShopComponent,
  ShopActiveFilters,
  SidebarFiltersDesktop,
  SidebarFiltersMobile,
  FilterRemoveBtn,
  SortList,
  PriceRange,
  ColumnSwitcher,
  FiltersSubmitBtn,
  BeforeAfterImages,
  CountdownTimer,
  ProductInformationDrawer,
  SidebarFiltersStickyMobileButton,
  RecipientForm,
  ShapeSwatch,
  CountrySelector,
  LoginComponent,
  RegisterComponent,
  AddressesComponent,
  TabWithDynamicHeight,
  VideoBanner,
  CartItem,
  CartRemoveButton,
  CartItemsBlock,
  CartButtonsBlock,
  CartCountdownBlock,
  CartRelatedProductsBlock,
  CartOrderNotesBlock,
  CartNote,
  CartAppBlock,
  CartSubtotalBlock,
  CartInCartBannerBlock,
  CartFreeShippingBarBlock,
  CartRelatedProducts,
  CartCount,
  CartOrderNotes,
  ShareWrapper,
  ShareComponent,
  ScrollingText,
  ScrollingTextLine,
  CollapsedTags,
  ArticleTags,
  PopupAgeVerifier,
  PopupPromo,
  PopupSignup,
  PopupTeaser,
  LookbookComponent,
  LookbookModal,
  MapComponent,
  StoreLocator,
  BodyElement,
  FeaturedNavigation,
  ImageSlider,
  TimelineComponent,
  CloseCursor,
  QuoteComponent,
  TestimonialsComponent,
  ProductInfo,
  VideoElement,
  BottomSheet,
  CartDiscountCode,
  ShippingCalculator,
  CustomSelect,
];
window.recentlyViewed = RecentlyViewed;
const defineComponents = () => {
    components.forEach(registerComponent);
  },
  SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger",
  SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen",
  ZOOM_OUT_CLASSNAME = "animate--zoom-out",
  KEEP_OBSERVE_ATTRIBUTE = "data-keep-observe-animation",
  REMOVE_ANIMATION_CLASS_ATTRIBUTE = "data-remove-animation-class",
  IS_SLIDE_CLASSNAME = "slider-grid__slide",
  REGULAR_IMGAE_ZOOM_CLASSNAME = "zoom";
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    const elementTarget = element.target;
    element.isIntersecting
      ? handleIntersecting(elementTarget, index, observer)
      : handleNonIntersecting(elementTarget, observer);
  });
}
function handleIntersecting(elementTarget, index, observer) {
  elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME) &&
    (elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),
    elementTarget.hasAttribute(KEEP_OBSERVE_ATTRIBUTE) ||
      (elementTarget.setAttribute("style", `--gsc-animation-order: ${index};`),
      observer.unobserve(elementTarget))),
    (elementTarget.hasAttribute(REMOVE_ANIMATION_CLASS_ATTRIBUTE) ||
      elementTarget.classList.contains(REGULAR_IMGAE_ZOOM_CLASSNAME)) &&
      removeAnimationClasses(elementTarget);
}
function handleNonIntersecting(elementTarget, observer) {
  isMobile() &&
  (elementTarget.classList.contains(IS_SLIDE_CLASSNAME) ||
    elementTarget.classList.contains(ZOOM_OUT_CLASSNAME)) &&
  elementTarget.getBoundingClientRect().left >
    document.body.getBoundingClientRect().width
    ? (elementTarget.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
      observer.unobserve(elementTarget))
    : elementTarget.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
}
async function removeAnimationClasses(elementTarget) {
  await transitionToPromise(elementTarget),
    elementTarget.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
    elementTarget.removeAttribute("style");
}
function getObserverOptions() {
  const asidePaddings = getComputedStyle(document.body).getPropertyValue(
    "--gsc-aside-padding-size"
  );
  return { rootMargin: `0px -${asidePaddings} -25px -${asidePaddings}` };
}
function initializeScrollAnimationTrigger(rootEl = document) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );
  if (animationTriggerElements.length === 0) return;
  const observer = new IntersectionObserver(
    onIntersection,
    getObserverOptions()
  );
  animationTriggerElements.forEach((element) => observer.observe(element));
}
window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
});
Shopify.designMode &&
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target)
  );
Shopify.designMode &&
  (document.documentElement.className = `${document.documentElement.className} is-editor-mode`);
defineComponents();
